export default {
  country: {
    "CN": "Mainland China",
    "HK": "Hong Kong, China",
    "MO": "Macao, China",
    "TW": "Taiwan, China",
    "KR": "South Korea",
    "JP": "Japan",
    "AU": "Australia",
    "SG": "Singapore",
    "MY": "Malaysia",
    "TH": "Thailand",
    "VN": "Vietnam",
    "PH": "Philippines",
    "ID": "Indonesia",
    "DE": "Germany",
    "IT": "Italy",
    "FR": "France",
    "RU": "Russia",
    "NZ": "New Zealand",
    "NL": "Netherlands",
    "SE": "Sweden",
    "UA": "Ukraine",
    "AE": "United Arab Emirates",
    "AR": "Argentina",
    "AT": "Austria",
    "BE": "Belgium",
    "BG": "Bulgaria",
    "BR": "Brazil",
    "BS": "Bahamas",
    "BY": "Belarus",
    "BZ": "Belize",
    "CH": "Switzerland",
    "CL": "Chile",
    "CO": "Colombia",
    "DK": "Denmark",
    "EE": "Estonia",
    "EG": "Egypt",
    "ES": "Spain",
    "FI": "Finland",
    "HU": "Hungary",
    "GR": "Greece",
    "IE": "Ireland",
    "IL": "Israel",
    "IN": "India",
    "JO": "Jordan",
    "KG": "Kyrgyzstan",
    "KH": "Cambodia",
    "LK": "Sri Lanka",
    "LT": "Lithuania",
    "LU": "Luxembourg",
    "MA": "Morocco",
    "MN": "Mongolia",
    "MV": "Maldives",
    "NG": "Nigeria",
    "MX": "Mexico",
    "NO": "Norway",
    "PA": "Panama",
    "PE": "Peru",
    "PL": "Poland",
    "PT": "Portugal",
    "QA": "Qatar",
    "RO": "Romania",
    "RS": "Serbia",
    "SC": "Seychelles",
    "SA": "Saudi Arabia",
    "TN": "Tunisia",
    "TR": "Turkey",
    "VE": "Venezuela",
    "VG": "British Virgin Islands",
    "ZA": "South Africa",
    "AL": "Albania",
    "AO": "Angola",
    "AZ": "Azerbaijan",
    "BF": "Burkina Faso",
    "BH": "Bahrain",
    "BJ": "Benin",
    "BN": "Brunei",
    "BO": "Bolivia",
    "CM": "Cameroon",
    "CR": "Costa Rica",
    "CV": "Cape Verde",
    "CY": "Cyprus",
    "DJ": "Djibouti",
    "GA": "Gabon",
    "GD": "Grenada",
    "GE": "Georgia",
    "GM": "Gambia",
    "GN": "Guinea",
    "GQ": "Equatorial Guinea",
    "GT": "Guatemala",
    "GW": "Guinea-Bissau",
    "GY": "Guyana",
    "HN": "Honduras",
    "HR": "Croatia",
    "JM": "Jamaica",
    "KE": "Kenya",
    "KM": "Comoros",
    "KW": "Kuwait",
    "KY": "Cayman Islands",
    "LS": "Lesotho",
    "LV": "Latvia",
    "MD": "Moldova",
    "MG": "Madagascar",
    "ML": "Mali",
    "MR": "Mauritania",
    "MU": "Mauritius",
    "MW": "Malawi",
    "MZ": "Mozambique",
    "NA": "Namibia",
    "NE": "Niger",
    "NI": "Nicaragua",
    "OM": "Oman",
    "PG": "Papua New Guinea",
    "PS": "Palestine",
    "RW": "Rwanda",
    "SI": "Slovenia",
    "SK": "Slovakia",
    "SL": "Sierra Leone",
    "SN": "Senegal",
    "SR": "Suriname",
    "SV": "El Salvador",
    "SZ": "Eswatini",
    "TD": "Chad",
    "TG": "Togo",
    "TJ": "Tajikistan",
    "TM": "Turkmenistan",
    "TT": "Trinidad and Tobago",
    "TZ": "Tanzania",
    "UG": "Uganda",
    "UY": "Uruguay",
    "UZ": "Uzbekistan",
    "YE": "Yemen",
    "ZM": "Zambia",
    "ZW": "Zimbabwe",
    "AD": "Andorra",
    "AF": "Afghanistan",
    "AM": "Armenia",
    "BA": "Bosnia and Herzegovina",
    "BD": "Bangladesh",
    "BI": "Burundi",
    "BW": "Botswana",
    "CD": "DR Congo",
    "CF": "Central African Republic",
    "CG": "Republic of the Congo",
    "CI": "Cote d'Ivoire",
    "CW": "Curacao",
    "DO": "Dominican Republic",
    "CZ": "Czech Republic",
    "DZ": "Algeria",
    "EC": "Ecuador",
    "GH": "Ghana",
    "IQ": "Iraq",
    "KZ": "Kazakhstan",
    "LA": "Laos",
    "LB": "Lebanon",
    "LR": "Liberia",
    "LY": "Libya",
    "ME": "Montenegro",
    "MF": "Saint Martin",
    "MK": "North Macedonia",
    "MM": "Myanmar",
    "PK": "Pakistan",
    "PR": "Puerto Rico",
    "SO": "Somalia",
    "VC": "Saint Vincent and the Grenadines",
    "XK": "Kosovo",
    "NP": "Nepal",
    "MT": "Malta",
    "GB": "United Kingdom",
    "US": "United States",
    "CA": "Canada",
  },

  common: {
    and: "and",
    Success: "成功",
    Login: "Login",
    SignUp: "Sign Up",
    Recovery: "Recovery",
    "Start-Date": "Start Date",
    "End-Date": "End Date",
    "range-separator": "To",
    "change-lang-btn": "切换中文",
    "go-back": "Back",
    "back-home": "Back to Home",
    "guan-zhu-gong-zhong-hao": "Follow",
    "jia-zai-zhong": "Loading...",
    "Select-All": "Select All",
    "No-more": "No more",
    Authorize: "Authorize",
    "All-Status": "All Status",
    Confirm: "Confirm",
    Cancel: "Cancel",
    Home: "Home",
    Bot: "Bot",
    Insights: "Insights",
    Publish: "Publishing",
    Chat: "Chat",
    Docs: "Docs",
    Advisor: "Advisor",
    Templates: "Templates",
    Wiki: "Wiki",
    Team: "Team",
    Media: "Media",
    Tools: "Tools",
    Users: "Users",
    Text: "Text",
    Images: "Images",
    Emojis: "Emojis",
    Videos: "Videos",
    Links: "Links",
    "Facebook-desc":
      "Facebook is a global social media platform that connects users worldwide, offering personal networking, content sharing, and commercial advertising/promotion services.",
    "X-desc":
      "X (formerly Twitter) is a global social media platform where users can post short messages, images, videos, interact with others, and engage in topic discussions and content creation.",
    "TikTok-desc":
      "TikTok is a globally popular short-video creation and sharing platform. Users can create music, dance, comedy, educational content, and interact through likes, comments, and shares. The platform uses algorithms to recommend personalized content.",
    "Instagram-desc": "Instagram is a free social application by Meta for online photo and video sharing.",
    "YouTube-desc": "YoYouTube is the world's largest video sharing platform, where users can upload, watch, and share videos.",
    "VK-desc": "VK is a popular Russian social platform that integrates social networking, audio and video, payment and other functions, and has a large user base in the Russian-speaking region.",
    Access: "Access",
    Edit: "Edit",
    Delete: "Delete",
    Tips: "Tips",
    Upload: "Upload",
    Local: "Local",
    Helper: "Helper",
    Preview: "Preview",
    "AI-Assisted": "AI-Assisted",
    Options: "Options",
    Story: "Story",
    Posts: "Posts",
    Like: "Like",
    Comment: "Comment",
    Share: "Share",
    IamAIassistant: "I am an AI assistant～",
    alwaysaskquestions: "You can always ask me questions",
    Regenerate: "Regenerate",
    Insert: "Insert",
    Replace: "Replace",
    "Stop-generating": "Stop generating",
    "Please-enter-your-question": "Please enter your question",
    Record: "Record",

    SmartFeatures: "Smart Features",
    FriendlyLinks: "Friendly Links",
    aihub: "AIHub",
    ai2: "Love AI Tool Library",
    ai138: "AI Tool Network",
    toolsai: "AI Tool Navigation",
    aishenqi: "AI Artifacts Collection",
    ttdh: "Artificial Intelligence Tool Set",

    PrivacyPolicy: "Privacy Policy",
    TermsofUse: "Terms of Use",
    "Start-Date": "Start Date",
    "End-Date": "End Date",
    "Range-Separator": "To",
    "Next-Step": "Next step",
    Verified: "Verified",
    Unverified: "Unverified",
    Fans: "fans",
    Authorized: "Authorized",
    "Not-Authorized": "Not Authorized",
    "Grade-A": "High",
    "Grade-B": "Normal",
    "Grade-C": "Ignorable",
    English: "English",
    "Product-Preview": "Product Preview",
    "Product-Title": "Product Title",
    "View-Details": "View Details",
    "Scan-Follow": "Scan to follow JoinCompass Official Account",
    "Follow-Official": "Follow Official Account",
    "Video-Not-Supported": "Your browser does not support the video tag.",
    "Input-Language-Name": "Enter language name",
    "Bot-Name": "Bot Name",
    "Email-Address": "Email Address",
    Gender: "Gender",
    "Country-Region": "Country/Region",
    Language: "Language",
    Timezone: "Timezone",
    "Last-Chat-Time": "Last Chat Time",
    Unknown: "Unknown",
    Remark: "Remark",
    "Add-Remark": "Add Remark",
    "Remark-Placeholder": "Please enter 5~200 characters of remarks",
    "Resend-In-Seconds": "S",
    "Your-Colleague": "Your Colleague",
    "Contact-Advisor": "Contact Advisor",
    "Scan-To-Contact-Advisor": "Scan the QR code to contact the product advisor",
    "Wechat-Pay": "WeChat Pay",
    "Alipay-Pay": "Alipay",
    "Team-Balance": "Team Balance",
    "JoinCompass-Scene": "JoinCompass Scene",
    "AI-Assistant": "AI Assistant",
    Info: "Info",
    Scene: "Scene",
    "Payment-Success": "Payment successful",
    "Payment-Failed": "Payment failed",
    "Payment-Failed-Contact": "If you have already paid successfully, please contact the product advisor!",
    "Paying-Wait": "Paying, please wait...",
    "Confirm-Recharged": "Have you completed the recharge?",
    "Got-It": "Got it",
    Close: "Close",
    "Order-Not-Found": "Alipay order not found. Please start the payment again!",
    Notice: "Notice",
    "Enable-Auto-Renew": "Enable Auto-Renewal",
    "Not-Enable": "Not Now",
    "Auto-Renew-Success": "Auto-Renewal Enabled",
    "Go-View": "Go to View",
    "Qr-Expired": "QR code expired",
    "Scan-Wechat": "Please scan with WeChat",
    "Scan-Qr-Pay": "Scan the QR code to pay",
    "Complete-Pay-In": "Please complete the payment within {time}!",
    "Switch-Payment-Method": "Switch Payment Method",
    "Select-Template": "Select Template",
    "Cancel-Reply": "Cancel Reply",
    Translating: "Translating...",
    Uploading: "Uploading...",
    "Translate-Result": "Translation",
    "Translate-Reply": "Translate Reply",
    "Send-Translation": "Send Translation",
    "Only-One-Image": "Only one image can be sent",
    "Image-Max-4MB": "Image size cannot exceed 4MB!",
    "Image-Max-1MB": "Image cannot exceed 1MB",
    "Standalone-Site": "Standalone Site",
    Recommendable: "Recommendable",
    "Not-Recommendable": "Not Recommendable",
    "Recommend-Tip":
      "Used to control the usage permission of products in scenes. When a product is set as not recommendable, the products already in use in scenes will be automatically removed.",
    Currency: "Currency",
    "Price-Range": "Price Range",
    "Variant-Stock": "Variants & Stock",
    "Total-Variants": "{n} variants",
    Spec: "Spec",
    Price: "Price",
    Stock: "Stock",
    "In-Stock": "In Stock",
    "Out-Of-Stock": "Out of Stock",
    "Variants-In-Stock": "{n} variants in stock",
    Brand: "Brand",
    "Updated-At": "Updated At",
    "Product-Info": "Product Info",
    "Message-Preview": "Message Preview",
    "No-Preview": "No Preview",
    "No-Preview-Desc": "Select a template<br/>to preview the message effect here",
    America: "United States",
    "Please-Select": "Please select ",
    "Enter-Phone-Number": "Enter phone number",
    "Auto-Renew-Intro":
      "<p>Thank you for your purchase! You can also enable auto-renewal, and the system will automatically renew your bot on the 1st of each month, ensuring you continue to enjoy uninterrupted bot service.</p><p style=\"color: #E90000\">The auto-renewal amount will be deducted from the team balance</p>",
    "Auto-Renew-From-Balance": "The auto-renewal amount comes from the team balance",
    "Auto-Renew-Desc":
      "The system will automatically deduct the payment on the 1st of each month based on your bot's current package. Please make sure your team balance is sufficient to ensure smooth auto-renewal.<br />If you wish to disable auto-renewal, you can do so in \"Team Package -> Next Month Package Settings\".",
    "Content-Generating": "Content is being generated...",
    "Replace-Selected": "Replace selected content",
    "Insert-Next-Line": "Insert into next line",
    Insert: "Insert",
    "Ask-AI-Here": "Ask AI here",
    "Template-Output": "Will output with the \"{name}\" template, please enter your question...",
    "History-Instructions": "History Instructions",
    "More-Instructions": "More Instructions",
    Saving: "Saving...",
    "Saved-Success": "Saved successfully!",
    "Article-Title-Placeholder": "Please enter the article title",
    "Space-AI-Placeholder": "Press space to invoke AI tools...",
    Bold: "Bold",
    Settings: "Settings",
    Invite: "Invite",
    "No-Team": "No Team Yet",
    "Main-Nav": "Main Navigation",
    "Qrcode-Load-Failed": "QR code failed to load",
    "Qrcode-Expired": "QR code expired",
    Refresh: "Refresh",
    "Fix-Nav": "Pin Navigation",
    "Unfix-Nav": "Unpin Navigation",
    AdAccounts: "Ad Accounts",
    PageAuth: "Page Auth",
    AccountAuth: "Account Auth",
    ShopAuth: "Shop Auth",
    "No-Data": "No Data",
    Closed: "Closed",
    Opened: "Opened",
  },
  gender: {
    "Select-Platform": "Select the platform where you want to post:",
    "Cannot-Be-Empty": "{label} cannot be empty",
    "Select-Language": "Select the output language",
    "AI-Model": "AI Model",
    "Output-Language": "Output Language",
    "Start-Generate": "Start Generating",
    Generating: "Generating...",
    Back: "Back",
    "Stop-Generate": "Stop Generating",
    "Insert-Doc": "Insert Document",
    Example: "Example",
  },
  Login: {
    Account: "Account",
    SignIn: "Sign in",
    SMS: "SMS",
    passwordInvalid: "The password must be at least 6 characters long and must include at least one uppercase letter, one lowercase letter, and one number.",
    passwordRequired: "Enter login password",
    "invites-you-to-join-the": "invites you to join the",
    Passwordmismatch: "Password mismatch",
    Pleaseenteryourpasswordagain: "Enter password again",
    Verificationcodehasbeensent: "Verification code has been sent",
    createdLogin: "Your account has been created. Please log in.",
    accountChanged: "Account password changed successfully. Do you want to log in?",

    accountLogin: "Account Login",
    SMSLogin: "SMS login",
    phoneRegist: "Phone",
    emailRegist: "Email",
    phoneRecover: "Phone",
    emailRecover: "Email",

    existingAccount: "Existing account? ",
    Logonafterverification: "Verify & log in; unregistered? JoinCompass account auto-created.",
    Pleaseenteryourloginaccount: "Enter your login account/mobile phone/email address",
    Enterthepassword: "Enter the password",
    Enteryourphonenumber: "Enter phone number",
    EnterSMSverificationcode: "Enter SMS verification code",

    Obtainverificationcode: "Get verification code",
    Enteremailaddress: "Enter email address",
    EnterVerificationCode: "Enter verification code",
    Enteryourloginaccount: "Enter your login account",
    verificationCode: "verification code",
    PasswordRecovery: "Password Recovery",
    ByclickingRegister: "Click Log in to agree to the ",

    UserAgreement: "User Agreement",
    PrivacyPolicy: "Privacy Policy",
    Resetpassword: "Reset password",

    TheyreonJoinCompass: "They're on JoinCompass",
    Seewhattheyhavetosay: "What they have to say",
    
    case1name: "Customer-service Team Lead, Shenzhen Jing** Co.",
    case1content: "Ever since we started using JoinCompass, my job feels like it’s on turbo-charge. It turns the headache of cross-platform communication and customer service into child’s play. Auto-replies and bad-review management free up my time for strategic planning—efficiency and customer-satisfaction just hit the next level.",
    case2name: "Customer-service Team Lead, Beijing Shan** Co.",
    case2content: "JoinCompass is pure gold for us. Its contextual replies make every customer feel valued, and the bad-review hiding keeps our brand image spotless. Now we can focus on lifting service quality instead of fire-fighting.",
    case3name: "Customer Relationship Manager, Guangzhou Wei** Co.",
    case3content: "CRM is my daily grind, but JoinCompass makes it a breeze. It auto-handles nasty reviews so I can spend my hours where I excel—building and nurturing real customer relationships.",
    case4name: "CEO, Shenzhen Wei** Start-up",
    case4content: "As a start-up CEO I keep things practical: JoinCompass saves us heaps of CS and marketing hassle without breaking the bank. Bottom line—our team stays laser-focused on core business. Thumbs-up.",
    case5name: "Senior CS Rep, Guangzhou Li** Co.",
    case5content: "Customer service tests your patience; JoinCompass is my lifesaver. Auto-replies and review management lighten the daily load, letting me give extra time to customers who truly need help.",
    case6name: "Operations Manager, Chengdu Hong** Co.",
    case6content: "Operations is a thousand-piece puzzle; JoinCompass is a handy piece. Shopify integration plus auto-reply keeps order processing and customer communication silky smooth—higher efficiency, lower team stress.",
    case7name: "Chief Executive Officer",
    case7content: "I’m results-driven. JoinCompass boosts our CS efficiency and actively protects brand image. That’s tangible value.",
    case8name: "Senior Customer Service Representative",
    case8content: "Honestly, JoinCompass makes my day easier. Customers ask left and right; it fires back accurate answers instantly. Problems solved on the spot—satisfaction sky-rockets!",
    case9name: "Senior CS Representative",
    case9content: "Customer asks about parcel status—JoinCompass pulls the Shopify data and replies before I lift a finger. Speed like that gets us praised for lightning-fast response.",
    case10name: "Market Analyst",
    case10content: "Data geek here—JoinCompass’s real-time analytics turn boring numbers into actionable insights. Spot a problem? JoinCompass crushes it instantly. Love that speed!",
  },
  Head: {
    "add-new-team": "Create Team",
    "personal-center": "Personal Center",
    "tui-chu-deng-lu": "Log Out",
    "scan-qrcode-follow-joinmc": "Scan the QR code below to follow JoinCompass",
    "expires-on": "Expires on",
    "Refresh-QR-Code": "Refresh",
    "help-doc": "Help Center",
    "developer-doc": "Developer Center",
    "bot-suffix": "Bot",
    "go-back-up": "Back",
    "become-super-admin-title": "Become Super Admin",
    "become-super-admin-msg": "You have become the super admin of the \"{name}\" team!",
    "confirm": "OK",
    "go-check": "Go Check",
    "got-it": "Got It",
    "fb-auth-expired-title": "Facebook Page Authorization Expired",
    "fb-auth-expired-msg":
      "Your {num} Facebook page authorizations have expired, causing the related bots to no longer provide services. Please re-authorize as soon as possible to ensure normal service.",
    "email-auth-expired-title": "Email Authorization Expired",
    "email-auth-expired-msg":
      "Your {num} email authorizations have expired, causing the related bots to no longer provide services. Please re-authorize as soon as possible to ensure normal service.",
    "notice": "Notice",
    "create-new-team": "Create New Team",
    "confirm-logout": "Are you sure you want to log out?",
    "cancel": "Cancel",
  },
  dashboard: {
    Hot: "Recommend",
    "smart-bot-desc":
      "Smart bots provide intelligent response and efficient customer support for Facebook, Messenger,Instagram and E-mail.",
    "public-opinion-monitoring-desc": "Real-time monitoring and analysis of public opinion.",
    "content-publishing-desc": "Easily publish your quality content to major global social media platforms.",
    "conversations-desc": "Conversations use NLA processing to interact with users via AI.",
    "document-writing-desc": "Use AI to automatically generate high-quality original content.",
    "Advisor-desc": "Expert-led guidance tailored to industry needs.",
    "Templates-desc": "Build writing templates for teams and advisors.",
    "Wiki-desc": "Central hub for team content and resources.",
    "Team-desc": "Manage members and view billing info.",
    "Media-desc": " Unified control of media platforms.",
    "Tools-desc": "Tools and strategies for promotion.",
    "Users-desc": "Track user interactions with AI assistants.",
    "Access-Title": "Important Notice",
    "Access-Online-Notice": "JoinCompass Smart Customer Service Launch Notice:",
    "Access-Online-Content":
      "The JoinCompass AI customer service product will officially launch on <span class=\"danger-color-text\">Nov 21</span>! The testing customer experience qualification will end on <span class=\"danger-color-text\">Nov 30</span>; starting from <span class=\"danger-color-text\">Dec 1</span>, the product will officially start charging.",
    "Access-Online-Footer":
      "For details, please consult the product operations staff. We sincerely thank you for your strong support and help during the product testing phase!!!",
    "JoinCompass-Assistant": "JoinCompass Assistant",
    "Welcome-Guide":
      "Welcome to JoinCompass! To help you get started quickly and use platform features efficiently, we have prepared a brief feature guide for you.",
    "Welcome-Guide-2": "In just a few steps, you can get an initial understanding of JoinCompass features. Let's get started!",
    "Skip-Guide": "Skip Guide",
    Next: "Next",
    Prev: "Previous",
    "Driver-Step1-Desc":
      "Welcome to the core functional area of JoinCompass! Each icon represents a unique functional module to help you handle various tasks with ease.",
    "Driver-Step2-Desc": "Here, you can switch teams at any time or quickly create a new team.",
    "Driver-Step3-Desc":
      "Follow our official account to receive early warning alerts from the system in a timely manner, ensuring you stay on top of important updates and respond to critical needs promptly!",
    "Driver-Step4-Desc":
      "This is the quick switch entry for functions. One-click switch makes functional switching effortless. No matter which page you are on, you can switch to the functions you need anytime to improve operational efficiency!",
    "Driver-Step5-Desc": "Here, you can easily manage your personal profile or log out of the system.",
    "Package-Expired-Title": "Package Expired",
    "Package-Expired-Content":
      "Your package has expired and your bot has stopped providing services. Please renew it before continuing to use it!",
    "Go-Renew": "Renew Now",
    "Package-Expired-Dialog-Title": "Package Expired",
    "Package-Expired-Dialog-Content": "Your current package has expired and related benefits are suspended. You can renew it or choose another package to continue.",
    "Package-Expired-Dialog-Subscribe": "Subscribe Package",
    "Package-Locked-Dialog-Title": "Authorized Account Frozen",
    "Package-Locked-Dialog-Content": "Please contact your dedicated customer service for assistance.",
    "Package-Locked-Dialog-Confirm": "Got It",
    "Package-Limit-Dialog-Title": "Account Limit Reached",
    "Package-Limit-Dialog-Content": "The number of accounts has reached your package limit. Upgrade your package or purchase an add-on pack to continue.",
    "Package-Limit-Dialog-Subscribe": "Upgrade Package",
    "Package-Limit-Dialog-Expansion": "Add-on Pack",
    "Team-Balance-Not-Enough": "Insufficient Team Balance",
    "Team-Balance-Content":
      "Your team package expires on {date}. Your current team balance is short by ¥{amount}. To ensure normal bot services, please recharge as soon as possible.",
    "Go-Recharge": "Recharge Now",
    // Copy for the in-app notification cards.
    "Site-Notification-WhatsApp-Title": "WhatsApp New Conversation",
    "Site-Notification-WhatsApp-Content": "You have {count} new customer inquiries. Please handle them as soon as possible.",
    "Site-Notification-View": "View",
    "Site-Notification-Package-Title": "Package Expiring Soon",
    // Copy for the balance-insufficient dialog opened by a WhatsApp WebSocket response.
    "WhatsApp-Balance-Insufficient-Title": "Insufficient Team Balance",
    "WhatsApp-Balance-Insufficient-Content": "Your team balance is insufficient to continue sending messages. Please recharge your team balance before trying again.",
    "WhatsApp-Estimated-Send-Cost": "Estimated Cost for This Send",
    "Auto-Renew-Upcoming": "Auto-Renewal Upcoming",
    "Auto-Renew-Content":
      "<p>Your bot package will expire on {date1}. According to the auto-renewal rules, the system will renew it on {date2} for ¥{amount}. Please make sure your team account balance is sufficient.</p><br /><p>If you do not want to auto-renew, please go to \"Team Management\" > \"Team Package\" > \"Next Month Package\" module before {date2} to turn off auto-renewal.</p>",
    Understood: "Understood",
  },
  Publish: {
    "Post-Publishing": "Post Publish",
    "Target-Home-Page": "Target Home Page",
    "Publishing-List": "List",
    "Publishing-Calendar": "Publishing Calendar",
    "Please-enter-the-content-to-be-published": "Please enter the content to be published",
    Publish: "Publish",
    "Select-Publishing-Homepages": "Select Publishing Homepages",
    FilterByLabel: "Filter by Label",
    More: "More",
    Republish: "Republish",
    "Status-Pending": "Pending",
    "Status-Publishing": "Publishing",
    "Status-Success": "Published",
    "Status-Failed": "Failed",
    "Status-Cancelled": "Cancelled",
    "Status-Deleted": "Deleted",
    "Joined-Queue": "Added to the publishing queue",
    "Stopped-Publishing": "Publishing stopped",
    "Social-Account": "Social Account",
    "Operation-Record": "Post Operation Record",
    "Operation-Time": "Operation Time",
    "Operation-Description": "Operation Description",
    Operator: "Operator",
    "p-e-t-h-n-y-w-t-s": "Please enter the homepage name",
    "homepages-selected": "{count} homepages selected",
    "Authorize-New-Homepage": "Authorize New Homepage",
    "had-selected": "This homepage is already added",
    "Select-Page-to-Publish": "Select Page to Publish",
    "Add-new-public-page": "Add Public Pages",
    "Supported-platforms": "Supported platforms：",
    "p-e-t-h-n-h-a-m-l-a": "Please enter the homepage name, homepage address, media login account",
    "All-Media-Platforms": "All Platforms",
    "All-Publisher": "All Publishers",
    "p-e-p-c-o-t-n": "Please enter post content or task number",
    "Release-time": "Release time:",
    "Task-Number": "Task Number:",
    "Create-a-Post": "Create a Post",
    "No-posts-published": "No Posts Published",
    "ins-no-text-only": "Instagram does not support posting text content alone!",
    "tiktok-empty-content-warning": "TikTok post content and media cannot both be empty!",
    "empty-content-warning": "Due to platform limitations, please enter your post content!",
    Settings: "Settings",
    "Allow-Comments": "Allow Comments",
    "Allow-Co-production": "Allow Co-production",
    "Allow-Splicing": "Allow Splicing",
    "Privacy-Settings": "Privacy Settings",
    "Add-media-page-to-create-a-post": "Add a media page to create a post.",
    "Add-Pages": "Add Pages",
    "Click-uploader-btn-alert":
      "{old_type} and {new_type} cannot exist at the same time. When uploading other types of materials, {old_type} will be automatically removed.To avoid abnormal content display, please confirm in advance whether you need to switch!",
    "Platform-limit-number":
      "Due to the limitations of the {platform} platform, release {postType} can only have a maximum of {maxAllowed} {type} added to it at a time",
    "Image-Upload-Tip": "Upload up to 10 photos at a time, support JPG, JPEG, PNG, GIF format, size ≤ 10M",
    "Video-Upload-Tip": "Upload a video with a size under 1GB",
    "Social-Media-Posting-Rules": "Social Media Posting Rules",
    "Please-stay-tuned": "The function is not yet open, please stay tuned",
    "Maximum-characters": "Maximum characters",
    "Material-Editing": "Material Editing",
    "p-u-m-p-c-b-u": "{length} photos uploaded, {number} more photos can be uploaded",
    "Video-Title": "Video Title",
    "c-v-t-a-o-s-o": "Custom video title",
    // "c-v-t-a-o-s-o": "Custom video titles are only supported on Facebook, LinkedIn, VKontakte",
    "Add-title-to-your-video": "Add a title to your video",
    "Set-video-cover": "Set video cover",
    "Add-pictures-or-videos": "Add pictures or videos",
    "Content-Name": "Content Name",
    "Support-Notes": "Support Notes",
    "p-does-not-support-image-posts": "{platform} does not support image posts",
    "p-does-not-support-links": "{platform} does not support links",
    Notice: "Notice",
    "Validation-Warnings": "Warnings ({count})",
    "X-image-ratio-warning":
      "X: A 16:9 or 1:1 image ratio is recommended. Please crop or adjust the image ratio for its display context. A suitable ratio keeps the composition focused and orderly, improving the overall visual presentation.",
    "c-c-n-p": "The following are errors that do not comply with the posting requirements of the platform. You must resolve these issues before you can publish. ",
    "Delete-the-non-compliant-homepage": "Delete the non-compliant homepage",
    "When-publishing-postType": `When publishing {postType}`,
    "Size-does-not-match": "Size does not match",
    "Aspect-ratio-does-not-match": "Aspect ratio does not match",
    "video-cover-setting-description": `The default cover image of the video`,
    // "video-cover-setting-description": `The content types that support custom uploaded images as video cover images include: Facebook posts, Facebook Reels, Instagram Reels, LinkedIn posts, and VKontakte posts; \nThe content types that support using slice images in the video as video cover images include: Facebook posts, Facebook Reels, Instagram Reels, LinkedIn posts, TikTok videos, and VKontakte posts`,
    "Post-Preview": "Post Preview",
    "youtube-only-videos": "YouTube only supports video posts, please upload a video",
    "youtube-video-title": "YouTube video title cannot be empty",
    // Missing scheduled-publish fields use the form red error state instead of a blocking dialog.
    "Schedule-Timezone-Required": "Please select a publishing timezone",
    "Schedule-Date-Required": "Please select a publishing date",
    "Schedule-Time-Required": "Please select a publishing time",
    // Draft list text is kept in Publish so the whole publishing module follows the same i18n namespace.
    "Publishing-Draft": "Drafts",
    "No-Permission": "No permission to publish content",
    "Video-Cover": "Video Cover",
    "Select-From-Video": "Select from video",
    "Drag-Slider-Tip": "Drag the slider to select a frame from the video as the cover",
    "Custom-Upload": "Custom upload",
    "Upload-5M-Tip": "Please upload an image within 5M as the cover",
    "Click-Upload": "Click to upload",
    "Second-Format": "{val}s",
    "Post-Data": "Post Data",
    "No-Data-Support": "This platform does not support viewing data yet",
    "Mark-Publisher": "Mark Publisher",
    "Current-Publisher": "Current Publisher: ",
    "Replace-Publisher": "Replace Publisher: ",
    "Select-Publisher": "Please select a publisher",
    "No-Publisher": "No available publisher",
    "Publisher": "Publisher",
    "Expand": "Expand",
    "Collapse": "Collapse",
    "Translate": "Translate",
    "Translating": "Translating...",
    "Collapse-Translation": "Collapse Translation",
    "No-Translation": "No translation available",
    "Translate-Failed": "Translation failed, please try again later",
    "Translate-Language": "Chinese",
    "Published-Via": "Published via {platform}",
    "More": "More",
    "Operation-Record": "Post Operation Records",
    "Operation-Time": "Operation Time",
    "Operation-Description": "Operation Description",
    "Operator": "Operator",
    "View-On-Platform": "View on {platform}",
    "Republish": "Republish",
    "Edit-Original": "Edit Original",
    "Delete": "Delete",
    "View-Data": "View Data",
    "Copy-Post-Link": "Copy Post Link",
    "Copy-Post-ID": "Copy Post ID",
    "Operation-Record-Menu": "Operation Record",
    "Edit": "Edit",
    "Cancel-Publish": "Cancel Publish",
    "PublishNow": "Publish Now",
    "Tooltip-Republish-Only-JoinCompass": "Only posts published via JoinCompass support this operation",
    "Tooltip-Not-Support-JoinCompass": "Posts published via JoinCompass do not support this operation",
    "Tooltip-Facebook-Only": "Only posts published via Facebook can be marked",
    "Tooltip-Edit-Only-JoinCompass": "Only posts published on JoinCompass can be edited",
    "Tooltip-JoinCompass-Only": "Only posts published via JoinCompass are supported",
    "Tooltip-Edit-Time-Limit": "Editing is disabled within 10 minutes before the publish time",
    "Member-Format": "Member {id}",
    "No-Copy-Content": "Nothing to copy",
    "Copy-Failed": "Copy failed, please try again later",
    "Operation-Failed": "Operation failed, please try again later",
    "Post-Link-Copied": "Post link copied",
    "Post-ID-Copied": "Post ID copied",
    "Feature-Placeholder": "This feature entry is displayed and can be wired up later",
    "Publish-Now-Confirm": "Are you sure you want to publish the post immediately before its scheduled time?",
    "Operation-Confirm-Title": "Operation Confirmation",
    "Cancel-Publish-Confirm": "After canceling the publish, this task will stop executing. Continue?",
    "Republish-Deleted-Confirm": "Do you want to republish the deleted content to {platform}? The new content will be published as a separate post and will not affect the deleted original post.",
    "Republish-Confirm": "Do you want to publish the content to {platform}?",
    "Join-Publish-Queue": "Added to publish queue",
    "Stop-Publish": "Stop publishing",
    "Operation-Success": "Operation successful",
    "Open-Republish-Failed": "Failed to open the republish page, please try again later",
    "Delete-Confirm-Not-Publish": "After deletion, the post can no longer be published to media platforms.",
    "Delete-Confirm-Sync": "Deleting the post here will also delete it from the media platform.",
    "Deleted": "Deleted",
    "Delete-Failed": "Delete failed, please try again later",
    "No-Accessible-Post-Link": "No accessible post link available",
    "Delete-Platform-Post-Confirm": "The system is about to delete your post on {platform}. Once deleted, the post cannot be recovered. Please confirm and proceed with caution.",
    "Delete-Task-Confirm": "After the task is deleted, the content will be permanently deleted and cannot be recovered. Please confirm and proceed with caution.",
    "Delete-Forbidden-Title": "Deletion Forbidden",
    "Delete-Blocked-Task": "This link has a guide comment task and cannot be deleted!",
    "Delete-Link-Confirm": "The link cannot be restored after deletion. Are you sure you want to delete it?",
    "Delete-Success": "Deleted successfully",
    "Validation-Errors": "Errors ({count})",
    "Detail-Missing-Page": "Detail data is missing homepage information and cannot be backfilled into the editor",
    "Detail-Fetch-Failed": "Failed to fetch details",
    "Store-Title": "Content Publishing",
    "List-Title": "Publish List",
    "Calendar-Title": "Publish Calendar",
    "Draft-Title": "Publish Drafts",
    "Free-Ratio": "Free",
    "Image-Edit": "Image Editing",
    "View-Day": "Day",
    "View-Week": "Week",
    "View-Month": "Month",
    "Uploading": "Uploading...",
    "Subscribers-Format": "{count} subscribers",
    "Subscribers": "{count} subscribers",
    MemberCount: "{count} members",
    "Now": "Now",
    "Impressions-Format": "{count} impressions",
    "View-Data-Analysis": "View Data Analysis",
    "Unknown-Platform": "Unknown Platform",
    "Favorite": "Save",
    "Get-Publisher-List-Failed": "Failed to get publisher list, please try again later",
    "Mark-Publisher-Success": "Publisher marked successfully",
    "Mark-Publisher-Failed": "Failed to mark publisher, please try again later",
    "Tag-Delete-Success": "Tag deleted successfully",
    "Tag-Delete-Failed": "Tag delete failed, please try again later",
    "Please-Upload-First": "Please upload {name} first",
    "Size-Exceed-MB": "The size cannot exceed {size}MB!",
    "Today-Badge": "Today",
    "Marketing-Events": "Marketing Events",
    "No-Marketing-Events": "No marketing events",
    "Posts-Label": "Posts",
    "No-Post-Data": "No post data",
    "Year-Format": "{year}",
    "Month-Format": "{month}",
    "Year-Month-Format": "{year}-{month}",
    "Marketing-Settings-Title": "Marketing Events Settings",
    "Regional-Festival": "Regional Holidays",
    "Search-Country-Region": "Search country/region",
    "No-Festival-Data": "No festival data",
    "Selected-Festivals": "Selected festivals ({count})",
    "Clear": "Clear",
    "No-Selected-Festivals": "No selected festivals",
    "Submitting": "Submitting...",
    "Select-At-Least-One-Festival": "Please select at least one festival",
    "Country-Religion-Not-Empty": "Country and religion cannot both be empty",
    "Marketing-Settings-Success": "Marketing events settings saved successfully",
    "Marketing-Settings-Failed": "Failed to save marketing events settings",
    "Post-Detail-Title": "Post Details",
    "Add-Tag": "Add Tag",
    "Unselected-Tag-Area": "Unselected tag area",
    "New-Tag": "New Tag",
    "Selected-Tags": "Selected tags",
    "No-Selected-Tag": "No selected tags",
    "Tag-Classify": "Tag category: ",
    "Select-Tag-Classify": "Please select a tag category",
    "New-Classify": "New Category",
    "Tag-Name": "Tag name: ",
    "Input-Tag-Names": "Enter tag names, press Enter for multiple",
    "New-Tag-Classify": "New Tag Category",
    "Input-Tag-Classify": "Enter a tag category",
    "Unnamed-Tag": "Unnamed Tag",
    "Unnamed-Classify": "Unnamed Category",
    "Select-Tag": "Please select a tag",
    "Tag-Add-Success": "Tag added successfully",
    "Tag-Add-Failed": "Failed to add tag, please try again later",
    "Classify-Create-Success": "Category created successfully",
    "Classify-Create-Failed": "Failed to create category, please try again later",
    "Tag-Content-Not-Empty": "Tag content cannot be empty",
    "Tag-Create-Success": "Tag created successfully",
    "Tag-Create-Failed": "Failed to create tag, please try again later",
    "Tag-Max-20": "A single tag supports up to 20 characters",
    "Tag-Only-Charset": "Only numbers, letters, and Chinese characters are supported",
    "Week-Holiday": "Holiday",
    "Week-Memorial": "Memorial Day",
    "Week-Festival-Or-Memorial": "Festival or Memorial Day",
    "Week-Religious": "Religious Holiday",
    "Date-Full-Format": "{month}-{day} | {week}",
    "Header-Date-Format": "{year}-{month}-{day}",
    "Week-Sun": "Sun",
    "Week-Mon": "Mon",
    "Week-Tue": "Tue",
    "Week-Wed": "Wed",
    "Week-Thu": "Thu",
    "Week-Fri": "Fri",
    "Week-Sat": "Sat",
    "Week-Name-Format": "{week}",
    "Month-Day-Format": "{month}-{day}",
    "AI-Create-Publish": "AI Create & Publish",
    "Google-Search-Link": "Google Search Links",
    "X-Search-Link": "X Search Links",
    "Facebook-Search-Link": "Facebook Search Links",
    "More-Events": "+{num} events",
    "Festival-Date-Format": "{year}-{month}-{day} ({week})",
    Unnamed: "Unnamed",
    "Platform-Label": "Platform",
    "Type-Text": "Text",
    "Type-Image": "Image",
    "Type-Image-Text": "Image + Text",
    "Type-Video": "Video",
    "Type-Video-Text": "Video + Text",
    "Type-Link": "Link",
    "Type-Video-Snap": "Video Snap",
    "Type-Image-Snap": "Image Snap",
    "Type-Unknown": "Unknown",
    "Date-Range-Format": "{start} - {end}",
    "All-Draft-Creators": "All Creators",
    "Draft-Search-Placeholder": "Please enter post content",
    "Draft-Attachment": "Draft attachment",
    "Image-Draft-Content": "Image post draft",
    "Video-Draft-Content": "Video post draft",
    "Link-Draft-Content": "Link post draft",
    "Link-Draft-Domain": "Link",
    "Image-Count-Suffix": "{count} images",
    "View-Translation": "View translation",
    "Hide-Translation": "Hide translation",
    Translating: "Translating...",
    "Creator-Label": "Creator: ",
    "Created-At-Label": "Created at: ",
    "Social-Account-Label": "Social account: ",
    "No-Drafts": "No drafts",
    "Draft-List-Failed": "Failed to load drafts",
    "No-Translation": "No translation",
    "Translation-Failed": "Translation failed. Please try again later",
    "Draft-Missing-Task-Num": "The draft task number is missing and cannot be deleted",
    "Draft-Delete-Confirm": "After deletion, this content will be permanently removed from the system and cannot be restored. Confirm whether to continue?",
    "Draft-Delete-Success": "Deleted successfully",
    "Draft-Delete-Failed": "Failed to delete",
    "Save-As-Draft": "Save as draft",
    "Saving-Draft": "Saving draft...",
    "Draft-Detail-Failed": "Failed to load draft details",
    "Draft-Missing-Pages": "The draft has no target pages and cannot be restored in the editor",
    "Media-Page": "Media page",
    DocImport: "Import Document",
    SelectDoc: "Select Document",
    PublishAs: "Publish material as:",
    DocFormatTip: "Supports .docx/.doc/.pdf/.txt formats, up to 15MB",
    DocSizeLimit: "Document size cannot exceed {size}MB!",
    "local-upload": "Local Upload",
    "local-upload-image-desc": "Choose images from your computer",
    "local-upload-video-desc": "Choose videos from your computer",
    "local-upload-doc-desc": "Choose documents from your computer",
    "library-select": "Select from Library",
    "library-select-desc": "JoinSpark platform library",
    "joinspark-auth-title": "Authorization required for JoinSpark AI Creative Platform",
    "joinspark-auth-desc": "After authorization, your library and AI creation history sync automatically across platforms, so all your creative assets are ready to use.",
    "joinspark-auth-confirm": "Authorize",
    Fleets: "Fleets",
    PublishNow: "Publish Now",
    SchedulePublish: "Schedule Publish",
    // YouTube publish settings
    Playlist: "Playlist:",
    "Select-Playlist": "Select a playlist",
    "New-Playlist": "Create New Playlist",
    "Made-For-Kids-Label": "Audience: Is this content made for kids?",
    "Made-For-Kids-Yes": "Yes, it's made for kids",
    "Made-For-Kids-No": "No, it's not made for kids",
    "Select-Made-For-Kids": "Please select whether the content is made for kids",
    "Synthetic-Media-Label": "Altered content: Does your content match any of the following descriptions?",
    "Synthetic-Media-Desc-1": "Depicts real people saying or doing things they didn't actually say or do",
    "Synthetic-Media-Desc-2": "Alters footage of real events or places",
    "Synthetic-Media-Desc-3": "Generates realistic scenes that didn't actually happen",
    Yes: "Yes",
    No: "No",
    Language: "Language:",
    "Select-Video-Language": "Select video language",
    "Select-Default-Language": "Select default language",
    "Recording-Date": "Recording date:",
    "Select-Recording-Date": "Select the recording date of the video",
    License: "License",
    "Allow-Embedding": "Allow embedding",
    Category: "Category:",
    "Select-Category": "Select category",
    Visibility: "Visibility:",
    "Select-Visibility": "Set the visibility of the video",
    "Playlist-Title": "Title",
    "Playlist-Description": "Description",
    // YouTube video metadata stays separate from the fields used to create a playlist.
    "Video-Description": "Description",
    "Enter-Video-Title": "Add a title that describes your video (type @ to mention a channel)",
    "Enter-Video-Description": "Introduce your video to viewers (type @ to mention a channel)",
    "Please-Enter-Title": "Please enter the title",
    "Please-Enter-Playlist-Title": "Please enter the playlist title",
    "Please-Enter-Playlist-Description": "Please enter the playlist description",
    Public: "Public",
    Private: "Private",
    Unlisted: "Unlisted",
    "Please-Enter-Video-Title": "Please enter the video title",
    "System-Error": "System Error",
    "Post-To-Channel": "Post to channel",
    "Post-To-Page": "Post to page",
  },
  SocialListening: {
    SocialMedia: "Social Media",
    HomepageManagement: "Page Management",
    DataSummary: "Data Summary",
    InteractionTasks: "Interaction Tasks",
    DataStatistics: "Data Statistics",
    MonitorList: "Monitor List",
    SocialListening: "Listening",
    ListeningTasks: "Listening Tasks",
    ListeningComparison: "Listening Comparison",
    AudienceTasks: "Audience Tasks",
    NewTopic: "New Topic",
    EditTopic: "Edit Topic",
    PleaseEnterTopicName: "Please enter topic name",
    PleaseEnterTopicNameShort: "Please enter topic name",
    Add: "Add",
    // Listening comparison actions use the SocialListening namespace, so keep these keys defined for tooltips.
    Edit: "Edit",
    Delete: "Delete",
    Topic: "Topic",
    Creator: "Creator",
    CreatedAt: "Created At",
    Actions: "Actions",
    NoData: "No data",
    Data: "Data",
    KeywordSettings: "Mention Keyword Settings",
    "Keyword-Quota-Fetch-Failed": "Failed to get keyword quota, please try again later",
    TopicNameLabel: "Topic Name:",
    PleaseEnterTaskName: "Please enter task name",
    MediaPlatformLabel: "Media Platform:",
    IncludeKeywordsLabel: "Included Keywords:",
    KeywordInputPlaceholder: "Enter a keyword and press Enter to add the next one. Up to 5 keywords.",
    TargetCountryLabel: "Target Country:",
    TargetCountryPlaceholder: "Limit content or authors to specific countries",
    TargetLanguageLabel: "Target Language:",
    TargetLanguagePlaceholder: "Limit content or authors to specific languages",
    DeleteConfirmMessage: "The social listening topic task cannot be restored after deletion. Confirm deletion?",
    OperationConfirm: "Operation Confirmation",
    ConfirmDelete: "Delete",
    Executing: "Processing...",
    SelectAtLeastOnePlatform: "Please select at least one media platform",
    PleaseEnterKeyword: "Please enter a keyword",
    MaxFiveKeywords: "You can add up to 5 keywords",
    KeywordCannotRepeat: "Keywords cannot be duplicated",
    KeywordExists: "This keyword already exists. Please enter another keyword.",
    FacebookSupport: "Supports posts, shares, and comments",
    InstagramSupport: "Supports posts, Reels, and comments",
    YouTubeSupport: "Supports videos, Shorts, and comments",
    LinkedInSupport: "Supports posts, reposts, and comments",
    Sentiment: "Sentiment",
    TopicDetail: "{topic} Details",
    BasicInfo: "Basic Info",
    TopicName: "Topic Name",
    MonitoringPlatform: "Monitoring Platform",
    IncludedKeywords: "Included Keywords",
    TargetCountry: "Target Country",
    TargetLanguage: "Target Language",
    AllMediaPlatforms: "All Media Platforms",
    AllLanguages: "All Languages",
    AllCountries: "All Countries",
    StartTime: "Start Time",
    EndTime: "End Time",
    Overview: "Overview",
    Content: "Content",
    Author: "Author",
    Dialogue: "Dialogue",
    KeyMetrics: "Key Metrics",
    SearchKeywordPlaceholder: "Enter keywords to search. Use Enter to separate multiple keywords.",
    TotalMonitoredContent: "Total Monitored Content",
    TotalMonitoredContentDesc: "Total number of captured posts",
    PositiveContent: "Positive Content",
    PositiveContentDesc: "Number of posts whose overall sentiment is positive",
    NegativeContent: "Negative Content",
    NegativeContentDesc: "Number of posts whose overall sentiment is negative",
    NeutralContent: "Neutral Content",
    NeutralContentDesc: "Number of posts whose overall sentiment is neutral",
    UnknownUser: "Unknown User",
    Positive: "Positive",
    Negative: "Negative",
    Neutral: "Neutral",
    NoPostData: "No post data",
    NoRelatedPosts: "No related posts found under the current filters",
    CreatedAtWithColon: "Created at: ",
    SerialNumberWithColon: "ID: ",
    ImageLoadFailed: "Image failed to load",
    VideoLoadFailed: "Video failed to load",
    LikeCount: "Likes",
    ShareCount: "Shares",
    CommentCount: "Comments",
    AIAnalysisSummary: "AI Analysis Summary",
    AIAnalysisSummaryTip: "Intelligent analysis summary based on current monitoring data",
    OperationSuggestions: "Operation Suggestions",
    MentionTrend: "Mention Trend",
    MentionTrendTip: "Changes in mention trends within the selected time range",
    PlatformMentionVolume: "Mention Volume by Platform",
    PlatformMentionVolumeTip: "Mention volume trend across different media platforms",
    MentionEmotionRatio: "Mention Sentiment Ratio",
    MentionEmotionRatioTip: "Percentage of positive, negative, and neutral mentions among all content",
    MentionEmotionTrend: "Mention Sentiment Trend",
    MentionEmotionTrendTip: "Trend of positive, negative, and neutral sentiment within the selected time range",
    MentionPlatformDistribution: "Mention Distribution by Platform",
    MentionPlatformDistributionTip: "Share of mentioned content across different platforms",
    MentionLanguageDistribution: "Mention Distribution by Language",
    MentionLanguageDistributionTip: "Share of mentioned content by language",
    MentionCountryDistribution: "Mention Distribution by Country",
    MentionCountryDistributionTip: "Share of mentioned content by country",
    InteractionTrend: "Interaction Trend",
    InteractionTrendTip: "Reactions, comments, and reposts in mentioned content within the selected time range",
    VideoViewTrend: "Video View Trend",
    VideoViewTrendTip: "Video play counts in mentioned content within the selected time range",
    HotContent: "Hot Content",
    HotContentTip: "Top 9 posts by reach within the selected time range",
    InteractionCount: "Interactions",
    VideoViewCount: "Video Views",
    PlatformEffectData: "Platform Performance Data",
    PlatformEffectDataTip: "Detailed performance data for each platform",
    Platform: "Platform",
    Other: "Other",
    MentionCount: "Mentions",
    MentionCountDesc: "Content discussing this topic",
    MentionCountTableDesc: "Number of content items discussing this topic",
    InteractionCountDesc: "Public interactions on related content, including reactions/likes, comments/replies, and shares/reposts",
    VideoViewCountDesc: "Video views of related content",
    UniqueAuthors: "Unique Authors",
    UniqueAuthorsDesc: "Number of unique authors discussing this topic",
    ReachCount: "Reach",
    ReachCountDesc: "Number of people reached by content discussing this topic",
    ReachCountShortDesc: "Users reached by mentioned content",
    VolumeTrend: "Volume Trend",
    EmotionTendency: "Sentiment Tendency",
    InteractionEffect: "Interaction Effect",
    EmotionRatio: "Sentiment Ratio",
    PositiveMentions: "Positive Mentions",
    PositiveMentionsDesc: "Number of content items with positive sentiment",
    NegativeMentions: "Negative Mentions",
    NegativeMentionsDesc: "Number of content items with negative sentiment",
    NeutralMentions: "Neutral Mentions",
    NeutralMentionsDesc: "Number of content items with neutral sentiment",
    ReactionsOrLikes: "Reactions/Likes",
    ReactionsOrLikesDesc: "Reactions or likes of the content",
    CommentsOrReplies: "Comments/Replies",
    CommentsOrRepliesDesc: "Comments or replies of the content",
    SharesOrReposts: "Shares/Reposts",
    SharesOrRepostsDesc: "Shares or reposts of the content",
    Total: "Total",
    AuthorGrowthTrend: "Author Growth Trend",
    AuthorGrowthTrendTip: "Trend in the number of authors publishing posts.",
    AuthorCountryDistribution: "Author Country Distribution",
    AuthorCountryDistributionTip: "Country distribution of authors.",
    AuthorEmotionTrend: "Author Sentiment Trend",
    AuthorEmotionTrendTip: "Trend of author sentiment.",
    AuthorProfileAnalysis: "Author Profile Analysis",
    AgeDistribution: "Age Distribution",
    AgeDistributionTip: "Age distribution of authors.",
    GenderDistribution: "Gender Distribution",
    GenderDistributionTip: "Gender distribution of authors.",
    AuthorCount: "Authors",
    Ratio: "Ratio",
    PositiveEmotion: "Positive Sentiment",
    NegativeEmotion: "Negative Sentiment",
    NeutralEmotion: "Neutral Sentiment",
    Male: "Male",
    Female: "Female",
    Unknown: "Unknown",
    TopMentionedKeywords: "Top Mentioned Keywords",
    TopMentionedKeywordsTip: "Most frequently mentioned keywords.",
    TopMentionedTopics: "Top Mentioned Topics",
    TopMentionedTopicsTip: "Most frequently mentioned topics in content.",
    TopMentionedAccounts: "Top Mentioned Accounts",
    TopMentionedAccountsTip: "Most frequently mentioned social media accounts in content.",
    TopMentionedEmojis: "Top Mentioned Emojis",
    TopMentionedEmojisTip: "Most frequently used emojis in content.",
    ContentPublishTimeDistribution: "Content Publish Time Distribution",
    ContentPublishTimeDistributionTip: "Publish time distribution of content.",
    TopMentionedDomains: "Top Mentioned Domains",
    TopMentionedDomainsTip: "Most frequently mentioned domains in content.",
    MaterialTypeDistribution: "Material Type Distribution",
    MaterialTypeDistributionTip: "Material type distribution of content.",
    ContentTypeDistribution: "Content Type Distribution",
    ContentTypeDistributionTip: "Content type distribution.",
    MentionTimes: "Mentions",
    PublishVolume: "Publish Volume",
    Post: "Post",
    Comment: "Comment",
    Share: "Share",
    ContentType: "Content Type",
    TenThousandFormat: "{value}w",
    AuthorDetail: "Author Details",
    FanCount: "Fans",
    FanInteractionRate: "Fan Interaction Rate",
    AuthorEmotionIdentification: "Author Sentiment Identification",
    PositiveEmotionDesc: "Positive attitude toward the brand and often publishes positive content",
    NeutralEmotionDesc: "Neutral attitude toward the brand with objective expressions",
    NegativeEmotionDesc: "Negative attitude toward the brand and often publishes negative content",
    ActiveTime: "Active Time",
    MentionHistory: "Mention History",
    RelatedAuthors: "Related Authors",
    UnknownAuthor: "Unknown Author",
    NoRelatedData: "No related data",
    FansWithColon: "Fans: ",
    Follow: "Follow",
    MutualFollow: "Mutual Follow",
    CompareAnalysis: "Comparison Analysis",
    ComparisonName: "Comparison Name",
    TopicCount: "Topic Count",
    PleaseEnterComparisonName: "Please enter comparison name",
    TargetTopic: "Target Topic",
    ComparedTopic: "Compared Topic",
    PleaseSelectTargetTopic: "Please select target topic",
    PleaseSelectComparedTopic: "Please select compared topic",
    PleaseSelectTargetTopicFirst: "Please select target topic first",
    AddTopic: "Add Topic",
    AtLeastOneComparedTopic: "Please select at least one compared topic",
    MaxThreeComparedTopics: "You can add up to three compared topics",
    KeepOneComparedTopic: "Keep at least one compared topic",
    EditFailed: "Edit failed",
    CreateFailed: "Create failed",
    ComparisonDeleteConfirmMessage: "The listening comparison task cannot be restored after deletion. Confirm deletion?",
    ComparisonDetailFallback: "Comparison Details",
    CoreMetricsComparison: "Core Metrics Comparison",
    NoCoreMetricsComparisonData: "No core metrics comparison data",
    TotalMentions: "Total Mentions",
    TotalMentionsTip: "Total mentions for this topic",
    TotalInteractions: "Total Interactions",
    TotalInteractionsTip: "Public interactions for related content, including reactions/likes, comments/replies, and shares/reposts",
    PositiveSentimentRatio: "Positive Sentiment Ratio",
    PositiveSentimentRatioTip: "Ratio of positive content for this topic",
    TotalContentCount: "Total Content",
    TotalContentCountTip: "Total content for this topic",
    TopicNameColumn: "Topic Name",
    MentionTrendComparisonTip: "Comparison trend of discussion content counts across multiple topics",
    NoMentionTrendData: "No mention trend data",
    PlatformMentionComparison: "Platform Mention Comparison",
    PlatformMentionComparisonTip: "Mention comparison across platforms for multiple topics",
    NoPlatformMentionComparisonData: "No platform mention comparison data",
    MentionRatio: "Mention Ratio",
    MentionRatioTip: "Ratio of discussion content counts across multiple topics",
    NoMentionRatioData: "No mention ratio data",
    SentimentDistributionComparison: "Sentiment Distribution Comparison",
    SentimentDistributionComparisonTip: "Sentiment ratio comparison of discussion content across multiple topics",
    NoSentimentDistributionComparisonData: "No sentiment distribution comparison data",
    PositiveSentimentTrend: "Positive Sentiment Trend",
    PositiveSentimentTrendTip: "Comparison trend of positive sentiment content across multiple topics",
    NoPositiveSentimentTrendData: "No positive sentiment trend data",
    ContentTotalComparison: "Content Total Comparison",
    ContentTotalComparisonTip: "Compare content volume generated by each topic",
    NoContentTotalComparisonData: "No content total comparison data",
    ContentTypeComparison: "Content Type Comparison",
    ContentTypeComparisonTip: "Show the ratio of different content types for each topic, including videos, images, and text",
    NoContentTypeComparisonData: "No content type comparison data",
    PopularContentComparison: "Popular Content Comparison",
    PopularContentComparisonTip: "Ratio of content with more than 10,000 interactions",
    NoPopularContentComparisonData: "No popular content comparison data",
    AverageContentInteractionComparison: "Average Content Interaction Comparison",
    AverageContentInteractionComparisonTip: "Average interactions measure the attractiveness of a single content item and are a core indicator of content quality. Higher average interactions mean each item receives better feedback.\nAverage interactions = total interactions / total content",
    NoAverageContentInteractionComparisonData: "No average content interaction comparison data",
    AuthorCountComparison: "Author Count Comparison",
    AuthorCountComparisonTip: "Ratio of authors publishing content across multiple topics",
    NoAuthorCountComparisonData: "No author count comparison data",
    AuthorAvgContributionComparison: "Author Average Contribution Mentions Comparison",
    AuthorAvgContributionComparisonTip: "Average mentions contributed per author measures author enthusiasm for discussing the brand.\nAverage mentions = total mentions / active authors",
    NoAuthorAvgContributionComparisonData: "No author average contribution comparison data",
    AuthorGenderComparison: "Author Gender Comparison",
    AuthorGenderComparisonTip: "Show gender distribution ratios of authors across multiple topics to understand appeal differences by gender group and support precise marketing strategies.\nGender ratio = authors of this gender / total authors × 100%",
    NoAuthorGenderComparisonData: "No author gender comparison data",
    AuthorAgeComparison: "Author Age Comparison",
    AuthorAgeComparisonTip: "Show age distribution of authors across multiple topics to understand audience age structure and support product positioning and marketing strategies.\nAge ratio = authors in this age group / total authors × 100%",
    NoAuthorAgeComparisonData: "No author age comparison data",
    PositiveSentiment: "Positive",
    NeutralSentiment: "Neutral",
    NegativeSentiment: "Negative",
    HotContentCount: "Popular Content Count",
    AverageInteractions: "Average Interactions",
    AverageContributionMentions: "Average Contribution Mentions",
    AgeUnder18: "<18",
    Age18To24: "18-24",
    Age34To44: "34-44",
    AuthorAvatar: "Author Avatar",
    UserAvatar: "User Avatar",
    VideoThumbnail: "Video Thumbnail",
    PlatformLogo: "Platform Logo",
    PlatformIcon: "Platform Icon",
  },
  Audience: {
    // Audience task breadcrumb uses the current Social Listening menu level instead of the old analysis/monitoring labels.
    AudienceTask: "Audience Task",
    AudienceAnalysis: "Audience Analysis",
    AudienceMonitoring: "Audience Monitoring",
    NewAudienceTask: "New Audience Task",
    EditAudienceTask: "Edit Audience Task",
    AudienceTaskDetail: "{task} Details",
    SearchPageNamePlaceholder: "Please enter social account name",
    Add: "Add",
    TaskName: "Task Name",
    SocialAccountName: "Social Account Name",
    DataPeriod: "Data Period",
    Creator: "Creator",
    CreatedAt: "Created At",
    Actions: "Actions",
    NoData: "No data",
    Data: "Data",
    Edit: "Edit",
    Delete: "Delete",
    TaskNameLabel: "Task Name:",
    DataPeriodLabel: "Data Period:",
    SocialAccountLabel: "Social Account:",
    PleaseEnterAudienceTaskName: "Please enter audience task name",
    PleaseEnterTaskName: "Please enter task name",
    PleaseSelectDataPeriod: "Please select data period",
    PleaseAddSocialAccount: "Please add at least one social account",
    PleaseSelectSocialAccount: "Please select a social account",
    AddSocialAccount: "+ Add Social Account",
    Confirm: "Confirm",
    Cancel: "Cancel",
    StartDate: "Start Date",
    EndDate: "End Date",
    RangeSeparator: "To",
    DeleteConfirmMessage: "The social account audience task cannot be restored after deletion. Confirm deletion?",
    OperationConfirm: "Operation Confirmation",
    ConfirmDelete: "Delete",
    Executing: "Processing...",
    DeleteSuccess: "Deleted successfully!",
    BasicInfo: "Basic Info",
    SocialAccountInfo: "Social Account Info",
    Platform: "Platform",
    UnknownPlatform: "Unknown platform",
    Unknown: "Unknown",
    None: "None",
    FansSuffix: "fans",
    Verified: "Verified",
    NotVerified: "Not verified",
    AISummary: "AI Summary",
    DataDetails: "Data Details",
    AIAnalysisSummary: "AI Analysis Summary",
    AudienceQuality: "Audience Quality",
    BestTiming: "Best Timing",
    OperationSuggestions: "Operation Suggestions",
    GenderDistribution: "Gender Distribution",
    GenderDistributionTip: "Gender distribution ratio of users who interacted",
    Female: "Female",
    Male: "Male",
    AgeDistribution: "Age Distribution",
    AgeDistributionTip: "Age distribution ratio of users who interacted",
    LanguageDistribution: "Language Distribution",
    LanguageDistributionTip: "Language distribution ratio of users who interacted",
    CityDistribution: "City Distribution",
    CityDistributionTip: "City distribution ratio of users who interacted",
    CountryDistribution: "Country Distribution",
    CountryDistributionTip: "Country distribution ratio of users who interacted",
    ActiveTimeDistribution: "Audience Active Time Distribution",
    ActiveTimeDistributionTip: "Active time distribution ratio of users who interacted",
    MostActivePeriod: "Most Active Period",
    WeekendAverageActivity: "Weekend Average Activity",
    WeekdayActivePeak: "Weekday Active Peak",
    DailyAverageActivity: "Daily Average Activity",
    ConstellationDistribution: "Audience Zodiac Distribution",
    ConstellationDistributionTip: "Zodiac distribution ratio of users who interacted",
    InteractionLevelDistribution: "Interaction Level Distribution",
    InteractionLevelDistributionTip: "Ratio of users who only reacted versus users who commented and shared",
    InteractionTypeDistribution: "Interaction Type Distribution",
    InteractionTypeDistributionTip: "Ratio of users who reacted, commented, and shared",
    ShallowInteraction: "Shallow Interaction",
    DeepInteraction: "Deep Interaction",
    Reaction: "Reactions",
    CommentAndShare: "Comments + Shares",
    Comment: "Comment",
    Like: "Like",
    Share: "Share",
    AudienceUserList: "Audience User List",
    UserInfo: "User Info",
    UserInfoTip: "Show followed avatar, nickname, login account, age, and gender",
    AgeSuffix: "years old",
    InteractionCount: "Interactions",
    InteractionCountTip: "Total reactions, comments, and shares made by the user during the selected period",
    Horoscope: "Zodiac",
    HoroscopeTip: "User zodiac sign",
    Country: "Country",
    CountryTip: "User country",
    City: "City",
    CityTip: "User city",
    Language: "Language",
    LanguageTip: "User language",
    TenThousand: "w",
    HundredMillion: "B",
    Activity: "Activity",
    Proportion: "Ratio",
    PeopleCount: "People",
    Monday: "Mon",
    Tuesday: "Tue",
    Wednesday: "Wed",
    Thursday: "Thu",
    Friday: "Fri",
    Saturday: "Sat",
    Sunday: "Sun",
    Capricorn: "Capricorn",
    Aquarius: "Aquarius",
    Pisces: "Pisces",
    Aries: "Aries",
    Taurus: "Taurus",
    Gemini: "Gemini",
    Cancer: "Cancer",
    Leo: "Leo",
    Virgo: "Virgo",
    Libra: "Libra",
    Scorpio: "Scorpio",
    Sagittarius: "Sagittarius",
    ZodiacSuffix: "",
  },
  Homepage: {
    Features: "Features",
    AIChatbot: "AI Chatbot",
    IndustryConsulting: "Industry Consulting",
    DocumentWriting: "Document Writing",
    CustomerCases: "Customer Cases",
    UserManual: "User Manual",
    ContactUs: "Contact Us",
    OfficialWeChataccount: "Official account",
    ProductContact: "Product Contact",
    CrossBorder: "Your Dedicated CrossBorder Marketing Assistant",
    gotouse: "Go to use",
    trynow: "Try Now",

    AIChatbotDesc: "The AI chatbot responds to inquiries instantly and efficiently to raise customer satisfaction. Supports Messenger, on‑site support, Facebook messages and auto email replies.",
    IndustryConsultingDesc: "Domain experts provide tailored consulting services with deep industry knowledge to help users solve business‑critical problems.",
    DocumentWritingDesc: "Use AI to generate high‑quality original content across formats, meeting diverse scenarios and audiences with customizable options.",

    PrivateKnowledgeBase: "Private Knowledge Base",
    PrivateKnowledgeBaseDesc: "Customized private knowledge base with easy setup and precise retrieval.",
    OmnichannelIntegration: "Omnichannel Integration",
    OmnichannelIntegrationDesc: "Messenger / Facebook posts / Email, bind multiple channels with ease.",
    PersonalizedReminders: "Personalized Reminders",
    PersonalizedRemindersDesc: "Schedule reminders for key messages to ensure quick, effective responses.",
    MultilingualTranslation: "Multilingual Translation",
    MultilingualTranslationDesc: "Hundreds of languages auto-detected with real-time target translation.",
    ScenarioReplies: "Scenario Replies",
    ScenarioRepliesDesc: "Multi-scenario intent detection to match customer needs precisely.",
    PublicOpinionRiskControl: "Public Opinion Risk Control",
    PublicOpinionRiskControlDesc: "Hide sensitive comments with AI to safeguard your brand reputation.",

    GlobalInsights: "Global Insights",
    GlobalInsightsDesc: "Up‑to‑date global industry knowledge to support smarter decisions.",
    MediaMonitoring: "Media Monitoring",
    MediaMonitoringDesc: "Query media information in real time to make ad placements smarter.",

    CreativeInspiration: "Creative Inspiration",
    CreativeInspirationDesc: "Spark unlimited ideas with unique creativity.",
    EfficientWriting: "Efficient Writing",
    EfficientWritingDesc: "Intelligently generate documents to improve writing efficiency.",
  },
  // Keep WhatsApp support actions and end-service confirmation copy in one locale section.
  "whatsapp-service": {
    ConversationAssignment: "Conversation assignment",
    AllConversations: "All conversations",
    AssignedToMe: "Assigned to me",
    Unassigned: "Unassigned",
    Members: "Support members",
    // Keep the sidebar self badge short enough for its 20px circle.
    SelfBadge: "Me",
    Conversations: "Conversations",
    WabaAccounts: "WABA accounts",
    History: "Conversation history",
    Online: "Online",
    Busy: "Busy",
    Offline: "Offline",
    UnknownStatus: "Status unknown",
    Approved: "Approved",
    Rejected: "Rejected",
    Pending: "Pending review",
    SearchPlaceholder: "Search name, note, or phone",
    AssignAgent: "Assign agent",
    Tags: "Tags",
    EndService: "End service",
    ServiceEnded: "Ended",
    EndServiceTitle: "End this service?",
    EndServiceDescription: "This conversation will be marked as ended. A new message from the customer will reactivate it.",
    Close: "Close",
    CancelEndService: "Cancel",
    ConfirmEndService: "End",
    // Keep the pending label tied to ending a conversation rather than saving a form.
    EndingService: "Ending...",
    NoConversation: "Select a conversation",
    NoMessages: "No messages yet",
    // Keep fetch failures retryable and avoid declaring no matches while more filtered pages remain.
    MessagesLoadFailed: "Failed to load chat history",
    SearchMoreMatches: "Load more to find matching conversations",
    Retry: "Retry",
    ManualReply: "Manual reply",
    AiReply: "AI reply",
    SendFailed: "Failed to send",
    Emoji: "Emoji",
    Attachment: "Attachment",
    // Keep the composer attachment tooltip distinct from the attachment menu label.
    AttachmentUploadTooltip: "Upload attachment",
    TranslateReply: "Translate reply",
    // Keep the WhatsApp reply-language popover labels scoped to this workspace.
    SelectReplyLanguage: "Select reply language",
    SearchLanguageName: "Search language name",
    Send: "Send",
    TypeMessage: "Type a message...",
    // WhatsApp attachments share a count limit, with separate per-file size limits for each media type.
    SendTranslation: "Send translation",
    TranslationSuffix: " translation",
    TranslationFailed: "Translation failed. Please try again.",
    Translating: "Translating...",
    UploadDocument: "Upload document",
    UploadImage: "Upload image",
    UploadImageVideo: "Upload image/video",
    // Scene preview lists video separately from images while video upload is disabled.
    UploadVideo: "Upload video",
    UploadAudio: "Upload audio",
    AttachmentTypeUnavailable: "This file format is not supported",
    AttachmentLimit: "Add up to 10 attachments at a time",
    AttachmentSizeLimitTitle: "File size limit exceeded",
    AttachmentSizeLimitIntro: "These files exceed their size limits:",
    AttachmentSizeLimitDetail: "{name} ({type}, {size} MB; limit {limit} MB)",
    AttachmentSizeSelectionHint: "Oversized files were not added. Other valid files were kept.",
    AttachmentSizeSendHint: "Remove or replace the oversized files before sending.",
    AttachmentTypeImage: "Image",
    AttachmentTypeVideo: "Video",
    AttachmentTypeAudio: "Audio",
    AttachmentTypeDocument: "Document",
    RemoveAttachment: "Remove attachment",
    CloseTranslation: "Close translation",
    WindowExpiredTitle: "More than 24 hours have passed since the customer's last message. Sending is unavailable.",
    WindowExpiredDescription: "Messages cannot be sent after the 24-hour customer service window. Wait for the customer to message again to continue the conversation.",
    PendingAccountTitle: "This WABA is pending review. Sending is unavailable.",
    PendingAccountDescription: "Messaging will be available after Meta approves the account.",
    // Explain rejected and unknown review states separately so the read-only composer shows the right reason.
    RejectedAccountTitle: "This WABA is not approved. Sending is unavailable.",
    RejectedAccountDescription: "Confirm Meta approval before sending messages.",
    UnknownAccountTitle: "The WABA review status is unavailable. Sending is unavailable.",
    UnknownAccountDescription: "Refresh the account status and confirm approval before sending.",
    ServiceEndedTitle: "This service has ended. Sending is unavailable.",
    ServiceEndedDescription: "You can continue after the customer sends another message.",
    UnassignedReplyTitle: "This conversation has no assigned agent. Sending is unavailable.",
    UnassignedReplyDescription: "Assign this conversation to yourself before replying.",
    OtherAgentReplyTitle: "This conversation is assigned to another agent. Sending is unavailable.",
    OtherAgentReplyDescription: "Only the assigned agent can reply.",
    // Assignable read-only chats share the composer prompt and action in both languages.
    AssignBeforeReply: "Assign this conversation to a team member before replying.",
    AssignAgentInComposer: "Assign agent",
    // Assignment updates make sending read-only until the current owner is verified again.
    AssignmentCheckingTitle: "Checking the assigned agent. Sending is temporarily unavailable.",
    AssignmentCheckingDescription: "Sending will resume when the check completes.",
    AssignmentCheckFailedTitle: "Could not verify the assigned agent. Sending is temporarily unavailable.",
    AssignmentCheckFailedDescription: "Retry loading the conversation.",
    // Keep a transferred or filtered-out chat readable without treating its old assignment as current.
    ConversationOutOfScope: "This conversation is no longer in the list. Select a conversation again.",
    Reply: "Reply",
    You: "You",
    Customer: "Customer",
    TranslateMessage: "Translate",
    CollapseTranslation: "Hide translation",
    TranslationLabel: "Translation",
    Collapse: "Collapse",
    Quote: "Quote",
    ReplyPrefix: "Reply: ",
    By: "Replied by",
    Replied: "replied",
    UnknownAgent: "Support agent",
    AgentRemovedDescription: "Left the team; profile deleted",
    // A missing directory entry does not prove that the historical sender left the team.
    AgentProfileUnavailable: "Agent profile unavailable",
    // Use neutral copy for an empty system event that is unrelated to transfer.
    SystemNotice: "System notice",
    // Keep a readable system notice when a transfer event has no recipient name.
    TransferNotice: "Conversation transferred to a support agent",
    TransferToAgent: "Conversation transferred to agent {name}",
    AssignmentRulesTitle: "Assignment rules",
    AssignmentMechanism: "Conversation assignment mechanism",
    MechanismInfo: "Choose who handles conversations and configure agent capacity and service timing.",
    NoAssignment: "Unassigned access",
    NoAssignmentDescription: "Anyone with access to the account can handle conversations.",
    ManualAssignment: "Manual assignment",
    ManualAssignmentDescription: "Assign agents when a conversation is handed to a human.",
    DistributionStrategy: "Assignment strategy",
    ManualAllocation: "Manual assignment",
    ManualAllocationDescription: "Do not assign automatically. Admins choose or change the agent from the conversation list.",
    AverageAllocation: "Balanced assignment",
    AverageAllocationDescription: "Distribute conversations by workload, prioritizing agents with the fewest active conversations.",
    CountryAllocation: "Assign by country",
    CountryAllocationDescription: "Match agents to the customer's country; other countries go to the remaining agents.",
    CountryRules: "Country assignment rules",
    CountryRegion: "Country/Region",
    // Country and agent rules share one centered multi-select dialog in the assignment editor.
    SetRuleCountries: "Set rule countries",
    SetReceptionAgents: "Set assigned agents",
    SearchCountryName: "Enter a country name",
    SearchAgentNameOrPhone: "Enter an agent name or phone",
    Continent: "Continent",
    Asia: "Asia",
    Americas: "Americas",
    Europe: "Europe",
    Africa: "Africa",
    Oceania: "Oceania",
    OtherCountries: "Other",
    SelectedCountryCount: "{count} countries selected",
    SelectedAgentCount: "{count} agents selected",
    // English singular counts use a separate key; Chinese reuses the same form for every count.
    SelectedCountryCountOne: "{count} country selected",
    SelectedAgentCountOne: "{count} agent selected",
    ReceptionAgents: "Assigned agents",
    Operation: "Actions",
    DefaultRule: "Default rule",
    DefaultCountryRuleDescription: "Countries without an individual rule",
    AllAgents: "All agents",
    AddCountryRule: "Add country rule",
    DeleteRule: "Delete",
    CountryPlaceholder: "Select country/region",
    AgentPlaceholder: "Select assigned agents",
    NoCountryOptions: "No countries or regions available",
    // The rule picker waits for the API catalog instead of using a local country list.
    LoadingCountryCatalog: "Loading countries and regions...",
    // Keep previously saved countries removable when they are absent from the current API catalog.
    SavedCountriesOutsideCatalog: "Other saved countries/regions",
    NoAgentOptions: "No agents available",
    CountryRulesRequired: "Set a country/region and assigned agents for every rule.",
    ServiceSettings: "Agent service settings",
    CapacityAndTimeout: "Capacity and time limits",
    SingleWabaLimit: "Concurrent conversations per WABA",
    SingleWabaLimitDescription: "Maximum conversations an agent can handle in one WABA. Assignment pauses at the limit.",
    PeopleUnit: "people",
    ServiceExpiry: "Service expiry time",
    ServiceExpiryDescription: "End the service automatically when a conversation exceeds this duration.",
    MinuteUnit: "min",
    ConversationRelease: "Conversation release time",
    ConversationReleaseDescription: "If an agent does not reply in time, return the conversation to the queue for reassignment.",
    HistoricalContacts: "Returning contacts",
    AssignToPreviousAgent: "Assign to the previous agent",
    AssignToPreviousAgentDescription: "Keep the conversation with the previous agent instead of assigning it to someone else.",
    UseCurrentStrategy: "Use the current assignment strategy",
    UseCurrentStrategyDescription: "Use the same assignment strategy as for new contacts.",
    Cancel: "Cancel",
    SaveRules: "Save rules",
    AssignmentRulesSaved: "Assignment rules saved",
    LoadFailed: "Failed to load WhatsApp conversations",
    LoadMore: "Load more conversations",
    SendUnavailable: "This conversation cannot send messages right now",
    AssignmentUnavailable: "Assignment data is not available from the current API",
    FeatureUnavailable: "This feature is not connected to the server yet",
    AttachmentUnavailable: "Attachments are not connected on this page yet",
    TranslateUnavailable: "Reply translation is not connected on this page yet",
    NoBoundAccount: "No WABA accounts are linked to a support bot",
    UnboundAccount: "This WABA account is not linked to a support bot",
    // Use one locale source for list, contact, assignment, and empty-state copy so language changes update every surface.
    ListAssignAgent: "Assign",
    AssignConversationAgent: "Assign an agent to {name}",
    ConversationFallback: "this conversation",
    ViewContactDetails: "View {name}'s profile",
    ContactFallback: "this contact",
    FilterAgentShort: "Agent",
    FilterAccountShort: "Account",
    SearchByAgent: "Search by agent",
    SearchByAccount: "Search by account",
    LinkedTags: "Linked tags",
    ConversationTags: "Conversation tags",
    ClearFilters: "Clear all",
    RemoveFilterKind: "Clear {kind} filter",
    SelectedFilterAria: "Selected {title}",
    SelectedFilterCount: "· {count} selected",
    RemoveFilterItem: "Remove {name}",
    FilterChipCount: "{label}: {count}",
    NoMatchingAgents: "No matching agents",
    NoMatchingAccounts: "No matching accounts",
    SelectedAccountCount: "{count} accounts selected",
    SelectedAccountCountOne: "{count} account selected",
    SearchWabaAccount: "Enter a WABA account",
    ConversationCount: "{count} conversations",
    ConversationCountOne: "{count} conversation",
    ContactProfile: "Contact profile",
    EditRemarkName: "Edit remark",
    Nickname: "Name",
    PhoneNumber: "Phone number",
    Email: "Email",
    RemarkName: "Remark",
    AddContactTag: "Add contact tag",
    SourceChannel: "Source channel",
    LinkedWaba: "Linked WABA",
    // Keep the WABA hover card's business phone label distinct from the contact phone label.
    CustomerServicePhone: "Business phone number",
    FirstConversation: "First conversation",
    RecentConversation: "Latest conversation",
    EnterRemark: "Enter a remark",
    SaveRemark: "Save remark",
    CancelReply: "Cancel quoted reply",
    Assigning: "Assigning...",
    CurrentAgent: "Current agent",
    SavingRules: "Saving...",
    NoConversationHintLine1: "Select a conversation from the list to view its messages.",
    NoConversationHintLine2: "Filter by WABA account and support member.",
    UnknownCountry: "Unknown country/region",
    // Media cards share type labels; conversation previews use a separate placeholder for files without text.
    MediaAttachment: "Media attachment",
    MediaFilePreview: "[Media file]",
    MediaImage: "Image",
    MediaVideo: "Video",
    MediaAudio: "Audio",
    MediaDocument: "Document",
    MediaSticker: "Sticker",
    MediaLocation: "Location",
    MediaContact: "Contact",
    MediaProducts: "Products",
    MediaTemplate: "Template message",
    MediaViewDetails: "View details",
    OpenDocument: "Open document",
    AudioNotSupported: "Your browser does not support audio playback",
    VideoNotSupported: "Your browser does not support video playback",
    // Keep the thumbnail playback button's accessible name in sync with its state.
    PlayVideo: "Play video",
    PauseVideo: "Pause video",
    MediaPreview: "Media preview",
    TemplateButton: "Button {index}",
    // API success and error messages may be monolingual; these fallbacks keep notices in the UI language.
    TeamPushConnectionFailed: "Could not connect to team updates",
    AgentStatusMissingContext: "Team or member information is missing; agent status was not updated",
    AgentStatusUpdateFailed: "Could not update agent status",
    AgentStatusUpdated: "Agent status updated",
    AgentProfileLoadFailed: "Could not load the current agent profile",
    MembersLoadFailed: "Could not load support members",
    WabaAccountsLoadFailed: "Could not load WhatsApp accounts",
    MessageCountLoadFailed: "Could not load conversation counts",
    AssignmentVerificationFailed: "Could not verify the assigned agent",
    ReadConversationFailed: "Could not mark the conversation as read",
    MissingConversationUserId: "Conversation user ID is missing; chat history cannot be loaded",
    TeamLabelsLoadFailed: "Could not load team tags",
    UnnamedCategory: "Unnamed category",
    TeamTags: "Team tags",
    ExistingTagUnknown: "Could not identify the existing tag “{name}”. Refresh and try again.",
    UnnamedTag: "Unnamed",
    AssignedTagsReadFailed: "Could not read this contact's tags. Try again shortly.",
    AssignAgentFailed: "Could not assign the agent",
    AssignSucceeded: "Agent assigned",
    AssignmentOnlyToSelf: "You can only assign an unassigned conversation to yourself",
    CountryCatalogLoadFailed: "Could not load the country list",
    // Super administrators and administrators can view and save assignment rules.
    RulesOnlyAdminView: "Only team super administrators or administrators can view assignment rules",
    RulesMissingTeamView: "Team information is missing; assignment rules cannot be loaded",
    NoRulesConfigured: "This team has no agent configuration yet",
    RulesLoadFailed: "Could not load assignment rules",
    RulesOnlyAdminSave: "Only team super administrators or administrators can save assignment rules",
    RulesMissingTeamSave: "Team information is missing; assignment rules cannot be saved",
    RulesSaveFailed: "Could not save assignment rules",
    EndServiceFailed: "Could not end the service",
    TagsNotSynced: "Tags have not synced yet. Select them again.",
    AssignedTagsVerifyFailed: "Could not verify this contact's existing tags. Try again shortly.",
    AssignedTagsChanged: "This contact's tags changed. Close and reopen the dialog before saving.",
    TagSaveFailed: "Could not save tags",
    TagsUpdated: "Tags updated",
    RemarkSaveFailed: "Could not save the remark",
    RemarkUpdated: "Remark updated",
    CategoryCreateFailed: "Could not create the category",
    CategoryCreatedRefresh: "Category created. Reopen the tag dialog.",
    SelectTagCategory: "Select a tag category first",
    TagCreateFailed: "Could not create the tag",
    TagCreatedRefresh: "Tag created. Reopen the tag dialog.",
    SendConnectionMissing: "Message service connection details are missing; sending is unavailable",
    // The shared upload method reports the failed filename and a localized server reason in the dialog.
    AttachmentUploadFailed: "Could not upload the attachment",
    AttachmentUploadFailureDetail: "{name}: {reason}",
    ImageUploadSizeExceeded: "Image cannot exceed {size} MB",
    UploadFailureConfirm: "Confirm",
    MessageSocketConnectionFailed: "Could not connect to the message service",
  },
  route: {
    "social-account": "Channels",
    "social-monitor": "Tracking",
    "content-publish": "Publishing",
    "message-center": "Inbox",
    // Keep the new primary AI menu translated when the sidebar switches language.
    "ai-robot": "AI Bot",
    "social-listening": "Listening",
    "marketing-tools": "Martech",
    "library": "Repository",
    "data-report": "Reports",
    "team-management": "Teams",
    "monitor-list": "Monitor List",
    "data-summary": "Data Summary",
    "config-bot": "Configure Bot",
    "service-bot": "Service Bot",
    // Share the WhatsApp Support label between the submenu and its page.
    "whatsapp-service": "WhatsApp Support",
    "publish-list": "Publish List",
    "publish-post": "Post Publishing",
    "publish-calendar": "Publish Calendar",
    "publish-draft": "Publish Draft",
    "whatsapp-blast": "WhatsApp Blast",
    "whatsapp-contacts": "WhatsApp Contacts",
    "tag-management": "Tag Management",
    // Coupon Library is a Marketing Tools submenu item shared by routes and navigation.
    "coupon-library": "Coupon Library",
    // Coupon detail is a third-level page opened from the Coupon Library task list.
    "coupon-detail": "Coupon Details",
    "listening-task": "Listening Task",
    "listening-comparison": "Listening Comparison",
    "audience-task": "Audience Task",
    "team-package": "Team Package",
    "member-management": "Member Management",
    "team-settings": "Team Settings",
    "consumption-records": "Consumption Records",
    "token-expired-title": "Notice",
    "token-expired-message": "Your login has expired. Please sign in again.",
    "mass-email-list": "Mass Email",
    "mail-bot-statistics": "Mail Bot Statistics",
    "robot-report": "Robot Report",
    "automateTaskList":"Automate Tasks",
    "automateTaskStatistics":"Task Details",
    CTWAReport: "CTWA Report",
    "CTWA-Detail": "Ad Account Details",
    "CTWA-Auth-Callback": "Ad Account Authorization Callback"
  },

  "route.adviser": "Industry Adviser",
  "route.ai-chatbot": "JoinCompass - AI Chatbot",
  "route.ai-chatbot-crumb": "JoinCompass - AI Chatbot",
  "route.ai-writing": "AI Writing",
  "route.ai-writing-crumb": "JoinCompass - AI Document Writing",
  "route.alipay": "Alipay Payment",
  "route.audience-task": "Audience Analysis",
  "route.audience-task-crumb": "JoinCompass - Listening - Audience Analysis",
  "route.audience-task-home-crumb": "JoinCompass - Listening - Audience Analysis - Page Details",
  "route.blast-template": "New Blast Task Template",
  "route.blast-template-crumb": "Blast Task Template",
  "route.bot": "Customer Service",
  "route.bot-create": "Create Bot",
  "route.bot-create-crumb": "JoinCompass - Create Bot",
  "route.bot-statistics-crumb": "JoinCompass - Bot Statistics",
  "route.bot-store": "Bot Settings",
  "route.bot-store-crumb": "JoinCompass - Bot Settings",
  "route.cases": "JoinCompass - Customer Cases",
  "route.chat": "Chat",
  "route.config-bot": "Configure Bot",
  "route.config-bot-crumb": "JoinCompass - Inbox - Configure Bot",
  "route.content-publish": "Publishing",
  "route.content-publish-crumb": "JoinCompass - Publishing",
  "route.dashboard": "Home",
  "route.dashboard-crumb": "Welcome to JoinCompass",
  "route.data-report": "Reports",
  "route.data-report-crumb": "JoinCompass - Reports",
  "route.data-summary": "Data Summary",
  "route.data-summary-crumb": "JoinCompass - Tracking - Data Summary",
  "route.ecommerce-crumb": "Media Management,E-commerce Platform",
  "route.expense-detail": "Expense Details",
  "route.expense-detail-crumb": "JoinCompass Teams - Expense Details",
  "route.fb-posts": "Facebook Post Assistant",
  "route.fb-posts-crumb": "JoinCompass - Facebook Post Assistant Info",
  "route.finance": "Financial Info",
  "route.finance-crumb": "JoinCompass Teams - Financial Info",
  "route.inspiration-writing": "💡 Inspiration Writing",
  "route.instruct-center": "Template Center",
  "route.instruct-center-crumb": "JoinCompass - Template Center",
  "route.instruct-create": "Create Template",
  "route.instruct-create-crumb": "JoinCompass - Create Template",
  "route.library": "Repository",
  "route.library-crumb": "JoinCompass - Repository",
  "route.library-grab": "Grab Link",
  "route.library-grab-crumb": "Repository - Grab Link",
  "route.library-store-crumb": "JoinCompass - Online Writing Materials",
  "route.linkedin-auth": "LinkedIn Authorization",
  "route.linkedin-auth-crumb": "JoinCompass - LinkedIn Authorization",
  "route.listening-comparison": "Listening Comparison",
  "route.listening-comparison-crumb": "JoinCompass - Listening - Listening Comparison",
  "route.listening-comparison-home-crumb": "JoinCompass - Listening - Listening Comparison - Page Details",
  "route.listening-task-crumb": "JoinCompass - Listening - Listening Task",
  "route.listening-task-home-crumb": "JoinCompass - Listening - Listening Task - Page Details",
  "route.mail": "Mail",
  "route.mail-crumb": "JoinCompass - Mail",
  "route.mail-reply": "Reply Mail",
  "route.mail-reply-crumb": "JoinCompass - Reply Mail",
  "route.marketing-tools": "Martech",
  "route.media-management": "Media Management",
  "route.member-detail": "Member Details",
  "route.member-detail-crumb": "JoinCompass Teams - Member Details",
  "route.member-management": "Member Management",
  "route.member-management-crumb": "JoinCompass Teams - Member Management",
  "route.messenger": "Messenger Service",
  "route.messenger-crumb": "JoinCompass - Messenger Service Info",
  // Keep the Facebook standalone detail route title aligned with its route meta key.
  "route.facebook-platform-crumb": "JoinCompass - Tracking - Facebook Page Details",
  "route.monitor-detail-crumb": "JoinCompass - Tracking - Page Management - Page Details",
  "route.monitor-list-crumb": "JoinCompass - Tracking - Page Management",
  "route.order-product": "Orders & Products",
  "route.personal": "Personal Center",
  "route.post-detail": "Post Details",
  "route.post-detail-crumb": "JoinCompass - Post Details",
  "route.privacy-policy": "Privacy Policy",
  "route.profile": "Profile",
  "route.profile-crumb": "JoinCompass Personal Center - Profile",
  "route.publish-calendar": "Publish Calendar",
  "route.publish-calendar-crumb": "JoinCompass - Publishing - Publish Calendar",
  "route.publish-draft": "Publish Draft",
  "route.publish-draft-crumb": "JoinCompass - Publishing - Publish Draft",
  "route.publish-list": "My Publishing",
  "route.publish-list-crumb": "JoinCompass - Publishing - Publish List",
  "route.publish-not-activated": "Publishing - Not Activated",
  "route.publish-not-activated-crumb": "JoinCompass - Publishing - Not Activated",
  "route.publish-post-crumb": "JoinCompass - Publishing - Post Publishing",
  "route.recharge": "Recharge",
  "route.recharge-crumb": "JoinCompass Teams - Recharge",
  "route.scene-store": "Scene Settings",
  "route.scene-store-crumb": "JoinCompass - Scene Settings",
  "route.sentiment": "Sentiment",
  "route.service-bot-crumb": "JoinCompass - Inbox - Service Bot",
  "route.shopify-auth": "Shopify Authorization",
  "route.shopline-auth": "Shopline Authorization",
  "route.signal-post-crumb": "JoinCompass - Tracking - Single Post Details",
  "route.social-account-crumb": "JoinCompass - Channels",
  "route.social-listening": "Listening",
  "route.social-listening-crumb": "JoinCompass - Listening",
  "route.social-monitor": "Tracking",
  "route.social-monitor-crumb": "JoinCompass - Tracking",
  "route.specific-store": "Specific Post Settings",
  "route.specific-store-crumb": "JoinCompass - Specific Post Settings",
  "route.tag-management": "Tag Management",
  "route.tag-management-crumb": "JoinCompass - Martech - Tag Management",
// Coupon Library page title and browser breadcrumb.
  "route.coupon-library": "Coupon Library",
  "route.material-creation": "Material Creation",
  "route.coupon-library-crumb": "JoinCompass - Martech - Coupon Library",
  "route.material-creation-crumb": "JoinCompass - Material Creation",
  // Material Creation (JoinSpark authorization binding) page copy.
  "material.banner-title": "Unlock JoinSpark AI Ad Creative Engine",
  "material.banner-subtitle": "Bind JoinCompass and JoinSpark accounts with one-click authorization. Seamlessly connect inspiration search to high-converting creative generation and boost your overseas ad performance.",
  "material.use-joinspark": "Use JoinSpark",
  "material.start-bind": "Start Authorization",
  "material.need-super-admin-tip": "This feature is not available yet. Please contact the super admin to complete authorization. Once enabled, you can connect to the AI content creation platform for seamless data interoperability.",
  "material.cards-title": "Unlock the full ad creative workflow after authorization",
  "material.cards-subtitle": "Discover ad inspiration, generate creatives, analyze campaigns and collaborate with your team — all in one place",
  "material.card1-title": "Creative Ad Library",
  "material.card1-desc": "Integrate the world's top ad creative platforms to search trending assets across Meta, TikTok, Google and more, filtered by industry, channel and country for instant inspiration.",
  "material.card2-title": "AI Creative Studio",
  "material.card2-desc": "Powered by Seedance, Kling 3.0, Vidu, Veo 3.1 and more, supporting 5+ generation modes including video-to-video, image-to-video and text-to-video.",
  "material.card3-title": "Ad Analysis Report",
  "material.card3-desc": "Structured campaign execution plans built on social listening, competitor breakdown and smart frame-by-frame analysis, so high-converting creatives are data-backed.",
  "material.card4-title": "Team Management",
  "material.card4-desc": "Multi-team collaboration, unified credit allocation and alerts, and fine-grained member permission control.",
  "material.step-agreement": "Agreement",
  "material.step-verify": "Phone Verification",
  "material.step-done": "Authorization",
  "material.agreement-title": "Confirm Authorization Agreement",
  "material.agreement-subtitle": "Please read and agree to the following agreements to complete account binding",
  "material.protocol1-name": "JoinSpark Terms of Service",
  "material.protocol1-desc": "Learn about JoinSpark platform services and account rules",
  "material.protocol2-name": "JoinSpark Privacy Policy",
  "material.protocol2-desc": "Learn how personal information is collected, used and protected",
  "material.protocol3-name": "JoinCompass & JoinSpark Account Authorization and Data Sharing Agreement",
  "material.protocol3-desc": "Learn about account binding and necessary data sharing scope",
  "material.protocol4-name": "AI Content Generation Guidelines",
  "material.protocol4-desc": "Learn about AI content generation and compliance requirements",
  "material.agree-checkbox": "I have read and agree to all the above agreements",
  "material.agree-required": "Please agree to the agreements first",
  "material.next-step": "Next",
  "material.prev-step": "Previous",
  "material.verify-title": "Phone Verification",
  "material.verify-subtitle": "Verify your phone number to complete account binding",
  "material.enter-phone": "Please enter your phone number",
  "material.sms-placeholder": "Enter SMS code",
  "material.get-code": "Get Code",
  "material.resend-code": "Resend in {second}s",
  "material.enter-sms-code": "Please enter the correct SMS code",
  "material.complete-bind": "Complete Binding",
  "material.bind-success": "Binding Successful",
  "material.bind-success-subtitle": "JoinCompass and JoinSpark accounts are now linked. Click the button below or wait for automatic redirect — no need to log in again.",
  "material.enter-joinspark": "Enter JoinSpark Now",
  "material.auto-redirect": "Redirecting in",
  "material.bind-fail": "Binding Failed",
  "material.rebind": "Retry",
  "material.sms-sent": "Verification code sent",
  "material.bind-success-msg": "Binding successful. Redirecting to JoinSpark in 5 seconds.",
  "material.bind-fail-retry": "Binding failed, please try again later.",
  "route.coupon-detail": "Coupon Details",
  "route.coupon-detail-crumb": "JoinCompass - Martech - Coupon Details",
  "route.task-data": "Task Data",
  "route.team-management": "Teams",
  "route.team-package": "Team Package",
  "route.team-package-crumb": "JoinCompass Teams - Team Package",
  "route.team-profile": "Team Profile",
  "route.team-profile-crumb": "JoinCompass Personal Center - Team Profile",
  "route.team-settings": "Team Settings",
  "route.team-settings-crumb": "JoinCompass Teams - Team Settings",
  "route.template-edit": "Add/Edit Template",
  "route.test-cases": "Test Cases",
  "route.tiktok-auth": "TikTok Authorization",
  "route.tiktok-auth-crumb": "JoinCompass - TikTok Account Authorization",
  "route.tiktok-platform-crumb": "JoinCompass - Tracking - TikTok Platform",
  "route.tiktok-post-crumb": "JoinCompass - Tracking - TikTok Post Details",
  "route.user": "User Management",
  "route.user-agreement": "User Agreement",
  "route.view": "View",
  "route.view-settings": "View Settings",
  "route.vk-auth": "VK Authorization",
  "route.vk-auth-crumb": "JoinCompass - VK Authorization",
  "route.whatsapp-api": "WhatsApp API Management",
  "route.whatsapp-api-crumb": "Media Management,WhatsApp API Management",
  "route.whatsapp-blast": "WhatsApp Blast",
  "route.whatsapp-blast-crumb": "JoinCompass - Martech - WhatsApp Blast",
  "route.whatsapp-contacts": "WhatsApp Contacts",
  "route.whatsapp-contacts-crumb": "JoinCompass - Martech - WhatsApp Contacts",
  // Keep the standalone support page title under the Inbox hierarchy.
  "route.whatsapp-service-crumb": "JoinMC - Inbox - WhatsApp Support",
  "route.whatsapp-template": "WhatsApp Templates",
  "route.whatsapp-template-crumb": "Media Management,WhatsApp Templates",
  "route.workbench": "Workbench",
  "route.writing": "Writing",
  "route.writing-templates": "Writing Templates",
  "route.x-auth": "X Authorization",
  "route.x-auth-crumb": "JoinCompass - X Account Authorization",
  platform: {
    "Api-Settings": "API Settings",
    "Label-Management": "Label Management",
    "New-Authorization": "Add Channel",
    "All-Auth-Status": "All Auth Status",
    "All-Page-Labels": "All Page Labels",
    "Page-Info": "Page Info",
    Verified: "Verified",
    Unverified: "Unverified",
    Fans: "{count} Fans",
    "Auth-Status": "Auth Status",
    Authorized: "Authorized",
    Unauthorized: "Unauthorized",
    "Related-Labels": "Related Labels",
    Add: "Add",
    "Join-Time": "Join Time",
    Actions: "Actions",
    Unauth: "Unauthorize",
    Reauth: "Reauthorize",
    More: "More",
    "Delete-Page": "Delete Page",
    "Search-Label": "Search Labels",
    "Add-Label": "Add Label",
    "Label-Name": "Label Name",
    "Label-Account-Count": "Linked Accounts",
    "Edit-Label": "Edit Label",
    "Delete-Label": "Delete Label",
    "New-Label": "New Label",
    "Enter-Label-Name": "Please enter a label name",
    "Manage-Labels": "Manage Labels",
    "Label-Dialog-Desc": "After linking labels, you can directly filter by label during data analysis.",
    "Linked-Labels": "Linked Labels",
    "Label-Select": "Select Label",
    "Not-Set": "Not Set",
    "Operation-Failed": "Operation Failed",
    "Linked-Bots": "Linked Bots:",
    "Chat-Bot": "Chat Bot",
    "Page-Bot": "Page Bot",
    "Social-Monitor": "Social Monitor:",
    "Monitor-Days": "Monitored for {days} days",
    "Got-It": "Got It",
    "Info-Update-Success": "Information updated successfully",
    "Search-Shop-Placeholder": "Enter shop name",
    "Search-Account-Placeholder": "Enter account info",
    "Search-Page-Placeholder": "Enter page name",
    "Delete-Bound-Failed": "This page is linked to a bot or social monitor and cannot be deleted",
    "Unauth-Bound-Failed": "This page is linked to a bot or social monitor and cannot be unauthorized",
    "Delete-Page-Confirm": "After deletion, all data related to this page will be permanently removed!",
    "Operation-Confirm": "Operation Confirmation",
    Deleted: "Deleted",
    "Unauth-Confirm": "After unauthorized, the social monitor module can only monitor public data of this page. Authorized data will no longer be displayed!",
    Unauthed: "Authorization Removed",
    "Auth-Window-Failed": "Failed to open the authorization window. Please check your browser pop-up blocker settings",
    "Auth-Sync-Loading": "Authorization successful, syncing pages...",
    "Label-Add-Success": "Label added successfully",
    "Fans": "{count} Fans",
    "Verified": "Verified",
    "Unverified": "Unverified",
    "Back": "Back",
    "Label-Update-Success": "Label updated successfully",
    "Delete-Label-Confirm": "Are you sure you want to delete this label?",
    "Label-Delete-Success": "Label deleted successfully",
    // ===== Authorization dialog =====
    "Add-Social-Page": "Add Social Page",
    "Select-Page": "Select Page",
    "Add-Page-Desc": "Add pages that require logging into social accounts. Once done, you can analyze authorized data, publish posts, and manage DMs and comments.",
    "Add-Public-Desc": "Easily add public social accounts by searching. Fully analyze their public data to accurately evaluate their performance.",
    "Authorize-Platform-Sub": "Select the platform to authorize. Once authorized, the account will be synced to the list automatically.",
    "WhatsApp-Register-Sub": "Choose a WhatsApp Business registration method",
    "Add-Ecommerce-Auth": "Add E-commerce Authorization",
    "Shop-Auth-Sub": "Select shop type and fill in the authorization info",
    "Set-Label": "Set Labels",
    "Add-New-Label": "Add New Label",
    "New-Label-Success": "New label created successfully",
    "Set-Label-Success": "Labels set successfully",
    "Selected-Pages": "{count} pages selected",
    "Authorize-New-Page": "Authorize New Page",
    "Select-Bind-Page": "Please select the page you want to bind",
    "Select-Page-Warning": "Please select a page",
    "Select-Platform": "Please select a page platform",
    "Confirm-Add": "Confirm Add",
    "Page-Added-Monitor": "Page added to monitoring",
    "Added-Monitor": "Monitored",
    "Bound": "Bound",
    "Auth-Partial-Failed": "Some Social Accounts Failed to Authorize",
    "Added-Other-Team": "Added to Another Team",
    "Authorized": "Authorized",
    "Authorized-Other-Team": "Authorized to Another Team",
    "No-Result": "No pages found for your search",
    "Auth-Success": "Authorization successful",
    "Auth-Failed": "Authorization failed",
    "Auth-In-Progress": "Authorizing...",
    "Auth-Cancelled": "You cancelled the authorization.",
    "Global-Page": "Global Page",
    "All": "All",
    "Tip": "Notice",
    // Telegram authorization
    "Phone-Number": "Phone Number:",
    "Enter-Phone": "Please enter your phone number",
    "Verification-Code": "Verification Code:",
    "Enter-Code": "Please enter the verification code",
    "Get-Code": "Get Code",
    "Resend-In": "Resend in {seconds}s",
    "Code-Sent": "Verification code sent",
    "Check-Telegram-Notice": "Please check your Telegram for the verification code",
    "Enter-Second-Password": "Enter your Telegram two-step password",
    "Second-Password": "Two-Step Password:",
    "Enter-Second-Password-Placeholder": "Please enter your two-step password",
    "Select-Channel-Title": "Select Channels to Authorize",
    "Search-Channel-Placeholder": "Enter the page name you want to search",
    "Public-Channel": "Public Channel",
    "Private-Channel": "Private Channel",
    // LinkedIn authorization
    "Auth-Company-Page": "Authorize Company Page",
    "Auth-Personal-Page": "Authorize Personal Page",
    "Personal-Not-Open": "Personal page authorization is not available yet",
    "No-Company-Page": "No company page found for authorization",
    "Check-Following": "You can check the following:",
    "Check-Item-1": "1. Check that you are logged in with the correct LinkedIn account.",
    "Check-Item-2": "2. Check that the LinkedIn account owns a company page and is a senior admin of it.",
    // WhatsApp authorization
    "WA-Confirm-Auth": "Confirm Authorization",
    "WA-Sync-Title": "Sync Contacts and Chat History",
    "WA-Sync-Desc": "Syncing data from WhatsApp Business App. Please wait — syncing takes some time, and you can do other things in the meantime.",
    "WA-Stats-Period": "Stats Period",
    "WA-Stats-Period-Desc": "All sent and received messages within 180 days from the connection date",
    "WA-Filter-Range": "Filter Range",
    "WA-Filter-Range-Desc": "Group chat messages are not shown",
    "WA-View-Contacts": "View Contacts",
    "WA-API-Desc": "For medium and large businesses, enabling scalable customer communication through programmatic access",
    "WA-App-Title": "WhatsApp Business App Sharing",
    "WA-App-Desc": "Register using an existing WhatsApp Business app account and phone number",
    "WA-Coexistence-Fail-Title": "Coexistence Activation Failed",
    "WA-Coexistence-Fail-Content": "Error reason: you did not select the coexistence mode but accidentally checked the related business assets entry, so the current flow cannot enable the coexistence of WhatsApp Business App on the phone and the API at the same time.<br><br>Please re-authorize and select the [WhatsApp Coexistence] channel to submit.",
    "WA-Auth-Incomplete": "WhatsApp authorization incomplete",
    "WA-Auth-Success": "WhatsApp authorized successfully",
    "WA-Auth-Failed": "WhatsApp authorization failed",
    "WA-App-Auth-Incomplete": "WhatsApp Business App coexistence authorization incomplete",
    "WA-App-Auth-Failed": "WhatsApp Business App coexistence authorization failed",
    "WA-App-Register-Timeout": "Registration timed out. Could not retrieve WhatsApp Business App coexistence account info",
    "WA-App-Coexist-Timeout": "Timed out waiting for WhatsApp Business App coexistence account data",
    "WA-Select-Mode": "Please select a WhatsApp Business registration method",
    "WA-Auth-Start-Failed": "Failed to start WhatsApp authorization",
    "WA-Register-Timeout": "Registration timed out. Could not retrieve WhatsApp Business account info",
    // Shop authorization, including Shoplazza
    "Url-Invalid": "Invalid URL format",
    "Shopify-Desc": "Shopify shop authorization",
    "Shopline-Desc": "Shopline shop authorization",
    "Shoplazza-Desc": "Shoplazza shop authorization",
    "Website-Name": "Independent Site",
    "Website-Desc": "Independent site authorization",
    "Enter-Shop-Name": "Please enter the shop name",
    "Enter-Shop-Url": "Please enter the shop URL",
    "Enter-Shop-Address": "Please enter your shop address",
    "Website-Auth-Success": "Independent site authorized successfully",
    "Network-Error": "Network error, please try again later",
    "Shopify-Auth-Success": "Shopify authorized successfully",
    "Shopify-Auth-Failed": "Shopify authorization failed",
    "Shopline-Auth-Success": "Shopline authorized successfully",
    "Shopline-Auth-Failed": "Shopline authorization failed",
    "Shoplazza-Auth-Started": "The Shoplazza authorization window is open. Complete authorization in the window.",
    "Shoplazza-Auth-Window-Closed": "Shoplazza authorization has ended",
    "Shoplazza-Auth-Success": "Shoplazza authorized successfully",
    "Shoplazza-Callback-Params-Missing": "Shoplazza authorization callback parameters are incomplete",
    "Shoplazza-Order-Search-Placeholder": "Order No./Customer/Email/Phone",
    "Shoplazza-Published-Status": "Publication Status",
    "Shoplazza-Published": "Published",
    "Shoplazza-Unpublished": "Unpublished",
    "Shoplazza-Product-Image": "Product Image",
    "Shoplazza-Product-Info": "Product Info",
    "Shoplazza-Inventory": "Inventory",
    "Shoplazza-Variant-Count": "Variants",
    "Shoplazza-Variant-Inventory": "Variants & Inventory",
    "Shoplazza-Variant-Total": "{count} variants",
    "Shoplazza-Variant-Available": "{count} variants in stock",
    "Shoplazza-Customer-Name": "Customer Name: ",
    "Shoplazza-Customer-Phone": "Customer Phone: ",
    "Shoplazza-Customer-Email": "Customer Email: ",
    "Shoplazza-Order-Pending": "Pending",
    "Shoplazza-Order-Cancelled": "Cancelled",
    "Shoplazza-Order-Placed": "In Progress",
    "Shoplazza-Order-Finished": "Processed",
    // Shoplazza order columns share these labels so language changes never fall back to untranslated keys.
    "Order-Status": "Order Status",
    "Country": "Country",
    "Shop-Name-Label": "Shop Name:",
    "Enter-Website-Name": "Please enter your independent site name",
    "Domain-Label": "Website Domain:",
    "Enter-Domain": "Please enter your shop's homepage domain",
    "Shop-Address-Label": "{name} Shop Address:",
    "Enter-Shop-Address-Name": "Please enter your {name} shop address",
    "Shoplazza-Domain-Label": "Shop System Domain:",
    "Enter-Shoplazza-Domain": "Please enter the shop system subdomain",
    "Shoplazza-Store-Id-Label": "Shop ID:",
    "Enter-Shoplazza-Store-Id": "Please enter the shop ID",
    "Shoplazza-Store-Id-Invalid": "Shop ID must be an integer",
    "Shop-Confirm-Auth": "Confirm Authorization",
    // Ecommerce platform list page and compact order/product statistic tags.
    "Shop-Platform": "E-commerce Platform",
    "EC-Shop-Info": "Shop Info",
    "EC-Order-Info": "Order Info",
    "EC-Phone": "Phone",
    "EC-Authorizer": "Authorizer",
    "EC-Join-Time": "Join Time",
    "EC-Update-Time": "Update Time",
    "EC-Auth-Status": "Auth Status",
    "EC-Authorized": "Authorized",
    "EC-Operation": "Operation",
    "EC-View-Detail": "View Detail",
    "EC-More": "More",
    "EC-View-Product": "View Products",
    "EC-Info-Update": "Update Info",
    "EC-Mall-Home": "Mall Home",
    "EC-Delete": "Delete",
    "EC-Delete-Mall": "Delete Mall",
    "EC-View-Order": "View Order",
    "EC-Author-At": "Authorized At",
    "EC-Last-Update": "Last Updated At",
    "EC-Updating": "Updating...",
    "EC-Total-Orders": "{count} orders",
    "EC-Products": ", {count} products",
    "EC-Order-Count": "Orders {count}",
    "EC-Product-Count": "Products {count}",
    "EC-Search-Order": "Enter email / phone / customer name",
    "EC-Order-Number": "Order Number",
    "EC-Transaction-Number": "Transaction Number",
    "EC-Platform": "Platform",
    "EC-Logistics-Info": "Logistics Info",
    "EC-Logistics-Channel": "Logistics Channel: ",
    "EC-Waybill-Number": "Waybill Number: ",
    "EC-Internal-Number": "Internal Number: ",
    "EC-Country-Code": "Country Code",
    "EC-Order-Status": "Order Status",
    "EC-Payment-Delivery-Time": "Payment & Delivery Time",
    "EC-Payment-Time": "Payment Time: ",
    "EC-Delivery-Time": "Delivery Time: ",
    "EC-Customer-Info": "Customer Info",
    "EC-Upload-Title": "Upload Orders",
    "EC-Select-File": "Select File",
    "EC-Upload-Format": "Upload format: .xls/.xlsx",
    "EC-Download-Template": "Download Template",
    "EC-Cancel": "Cancel",
    "EC-Start-Upload": "Start Upload",
    "EC-Order-Start-Time": "Order Start Time",
    "EC-Order-End-Time": "Order End Time",
    "EC-Select-Logistics-Status": "Please select logistics status",
    "EC-Order": "Order",
    "EC-Transaction-No": "Transaction No.: ",
    "EC-Order-No": "Order No.: ",
    "EC-Order-Time": "Order Time: ",
    "EC-Unit-Price": "Unit Price: $",
    "EC-Total": "Total",
    "EC-Logistics-Number": "Tracking Number",
    "EC-Product-Info": "Product Info",
    "EC-Sale-Price": "Sale Price",
    "EC-Style": "Variant",
    "EC-Spec": "Spec",
    "EC-Price": "Price",
    "EC-Stock": "Stock",
    "EC-Enter-Product-Name": "Enter product name",
    "EC-Delete-Confirm": "After canceling authorization, the products and orders in the mall will be removed, and related online customer service will no longer be able to reference info from this mall",
    "EC-Auth-Cancel": "Cancel Authorization",
    "EC-Delete-Success": "Deleted successfully",
    "EC-Delete-Failed": "Delete failed",
    "EC-Upload-Success": "Uploaded successfully",
    "EC-Upload-Failed": "Upload failed",
    "EC-Only-Xls": "Only .xls and .xlsx files are allowed",
    "EC-One-File": "Only one file can be uploaded at a time",
    "EC-Shopify-Order-Title": "{name}-Order Info",
    "EC-Shopify-Shop-Title": "{name}-Products",
    "WA-Avatar": "Avatar",
    "WA-Status-Unverified": "Unverified",
    "WA-Status-Reviewing": "Under Review",
    "WA-Status-Verified": "Verified",
    "WA-Status-Rejected": "Rejected",
    "WA-Account-Rejected": "Rejected",
    "WA-Account-Approved": "Approved",
    "WA-Account-Pending": "Pending",
    "WA-Unbound": "Unbound",
    "WA-Header-Account": "Account Info",
    "WA-Header-CompanyAuth": "Company Verification Status",
    "WA-Header-AccountStatus": "Account Status",
    "WA-Header-BM": "Business Manager",
    "WA-Header-RelatedPhone": "Associated Phone",
    "WA-Header-MsgUsage": "Message Usage/Limit",
    "WA-Header-AuthTime": "Authorization Time",
    "WA-Header-Authorizer": "Authorizer",
    "WA-Filter-Company": "Filter by Company Verification",
    "WA-Filter-Account": "Filter by Account Status",
    "WA-Clear": "Clear",
    "WA-Confirm": "Confirm",
    "WA-AuthStatus": "Verification Status:",
    "WA-Pop-UnverifiedDesc": "Complete verification to enhance brand credibility and account stability",
    "WA-Pop-ReviewingDesc": "Expected to take 1 business day to complete the review",
    "WA-Pop-VerifiedDesc": "Congratulations! Your business verification has passed Meta review",
    "WA-Pop-RejectedDesc": "Unfortunately, your business verification application did not pass Meta review",
    "WA-Pop-Trust1": "· Enhance customer trust and increase inquiry conversion",
    "WA-Pop-Trust2": "· More stable account, reduce risk of bans and blocks",
    "WA-AuditProgress": "Audit Progress",
    "WA-Step-Submit": "Application Submitted",
    "WA-Step-PlatformReview": "Platform Review",
    "WA-Step-MetaReview": "Meta Review",
    "WA-Step-Complete": "Review Complete",
    "WA-PlatformPassed": "Platform Review Passed",
    "WA-MetaReviewing": "Meta Reviewing",
    "WA-VerifiedCompany": "Verified Company",
    "WA-VerifiedTime": "Verification Time",
    "WA-Fail3Title": "Your verification has failed 3 times",
    "WA-Fail3Desc": "Unable to verify your business in JoinCompass. Please verify on the official WhatsApp platform",
    "WA-FailReason": "Failure Reason",
    "WA-CertInfo": "Verification Info",
    "WA-CertNow": "Verify Now",
    "WA-ViewProgress": "View Full Progress",
    "WA-FailDetail": "Failure Details",
    "WA-WACert": "WhatsApp Verification",
    "WA-Reapply": "Reapply",
    "WA-ApplyCert": "Apply Verification",
    "WA-Recertify": "Recertify",
    "WA-ViewCert": "View Verification",
    "WA-Broadcast": "Broadcast Messages",
    "WA-PhoneMgmt": "Phone Number Management",
    "WA-GetQR": "Get QR Code",
    "WA-ViewDetail": "View Details",
    "WA-TemplateMgmt": "Template Management",
    "WA-ConversationMgmt": "Conversation Management",
    "WA-ContactsMgmt": "Contacts Management",
    "WA-Drawer-ReviewingDesc": "Expected to take 1 business day to complete the review.",
    "WA-Drawer-VerifiedDesc": "Congratulations! Your business verification has passed Meta review.",
    "WA-Drawer-Fail3Status": "Verification failed 3 times",
    "WA-Drawer-Fail3Desc1": "Your verification has failed 3 times and cannot be completed in JoinCompass",
    "WA-Drawer-Fail3Desc2": "Please verify on the official WhatsApp platform",
    "WA-Drawer-RejectedDesc": "Unfortunately, your business verification application did not pass Meta review.",
    "WA-Drawer-UnverifiedDesc": "After verification, you can enhance customer trust, increase inquiry conversion, and reduce risks.",
    "WA-Title-Trust": "1. Enhance customer trust and increase inquiry conversion",
    "WA-Trust-1": "Automatically display your business brand name: even if customers haven't saved your number, your company name appears at the top of the chat, avoiding the resistance caused by unknown numbers.",
    "WA-Trust-2": "Official qualification endorsement against fraud: with the verified badge and Meta business verification, customers are more willing to negotiate, submit shipping information, and complete payment, boosting message open and reply rates by 50%~70% and effectively improving inquiry conversion.",
    "WA-Trust-3": "Prevent account impersonation: effectively stops others from registering similar accounts to impersonate your company, helping customers identify official accounts; you can report impersonating accounts to Meta for removal, protecting your overseas brand reputation.",
    "WA-Title-Stability": "2. More stable account, reduce risk of bans and blocks",
    "WA-Stability-1": "More lenient risk-control review, greatly reducing ban probability: personal and unverified business accounts are easily rate-limited or banned for bulk messaging; after business verification, the platform's risk control is more tolerant, suitable for reaching existing customers in bulk and sending marketing notifications, reducing wrongful ban probability by about 60%.",
    "WA-Stability-2": "Lower probability of being flagged as spam: unsolicited outbound messages are easily reported and blocked by customers; verified accounts are less likely to be judged as spam, keeping message delivery more stable.",
    "WA-Stability-3": "Higher message sending quota: the initial daily messaging limit far exceeds that of ordinary business accounts, fitting bulk customer operation scenarios for foreign trade and cross-border e-commerce.",
    "WA-Feedback": "1. Application Feedback:",
    "WA-MetaFeedback": "Meta Feedback",
    "WA-Cancel": "Cancel",
    "WA-GotIt": "Got it",
    "WA-UploadCert": "Document Upload",
    "WA-UploadDesc": "Please upload the following documents. At least 1 document is required, supported in PDF/JPG/PNG format",
    "WA-AppLimit": "Limited verification applications",
    "WA-AppLimitDesc": "JoinCompass supports up to 3 verification applications. Please ensure the company name, address, and supporting documents are fully consistent to improve the approval rate.",
    "WA-UsedCount": "Used {used}/{limit} times",
    "WA-RemainCount": "{count} remaining",
    "WA-CompanyDocs": "Business Proof Documents",
    "WA-CompanyDocsDesc": "Business license/commercial registration, etc. Bank statements/utility bills/tax notices, etc. Must include company name + address",
    "WA-NoWatermark": "Watermarked materials cannot pass verification",
    "WA-NoWatermarkDesc": "Uploaded attachments must not contain any watermark. Please upload clear proof documents without watermarks",
    "WA-DragUpload": "Drag files here or click to upload",
    "WA-UploadSupport": "Supports PDF / JPG / PNG, max 5MB per file",
    "WA-SelectFile": "Select File",
    "WA-SubmitApp": "Submit Application",
    "WA-DayLimit": "Daily Message Limit",
    "WA-SearchPhone": "Search associated phone numbers",
    "WA-AddPhone": "Add Phone Number",
    "WA-Phone": "Phone Number",
    "WA-Status": "Status",
    "WA-QualityRating": "Quality Rating",
    "WA-Warn-UploadCert": "Please upload business proof documents",
    "WA-Success-Submitted": "Application submitted",
    "WA-Warn-NoBot": "The current WABA has no bound customer service bot. Conversation management is unavailable",
    "WA-Err-RegTimeout": "Registration timed out. Failed to obtain WhatsApp Business account information",
    "WA-Err-WaitTimeout": "Timed out waiting for embedded registration data",
    "WA-Err-FileFmt": "Unsupported file format{ext}. Only PDF/JPG/PNG formats are supported",
    "WA-Err-FileSize": "File size exceeds the limit ({size}MB). Max 5MB",
    "WA-Warn-Max3Files": "At most 3 files can be uploaded",
    "WA-Quality-GREEN": "High",
    "WA-Quality-YELLOW": "Medium",
    "WA-Quality-RED": "Low",
    "WA-Quality-UNKNOWN": "Unknown",
    "WA-PhoneStatus-PENDING": "Pending",
    "WA-PhoneStatus-UNVERIFIED": "Unverified",
    "WA-PhoneStatus-MANUAL_REVIEW": "Under review",
    "WA-PhoneStatus-DISCONNECTED": "Disconnected",
    "WA-PhoneStatus-CONNECTED": "Connected",
    "WA-PhoneStatus-FLAGGED": "Flagged",
    "WA-PhoneStatus-WARNED": "Warned",
    "WA-PhoneStatus-RATE_LIMITED": "Message limited",
    "WA-PhoneStatus-BANNED": "Banned",
    "WA-PhoneStatus-RESTRICTED": "Restricted",
    "WA-PhoneStatus-BLOCKED": "Message limit reached",
    "WA-PhoneStatus-MIGRATED": "Migrated",
    "WA-PhoneStatus-UNKNOWN": "Unknown",
    // WhatsApp template create page
    "WhatsApp-Template": "WhatsApp Templates",
    "New-Template": "New Template",
    "Save-Settings": "Save Settings",
    "Template-Name": "Template Name",
    "Template-Category": "Template Category:",
    "Template-Utility": "Utility",
    "Template-Marketing": "Marketing",
    "Template-Authentication": "Authentication",
    "Template-Utility-Desc": "Send order or account information",
    "Template-Marketing-Desc": "Send promotional information about products, services or business",
    "Template-Authentication-Desc": "Send verification codes to verify transactions or logins",
    "Template-Language": "Template Language:",
    "Select-Language": "Select language",
    "Header": "Header:",
    "None": "None",
    "Image": "Image",
    "Video": "Video",
    "Text": "Text",
    "Upload-Sample-Image": "Upload sample image",
    "Body": "Body:",
    "Footer": "Footer:",
    "Buttons": "Buttons:",
    "Website-URL": "Website URL",
    "Phone": "Phone",
    "Quick-Reply": "Quick Reply",
    "Button-Type": "Button Type:",
    "Button-Text": "Button Text:",
    "Please-Enter": "Please enter",
    "URL-Type": "URL Type:",
    "Website": "Website:",
    "Phone-Number": "Phone Number:",
    "Enter-Phone-Number": "Enter phone number",
    "Message-Content": "Message Content:",
    "Add-Safety-Advice": "Add safety advice",
    "Expire-In-Minutes": "minutes to expire",
    // WhatsApp template list page
    To: "To",
    "Start-Date": "Start Date",
    "End-Date": "End Date",
    "Select-Status": "Select status",
    "Template-Status-Pending": "Pending",
    "Template-Status-Quality-Pending": "Quality Pending",
    "Template-Status-High-Quality": "High Quality",
    "Template-Status-Medium-Quality": "Medium Quality",
    "Template-Status-Low-Quality": "Low Quality",
    "Template-Status-Rejected": "Rejected",
    "Template-Status-Paused": "Paused",
    "Template-Status-Disabled": "Disabled",
    "Enter-Template-Name": "Enter template name",
    Status: "Status",
    Language: "Language",
    "Last-Updated": "Last Updated",
    Creator: "Creator",
    Duplicate: "Duplicate",
    Continue: "Continue",
    "Confirm-Delete-Template": "The template cannot be restored after deletion. Do you still want to delete it?",
    "Confirm-Action": "Confirm Operation",
    // Shopify / Shopline / WhatsApp API manage
    "Shopify-Authorizing": "Authorizing Shopify, please wait...",
    "Shopify-Auth-Success": "Shopify authorization successful",
    "Shopify-Auth-Failed": "Shopify authorization failed",
    "Shopline-Authorizing": "Authorizing Shopline, please wait...",
    "Shopline-Auth-Success": "Shopline authorization successful",
    "Shopline-Auth-Failed": "Shopline authorization failed",
    Close: "Close",
    "Update-Order": "Update Order",
    "Update-Product": "Update Product",
    "Batch-Upload": "Batch Upload",
    "Download-Template": "Download Template",
    "Order-Start-Time": "Order Start Time",
    "End-Time": "End Time",
    "Logistics-Status": "Logistics Status",
    "Transaction-Search-Placeholder": "Transaction No./Email/Phone/Customer Name",
    "Update-Start-Time": "Update Start Time",
    "Get-QR-Code": "Get QR Code",
    "Create-Secret": "Create Secret Key",
    "Edit-Secret": "Edit Secret Key",
    "Confirm-Create": "Confirm Create",
    "Confirm-Edit": "Confirm Edit",
    "Secret-Name": "Secret Name",
    "Secret-Name-Min-Length": "Secret name must be at least 2 characters",
    "Secret-Name-Duplicate": "Secret name already exists",
    "No-API-Secret": "No API secret keys",
    "API-Secret-Desc": "After creating a secret key, you can send and receive messages and manage accounts through the API",
    "Create-First-API-Secret": "Create your first API secret key",
    "API-Instruction": "API instruction",
    "Webhook-Placeholder": "Enter Webhook callback URL, e.g. https://example.com/webhook",
    "Webhook-Desc": "URL that receives event pushes such as message delivery status and inbound messages",
    "Webhook-URL-Invalid": "Webhook URL format is incorrect",
    "Closing-Please-Wait": "Closing, please wait...",
    "API-Enabled": "API enabled",
    "API-Disabled": "API disabled",
    "API-Delete-Success": "API deleted successfully",
    "API-Add-Success": "API added successfully",
    "Enable-Secret-Confirm": "After enabling this secret key, other secret keys will be automatically disabled. Confirm to enable?",
    "Confirm-Enable": "Confirm Enable",
    Enable: "Enable",
    "Operation-Failed": "Operation failed",
    "Delete-Secret-Confirm": "After deleting the secret key, the related functions called with it will become unavailable. Confirm deletion?",
    "Confirm-Delete": "Confirm Delete",
    "Secret-Copied": "Secret key copied to clipboard",
    "Secret-Copy-Error": "Failed to copy secret key",
    "Daily-Message-Limit": "Daily Message Limit",
    "Phone-QR-Code": "{phone}'s QR code",
    "Download-QR-Code": "Download QR Code",
    "No-Phone-For-QR-Code": "No phone numbers available for QR code generation",
    Order: "Order",
    Product: "Product",
    "Upload-File": "Upload File",
    "Upload-Xls-Tip": "Please upload an xls file no larger than 60M",
    "Order-Replace-Tip": "New orders will be added, and existing orders will be replaced with the latest uploaded information",
    "Product-Override-Tip": "When uploaded products have the same information as existing ones, the system will overwrite the old information with the new one",
    "Contact-Search-Placeholder": "Email/Phone/Customer Name",
    "Social-Account": "Social Accounts",
    "API-Settings": "API Settings",
    "Secret-Table-Name": "Name",
    "Secret-Key": "Secret Key",
    "Webhook-Callback-URL": "Webhook Callback URL",
    "Created-At": "Created At (UTC+8)",
    "Enable-Switch": "Enable Switch",
    "Copy-Secret": "Copy Secret",
    More: "More",
    "Secret-Name-Placeholder": "Enter secret name, e.g. production environment secret",
    "API-Edit-Success": "API updated successfully",
    "Please-Enter-Secret-Name": "Please enter the secret name",
    "Please-Enter-Webhook": "Please enter the Webhook callback URL",
    "Shop-Detail": "Shop Details",
    "Mall-Avatar": "Mall Avatar",
    "Upload-Title": "Upload {name}",
    "Order-Manage": "Order Management",
    "Product-Manage": "Product Management",
    "Update-Success": "Updated successfully",
    "File-Too-Large": "File too large, max 60M allowed",
    "Xls-Only": "Only xls files are allowed",
    "Upload-Success": "Uploaded successfully",
    Currency: "Currency",
    "Product-Name": "Product Name",
    "Order-Detail": "Order Detail",
    Amount: "Amount",
    Recipient: "Recipient",
    Subtotal: "Subtotal: ",
    Tax: "Tax: ",
    "Total-Colon": "Total: ",
    "Tracking-Number": "Tracking Number",
    "Total-Products": "{count} products",
    "Payment-Time": "Payment Time",
    "Delivery-Time": "Delivery Time",
    // ===== Media - social account member authorization =====
    "Member-Authorization": "Member Authorization",
    "Member-Authorization-Add": "Add Member",
    "Member-Authorization-Add-Title": "Add Team Member",
    "Member-Authorization-Add-Desc": "Only regular team members can be selected. Please select the members to authorize.",
    "Member-Authorization-Search": "Search name / phone number",
    "Member-Authorization-Nickname": "Member Name",
    "Member-Authorization-Able-Add": "{count} members available",
    "Member-Authorization-Selected": "{count} selected",
    "Member-Authorization-Cancel-Select": "Clear selection",
    "Member-Authorization-Added": "Added to this account",
    "Member-Authorization-Confirm-Add": "Add",
    "Member-Authorization-Remove-Title": "Remove this team member?",
    "Member-Authorization-Remove-Desc": "Once removed from this social account, the member will no longer have permission to view it. Add the member again to restore access.",
    "Member-Authorization-Remove": "Remove",
    "Member-Authorization-Success": "Member authorized successfully",
    "Product-Count": "Products",
    "Order-Count": "Orders",
  },
  library: {
    "Library-Name": "Repository",
    "Training-Status": "Training Status",
    "Enter-Content-Name": "Enter content name",
    "Add-Content": "Add Content",
    "Write-Online": "Write Online",
    "Upload-Content": "Upload Content",
    "Select-From-Library": "Select from Knowledge Base",
    "Grab-By-Link": "Grab by Link",
    "Content-Name": "Content Name",
    "Source": "Source: ",
    "Training-Progress": "Training Progress",
    "Train-Not-Started": "Not Trained",
    "Train-Training": "Training",
    "Train-Completed": "Training Completed",
    "Train-Failed": "Training Failed",
    "Use-Count": "Usage Count",
    "Creator-Time": "Creator / Created At",
    "Unknown": "Unknown",
    "Created-At": "Created At",
    "Operation": "Operation",
    "Edit-Content": "Edit Content",
    "Delete-Content": "Delete Content",
    "Edit": "Edit",
    "Delete": "Delete",
    "Delete-Confirm": "This action cannot be undone. Continue?",
    "Warning": "Warning",
    "New-Type": "New Type",
    "Enter-Type-Name": "Enter type name",
    "All-Types": "All Types",
    "Loading": "Loading...",
    "No-More": "No more",
    "Type-Name": "Type Name",
    "Edit-Type": "Edit Type",
    "Add-Type": "Add Type",
    "Type-Name-Required": "Type name cannot be empty",
    "Delete-Type-Confirm": "This action cannot be undone! Delete \"{name}\"?",
    "Tip": "Tip",
    "Upload-Filter-Tip": "Tables and images are not supported in uploaded content and will be filtered automatically!",
    "Select-File": "Select File: ",
    "Select-File-Btn": "Select File",
    "Upload-Format-Tip": "Supported types: .txt, .pdf, .ppt. TXT up to 100K, PDF and PPTX up to 200M, up to 100 files",
    "Cancel": "Cancel",
    "Confirm": "Confirm",
    "Please-Select-File": "Please select a file",
    "Uploading": "Uploading file, please submit later",
    "File-Format-Error": "{name} file format error",
    "TXT-Size-Limit": "{name} TXT file size cannot exceed 100K",
    "PDF-Size-Limit": "{name} PDF file size cannot exceed 200M",
    "File-Limit": "A maximum of 10 files can be selected",
    "Write-Online-Title": "Write Online",
    "Enter-Content-Title": "Enter content title (2-45 characters)",
    "Enter-Content": "Enter content",
    "Word-Count": "3000 characters in total",
    "Source-Label": "Source: ",
    "Enter-Source": "Enter source",
    "Author-Label": "Author: ",
    "Enter-Author": "Enter author name",
    "Publish": "Publish",
    "Title-Required": "Please enter content name",
    "Content-Required": "Please enter content",
    "Saved": "Saved",
    "Grab-Link-Content": "Grab Link Content",
    "Grabbed-Links": "Grabbed Links",
    "Grab-Warning-1": "Please avoid illegally scraping others' websites. Make sure the link is publicly accessible and the content is copyable!",
    "Grab-Warning-2": "Supports grabbing a single URL or all URLs related to a URL",
    "Grab-Warning-3": "When grabbing URLs related to a page, the system automatically visits the URL and grabs all text content and all links starting with the URL. The more URLs, the slower it gets. At most 600 URLs per grab!",
    "Grab-Warning-4": "Already grabbed content will be filtered automatically. Duplicate content already in the system will not be grabbed again",
    "Grab-Type": "Grab Type: ",
    "Single-Link-Page": "Single Link Page",
    "Related-Link-Page": "Related Link Pages",
    "Link-Url": "URL: ",
    "Enter-Link": "Please enter a link",
    "Enter-Link-Url": "Please enter a link starting with http:// or https://",
    "Link-Example": "e.g. To grab all content under https://www.example.com/active/, just enter https://www.example.com/active/",
    "Add-Link": "Add Link",
    "Grabbed-Content": "Grabbed content ({n} links in total)",
    "Start-Parse-Url": "Start Parsing URL",
    "Back": "Back",
    "Grab-Store": "Grab and Store",
    "Grabbing-Tip": "Grabbing links, please do not close the browser",
    "Store-Classify": "Store Category",
    "Enter-Source-Name": "Enter source website name",
    "Enter-Author-Name": "Enter author name",
    "Back-Confirm": "Going back will delete the pages grabbed on this page!",
    "Careful-Operation": "Careful Operation",
    "Parsing-Link": "Parsing link, please wait...",
    "No-Content": "No content found under the link you entered. Please check or change the link",
    "Select-Cs-Content": "Select Customer Service Content",
    "View-Detail": "View Details",
  },
  dataReport: {
    "Data-Report": "Reports",
    "All-Bots": "All Bots",
    "Conversation-Bot": "Conversation Bot",
    "Homepage-Bot": "Homepage Bot",
    "Email-Bot": "Email Bot",
    "To": "to",
    "Start-Date": "Start Date",
    "End-Date": "End Date",
    "Scene-Num": "Scene Count",
    "Scene-Num-Desc": "The specific number of scenes triggered by users",
    "Scene-Interaction-Count": "Scene Interaction Count",
    "Scene-Interaction-Desc": "The cumulative number of times user interactions triggered scenes",
    "Scene-Interaction": "Scene Interaction",
    "Interaction-Data": "Interaction Data",
    "Service-List": "Service List",
    "Enter-Service-Name": "Enter service name",
    "Bot-Info": "Bot Info",
    "Created-At-Prefix": "Created at: ",
    "User-Interaction-Count": "User Interaction Count",
    "User-Interaction-Count-Desc": "The number of interactions between users and bots",
    "User-Interaction-People": "Users Interacted",
    "User-Interaction-People-Desc": "The number of users who interacted with bots",
    "Person-Reply-Count": "Manual Reply Count",
    "Person-Reply-Count-Desc": "Customer interaction questions replied to by customer service staff",
    "AI-Reply-Count": "AI Auto Reply Count",
    "AI-Reply-Count-Desc": "Customer interaction questions replied to by AI",
    "Person-Reply-Proportion": "Manual Reply Proportion",
    "Person-Reply-Proportion-Desc": "The percentage of manual replies in total replies",
    "Service-Person-Reply-Proportion": "Service Manual Reply Proportion",
    "AI-Reply-Proportion": "AI Auto Reply Proportion",
    "AI-Reply-Proportion-Desc": "The percentage of AI replies in total replies",
    "Operation": "Operation",
    "View-Detail": "View Details",
  },
  mailStatistics: {
    "Mail-Bot-Statistics": "Mail Bot Statistics",
    "Beijing-Time": "Beijing Time (UTC+8:00)",
    "Data-Overview": "Data Overview",
    "Compared-To-Last": "vs. last period",
    "Total-Emails": "Total Emails",
    "All-History-Emails": "All historical emails",
    "Total-Emails-Tip": "Cumulative number of emails received up to the latest date",
    "Unreplied-Emails": "Unreplied Emails",
    "All-Unreplied-Emails": "All emails pending reply",
    "Unreplied-Emails-Tip": "Total number of unreplied emails up to the latest date",
    "New-Emails": "New Emails",
    "New-Emails-Tip": "Number of emails received within the selected period",
    "Replied-Emails": "Replied Emails",
    "Replied-Emails-Tip": "Number of emails replied to within the selected period",
    "Man-Replies": "Manual Replies",
    "Man-Replies-Tip": "Number of emails replied to manually within the selected period",
    "AI-Replies": "AI Replies",
    "AI-Replies-Tip": "Number of emails replied to by AI within the selected period",
    "Mail-Processing-Analysis": "Email Processing Analysis",
    "Mail-Processing-Trend": "Email Processing Trend",
    "Mail-Replied-Ratio": "Replied Email Ratio",
    "New-Emails-Replies": "New Email Replies",
    "History-Emails-Replies": "Historical Email Replies",
    "Mail-Detail": "Email Details",
    "Seat-Detail": "Seat Details",
    "Enter-Email-Address": "Enter email address",
    "Enter-User-Name": "Enter user name",
    "Mail-Name": "Email",
    "Total-Emails-Colon": "Total Emails: ",
    "Unreplied-Emails-Colon": "Unreplied: ",
    "New-Emails-Col": "New Emails",
    "Replied-Emails-Col": "Replied Emails",
    "Man-Replied-Col": "Manual Replies",
    "AI-Replied-Col": "AI Replies",
    "User-Name": "User Name",
    "Email-Count": "Email Count",
    "Reply-Emails": "Replies",
  },
  ctwa: {
    // ===== Common =====
    "Ad-Account": "Ad Account",
    "Ad-Account-Detail": "Ad Account Details",
    "Account-Info": "Account Info",
    "Account-Id": "Account ID",
    "Account-Id-Prefix": "Account ID: ",
    "Account-Name": "Account Name",
    "Account-Status": "Account Status",
    "Channel": "Channel",
    "Auth-Time": "Authorized At",
    "Status": "Status",
    "Operation": "Operation",
    "Detail": "Details",
    "View-Detail": "View Details",
    "Cancel-Auth": "Cancel Authorization",
    "Cancel-Auth-Confirm": "Once the ad account authorization is canceled, CTWA data will no longer be shown. Confirm cancellation?",
    "Confirm-Cancel-Auth": "Confirm",
    "Cancel-Auth-Success": "Authorization canceled: {name}",
    "Auth-Success": "Ad account authorized",
    "Auth-Failed": "Authorization failed",
    "Auth-Loading": "Authorizing ad account, please wait...",
    // Search / input
    "Search-Account-Placeholder": "Enter account name or ID",
    "Enter-Nickname": "Enter nickname",
    // Summary metrics
    "Spend": "Spend ($)",
    "Total-Spend": "Total Spend ($)",
    "Impressions": "Impressions",
    "Ad-Impressions": "Ad Impressions",
    "Total-Impressions": "Total Impressions",
    "Clicks": "Clicks",
    "Total-Clicks": "Total Clicks",
    "Reach": "Reach",
    "Contact-Count": "Contacts",
    "Total-Contact-Count": "Total Contacts",
    "Purchase-Count": "Purchases",
    "Order-Amount": "Order Amount($)",
    "Total-Order-Amount": "Order Amount ($)",
    "ROI": "ROI",
    "ROI-Rate": "ROI Rate",
    // Conversion funnel
    "Conversion-Funnel": "Conversion Funnel",
    "Funnel-Ad-Reach": "Ad Reach",
    // Tabs / sections
    "Tab-Accounts": "Ad Accounts",
    "Tab-Contacts": "Contacts",
    "Tab-Ads": "Ad Stats",
    "Tab-Contacts-Data": "Contact Data",
    "Export-Data": "Export Data",
    // Ad detail drawer
    "Ad-Detail": "Ad Details",
    "Ad-Id": "Ad ID",
    "Ad-Id-Account": "Ad ID · Account {name}",
    "Id-Detail": "ID {id} · Ad Account Details",
    "Total-People": "{count} contacts",
    // Contact columns (no reusable existing keys)
    "First-Contact-Time": "First Contact Time (UTC+08:00)",
    "First-Order-Time": "First Order Time (UTC+08:00)",
    // Ad account status (apiCTWA.js accountStatusMap)
    AccountStatus: {
      Normal: "Active",
      Disabled: "Disabled",
      Unpaid: "Unpaid Bill",
      RiskReview: "Pending Risk Review",
      PendingSettlement: "Pending Settlement",
      GracePeriod: "In Grace Period",
      PendingClose: "Pending Closure",
      Closed: "Closed",
    },
    // Ad delivery status (CTWADetail.vue adStatusMap)
    AdStatus: {
      Active: "Active",
      Paused: "Paused",
      Deleted: "Deleted",
      Archived: "Archived",
      CampaignPaused: "Campaign Paused",
      AdsetPaused: "Ad Set Paused",
      PendingReview: "Pending Review",
      Disapproved: "Disapproved",
      Preapproved: "Preapproved",
      PendingBillingInfo: "Pending Billing Info",
      InProcess: "In Process",
      WithIssues: "With Issues",
    },
  },
  team: {
    "Team-Manage": "Teams",
    "Member-Manage": "Member Management",
    "Member-Detail": "Member Details",
    // Keep member-edit authorization labels together so both locales expose the same page actions.
    "Edit-Member": "Edit Member",
    "Edit-Basic-Info": "Edit Basic Info",
    "Basic-Info-Update-Success": "Basic information saved",
    "Basic-Info-Update-Failed": "Failed to save basic information, please try again later",
    "Label-Authorization": "Label Authorization",
    "Authorized-Tag-List": "Authorized Tag List",
    "Authorized-Tag-Tip": "This member can view social accounts with these tags.",
    "Tag-Count": "{count} tags",
    "Tag-Name": "Tag Name",
    "Select-Tags": "Select tags",
    "Delete-Tag-Confirm": "Delete tag \"{name}\"?",
    "Save": "Save",
    "No-Data": "No Data",
    "User-Avatar": "User Avatar",
    "Team-Settings": "Team Settings",
    "Consumption-Records": "Consumption Records",
    "Billing-Rules": "Billing Rules",
    "Recharge": "Team Balance Recharge",
    "Expenditure-Detail": "Details",
    "Search-Member-Name": "Enter member name",
    // Keep the redesigned member list filters, account column, and actions translated together.
    "Search-Member-Details": "Search name, phone, or email",
    "Select-Member-Role": "Select member role",
    "Authorized-Account-Count": "Authorized Accounts",
    "All-Accounts": "All accounts",
    // Tooltip in the administrator account column explaining the all-accounts permission.
    "All-Accounts-Tip": "Administrators can view all social accounts in the Social Accounts module.",
    "Account-Count": "{count} accounts",
    "Set-Role-Permissions": "Set role permissions",
    "Transfer-Permissions": "Transfer permissions",
    "More": "More",
    // Keep the design's pagination wording here so it can be updated with the shared component later.
    "Pagination-Go-To": "Go to",
    "Pagination-Page": "Page",
    "Select-Activation-Status": "Select activation status",
    "Inactive": "Inactive",
    "Active": "Active",
    "Select-Role": "Select role",
    "Super-Admin": "Super Admin",
    "Admin": "Admin",
    "Team-Member": "Team Member",
    "Member": "Member",
    "Invite-Member": "Invite Member",
    "Personal-Info": "Personal Info",
    "New-Member": "New Member {id}",
    "Myself": "Me",
    "Email-Not-Bound": "Email not bound",
    "Email-Not-Set": "Email not set",
    "Mobile-Not-Added": "Mobile not added",
    "Role": "Role",
    "Activation-Status": "Activation Status",
    "Join-Time": "Join Time",
    "Operation": "Operation",
    "Re-Invite": "Re-invite",
    "Recall-Invite": "Recall Invitation",
    "Handover-Admin": "Hand Over Super Admin",
    "Edit": "Edit",
    "Remove-Team": "Remove from Team",
    "Remove-Team-Success": "Removed from Team",
    "Remove-Team-Failed": "Failed to remove from Team, please try again later",
    "Remove-Team-Confirm": "Selected user: {name}\nAfter removal, this user will no longer be able to view files created in this team!",
    "Remove-Team-Title": "Remove from Team",
    "Sent": "Sent",
    "Recalled": "Recalled",
    "Recall-Invite-Confirm": "After recalling the invitation, the user will not be able to join the team through the invitation link you sent before",
    "Recall-Invite-Title": "Recall Invited User",
    "Change-Name-Desc": "Modify the remark name in the current team; remarks in other teams will not be changed",
    "Change-Name-Title": "Modify Name",
    "Enter-New-Name": "Enter a new name",
    "Add-Member": "Add Member",
    "Add-Member-Subtitle": "Fill in the member's phone number and team role to complete the invitation",
    // Shared explanation for link and email invitations after direct member creation was removed.
    "Invite-Member-Subtitle": "Invite members to join the team by link or email and start collaborating.",
    "Add-Email": "Add",
    "Add-Member-Success": "Member added successfully",
    "Add-Success-Tip-1": "1. First-time login requires phone number and verification code",
    "Add-Success-Tip-2": "2. After login, you can set your account password in Personal Center",
    "Admin-Desc": "Can manage members and team settings",
    "Confirm-Add": "Confirm Add",
    "Confirm-Handover": "Confirm Handover",
    "Current-Role": "Current role",
    "Enter-Member-Name": "Please enter member name",
    "Enter-Member-Email": "Enter member email address",
    "Handover-Success": "Handover completed",
    "Handover-Title": "Hand Over Super Admin",
    "Handover-Warning-Header": "Super Admin Permission Handover",
    "Handover-Warning-Desc": "After handover, you will be downgraded to Admin, and the receiver will become the sole Super Admin. This operation cannot be undone.",
    "Login-Phone": "Login phone number",
    "Member-Desc": "Can use team tools and resources",
    "Phone-Required": "Please enter phone number",
    "Receiver": "Receiver",
    "Team-Role": "Team Role",
    "Member-Nickname": "Member Nickname",
    "Basic-Info": "Basic Info",
    "Name": "Name",
    "Phone": "Phone",
    "Email": "Email",
    "WeChat": "WeChat",
    "Account-Rules": "Account Assignment Rules",
    "Rules-Desc": "Rules Description",
    "Rules-Name": "Rule Name",
    "Self-Authorization": "Self Authorization",
    "Delete": "Delete",
    "Add-Tag": "Add Tag",
    "Submit": "Submit",
    "Social-Accounts": "Social Accounts",
    "Social-Account-List": "Social Account List",
    "Social-Account-List-Tip": "View the member's accessible social accounts and related labels.",
    "Social-Account-Total": "{count} accounts total",
    "Add-Account": "Add Account",
    "Remove-Account": "Remove",
    "All-Platforms": "All Platforms",
    "All-Rules": "All Rules",
    "Search-Account-Name": "Enter social account name",
    "Account-Info": "Account Info",
    "Page-Info": "Page Info",
    "Account-Tags": "Account Tags",
    "Certified": "Certified",
    "Uncertified": "Uncertified",
    "No-Social-Account": "No social accounts",
    "Change-Avatar": "Change Avatar",
    "Social-Accounts-Count": "Social Accounts ({count})",
    "Public-Page": "Public Page",
    "Authorized": "Authorized",
    "Unauthorized": "Unauthorized",
    "Followers": "{count} followers",
    "0-Followers": "0 followers",
    "Delete-Auth-Confirm": "Are you sure you want to delete this user's authorization for this page? After deletion, this page will be invisible to this user.",
    "Careful-Operation": "Confirm Operation",
    "Delete-Success": "Deleted successfully",
    "Delete-Failed": "Deletion failed",
    "Delete-Failed-Retry": "Deletion failed, please try again later",
    "Fetch-Member-Failed": "Failed to fetch member details",
    "Fetch-Tags-Failed": "Failed to fetch member tags",
    "Fetch-Tag-List-Failed": "Failed to fetch tag list",
    "Fetch-Account-Failed": "Failed to fetch social accounts",
    "Missing-Info": "Missing member or page info",
    "Finish-Tag-Selection": "Please finish the current tag selection first",
    "Missing-Submit-Info": "Missing member or team info, cannot submit for now",
    "Avatar-Upload-Failed": "Avatar upload failed",
    "Change-Avatar": "Change avatar",
    "Submit-Failed": "Failed to submit, please try again later",
    "Submit-Success": "Submitted successfully",
    "Invite-Title": "Invite Member",
    "Invite-Email": "Email",
    "Invite-Name": "Name",
    "Invite-Role": "Role",
    "Invite-Send": "Send Invitation",
    "Invite-Link": "Invitation Link",
    "Copy-Link": "Copy Link",
    "Copy-Success": "Copied successfully",
    "Invite-Success": "Invitation sent",
    "Select-Role-Required": "Please select a member role",
    "Email-Valid": "Please enter a valid email address",
    "Invite-Method": "Invitation Method",
    "Link-Invite": "Link Invitation",
    "Email-Invite": "Email Invitation",
    "Link-Info": "Link Info",
    "Invitee-Email": "Invitee Email",
    "Email-Placeholder": "Enter email addresses and press Enter to add to the invitation list",
    "Email-Address": "Email Address",
    "Invite-Link-Prefix": "Invitation Link: ",
    "Inviter-Prefix": "Inviter: ",
    "Invite-Team-Prefix": "Inviting Team: ",
    "Link-Valid-Prefix": "Link Validity: ",
    "Long-Term": "Long-term valid",
    "To": "to",
    "Change-Role-Title": "Modify Role",
    "Handover-Super-Admin": "Hand Over Super Admin",
    "Selected-User": "Selected User",
    "Target-Role": "Target Role",
    "Handover-Desc": "After the super admin handover is completed, the current super admin will be downgraded to admin",
    "Select-Receiver": "Select receiver",
    "Package-List": "Team Packages",
    "Current-Package": "Current Package",
    "Upgrade-Package": "Upgrade Package",
    "Renew-Package": "Renew",
    "Buy-Package": "Buy Package",
    "Package-Expire": "Expiry Date",
    "Package-Price": "Price",
    "Package-Duration": "Duration",
    "Package-Details": "Package Details",
    "Unpaid": "Unpaid",
    "Paid": "Paid",
    "Auto-Renew": "Auto Renew",
    "Package-Content": "Package Content",
    "Manual-Renew": "Manual Renewal",
    "Modify-Settings": "Modify Settings",
    "Monthly": "Billed Monthly",
    "Yearly": "Billed Yearly",
    "Original-Price": "Original Price",
    "Current-Price": "Current Price",
    "Valid-Until": "Valid Until",
    "Contact-Us": "Contact Us",
    "Next-Month-Package": "Next Month Package",
    "Current-Month-Package": "Current Month Package",
    "Expired-Package": "Expired Package",
    "Auto-Renew-Notice": "Your package will be auto-renewed next month. To stop it, go to the \"Next Month Package\" settings in Team Packages and turn off \"Auto Renew\".",
    "Auto-Renew-Title": "Auto Renew Notice",
    "Got-It": "Got it",
    "Auto-Renew-Closed": "Closed",
    "Purchase-Title": "Buy Package",
    "Select-Package": "Select Package",
    "Save-Settings": "Save Settings",
    "Go-Pay": "Go to Pay",
    "Selected-Package": "Selected Package",
    "Package-Price-Label": "Package Price",
    "Month": "month",
    "Change-Package": "Change Package",
    "Package-Effective-Time": "Package Effective Time",
    "Days-Left": "{n} days left this month",
    "Payment-Channel": "Payment Channel",
    "Bot-Settings": "Bot Settings",
    "Bot-Settings-Desc": "Adjust the bot's operation strategy, choose to continue operating or stop operating the bot",
    "Fee-Details": "Fee Details",
    "Total-Amount": "Total Amount",
    "Ad-Discount-Rate": "Ad Member Discount Rate",
    "Ad-Discount-Amount": "Ad Member Discount Amount",
    "Actual-Pay": "Actual Payable",
    "Date-Tip": "This product package is calculated by calendar month, valid until the last day of the current month, and the package fee is charged proportionally based on the remaining days of the month.\nDifference supplement rules details\nFee calculation: The package fee is fixed at 158 yuan and does not change with the purchase date.\nRemaining days calculation at purchase: If the user purchases the package in the middle of a calendar month, we offer a discount, i.e. the fee is reduced proportionally based on the remaining days. The specific calculation is as follows:\nCalculate remaining days: the days from the purchase date to the last day of the current month.\nCalculate the discounted fee: the package fee multiplied by the proportion of remaining days to the whole calendar month.\nExample: If the user purchases on January 15, January has 31 days, and the remaining days are 16 (31-15). Discounted fee = 158×(16/31)\nResult: According to the above calculation, the discounted fee is: 158×(16/31)=80 yuan\n",
    "Current-Month-Upgrade": "Current Month Package Upgrade",
    "Next-Month-Settings": "Next Month Package Settings",
    "Next-Month-Purchase": "Next Month Package Purchase",
    "Next-Month-Upgrade": "Next Month Package Upgrade",
    "Set-Success": "Set successfully",
    "Tip": "Notice",
    "Bot-Limit-Alert": "The selected package supports {n} operable bots. Please adjust your bot operation status!",
    "Operation-Success": "Operation Successful",
    "Next-Month-Rule-Notice": "This rule will take effect next month. If you are not satisfied, you can modify the settings at any time.",
    "Pay-Success-Notice": "Thank you for your purchase! Your package will be auto-renewed next month with the same rules as this month. To adjust, please go to the next month settings in Team Packages.",
    "Price-Changed-Alert": "The fee details of the current package purchase have changed. Click \"Confirm\" to refresh the price",
    "Balance-Insufficient-Notice": "The current team balance is insufficient to complete the bot purchase. Please recharge the team balance first, then try again!",
    "Recharge-Success-Short": "Recharged",
    "Go-Recharge": "Go Recharge",
    "First-Buy-Auto-Renew-Notice": "Thank you for your purchase! You can also enable the auto-renewal feature. The system will automatically renew your bots on the first day of the next month, ensuring uninterrupted bot service.",
    "Auto-Renew-Balance-Notice": "The auto-renewal amount is deducted from the team balance",
    "Enable-Auto-Renew": "Enable Auto Renew",
    "Disable": "Don't Enable",
    "Auto-Renew-Enabled-Notice": "The system will automatically deduct the payment on the first day of every month according to the current bot package. Please make sure your team balance is sufficient to ensure smooth auto-renewal.<br />If you wish to disable auto-renewal, you can turn it off in \"Team Packages -> Next Month Package Settings\".",
    "Auto-Renew-Enabled-Title": "Auto Renew Enabled",
    "Go-See": "Go Check",
    "Verification-Code-Error": "Verification code error, please re-enter.",
    "Payment-Method": "Payment Method",
    "Wechat-Pay": "WeChat Pay",
    "Alipay-Pay": "Alipay",
    "Pay-Now": "Pay Now",
    "Pay-Success": "Payment successful",
    "Pay-Failed": "Payment failed",
    "Total-Price": "Amount Payable",
    "Recharge-Amount": "Recharge Amount",
    "Recharge-Rate": "Recharge Rate",
    "Rate-Amount": "Rate Amount",
    "Enter-Recharge-Amount": "Enter recharge amount",
    "Recharge-Success": "The funds have entered the team balance. If you find the funds incorrect, please contact the product consultant for assistance!",
    "Pay-Success-Title": "Payment Successful",
    "Team-Balance": "Team Balance",
    "Balance-Insufficient": "Insufficient balance",
    "Filter-All": "All",
    "Select-Bot": "Select Bot",
    "Bot-Name": "Bot Name",
    "Search-Bot": "Enter bot name",
    "Default-AI-Model": "Default AI Model",
    "Default-AI-Model-Desc": "The bot model used by default when AI generates content",
    "Modify-AI-Model": "Modify AI Model",
    "Modify-AI-Model-Desc": "After modifying the default model, the system will use this model when calling AI!",
    "Modify-AI-Model-Success": "AI model modified successfully",
    "Modify-Team-Name": "Modify Team Name",
    "Team-Name-Input-Error": "Please enter a 2-10 character team name without special characters",
    "Team-Name-Placeholder": "Enter team name",
    "Modify-Team-Name-Success": "Team name modified successfully",
    "Dissolve-Team": "Dissolve Team",
    "Dissolve-Team-Confirm": "After dissolution, the team cannot be restored and all team content will be deleted. Please proceed with caution!",
    "Delete-Success-Ex": "Deleted successfully!",
    "Billing-Rules-Title": "Billing Rules Description",
    "Billing-Mode-1": "1. Payment Mode",
    "Billing-Mode-1-Desc": "{brand} adopts a prepaid model. Before using the product, you need to prepay funds via WeChat or Alipay to ensure sufficient balance in your account.",
    "Billing-Mode-2": "2. Deduction Mode",
    "Billing-Mode-2-Desc": "{brand} charges based on the number of words used. Each word used will deduct the corresponding amount. Different AI models have different deduction rates, and you can choose different models when using.",
    "Billing-Mode-3": "3. Model Amount Ratio",
    "Billing-Mode-3-Desc": "{model}&nbsp;&nbsp;&nbsp;&nbsp;1 yuan = {count} words",
    "Billing-Mode-4": "4. Billing Date",
    "Billing-Mode-4-Desc": "The bill for the previous day is generated at 0:00 every day, and today's bill does not show details.",
    "Consumption-Title": "Consumption Records",
    "Cost-Summary": "Cost Summary",
    "Total-Cost": "Total Cost (yuan)",
    "Online-Cost": "Online Customer Service (yuan)",
    "Posts-Cost": "Post Management (yuan)",
    "Email-Cost": "Email Reply (yuan)",
    "Write-Cost": "Writing Module (yuan)",
    "Adviser-Cost": "Advisor Module (yuan)",
    "Library-Cost": "Knowledge Base (yuan)",
    "Consumption-Date": "Consumption Date",
    "Consumption-Type": "Consumption Type",
    "Consumption-Amount": "Consumption Amount",
    "Expenditure-Detail-Title": "Expenditure Details",
    "Bot-Robot": "Bot",
    "Created-At": "Created on",
    "Continue-Operating": "Continue Operating",
    "Stop-Operating": "Stop Operating",
    "Bot-Info": "Bot Info",
    "Operating-Status": "Operating Status",
    "Team-Balance-Payment": "Team Balance Payment",
    "Verification-Code": "Verification Code",
    "Enter-Verification-Code": "Please enter the verification code",
    "Enter-SMS-Code": "Please enter the SMS verification code",
    "Resend-After-Seconds": "Resend in {n}s",
    "Get-Verification-Code": "Get Verification Code",
    "Verification-Code-Sent": "Verification code sent successfully",
    "Warning": "Warning",
    "Team-Balance-Admin-Warning":
      "<p>To pay with team balance, the team super administrator needs to provide a mobile number verification code. Currently, as the team super administrator, you have not bound a mobile number yet, so payment cannot be made. Please follow these steps to bind your mobile number:</p><br /><p>Log in to the system.</p><p>Click the avatar in the upper right corner of the page.</p><p>Enter \"Personal Center\".</p><p>Select the \"Change Mobile Number\" module.</p><p>Bind your mobile number.</p><p>After binding, you can pay with the team balance.</p>",
    "Team-Balance-Member-Warning":
      "<p>To pay with team balance, the team super administrator needs to provide a mobile number verification code. Currently, the team super administrator has not bound a mobile number yet, so payment cannot be completed. Please ask the team super administrator to bind their mobile number following these steps:</p><br /><p>Log in to the system.</p><p>Click the avatar in the upper right corner of the page.</p><p>Enter \"Personal Center\".</p><p>Select the \"Change Mobile Number\" module.</p><p>Bind your mobile number.</p><p>After binding, you can pay with the team balance.</p>",
    "Finance-Info": "Finance Info",
    "Account-Overview": "Account Overview",
    "Available-Balance": "Available Balance ($)",
    "Alipay": "Alipay",
    "Wechat": "WeChat",
    "System-Gift": "System Gift",
    "Airwallex": "Airwallex",
    "Pending-Review": "Pending Review",
    "Review-Failed": "Review Failed",
    "Recharge-Button": "Recharge",
    "Account-Funds": "Account Funds",
    "Balance-History-Desc": "Current balance and recharge history",
    "Recharge-Balance": "Recharge Balance ($)",
    "Gift-Balance": "Gift Balance ($)",
    "Total-Recharged": "Total Recharged ($)",
    "Spend-Statistics": "Spending Statistics",
    "Payment-Frozen-Desc": "Payments and frozen spending",
    "Frozen-Spend": "Current Frozen Spend ($)",
    "Frozen-Tip":
      "When initiating a WhatsApp marketing message task, the system pre-freezes an equal amount of funds; after the task is sent, the frozen funds are automatically unfrozen and can be used for subsequent charges or withdrawals",
    "Yesterday-Spend": "Yesterday's Spend ($)",
    "Total-Spend": "Total Spend ($)",
    "Recharge-Records": "Recharge Records",
    "Payment-Status": "Payment Status",
    "Select-Recharge-Channel": "recharge channel",
    "Select-Consumption-Type": "Consumption Type",
    "Start-Date": "Start Date",
    "End-Date": "End Date",
    "Consumption-Time": "Consumption Time",
    // Consumption records show both the stored Beijing time and the account-local time.
    "Consumption-Time-Beijing": "Consumption Time (Beijing Time)",
    "Consumption-Time-Actual": "Consumption Time (Actual Timezone)",
    "Beijing-Timezone": "Beijing Time (UTC+08:00)",
    "Remark": "Remark",
    "Recharge-Time": "Recharge Time",
    "Order-Status": "Order Status",
    "Pending-Payment": "Pending Payment",
    "Recharge-Status-Failed": "Recharge Status: Failed",
    "Transaction-No": "Transaction No.: ",
    "Failure-Reason": "Failure Reason",
    "Recharge-Again": "Recharge Again",
    "Online-Recharge": "Online Recharge",
    "Currency-Select": "Currency",
    "USD-Label": "USD",
    "Recharge-Channel": "Recharge Channel",
    "Confirm-Recharge": "Confirm Recharge",
    "Amount-Details": "Amount Details",
    "Current-Team-Balance": "Current team available balance",
    "Recharge-Rate-Amount": "Recharge Rate Amount",
    "Actual-Pay-Amount": "Actual Pay Amount",
    "Select-Currency": "Please select a currency",
    "Invalid-Amount": "Please enter a valid amount with at most two decimal places",
    "Amount-Greater-Zero": "Amount must be greater than 0",
    "LianLian": "LianLian",
    "Payment-Component-Failed": "Payment component failed to load, please try again later",
    "Recharge-Processing": "Recharge in progress, please check the recharge records for the final result",
    "Recharge-Accepted": "Recharge accepted, awaiting final confirmation",
    "Extra-Verification": "Please complete additional identity verification (e.g. 3DS verification)",
    "Payment-Session-Error": "Payment session error, please try recharging again",
    "Recharge-Cancelled": "Recharge cancelled or failed",
    "Recharge-Status-Unknown": "Unknown recharge status, please contact customer service",
    "Query-Status-Failed": "Failed to query payment status",
    "Buy-Bot-Package": "Buy Bot Package",
    "Export": "Export",
    "Addon-Pack": "Add-on Pack",
    "Exceed-After": "After Change",
    "Exceed-Back-Adjust": "Back to Adjust",
    "Exceed-Current-Used": "Current Usage",
    "Exceed-Handle": "Handle Excess",
    "Exceed-Normal": "Normal",
    "Exceed-Notice-Desc": "Some resource quotas in the new package are lower than your current usage. Exceeded resources will not be deleted, but will be paused after the new package takes effect. You need to confirm a retention plan first.",
    "Exceed-Notice-Title": "Please first confirm the impact of the package change on current resources",
    "Exceed-Over-N": "Exceeded by {n}",
    "Exceed-Plan-Quota": "{name} Quota",
    "Exceed-Resource": "Resource",
    "Exceed-Table-Title": "Quota Change",
    "Exceed-Title": "Package Change Confirmation",
    "Expansion-Addon-Payable": "Add-on Payable Amount",
    "Expansion-Buy": "Extend Add-on",
    "Expansion-Current-Remain-Valid": "Current Package Remaining Validity",
    "Expansion-Expired": "Expired",
    "Expansion-Resource-Situation": "Resource Status",
    "Expansion-Selected-Addon": "Selected Add-on",
    "Expansion-Subtitle": "Add-on packs are billed separately and expire together with the main package; they become invalid automatically after expiry",
    "Expansion-Title": "Expand Your Resource Quota",
    "Handle-Account-Info": "Account Info",
    "Handle-All-Status": "All Business Status",
    "Handle-Busy": "In Business",
    "Handle-Cancel": "Cancel",
    "Handle-Confirm": "Confirm Plan",
    "Handle-Data-Not-Ready": "Resource data is not ready yet, please try again later",
    "Handle-Exceed-N": "Exceeded quota by {n}",
    "Handle-Idle": "Idle",
    "Handle-Keep-Current-N": "Currently keep {n}",
    "Handle-Max-Enable-NoLimit": "After the new package takes effect, there is no limit on the number of enabled accounts. Accounts not kept will be paused.",
    "Handle-Max-Enable-Tip": "After the new package takes effect, at most {n} can be enabled. Accounts not kept will be paused.",
    "Handle-Max-Enable-Warn": "After the new package takes effect, at most {n} can be enabled",
    "Handle-No-Data": "No data",
    "Handle-No-Limit": "No limit",
    "Handle-Reduce-Other": "Other resource types still exceed the quota, please switch above and uncheck more accounts",
    "Handle-Reduce-Tip": "The number of kept accounts exceeds the new package quota, please uncheck {n} account(s) you do not want to keep",
    "Handle-Operating-Status": "Business Status",
    "Handle-Search-Placeholder": "Enter account name",
    "Handle-Selected": "Selected",
    "Handle-Submit-Failed": "Failed to submit the keep plan, please retry",
    "Handle-Subtitle": "Select the resources to continue using after the new package takes effect",
    "Handle-Title": "Handle Exceeded Resources",
    "List-Addon-Quota": "Add-on quota: {n}",
    "List-Package-Quota": "Package quota: {n}",
    "List-Quota-Composition": "Quota Composition",
    "List-Remaining": "Remaining",
    "List-Total-Quota": "Total Quota",
    "List-Used": "Used",
    "Package-Back-Subscribe": "Back to Subscribe",
    "Package-Buy-Title": "Buy {name}",
    "Package-Carried-Notice": "Current active add-on configuration has been carried in. Adjust the quantity as needed for this purchase",
    "Package-Config-Addon": "Configure Add-on",
    "Package-Current-Banner": "This subscription: JoinCompass {name}",
    "Package-Current-Valid-Days": "Current Package Validity",
    "Package-Day": "days",
    "Package-Days": "{n} days",
    "Package-Discount": "Discount",
    "Package-Fetch-Failed": "Failed to fetch package info. Please go back and choose a package again",
    "Package-Goods-Total": "Total Product Amount",
    "Package-Missing-Param": "Missing package parameter",
    "Package-Per-Month": "/mo",
    "Package-Per-Unit": "/unit",
    "Package-Per-Year": "/yr",
    "Package-Price-Tip": "This is the product price. The final payable amount is subject to the payment page",
    "Package-Resources-Title": "Packages & Resources",
    "Package-Selected-N": "Selected {n}",
    "Package-Subscribe-Page": "Subscribe Package",
    "Package-This-Purchase": "This Purchase",
    "Package-Valid-Immediately": "After payment, the new package takes effect immediately, and its validity is calculated from the date of purchase.",
    "Payment-Actual-Amount": "Actual Payment",
    "Payment-Addon-Total": "Add-on Total Amount",
    "Payment-Airwallex": "Airwallex",
    "Payment-Back-Addon": "Back to Extend Add-on",
    "Payment-Balance-Pay": "Balance Pay",
    "Payment-Balance-Still-Insufficient": "The balance is still insufficient after recharging. Please continue recharging",
    "Payment-Confirm-Pay": "Confirm Payment {amount}",
    "Payment-Details": "Payment Details",
    "Payment-Fee-Rate": "Fee {rate}%",
    "Payment-Insufficient-Go-Recharge": "Insufficient balance, go recharge",
    "Payment-Invalid-Order": "Invalid order. Please go back and choose a package again",
    "Payment-Months": "{n} months",
    "Payment-Months-Same-Expiry": "{n} months (expires together with the current package)",
    "Payment-Online-Pay": "Online Pay",
    "Payment-Package": "Package",
    "Payment-Package-Amount": "Package Amount",
    "Payment-Paying": "Paying...",
    "Payment-Purchase-Failed": "Purchase failed",
    "Payment-Purchase-Failed-Retry": "Purchase failed, please try again later",
    "Payment-Purchase-Info": "Purchase Info",
    "Payment-Purchase-Success": "Purchase successful",
    "Payment-Refund-1": "After paying for the new package, the new package takes effect immediately and the original package becomes invalid at the same time.",
    "Payment-Refund-2": "The unused portion of the original package will be refunded based on the remaining time.",
    "Payment-Refund-Notice": "Refund Notice",
    "Payment-Service-Fee": "Airwallex payment service fee ({rate}%)",
    "Payment-Subscribe-Package-Fee": "Package Subscription Fee",
    "Payment-Subscribe-Period": "Subscription Validity",
    "Payment-This-Fee": "This Purchase Fee",
    "Payment-Time": "Time",
    "Payment-Valid-Period": "Validity Period",
    "Product-Type": "Resource Type",
    "Product-Type-Email": "Email Account",
    "Product-Type-Listen": "Social Listening Keywords",
    "Product-Type-Listen-Short": "Listening Keywords",
    "Product-Type-Social": "Social Account",
    "Product-Type-Sub-1": "Business account for WhatsApp conversations and bulk messaging",
    "Product-Type-Sub-2": "Accounts for social platforms such as Facebook, Instagram and TikTok",
    "Product-Type-Sub-3": "Email accounts for email marketing and customer outreach",
    "Product-Type-Sub-4": "Connect and manage e-commerce standalone site channels",
    "Product-Type-Sub-5": "Keywords for social media monitoring and sentiment listening",
    "Product-Type-Website": "Standalone Site",
    "Product-Type-WhatsApp": "WhatsApp Account",
    "Quota-Addon-Of": "{name} Add-on",
    "Quota-Current-Of": "Current {name} Quota",
    "Quota-Detail-Of": "{name} Quota Details",
    "Resource-Type": "Resource Type {type}",
    "Subscribe-Active": "Subscribed",
    "Subscribe-Cheaper": "· Better Value",
    "Subscribe-Current": "Current Plan",
    "Subscribe-Month": "Monthly Subscription",
    "Subscribe-Monthly-Plan": "Monthly Plan",
    "Subscribe-Most-Popular": "Most Popular",
    "Subscribe-Quota": "Resource Quota",
    "Subscribe-Quota-Value": "{n}",
    "Subscribe-Save-Percent": "Annual Subscription · Save {n}%",
    "Subscribe-Subtitle": "Manage social accounts, email, WhatsApp, standalone sites and social listening in one place, and flexibly choose a package based on your team size",
    "Subscribe-Trial": "In Trial",
    "Subscribe-Trial-End-Notice": "days. Please subscribe to a paid plan after the trial ends to continue using",
    "Subscribe-Trial-Left": "Trial left",
    "Subscribe-Trial-Remaining": "Trial period left",
    "Subscribe-Year": "Yearly Subscription",
    "Subscribe-Yearly-Plan": "Yearly Plan",
    "Subscribe-Your-Package": "Subscribe to Your Package",
  },
  personal: {
    "Personal-Center": "Personal Center",
    "Personal-Profile": "Personal Profile",
    "Team-Profile": "Team Profile",
    "Nickname": "Nickname",
    "Mobile-Number": "Mobile Number",
    "Email": "Email",
    "Login-Account": "Account",
    "Login-Password": "Password",
    "Modify": "Modify",
    "Bind": "Bind",
    "Set-Up": "Set Up",
    "Change-Avatar": "Change Avatar",
    "Exit-Team": "Exit Team",
    "Change-Phone": "Change Mobile Number",
    "Change-Email": "Change Email",
    "Change-Phone-Title": "Change Mobile Number",
    "Change-Email-Title": "Change Email",
    "Confirm-Exit-Team": "Confirm Exit Team",
    "Mobile-Not-Bound": "Mobile number not bound",
    "Email-Not-Bound": "Email not bound",
    "Enter-Login-Account": "Please enter the login account",
    "Enter-Login-Password": "Please enter the login password",
    "Please-Enter-New": "Please enter a new {name}",
    "Current-Name": "Current {name}",
    "New-Name": "New {name}",
    "Modify-Success": "{name} modified successfully",
    "Not-Bound": "Not Bound",
    "Bound": "Bound",
    "Bind-Success": "Bound successfully",
    "Verification-Code": "Verification Code",
    "Enter-Verification-Code": "Please enter the verification code",
    "Get-Code": "Get Code",
    "Mobile-Number-Short": "Mobile Number",
    "Email-Short": "Email",
    "Confirm-Exit-Team-Desc": "After exiting the team, you will no longer be able to access the team's files and data. This action cannot be undone!",
    "Exit-Team-Success": "Exited team successfully",
    "Enter-New-Nickname": "Please enter a new nickname",
    "Nickname-Length-Error": "Nickname must be 1-20 characters",
    "Nickname-Empty-Error": "Nickname cannot be empty",
    "Nickname-Updated": "Nickname updated successfully",
    "Personal-Info": "Personal Info",
    "Create-Account-Password": "Create Account & Password",
    "Create-Account-Password-Desc": "You have not created a login account yet. You need to create both the account and password this time.",
    "Create-Account-Password-Success": "Account and password created successfully",
    "Change-Password": "Change Password",
    "Enter-Old-Password": "Please enter the old password",
    "Enter-New-Password": "Please enter the new password",
    "Forgot-Password": "Forgot Password",
    "Enter-Password-Error": "Please enter the password",
    "Password-Format-Error": "Password must be at least 6 characters and contain both letters and numbers",
    "Change-Password-Success": "Password changed successfully",
    "Modify-Login-Account": "Modify login account",
    "Modify-Account": "Modify Account",
    "Account-Format-Error": "Please enter numbers and letters",
    "Modify-Account-Success": "Account modified successfully",
    "Modify-Nickname": "Modify Nickname",
    "Verify-Old-Tip": "To protect your account security, please verify the original {name}: {value}",
    "Enter-New-And-Code": "Please enter {isNew} {name} and the verification code",
    "New": "new",
    "Getting-Code": "Getting code",
    "Resend-After": "s before resend",
    "Enter-New-Mobile": "Please enter mobile number",
    "Enter-New-Email": "Please enter email",
    "Enter-SMS-Code": "Please enter SMS code",
    "Enter-Email-Code": "Please enter email code",
    "Mobile-Format-Error": "Please enter a valid mobile number",
    "Email-Format-Error": "Please enter a valid email",
    "Confirm-Replace-Tip": "Are you sure you want to replace the {name}: {value}?",
    "Confirm-Replace": "Confirm Replace",
    "Replace": "Replace",
    "Replace-Success": "Replaced successfully",
    "Replace-Failed": "Replacement failed",
    "Code-Required": "Verification code cannot be empty",
    "Get-Code-Success": "Verification code sent successfully",
    "Team-Module-Tip": "This module shows the team organizations you belong to",
    "Team-Info": "Team Info",
    "My-Role": "My Role",
    "Action": "Action",
    "Exit-Team-Confirm-Tip": "If you exit the team: {name}, your permissions in the team will be automatically removed.",
    "Exit-Team-Switch-Tip": "You have exited the team and been switched to team: {name}",
    "Warning": "Warning",
  },
  "bot-list": {
    "All-Bots": "All Bots",
    "Chat-Bot": "Chat Bot",
    "Page-Bot": "Page Bot",
    "Email-Bot": "Email Bot",
    "Bot-Type-Chat": "Chat",
    "Bot-Type-Page": "Page",
    "Bot-Type-Email": "Email",
    "Enter-Service-Name": "Please enter a service name",
    "All-Operating-Status": "All Operating Status",
    "Stop-Operation": "Stop Operation",
    "All-ToDos-Done": "All pending tasks have been processed",
    "Created-At": "Created at: ",
    "Reply-Content": "Reply content: ",
    "Reply": "Reply",
    "Cancel-ToDo": "Cancel To-Do",
    "Reply-ToDo-Message": "Reply To-Do Message",
    "Enter-Reply-Content": "Please enter reply content",
    "Bot-Stopped-Cannot-Reply": "The bot has stopped operating and cannot reply to messages!",
    "Independent-Site": "Independent Site",
    "Create-Bot": "Create Bot",
    "Create-Bot-Desc": "Quickly create a smart bot for your team",
    "Pending": "Pending",
    "Chat": "Chat",
    "Comment": "Comment",
    "Email": "Email",
    "Unread-Count": "{count} items",
    "FB-Page-Unavailable": "The current Facebook page is unavailable",
    "Auth-Invalid": "authorization has expired",
    "Email-Auth-Invalid": "Email authorization has expired",
    "Bot-Suffix": " Bot",
    "FB-And-INS": "Facebook and Instagram",
    "FB": "Facebook",
    "INS": "Instagram",
    "None": "None",
    "Bot-Operation": "Bot Operation",
    "Set-Bot": "Set Bot",
    "Copy-Bot": "Copy Bot",
    "Delete-Bot": "Delete Bot",
    "Message-Center": "Inbox",
    "Config-Bot": "Configure Bot",
    "Copy-Suffix": "copy",
    "Package-Quota-Used-Up": "Package quota used up",
    "Package-Quota-Used-Up-Desc": "Your current team package has reached the maximum number of bots. Please upgrade the package to create more bots.",
    "Go-Buy": "Go to Buy",
    "Cancel": "Cancel",
    "Delete-Bot-Confirm": "After the bot is deleted, it will no longer provide service. Continue?",
    "Warning": "Warning",
    "Confirm": "Confirm",
    "Delete-Success": "Deleted successfully!",
    "Bot-Close-Confirm": "After the bot is turned off, you need to wait 24 hours before turning it back on.",
    "Operation-Confirm": "Confirm Operation",
    "Operation-Success": "Operation successful",
    "Operation-Failed": "Operation failed",
    "Creating-Bot": "Creating bot...",
    "Create-Success": "Created successfully",
    "Bind-Other-Platforms-Confirm": "This bot can still bind other platforms. Continue binding?",
    "Create-Complete-Settings-Confirm": "The bot has been created. Continue to complete the settings?",
  },
  "bot-store": {
    "Next-Step-Set-Bot": "Next: Set Bot",
    "Prev-Step": "Previous",
    "Save-Settings": "Save Settings",
    "Bot-Avatar": "Bot Avatar: ",
    "Bot-Name": "Bot Name: ",
    "Bot-Desc": "Bot Description: ",
    "Enter-Bot-Name": "Please enter the bot name",
    "Enter-Bot-Desc": "Please enter the bot description",
    "Related-Email": "Related Emails",
    "Publishable-Platforms": "Publishable Platforms",
    "Please-Select-Bot-Type": "Please select a bot type first",
    "Chat-Bot": "Chat Bot",
    "Page-Bot": "Page Bot",
    "Email-Bot": "Email Bot",
    "Chat-Bot-Desc": "Supports Messenger, Instagram, WhatsApp, and independent websites",
    "Page-Bot-Desc": "Supports Facebook and Instagram comments",
    "Email-Bot-Desc": "Supports binding various types of email",
    "Smart-Bot": "Smart Bot",
    "Service-Settings": "Service Settings",
    "New-Bot": "New Bot",
    "Independent-Site": "Independent Site",
    "Messenger-About": "Facebook Messenger is a free comprehensive communication app that allows unlimited text, voice and video calls, as well as group video chats.",
    "Instagram-About": "Instagram is a free social app from Meta that provides online photo and video sharing.",
    "WhatsApp-About": "WhatsApp is a popular instant messaging app that lets users send text messages, voice messages, images and videos over the internet, and also supports voice and video calls.",
    "Site-About": "Insert a piece of JS code to easily add a smart customer service bot to your website.",
    "Facebook-About": "Facebook is a leading global social media platform where users can share information, photos and videos, stay connected with friends and family, and participate in various community activities.",
    "Package-Quota-Used-Up": "Package quota used up",
    "Package-Quota-Used-Up-Desc": "Your current team package has reached the maximum number of bots. Please upgrade the package to create more bots.",
    "Go-Buy": "Go to Buy",
    "Cancel": "Cancel",
    "Create-Success-Msg-1": "The bot has been created successfully! You can view the bound media information in Basic Info -> Publishable Platforms. You can also bind more media platforms in this module.",
    "Create-Success-Msg-2": "The bot has been created successfully! You can modify or bind more media platforms in Basic Info -> Publishable Platforms.",
    "Create-Success": "Created successfully",
    "Go-Set-Bot": "Go to Set Bot",
    "Back-To-List": "Back to List",
    "Notice": "Notice",
    "Confirm": "Confirm",
    "Email-Create-Success-Msg": "The bot has been created successfully. If you need to bind an email, please go to Basic Info -> Related Emails.",
    "Go-Edit": "Go to Edit",
    "Related-Email-Success": "Email linked successfully",
    "Change-Avatar": "Change Avatar",
    "Menu-Directory-Navigation": "Directory Navigation",
    "Menu-Basic-Settings": "Basic Settings",
    "Menu-Basic-Info": "Basic Info",
    "Menu-Service-Admin": "Service Admin",
    "Menu-Publishable-Platforms": "Publishable Platforms",
    "Menu-Reply-Settings": "Reply Settings",
    "Menu-Reply-Basic-Settings": "Basic Reply Settings",
    "Menu-Auto-Reply-Language": "Auto-Reply Language",
    "Menu-Service-Role": "Service Role Settings",
    "Menu-Knowledge-Base": "Knowledge Base",
    "Menu-Knowledge-Base-Settings": "Knowledge Base Settings",
    "Menu-E-Commerce": "E-Commerce Platforms",
    "Menu-Related-E-Commerce": "Related E-Commerce Platforms",
    "Menu-Product-Info": "Product Info",
    "Menu-Operation-Settings": "Operation Settings",
    "Menu-Operation-Scene": "Operation Scene Settings",
    "Menu-Manual-Reply-Reminder": "Manual Reply Reminder",
    "Menu-Public-Opinion": "Public Opinion Monitoring",
    "Menu-Specific-Post": "Specific Post Operation",
    "Menu-Related-Emails": "Related Emails",
    "Menu-Email-Default-Format": "Email Default Format",
    "Btn-Save-Settings": "Save Settings",
    "Btn-Add-Admin": "Add Admin",
    "Btn-Add-Exception-Rule": "Add Exception Rule",
    "Btn-Relate-Mall": "Relate Mall",
    "Btn-Update-Products": "Update Products",
    "Btn-Add-Scene": "Add Scene",
    "Btn-Add-Post": "Add Post",
    "Tip-Auto-Reply-Language": "When a user leaves a message in a specific language, reply in the specified language",
    "Tip-Service-Role": "You can enter a custom language style in the input box and press Enter to select it!",
    "Tip-Operation-Scene": "Whether the system auto-replies when a customer's question matches a specific scene",
    "Tip-Manual-Reply": "Set the manual reply notification push rules. After setting, push messages to bot admins at a unified time.",
    "Tip-Public-Opinion": "When enabled, the system will automatically hide malicious comments that match the definitions below",
    "Tip-Email-Format": "After enabling the preset email template, the system will send emails to customers in the template format.",
    "Update-Shopify-Shopline-Tip": "Only update product info for Shopify and Shopline stores",
    "Desc-Basic-Info": "Configure the bot, including setting its name, choosing an avatar, and writing a description.",
    "Desc-Service-Admin": "Customer service staff can be set when configuring the bot. When inquiries require manual handling, the bot will push notifications via WeChat.",
    "Desc-Publishable-Platforms": "Configure the bot to work on specific social media platforms and obtain the independent site service code.",
    "Desc-Related-Emails": "Manage the emails already associated with the bot.",
    "Desc-Reply-Basic-Settings": "When configuring the bot, you can set whether to enable auto-reply, reply frequency, a welcome message for first-time visitors, and a default reply when there is no answer.",
    "Desc-Auto-Reply-Language": "Configure the bot to set the language of user questions and reply in the corresponding language.",
    "Desc-Service-Role": "When setting the bot's AI auto-reply, you can define a specific persona and tone for the replies.",
    "Desc-Knowledge-Base-Settings": "Configure the bot to set the materials used for auto-replies, ensuring more accurate answers.",
    "Desc-E-Commerce": "Configure the bot to select the e-commerce platform it uses as reference materials, supporting features such as logistics tracking and pre-sales consultation.",
    "Desc-Product-Info": "View products on the e-commerce platforms associated with the bot.",
    "Desc-Operation-Scene": "Configure the scenes the bot can handle. When AI recognizes a corresponding scene, it processes it directly.",
    "Desc-Manual-Reply": "Set the notification push rules for manual replies. After configuration, messages are pushed to bot administrators at a unified time.",
    "Desc-Public-Opinion": "When the system detects malicious comments that meet the configured rules, it automatically hides them from the system.",
    "Desc-Specific-Post": "Set auto-reply for specific posts. After the system recognizes the corresponding scene, it processes it accordingly.",
    "Desc-Email-Default-Format": "The system sends emails to customers in the configured template format to keep the email format consistent.",
    "Enter-Bot-Desc-Info": "Please enter the bot description",
    "AI-Cmd-Introduce-Page": "I am an [E-commerce Platform]. Briefly output a general template introducing my Facebook page.",
    "Current-Model": "Currently Using Model",
    "Set-As-Default": "Set as Default",
    "Auto-Reply-Switch": "Auto Reply Switch: ",
    "Receive-Message": "Message Received: ",
    "Auto-Reply-After-Minutes": "minutes later, the system will reply automatically",
    "Welcome-Message": "Welcome Message: ",
    "AI-Cmd-Welcome": "I am an [E-commerce Platform]. Briefly output a welcome message template for a Facebook page.",
    "No-Answer-Reply": "No-Answer Reply: ",
    "AI-Cmd-No-Answer": "I am an [E-commerce Platform]. Output in one sentence a reply template for when the Facebook page receives a question that needs confirmation from colleagues.",
    "Reply-Language-Style": "Reply Language Style: ",
    "Select-Or-Enter-Language-Style": "Please select or enter a reply language style",
    "Mood-Formal": "Formal",
    "Mood-Rigorous": "Rigorous",
    "Mood-Humorous": "Humorous",
    "Mood-Friendly": "Friendly",
    "Mood-Professional": "Professional",
    "Mood-Warm": "Warm",
    "Mood-Lively": "Lively",
    "Mood-Serious": "Serious",
    "Mood-Relaxed": "Relaxed",
    "Mood-Enthusiastic": "Enthusiastic",
    "Mood-Calm": "Calm",
    "Character-Setting-Default-Template": "You are the operator of {name}, with 14 years of social media management and operations experience, including 6 years dedicated to Facebook post replies and user engagement. You are familiar with Facebook Community Standards and best practices. You can quickly capture the emotions and needs behind users' comments, have excellent written communication skills, and are good at wording. You can handle a variety of situations and provide users with appropriate replies and solutions. You are familiar with the brand's language and tone.\nCharacter traits: communicative, patient, professional and always friendly, highly sensitive to user feedback, and passionate about solving problems.",
    "Translate": "Translate",
    "Character-Setting": "Character Setting: ",
    "Character-Setting-Placeholder": "Please enter the role that the customer service plays. After setting, when users ask about the customer service identity, the system will inform them of the preset identity. When users ask questions, the system will think and answer from the perspective of this role.",
    "AI-Cmd-Character": "Briefly output a description of the service attitude and personality of an AI [E-commerce Customer Service].",
    "Select-Knowledge-Base": "Select Knowledge Base: ",
    "All-Knowledge-Bases": "All Knowledge Bases",
    "Bot-Specific-Knowledge-Base": "Bot-Specific Knowledge Base",
    "Knowledge-Base-Alert-1": "Use content from Join MC and team-specific knowledge bases as the knowledge base for this customer service.",
    "Knowledge-Base-Alert-2": "Set a dedicated knowledge scope for the bot, which only takes effect for this customer service.",
    "Auto-Public-Opinion-Control": "Auto Public Opinion Control: ",
    "Malicious-Comment-Definition": "Malicious Comment Definition: ",
    "Please-Enter": "Please enter",
    "AI-Cmd-Malicious": "I am an [E-commerce Platform]. Please list the common types of malicious comments encountered by e-commerce platforms comprehensively.",
    "Init-Malicious-Definition": "Initialize Malicious Comment Definition",
    "Facebook-Posts": "Facebook Posts",
    "Instagram-Posts": "Instagram Posts",
    "Select-Upload-Image": "Please select the image to upload",
    "Only-Support-JPG-PNG": "Only JPG and PNG formats are supported",
    "File-Size-Limit-5M": "File size cannot exceed 5M",
    "Current-Page-Unavailable": "The current page is unavailable",
    "Auth-Expired": "Authorization expired",
    "Current-Page-Normal": "The current page status is normal",
    "Normal": "Normal",
    "Media-Account": "Media Account",
    "Auth-Time": "Authorization Time",
    "Operator": "Operator",
    "Visit-Page": "Visit Page",
    "Unbind": "Unlink",
    "Edit-Site": "Edit Site",
    "View-Code": "View Code",
    "Not-Set": "Not Set",
    "Go-Bind": "Go to Bind",
    "Site-Settings": "Independent Site Settings",
    "Site-Name": "Site Name",
    "Enter-Site-Name": "Please enter the site name",
    "Domain-Address": "Domain Address",
    "Enter-Domain-Address": "Please enter a domain address starting with http:// or https://",
    "Domain-URL-Error": "Please enter a domain address starting with http:// or https://",
    "Get-Deploy-Code": "Get Deployment Code",
    "Copy-Code-Tip": "Please copy the code below and paste it into the <head> element of your website",
    "Close": "Close",
    "Copy-Code": "Copy Code",
    "Delete-Site-Confirm": "After deleting the independent site, the bot deployed on your website will no longer be able to provide services!",
    "Delete-WABA-Confirm": "After deleting the WABA account, the bot will stop providing services on the WhatsApp platform!",
    "Delete-Page-Confirm": "After deleting the page, the bot will no longer manage the page!",
    "Warning": "Warning",
    "Email-Sync-Tip": "After successful linking, emails from the last two days will be synced",
    "Email-Type": "Email Type",
    "Select-Email-Type": "Please select the email type",
    "Email-Account": "Email Account",
    "No-Need-Account-Tip": "No need to fill in the account. Please click the account authorization button to authorize",
    "Enter-Email-Address": "Please enter a valid email address",
    "Auth-Login": "Authorized Login",
    "Account-Auth": "Account Authorization",
    "Auth-Failed": "Authorization failed",
    "Email-Auth-Code": "Email Authorization Code",
    "Enter-Email-Auth-Code": "Please enter the email authorization code",
    "How-To-Get-Auth-Code": "How to get the authorization code?",
    "Usage-Description": "Usage Description",
    "Enter-Description": "Please enter a description",
    "Service-Type": "Service Type",
    "Server": "server",
    "Server-Example-IMAP": "e.g.: imap.example.com",
    "Port-Example": "e.g.: 993",
    "SMTP-Server": "SMTP server",
    "Server-Example-SMTP": "e.g.: smtp.example.com",
    "Fill-Email-Address": "Please enter the email address",
    "Fill-Usage-Description": "Please fill in the usage description",
    "Select-Service-Type": "Please select the receiving service type",
    "Enter-Receiving-Server": "Please enter the receiving server address",
    "Enter-Port": "Please enter the port number",
    "Enter-Outbox-Server": "Please enter the sending server address",
    "Enter-Port-Type": "Please enter the port type",
    "Enter-Tenant-ID": "Please enter the Tenant ID",
    "Enter-App-ID": "Please enter the App ID",
    "Enter-Client-Secret": "Please enter the Client Secret",
    "Auth-Success-Alert": "Account authorization successful. Please click OK to complete the email linking.",
    "Admin-Not-Follow-Tip": "This admin has not followed and bound the official account yet, so push notifications cannot be received",
    "Follow-Offical-Account": "Follow Official Account",
    "Role-Prefix": "Role: ",
    "Email-Prefix": "Email: ",
    "Phone-Prefix": "Phone: ",
    "Add-Time-Prefix": "Added At: ",
    "Role-Super-Admin": "Super Admin",
    "Role-Admin": "Admin",
    "Role-Team-Member": "Team Member",
    "Set-Admin": "Set Admin",
    "Enter-Admin-Nickname-Or-Phone": "Please enter the admin nickname/phone number",
    "No-Personnel": "No personnel",
    "Message-Language": "Message Language",
    "Reply-Language": "Reply Language",
    "Operation": "Operation",
    "Message-Language-Manage": "Message Language Management",
    "Message-Language-Prefix": "Message Language: ",
    "Reply-Language-Prefix": "Reply Language: ",
    "Select-Language": "Please select a language",
    "Delete-Language-Confirm": "This operation cannot be recovered! Are you sure you want to delete it?",
    "Role-Placeholder": "Please enter the role the customer service agent plays. Once set, when users ask about the agent's identity, the system will inform them of the preset identity.\nWhen users ask questions, the system will think and answer from this role's perspective.",
    "AI-Help-Generate": "AI-Assisted Generation",
    "Tip": "Tip",
    "Customer-Service-Operation-Settings": "Customer Service Operation Settings",
    "Independent-Post-Operation-Settings": "{0} Specific Post Operation",
    "Select-Post": "Select Post",
    "Remarks-Info": "Remarks",
    "Enter-Remarks": "Please enter remarks",
    "Unified-Reply-Mode": "Unified Reply Mode",
    "Enter-Reply-Content": "Please enter reply content",
    "Keyword-Mode": "Keyword Mode",
    "Scene-Reply-Mode": "Scene Reply Mode",
    "Please-Select-Post": "Please select a post",
    "Add-Post": "Add {0} Post",
    "Enter-Post-Keyword": "Please enter post keyword",
    "Enter-Post-Id": "Please enter post ID",
    "Go-To-Facebook-Add": "Go to Facebook to add",
    "Go-To-Instagram-Add": "Go to Instagram to add",
    "Update-Posts": "Update Posts",
    "Updating": "Updating",
    "Posts-Updated": "{0} posts updated",
    "Background-Update": "Background Update",
    "Not-Bound-Platform": "You have not linked a platform. Please link one first.",
    "Add-Rule": "Add Rule",
    "Reply-Rule": "Reply Rule",
    "Reply-Comment": "Reply Comment",
    "Send-Messenger-Notification": "Send one Messenger notification",
    "Messenger-Notification-Tooltip": "When a user comments on the post, the system will send one Messenger push notification. Each Facebook page can only send one push within the specified time limit. Enabling this feature requires activating the Messenger Assistant.",
    "Priority": "Priority",
    "Priority-Tooltip": "The system matches replies based on priority. If there are items with the same priority, it will match by addition time, prioritizing earlier added replies.",
    "Keywords-Label": "Keywords",
    "Enter-Keyword-Enter-Confirm": "Enter keyword, press Enter to confirm",
    "Remember-Enter-Confirm": "Remember to press Enter to confirm",
    "Comment-Reply": "Comment Reply",
    "Enter-Comment-Reply-Content": "Please enter comment reply content",
    "Messenger-Notification": "Messenger Notification",
    "Enter-Messenger-Notification-Content": "Please enter Messenger notification content",
    "Highest": "Highest",
    "Higher": "Higher",
    "Medium": "Medium",
    "Lower": "Lower",
    "Lowest": "Lowest",
    "Please-Set-Reply-Rule": "Please set at least one reply rule",
    "Keyword-Cannot-Be-Empty": "Keyword cannot be empty",
    "Please-Enter-Reply-Or-Upload": "Please enter reply content or upload an image",
    "Keyword-Already-Exists": "Keyword already exists, please re-enter",
    "Messenger-Assistant-Create-Msg": "Since this involves Messenger notifications, you need to create a Messenger Assistant to enable this feature. Click OK and the system will configure a Messenger Assistant for you!",
    "Messenger-Assistant-Quota-Msg": "Since this involves Messenger notifications, you need to create a Messenger Assistant. However, your team package has reached the maximum number of bots. Please upgrade first.",
    "Scene-Setting": "Scene Setting",
    "Enter-Scene-Setting": "Please enter scene setting",
    "Ad-Post": "Ad Post",
    "Video-Only": "[Video Only]",
    "Image-Only": "[Image Only]",
    "Auto-Operation": "Auto Operation",
    "Post-Id": "Post ID",
    "Created-At": "Created at",
    "Remarks": "Remarks",
    "No-Data": "No Data",
    "Start-Date": "Start Date",
    "End-Date": "End Date",
    "Date-Range-Separator": "to",
    "Operation-Success": "Operation Successful",
    "All-Post-Types": "All Post Types",
    "Enter-Remarks-Content": "Please enter remarks",
    "Delete-Specific-Reply-Confirm": "Are you sure you want to delete this specific reply rule?",
    "Reminder-Switch": "Reminder Switch",
    "Push-Time": "Push Time",
    "Time-Oclock": ":00",
    "Follow-Wechat-Account": "Follow WeChat Account",
    "Admin-Not-Follow-Wechat": "Administrators under this customer service have not yet followed and bound their WeChat accounts, making it impossible to receive WeChat push notifications",
    "Comment-Count": "Comments",
    "Reply-Count": "Replies",
    "Suggest-Reply-Prefix": "Suggested Reply {index}",
    "Use-Answer": "Use Answer",
    "Created-At-Colon": "Created at: ",
    "Comment-Hidden": "This comment has been hidden",
    "Forward": "Forward",
    "More-Scenes": "+ More Scenes",
    "All-Comments": "All Comments ({count})",
    "Only-Show-Unreplied": "Only show unreplied",
    "Comment-Sending": "Comment sending...",
    "Delete-Confirm-Msg": "This action cannot be undone. Are you sure you want to delete?",
    "Warning": "Warning",
    "Unhide": "Unhide",
    "Hide": "Hide",
    "Generate-AI-Reply": "Generate AI suggested reply",
    "Cancel-Reply": "Cancel reply",
    "Reply": "Reply",
    "Reply-Input-Placeholder": "Type reply content, press Enter to send",
    "Select-Platform": "Please select a platform",
    "Comment-Content": "Comment content",
    "Corresponding-Post": "Corresponding post",
    "Platform": "Platform",
    "Deal-Info": "Processing info",
    "Deal-Method-Colon": "Processing method: ",
    "Deal-Time-Colon": "Processing time: ",
    "View-Post": "View post",
    "Post-Detail": "Post details",
    "Intelligent-Assist": "AI assistant",
    "Stop-AI-Confirm": "Are you sure you want to stop the AI response?",
    "Restore-Confirm": "Are you sure you want to restore this comment to normal?",
    "Confirm-Restore": "Confirm restore",
    "Commented-On-Post": "commented on the post of page {page} ({platform})",
    "Set-Not-Reply": "Set as no reply",
    "Not-Reply-Confirm": "Set this comment as no reply?",
    "Set-Success": "Set successfully",
    "Delete-Success": "Deleted successfully",
    "Operation-Success": "Operation successful",
    "Updating-Post": "Updating posts, currently updated: {count}",
    "Select-Comment-Importance": "Please select comment importance",
    "Post-Id-Colon": "Post ID: ",
    "Normal-Post": "Normal post",
    "Like-Count": "Likes",
    "Share-Count": "Shares",
    "Pending-Reply-Count": "Pending reply comments",
    "Post-Id-Prefix": "Post ID: ",
    "Unprocessed": "Unprocessed",
    "Processed": "Processed",
    "Pending-Comments": "Pending comments",
    "Page-Posts": "Page posts",
    "Hidden-Comments": "Hidden comments",
    "Deleted-Comments": "Deleted comments",
    "All-Post-Types": "All post types",
    "Comment-Restored": "Comment restored",
    "Set-Status": "Set",
    "Select-Set-Status": "Please select set status",
    "AI-Prompt-Product-Promo": "I am an e-commerce platform. When setting a default reply for a single 【product promotion】 type post, what should this post include? Please output a reply template.",
    "AI-Prompt-List-Scenes": "I am an e-commerce platform. Please list several common scenarios that customers often ask about.",
    "AI-Prompt-Greeting": "I am an e-commerce platform. I want to greet customers in Messenger and guide them to complete their purchase. As a professional customer service agent, please output a greeting template.",
    "AI-Prompt-Logistics": "I am an e-commerce platform. I am setting 【logistics duration】 as the reply keyword. As a professional customer service agent, please create a targeted reply template for this keyword, including 【shipping time】 and 【delivery time】.",
    "AI-Prompt-Price": "I am an e-commerce platform. I am setting 【how much】 as the reply keyword. As a professional customer service agent, please create a targeted reply template for this keyword, including 【purchase link】 and 【price】.",
    "AI-Prompt-Buy-Intent": "I am an e-commerce platform. In a post, I set 【all comments with purchase intent】 as a scene. As a professional customer service agent, please create a targeted reply template for this scene. The reply should include 【purchase link】 and 【price】, and be output in 【email format】.",
    "Choose-Bot-Type": "Choose bot type",
    "New-Bot-With-Name": "New {name}",
    "Bind-Other-Platforms-Confirm-With-Name": "{name} can also be bound to other media platforms. Do you still want to bind?",
    "Keyword-Rule-Settings": "Keyword Rule Settings",
    "Reply-Rule-Colon": "Reply Rule: ",
    "Messenger-Notify-Once": "Send one Messenger notification",
    "Messenger-Notify-Desc": "When a user comments on a post, the system can push one Messenger notification, and each comment can only be pushed once. Enabling this feature requires activating the chat bot.",
    "Keyword-Colon": "Keyword: ",
    "Enter-Keyword-Tip": "Enter a keyword and press Enter to confirm",
    "Press-Enter-Confirm": "Remember to press Enter to confirm",
    "Scene-Setting-Colon": "Scene Setting: ",
    "Max-3000-Chars": "Up to 3000 characters",
    "Comment-Reply-Colon": "Comment Reply: ",
    "Max-12-Images": "Up to 12 images can be uploaded",
    "Messenger-Colon": "Messenger: ",
    "Keyword-Required": "Keyword cannot be empty",
    "Answer-Required": "Answer cannot be empty",
    "Uploading-Image-Tip": "Uploading images, please submit later",
    "Only-Image-Error": "{name} can only upload images",
    "File-Too-Large-Error": "{name} TXT file size cannot exceed 5M",
    "Max-12-Images-Limit": "Currently limited to selecting 12 images",
    "Messenger-Quota-Desc": "Since this involves Messenger notifications, you need to create a Messenger assistant to enable this feature. However, your current team package has reached the maximum number of bots. Please upgrade your package first.",
    "Messenger-Create-Assistant-Confirm": "Since this involves Messenger notifications, you need to create a Messenger assistant to enable this feature. Click OK and the system will configure a Messenger assistant for you!",
    "AI-Prompt-Logistics-Email": "I am an e-commerce platform. I am setting 【logistics duration】 as the reply keyword. As a professional customer service agent, please create a targeted reply template for this keyword, including 【shipping time】 and 【delivery time】, and output in 【email format】.",
    "AI-Prompt-Logistics-Scene": "I am an e-commerce platform. I am setting 【logistics duration】 as the reply scene. As a professional customer service agent, please create a targeted reply template for this scene, including 【shipping time】 and 【delivery time】.",
    "Save-Success": "Saved successfully",
    "Notify-Success-Title": "Success",
    "Update-Saved": "Changes saved",
    "Enter-Service-Name": "Please enter the service name",
    "Enter-Service-Desc": "Please enter the service description",
    "Enter-Welcome-Message": "Please enter the welcome message",
    "Bind-Page": "Please bind a page",
    "Please-Set-Admin": "Please set an administrator",
    "Set-Default-Model": "Please set the default AI model for this bot",
    "Select-Language-Style": "Please select a reply language style",
    "Character-Setting-Desc": "Please describe the bot's character setting in detail so that AI replies are more relevant",
    "Enter-0-120": "Please enter a number between 0 and 120",
    "Enter-Email-Addr": "Please enter the email address",
    "Enter-Malicious-Desc": "Please describe in detail your definition of malicious comments",
    "Malicious-Example": "Personal attacks, insults and abuse, discriminatory behavior, gender discrimination, age discrimination, religious discrimination, body image discrimination, mental health discrimination, professional discrimination, regional discrimination, family status discrimination, sexual orientation discrimination, cultural discrimination: posting aggressive comments or prejudice against individuals or groups, harming their dignity and rights.\n\nMalicious defamation, provocation and incitement to hatred, racism and hate speech, psychological abuse: attacking others with false information or malicious remarks, causing conflict or harming their emotions and physical and mental health.\n\nPornographic content, sexual harassment: posting obscene or indecent content that causes distress or discomfort to others.\n\nMalicious disclosure of personal information, identity theft: making public others' private information or impersonating others, infringing on their privacy or reputation.\n\nHarassment and threats: causing psychological pressure or fear to others through continuous harassing remarks or intimidation.\n\nInappropriate content, political intervention, false information and fraud, illegal acts, antisocial behavior, illegal trafficking and contraband, self-harm and suicide threats, insulting memories, false statements, harm to children: posting illegal, false, inappropriate or harmful content that may cause social instability, harm others or violate laws and regulations.",
  },
  "workbench": {
    "Chat-Bot": "Chat Bot",
    "Page-Bot": "Page Bot",
    "Email-Bot": "Email Bot",
    "Mail-Bot": "Mail Bot",
    "Todo-Tasks": "Todo Tasks",
    "Search-Placeholder": "Type keywords and press Enter to search",
    "Bot-Settings": "Bot Settings",
    "Data-Analysis": "Data Analysis",
    "Workbench": "Workbench",
  },
  "chat-room": {
    // TODO
  },
  "fb-posts": {
    // TODO
  },
  "mail-manage": {
    // TODO
  },
  "scene-setting": {
    "Select-Enable-Status": "Select Enable Status",
    "Enabled": "Enabled",
    "Disabled": "Disabled",
    "Enter-Scene-Name": "Enter Scene Name",
    "Total-Scene-Settings": "{count} scene settings in total",
    "Reply-Strategy": "Reply Strategy: ",
    "WeChat-Reminder": "WeChat Reminder: ",
    "Is-Enabled": "Is Enabled: ",
    "Customer-Service-Settings": "Customer Service Settings",
    "Scene-Settings-Crumb": "Scene Settings",
    "Scene-Type": "Scene Type: ",
    Custom: "Custom",
    "Track-Logistics": "Track Logistics",
    "Scene-Name": "Scene Name: ",
    "Enter-Scene-Desc": "Enter Scene Description",
    "Scene-Definition-Placeholder": "Enter the scene definition contained in the user's inquiry",
    "AI-Command-Scene": "I am an [e-commerce platform]. Please list some common inquiry scenarios encountered from customers.",
    "AI-Command-Track": "I am an [e-commerce platform]. Please list the inquiry scenarios customers may encounter when emailing to check logistics information.",
    "AI-Command-Reply": "I am an [e-commerce platform]. I am setting [logistics time] as the reply keyword. As a professional customer service agent, please create a targeted reply template for this keyword, including [shipping time] and [logistics time].",
    "Auto-Reply": "Auto Reply",
    "Manual-Reply": "Manual Reply",
    "No-Reply": "No Reply",
    "Reply-Form": "Reply Form: ",
    "Scene-Specific-Reply": "Scene-Specific Reply",
    "Keyword-Specific-Reply": "Keyword-Specific Reply",
    "Knowledge-Base-Reply": "Reply with Knowledge Base Content",
    "Scene-Definition": "Scene Definition: ",
    "Header-Tail-Template": "Email Header/Footer Template: ",
    "Manage-Template": "Manage Templates",
    "Reply-Accuracy": "Reply Accuracy: ",
    Strict: "Strict",
    Free: "Free",
    "KB-No-Answer-Tip": "When there is no matching content in the knowledge base, the system will not provide an answer",
    Keyword: "Keyword: ",
    "Enter-Keyword-Confirm": "Enter a keyword and press Enter to confirm",
    "Press-Enter-Tip": "Remember to press Enter to confirm",
    "Reply-Content": "Reply Content: ",
    "Enter-Reply-Content": "Enter the reply content",
    "17Track-Auth": "17TRACK Platform Authorization: ",
    "17Track-Not-Auth": "Your 17TRACK platform is not authorized yet, so the system cannot serve you",
    "Go-Auth": "Authorize Now",
    "17Track-Fee": "Single order tracking costs 0.03 yuan",
    "Add-Track-Rule": "Add Tracking Rule",
    "Add-Rule": "Add Rule",
    "Email-Tag": "Email Tag: ",
    "Manage-Tag": "Manage Tags",
    "Save-Settings": "Save Settings",
    "Add-Template-Variable": "Add Template Variable",
    "Header-Tail-Empty": "No content in email header/footer template!",
    "Header-Empty": "No content in email header file!",
    "Tail-Empty": "No content in email footer file!",
    Oclock: ":00",
    "Enter-Keyword": "Please add a keyword",
    "Enter-Reply-Content-Rule": "Please enter the reply content",
    "17Track-Confirm": "Use the 17TRACK platform authorized by JoinCompass for logistics tracking. Each query costs 0.01 yuan. Continue?",
    "17Track-Auth-Title": "17TRACK Authorization",
    "Keyword-Exists": "Keyword already exists, please re-enter",
    "Save-Success": "Saved successfully",
    "Rule-Define": "Rule Definition: ",
    "Enable-Status": "Enable Status: ",
    "Expand": "Expand",
    "Collapse": "Collapse",
    "Query-From-Order-Time": "Query time since order placement",
    "Enter-Content": "Enter content",
    "Min": "Min",
    "Max": "Max",
    "Days": "Days",
    "Reply-Pattern": "Reply Mode: ",
    "Add-Variable": "Add Variable",
    "AI-Command-Shipped": "I am an [e-commerce platform]. Please generate a reply template for customers about shipped goods in [email format].",
    "AI-Command-Not-Shipped": "I am an [e-commerce platform]. Please generate a reply template for customers about goods not yet shipped in [email format].",
    "AI-Command-Order-Not-Exist": "I am an [e-commerce platform]. Please generate a reply template for the case where the order number provided does not exist in [email format].",
    "AI-Command-Order-Not-Found": "I am an [e-commerce platform]. Please generate a reply template for the case where the order number is not found and needs to be provided by the customer in [email format].",
    "Logistics-Stage": "Logistics Stage: ",
    "Use-Knowledge-Base-Reply": "Reply using knowledge base content",
    "Edit-Scene": "Edit scene",
    "Delete-Scene": "Delete scene",
    "No-Scene": "No scenes",
    "Delete-Scene-Confirm": "Scenes cannot be restored after deletion. Are you sure you want to delete?",
    "Reply-Form-Colon": "Reply form: ",
    "Reply-Mode-Colon": "Reply mode: ",
    "System-Auto-Reply": "System auto reply",
    "Reply-Content-Colon": "Reply content: ",
    "Query-From-Payment-Min-Max": "Minimum {min} day(s), maximum {max} day(s) after payment for query",
    "No-Product-In-Scene": "No products in this scene",
  },
  chat: {
    "new-chat": "New Chat",
    "ai-model-select": "AI Model Selection: ",
    "history-records": "History",
    "input-title": "Please enter a title",
    "input-new-name": "Please enter a new conversation name",
    "rename-title": "Rename Conversation",
    "input-name-required": "Please fill in the conversation name",
    "attention": "Attention",
    "delete-confirm": "This operation cannot be undone! Are you sure you want to delete the conversation \"{name}\"?",
    "current-model": "Current Conversation AI Model: ",
    "no-answer": "No Answer",
    "copy-answer": "Copy Answer",
    "input-reply": "Please enter the reply content",
    "browser-not-support-title": "Notice",
    "browser-not-support-msg": "The current browser does not support this feature. It is recommended to use the Chrome browser!",
  },
  socialMedia: {
    SocialMediaMonitor: "Tracking",
    HomepageManagement: "Homepage Management",
    DataSummary: "Data Summary",
    SocialMedia: "Social Media",
    StartDate: "Start Date",
    EndDate: "End Date",
    AllMediaPlatforms: "All Media Platforms",
    AllAuthStatus: "All Auth Status",
    AllLabels: "All Labels",
    All: "All",
    FansTrend: "Follower Trend",
    FansTrendTip: "Trend of follower count changes across platforms within the search time range",
    FansDistribution: "Follower Distribution",
    FansDistributionTip: "Proportion of followers by platform as of the search end time",
    FansNetGrowthTrend: "Follower Net Growth Trend",
    FansNetGrowthTrendTip: "Trend of net follower growth across platforms within the search time range",
    PostTrend: "Post Trend",
    PostTrendTip: "Trend of post count changes across platforms within the search time range",
    PostDistribution: "Post Distribution",
    PostDistributionTip: "Proportion of posts by platform within the search time range",
    PostInteractionTrend: "Post Interaction Trend",
    PostInteractionTrendTip: "Trend of post interaction count changes across platforms within the search time range",
    PostInteractionDistribution: "Post Interaction Distribution",
    PostInteractionDistributionTip: "Proportion of interactions by platform within the search time range",
    PostExposureTrend: "Post Exposure Trend",
    PostExposureTrendTip: "Trend of post exposure count changes across platforms within the search time range",
    PostExposureDistribution: "Post Exposure Distribution",
    PostExposureDistributionTip: "Proportion of exposures by platform within the search time range",
    PostImpressionsTrend: "Post Impressions Trend",
    PostImpressionsTrendTip: "Trend of post impressions count changes across platforms within the search time range",
    PostImpressionsDistribution: "Post Impressions Distribution",
    PostImpressionsDistributionTip: "Proportion of impressions by platform within the search time range",
    InteractionRateTrend: "Interaction Rate Trend",
    TopPostTOP10: "Top Posts TOP10",
    Collapse: "Collapse",
    Expand: "Expand",
    ImageLoadFailed: "Image Load Failed",
    PublicData: "Public Data",
    AuthData: "Authorized Data",
    NoTopPostData: "No Top Post Data",
    NoAccountForPlatform: "No social accounts for current platform",
    NoAccountForPlatformDesc: "No social accounts added for the selected platform, please try selecting other platforms",
    ResetFilter: "Reset Filter",
    NoAccountAtAll: "No social accounts added yet",
    NoAccountAtAllDesc: "Please add social accounts to view relevant data",
    AddNow: "Add Now",
    Followers: "Followers",
    FollowersTip: "Total followers count of each social account as of the search end time",
    FollowerNetGrowth: "Follower Net Growth",
    FollowerNetGrowthTip: "Net follower growth of each social account within the search time range",
    PostCount: "Post Count",
    PostCountTip: "Total posts published by each social account within the search time range",
    PostInteractionCount: "Post Interaction Count",
    PostInteractionCountTip: "Total interactions received by each social account within the search time range",
    PostExposureCount: "Post Exposure Count",
    PostExposureCountTip: "Total times posts of each social account were viewed by users within the search time range",
    PostImpressionsCount: "Post Impressions",
    PostImpressionsCountTip: "Number of unique users that posts of each social account reached within the search time range",
    AvgFollowerInteractionRate: "Avg Follower Interaction Rate",
    AvgFollowerInteractionRateTip: "Interaction ratio of posts published by each social account within the search time range",
    AvgExposureInteractionRate: "Avg Exposure Interaction Rate",
    AvgExposureInteractionRateTip: "Exposure interaction ratio of posts published by each social account within the search time range",
    AvgCoverageInteractionRate: "Avg Coverage Interaction Rate",
    AvgCoverageInteractionRateTip: "Ratio of user interactions to impressions of posts published by each social account within the search time range",
    VideoViewCount: "Video View Count",
    VideoViewCountTip: "Video view count of posts published by each social account within the search time range",
    FollowerInteractionRate: "Follower Interaction Rate",
    FollowerInteractionRateTip: "Trend of follower interaction rate across platforms within the search time range",
    FollowerInteractionRateAuth: "Follower Interaction Rate (Auth)",
    FollowerInteractionRateAuthTip: "Trend of authorized follower interaction rate across platforms within the search time range",
    ExposureInteractionRate: "Exposure Interaction Rate",
    ExposureInteractionRateTip: "Trend of exposure interaction rate across platforms within the search time range",
    CoverageInteractionRate: "Coverage Interaction Rate",
    CoverageInteractionRateTip: "Trend of coverage interaction rate across platforms within the search time range",
    ExposureViewCount: "Exposure/View Count",
    ImpressionsAuth: "Impressions (Auth)",
    InteractionCount: "Interaction Count",
    FollowerInteractionRateAuth2: "Follower Interaction Rate (Auth)",
    ExposureInteractionRateMixed: "Exposure Interaction Rate (Mixed)",
    CoverageInteractionRateAuth: "Coverage Interaction Rate (Auth)",
    HundredMillion: "B",
    TenThousand: "10K",
    To: "To",
    AuthStatusLabel: "Auth Status",
    EnterPageName: "Enter Page Name",
    AddAccount: "Add Account",
    AdjustList: "Adjust List",
    Verified: "Verified",
    Unverified: "Unverified",
    Authorized: "Authorized",
    Unauthorized: "Unauthorized",
    ManageLabel: "Manage Label",
    CancelMonitor: "Cancel Monitor",
    Cancel: "Cancel",
    Confirm: "Confirm",
    NewLabel: "New Label",
    AddNewLabel: "Add New Label",
    NotSet: "Not Set",
    EnterLabelName: "Enter Label Name",
    LabelAddSuccess: "Label Added Successfully",
    SetLabels: "Set Labels",
    SetLabelsTip: "After setting up social account labels, you can directly filter by labels during data filtering.",
    TotalPages: "{count} Pages in Total",
    CancelMonitorConfirm: "Once monitoring is cancelled, the system will immediately stop tracking and collecting data for this page. All historical data related to this page will be permanently deleted and cannot be recovered!",
    OperationConfirm: "Operation Confirm",
    SelectedLabelCount: "{count} Labels Selected",
    TagSuccess: "Label Added Successfully",
    SettingLabelMsg: "Setting labels, please wait...",
    SocialPage: "Social Page",
    FollowersCount: "Followers",
    FollowersCountAuth: "Followers (Auth)",
    FollowerNetGrowthCol: "Follower Net Growth",
    PostCountCol: "Post Count",
    PostCountColAuth: "Post Count (Auth)",
    PostInteractionCountCol: "Post Interaction Count",
    PostInteractionCountColAuth: "Post Interaction Count (Auth)",
    PostExposureCountCol: "Post Exposure Count",
    PostImpressionsCol: "Post Impressions",
    PostImpressionsColAuth: "Post Impressions (Auth)",
    HeartsCount: "Reactions",
    CommentsCountCol: "Comments",
    SharesCountCol: "Shares",
    PerMilleInteractionCol: "Per Mille Interaction",
    FollowerInteractionRateCol: "Follower Interaction Rate",
    FollowerInteractionRateColAuth: "Follower Interaction Rate (Auth)",
    ExposureInteractionRateCol: "Exposure Interaction Rate",
    VideoViewsCol: "Video Views",
    AvgVideoWatchTimeCol: "Avg Video Watch Time",
    VideoCompletionRateCol: "Video Completion Rate",
    LikesCountCol: "Likes",
    RetweetsCountCol: "Retweets",
    RepliesCountCol: "Replies",
    ClicksCountCol: "Clicks",
    SavesCountCol: "Saves",
    UpvotesCountCol: "Upvotes",
    ViewInteractionRateCol: "View Interaction Rate",
    VideoViewInteractionRateCol: "Video View Interaction Rate",
    EmojiReactionsCountCol: "Emoji Reactions",
    FollowerNetGrowthColAuth: "Follower Net Growth (Auth)",
    PostExposureCountColAuth: "Post Exposure Count (Auth)",
    PostCoverageCountAuth: "Post Coverage (Auth)",
    CommentsRepliesCol: "Comments/Replies",
    ClicksCountAuth: "Clicks (Auth)",
    CommentsCountAuth: "Comments (Auth)",
    PostInteractionNum: "Post Interactions",
    PostInteractionNumAuth: "Post Interactions (Auth)",
    RepliesCountAuth: "Replies (Auth)",
    SearchMetric: "Search Metrics",
    ListItem: "List Item",
    SupportedMedia: "Supported Media",
    AdjustOrder: "Adjust Order",
    GoAuth: "Authorize",
    PageDetail: "Page Detail",
    SinglePost: "Single Post",
    PaidPost: "Paid Post",
    NormalPost: "Normal Post",
    OpenPost: "Open Post",
    CreatedAt: "Created: ",
    PostID: "ID: ",
    PacificTime: "Pacific Time (UTC -07:00)",
    UTCTime: "UTC +00:00",
    StartTime: "Start Time",
    EndTime: "End Time",
    ChannelData: "Channel Data",
    PageData: "Page Data",
    FollowersData: "Follower Data",
    VideoData: "Video Data",
    PostData: "Post Data",
    VideoWatchData: "Video Watch",
    VideoInteractionData: "Video Interactions",
    PostsData: "Posts",
    ReelsData: "Reels Data",
    LastUpdate: "Last Updated: ",
    // Copy for the social monitoring data-update popover in the page toolbar.
    DataUpdate: "Data update: ",
    UpdatedPlatformCount: "{count} platforms",
    LatestPlatformUpdateTimes: "Latest update times by platform",
    UtcUpdateTimeHint: "Displayed in UTC 00:00",
    UpdateData: "Refresh",
    Updating: "Updating",
    Update: "Update",
    UpdateDataDesc: "Select the data time range to update (Up to one year before the current date)",
    UpdateDataRange: "Update Range",
    UpdatingWait: "Data updating, please wait...",
    Cancel: "Cancel",
    CoverageInteractionRateCol: "Coverage Interact. Rate",
    CoverageInteractionRateColAuth: "Coverage Interact. Rate (Auth.)",
    ReactionsLikesCol: "Reactions / Likes",
    SharesRetweetsCol: "Shares / Retweets",
    PostClickCountCol: "Post Click Count",
    PageViewsCol: "Page Views",
    PageVideoViewsCol: "Page Video Views",
    PagePostImpressionsCol: "Page Post Impressions",
    PageNegativeActionsCol: "Page Negative Actions",
    AvgPostInteractionsCol: "Avg Post Interactions",
    AvgPostInteractionsAuthCol: "Avg Post Interactions (Auth)",
    AvgInteractionPer1KFollowersCol: "Interactions/1K Followers",
    AvgInteractionPer1KFollowersAuthCol: "Interactions/1K Followers (Auth)",
    PageLikesPublicCol: "Page Likes (Public)",
    PageLikesNetGrowthPublicCol: "Page Likes Net Growth (Public)",
    PageLikesAuthCol: "Page Likes (Auth)",
    PageLikesNetGrowthAuthCol: "Page Likes Net Growth (Auth)",
    BrandCol: "Brand",
    PostContentCol: "Post Content",
    PostTypeCol: "Post Type",
    PostStatusCol: "Status",
    PostTimeCol: "Post Time",
    PostTimeBeijingCol: "Posted (Beijing)",
    PostTimePacificCol: "Posted (PT)",
    PostTimeUTCCol: "Posted (UTC)",
    PostViewsCol: "Views",
    InteractionCountCol: "Interactions",
    LikesCol: "Likes",
    // Keep X's platform-specific metric key aligned with the Chinese “喜欢数” label.
    LikesXCol: "Likes",
    CommentsCol: "Comments",
    SharesCol: "Shares",
    ImpressionsCol: "Impressions",
    ReachCol: "Reach",
    ReachInteractionRateCol: "Reach Interact.",
    TotalWatchTimeCol: "Total Watch Time",
    AvgWatchTimeCol: "Avg Watch Time",
    VideoDurationCol: "Video Duration",
    PositiveCommentsCol: "Positive Comments",
    NegativeCommentsCol: "Negative Comments",
    NeutralCommentsCol: "Neutral Comments",
    OriginalStatusCol: "Original Status",
    RepliesCol: "Replies",
    RetweetsCol: "Retweets",
    VideoViewsAuthCol: "Video Views (Auth)",
    QuoteCountCol: "Quote Count",
    ImpressionsAuthCol: "Impressions (Auth)",
    ReachAuthCol: "Reach (Auth)",
    SharesAuthCol: "Shares (Auth)",
    SavedCountAuthCol: "Saves (Auth)",
    ExitCountAuthCol: "Exits (Auth)",
    ForwardCountAuthCol: "Tap Forward (Auth)",
    ReturnCountAuthCol: "Tap Back (Auth)",
    PaidViewsCol: "Paid Views",
    OrganicViewsCol: "Organic Views",
    UniqueViewersAuthCol: "Unique Viewers (Auth)",
    ClickPhotoViewAuthCol: "Photo View (Auth)",
    ClickVideoPlayAuthCol: "Video Play (Auth)",
    ClickLinkAuthCol: "Link Click (Auth)",
    ClickOtherAuthCol: "Other Click (Auth)",
    Views3SecCol: "3-Second Views",
    TotalWatchTimeAuthCol: "Total Watch Time (Auth)",
    AvgWatchTimeAuthCol: "Avg Watch Time (Auth)",
    VideoCompletionRateAuthCol: "Completion Rate (Auth)",
    Views30SecAuthCol: "30-Second Views (Auth)",
    PositiveCommentsAuthCol: "Positive Comments (Auth)",
    NegativeCommentsAuthCol: "Negative Comments (Auth)",
    NeutralCommentsAuthCol: "Neutral Comments (Auth)",
    // Facebook Page Detail
    FacebookHomepageDetail: "Facebook Homepage Details",
    NeedAuthForPageViews: "To view page impressions, please complete social page authorization!",
    NeedAuthForViewersCount: "To view page viewers, please complete social page authorization!",
    NeedAuthForVisits: "To view page visits, please complete social page authorization!",
    NeedAuthForInteraction: "To view interactions per 1K followers, please complete social page authorization!",
    NeedAuthForReactions: "To view post reactions, please complete social page authorization!",
    NeedAuthForVideoViews: "To view video views, please complete social page authorization!",
    NeedAuthForVideoViews30s: "To view 30-second video views, please complete social page authorization!",
    NeedAuthForVideoViews30sPosts: "To view 30-second video views, please complete social page authorization!",
    FacebookApiRangeTip: "Facebook API only supports: today, previous day, last 7 days, and last 28 days",
    // Shared notice for the Facebook audience and visit modules when the API supports fixed time ranges only.
    FacebookApiRangeNotice: "Due to Facebook API limitations, only data for today, the previous day, the last 7 days, and the last 28 days is available.",
    TimeDimension: "Time Dimension:",
    DataDimension: "Data Dimension:",
    DataDetail: "Data Details",
    ExportReport: "Export",
    TimeCol: "Time",
    PageViews: "Impressions",
    PageVisits: "Visits",
    ViewersCount: "Viewers",
    PageEngagementCount: "Page Engagements",
    PostReactions: "Post Reactions",
    PostReactionsPublic: "Post Reactions (Public)",
    PostReactionsAuth: "Post Reactions (Auth)",
    Views3SecCountTitle: "3-Second Views",
    Views30SecCountTitle: "30-Second Views",
    Views3SecCount: "3-Second Views",
    Views30SecCount: "30-Second Views",
    TypeCol: "Type",
    CountCol: "Count",
    ProportionCol: "Proportion",
    Today: "Today",
    PrevDay: "Prev Day",
    Last7Days: "Last 7 Days",
    Last28Days: "Last 28 Days",
    Day: "Day",
    Week: "Week",
    Month: "Month",
    Total: "Total",
    Paid: "Paid",
    Organic: "Organic",
    Social: "Social",
    PaidOrganic: "Paid/Organic",
    AutoClick: "Auto/Click",
    Auto: "Auto",
    Click: "Click",
    InteractionPer1K: "Interact. per 1K",
    EngagementCount: "Engagements",
    NewPageLikes: "New Page Likes",
    NetPageLikes: "Net Page Likes",
    TotalPageLikes: "Total Page Likes",
    NewPaidPageLikes: "New Paid Page Likes",
    NewOrganicPageLikes: "New Organic Page Likes",
    AvgInteraction: "Avg Interactions",
    MaxSingleDayInteraction: "Max Single-Day Interactions",
    MinSingleDayInteraction: "Min Single-Day Interactions",
    TotalInteraction: "Total Interactions",
    MaxSingleDayVisits: "Max Single-Day Visits",
    MinSingleDayVisits: "Min Single-Day Visits",
    TotalReactions: "Total Reactions",
    MaxSingleDayReactions: "Max Single-Day Reactions",
    MinSingleDayReactions: "Min Single-Day Reactions",
    TotalViewsTitle: "Total Impressions",
    TotalViews3Sec: "Total Plays",
    OrganicViews3Sec: "Organic Plays",
    PaidViews3Sec: "Paid Plays",
    AutoPlayViews3Sec: "Auto Plays",
    ClickPlayViews3Sec: "Click Plays",
    MaxSingleDayViewers: "Max Single-Day Viewers",
    MinSingleDayViewers: "Min Single-Day Viewers",
    MoodLike: "Like",
    MoodLove: "Love",
    MoodHaha: "Haha",
    MoodWow: "Wow",
    MoodAngry: "Angry",
    MoodSad: "Sad",
    // Posts Page
    PostPublishedDate: "Published Date",
    PostCreatedTime: "Post Created Time",
    AuthPostEngagements: "Post Engagements (Auth)",
    AuthPostImpressions: "Post Impressions (Auth)",
    InteractionRateCol: "Interaction Rate",
    PostContent: "Post Content",
    MediaType: "Media Type",
    PostLink: "Post Link",
    ViewCount: "View Count",
    Search: "Search",
    Reset: "Reset",
    Export: "Export",
    HasLink: "With Link",
    NoLink: "No Link",
    Published: "Published",
    Deleted: "Deleted",
    // Fans page
    FansData: "Fans Data",
    FansGrowth: "Fans Growth",
    FansDemographics: "Fans Demographics",
    FansOverview: "Fans Overview",
    NewFans: "New Fans",
    NetFansGrowth: "Net Fans Growth",
    TotalFans: "Total Fans",
    NewPaidFans: "New Paid Fans",
    NewOrganicFans: "New Organic Fans",
    AvgFans: "Avg Fans",
    MaxSingleDayFans: "Max Single-Day Fans",
    MinSingleDayFans: "Min Single-Day Fans",
    TotalNewFans: "Total New Fans",
    MaxSingleDayNewFans: "Max Single-Day New Fans",
    MinSingleDayNewFans: "Min Single-Day New Fans",
    GenderAge: "Gender & Age",
    TopCities: "Top Cities",
    TopCountries: "Top Countries/Regions",
    Male: "Male",
    Female: "Female",
    Unknown: "Unknown",
    // Signal post page
    SignalPostList: "Signal Post List",
    SignalPostDetail: "Signal Post Detail",
    PostId: "Post ID",
    ChannelName: "Channel Name",
    AccountName: "Account Name",
    // Signal post comments
    CommentsList: "Comments",
    CommentContent: "Comment Content",
    CommentTime: "Comment Time",
    CommentSentiment: "Sentiment",
    Positive: "Positive",
    Negative: "Negative",
    Neutral: "Neutral",
    ReplyTo: "Reply To",
    Hashtags: "Hashtags",
    Mentions: "Mentions",
    LinksInPost: "Links",
    NoData: "No Data",
    Loading: "Loading...",
    LoadMore: "Load More",
    AllLoaded: "All Loaded",
    NeedAuthForViews: "To view impressions, please complete social page authorization!",
    NeedAuthForPostEngagements: "To view post interactions, please complete social page authorization!",
    NeedAuthForPostTrend: "To view post & interaction trends, please complete social page authorization!",
    NeedAuthForReach: "To view reach, please complete social page authorization!",
    NeedAuthForVideoViewers: "To view video viewers, please complete social page authorization!",
    NeedAuthForVideoWatchTime: "To view video watch time & play method, please complete social page authorization!",
    NeedAuthForCommentsTrend: "To view comment trends, please complete social page authorization!",
    NeedAuthForClicks: "To view clicks, please complete social page authorization!",
    PostInteractionCount: "Post Interactions",
    PostInteractionCountAuth: "Post Interactions (Auth)",
    PostCount: "Post Count",
    PostInteractionRate: "Interaction Rate",
    PostInteraction: "Post Interactions",
    PostsAndInteractionTrend: "Posts & Interaction Trends",
    ReachCoverage: "Reach",
    VideoViewers: "Video Viewers",
    VideoWatchTimeAndMethod: "Video Watch Time & Play Method",
    CommentsTrend: "Comment Trends",
    ClickCount: "Clicks",
    PostsPublished: "Posts Published",
    PublishedPosts: "Published Posts",
    AvgPostsPublished: "Avg Posts Published",
    MaxPostsPublished: "Max Posts/Day",
    MinPostsPublished: "Min Posts/Day",
    AvgInteractionRate: "Avg Int. Rate",
    MaxInteractionRate: "Max Int. Rate",
    MinInteractionRate: "Min Int. Rate",
    AvgImpressions: "Avg Impressions",
    MaxImpressions: "Max Impressions",
    MinImpressions: "Min Impressions",
    AvgReach: "Avg Reach",
    MaxReach: "Max Reach",
    MinReach: "Min Reach",
    AvgVideoViews: "Avg Video Views",
    MaxVideoViews: "Max Video Views",
    MinVideoViews: "Min Video Views",
    AvgWatchTime: "Avg Watch Time",
    MaxWatchTime: "Max Watch Time",
    MinWatchTime: "Min Watch Time",
    AvgComments: "Avg Comments",
    MaxComments: "Max Comments",
    MinComments: "Min Comments",
    AvgClicks: "Avg Clicks",
    MaxClicks: "Max Clicks",
    MinClicks: "Min Clicks",
    InteractionTrend: "Interaction Trends",
    ExposureTrend: "Impressions Trends",
    NetFansGrowthTrend: "Net Fans Growth Trends",
    NewFansTrend: "New Fans Growth Trends",
    NeedAuthForFansTrend: "To view fans trends, please complete social page authorization!",
    NeedAuthForCountryDistribution: "To view country distribution, please complete social page authorization!",
    NeedAuthForCityDistribution: "To view city distribution, please complete social page authorization!",
    NeedAuthForLanguageDistribution: "To view language distribution, please complete social page authorization!",
    NewFansCount: "New Fans",
    NetFansCount: "Net Fans",
    TotalFansCount: "Total Fans",
    NetFansCountAuth: "Net Fans (Auth)",
    TotalFansCountAuth: "Total Fans (Auth)",
    FansTrend: "Fans Trends",
    CountryDistribution: "Country Distribution",
    CityDistribution: "City Distribution",
    LanguageDistribution: "Language Distribution",
    AgeDistribution: "Age Distribution",
    GenderDistribution: "Gender Distribution",
    LgCodeCount: "Channels",
    AccountCount: "Accounts",
    FansOverviewTitle: "Fans Overview",
    Day: "Day",
    Week: "Week",
    Month: "Month",
    PublicData: "Public Data",
    AuthData: "Auth Data",
    AvgInteractions: "Avg Interactions",
    MaxInteractions: "Max Interactions/Day",
    MinInteractions: "Min Interactions/Day",
    AvgPosts: "Avg Posts",
    MaxPosts: "Max Posts/Day",
    MinPosts: "Min Posts/Day",
    AvgExposure: "Avg Impressions",
    MaxExposure: "Max Impressions/Day",
    MinExposure: "Min Impressions/Day",
    AvgReachCount: "Avg Reach",
    MaxReachCount: "Max Reach/Day",
    MinReachCount: "Min Reach/Day",
    AvgTopics: "Avg Topics",
    MaxTopics: "Max Topics/Day",
    MinTopics: "Min Topics/Day",
    AvgSaved: "Avg Saved",
    MaxSaved: "Max Saved/Day",
    MinSaved: "Min Saved/Day",
    AvgViews: "Avg Views",
    MaxViews: "Max Views/Day",
    MinViews: "Min Views/Day",
    AvgCommentsCount: "Avg Comments",
    MaxCommentsCount: "Max Comments/Day",
    MinCommentsCount: "Min Comments/Day",
    TotalExposure: "Total Impressions",
    TotalExposureCount: "Total Impressions",
    TotalCoverage: "Total Coverage",
    TotalCoveragePeople: "Total Reach",
    TotalFollowing: "Total Following",
    NewFollowing: "New Following",
    LostFollowing: "Unfollow Count",
    NetFollowing: "Net Following",
    TotalFollowers: "Total Followers",
    NewFans: "New Fans",
    LostFans: "Lost Fans",
    NetFans: "Net Fans",
    NewFansCountReal: "New Fans",
    LostFansCount: "Unfollow Fans",
    TotalFans: "Total Fans",
    OnlineUsers: "Online Users",
    AvgOnlineUsers: "Avg Online",
    MaxOnlineUsers: "Max Online",
    MinOnlineUsers: "Min Online",
    SinglePostInteraction: "Per Post Interactions",
    SingleCoverage: "Per Story Reach",
    CompletionRate: "Completion Rate",
    MaxCompletionRate: "Max Completion Rate",
    MinCompletionRate: "Min Completion Rate",
    TotalReplies: "Total Replies",
    MaxReplies: "Max Replies/Day",
    MinReplies: "Min Replies/Day",
    TotalExits: "Total Exits",
    MaxExits: "Max Exits/Day",
    MinExits: "Min Exits/Day",
    TotalCount: "Total",
    ImageCount: "Image Count",
    VideoCount: "Video Count",
    Image: "Image",
    Video: "Video",
    ReelsCount: "Stories",
    ReelsExposureCount: "Story Impressions",
    TotalSaved: "Total Saved",
    MaxSavedCount: "Max Saved/Day",
    MinSavedCount: "Min Saved/Day",
    ExposureCount: "Impressions",
    ReachCount: "Reach",
    Reach: "Reach",
    SavedCount: "Saved",
    CommentsCount: "Comments",
    ImpressionsCount: "Impressions",
    TopicsCount: "Topics",
    TotalPosts: "Total Posts",
    TotalViews: "Total Views",
    TotalComments: "Total Comments",
    NewComments: "New Comments",
    NewRetweets: "New Retweets",
    NewLikes: "New Likes",
    VideoPlayCount: "Video Plays",
    CarouselAlbumInteractions: "Carousel Album Engagements",
    CarouselAlbum: "Carousel Album",
    InsTopicsUsedCount: "Topics Used Count",
    InsTopicsUsedCountTip: "The number of hashtags used in posts published on the specified date.",
    InsTopicsUsedTotal: "Total Topics Used",
    InsPostInteractionTrend: "Post & Post Interaction Trend",
    InsPostInteractionTrendTip: "The correlation between posts published on the homepage and the interactions received by those posts.",
    InsPostExposureCountTip: "The number of times Instagram photos, videos, stories, or albums were seen in the selected date range.",
    InsNeedAuthForPostExposure: "To view post exposure count, please authorize your social homepage first!",
    InsPostCoverageCount: "Post Coverage Count",
    InsPostCoverageCountTip: "The number of users who saw Instagram photos, videos, stories, or albums in the selected date range.",
    InsPostSavedCount: "Post Saved Count",
    InsPostSavedCountTip: "The number of users who saved Instagram photos, videos, stories, or albums in the selected date range.",
    InsNeedAuthForPostSaved: "To view post saved count, please authorize your social homepage first!",
    InsCarouselAlbumTip: "Data related to carousel albums.",
    InsNeedAuthForCarouselAlbum: "To view carousel albums, please authorize your social homepage first!",
    InsVideoWatchDataTip: "The number of times videos on the Instagram homepage were viewed in the selected date range (excluding videos in carousels).",
    PostInteractionsCount: "Post Interactions",
    InsInteractionDetailTip: "Public data: post {interactions} on the specified date = total interactions earned by posts published by the homepage on the specified date (likes + comments), broken down by interaction type. If the homepage did not post on a certain date, the post {interactions} for that day is 0 \nPost {interactions} on the specified date = total interactions earned by posts published by the homepage on the specified date (likes + comments + shares + saves), broken down by interaction type. The shares metric only supports Reels; if the homepage did not post on a certain date, the post {interactions} for that day is 0",
    AuthViewInteractions: "To view post interactions, please complete social page authorization",
    InsInteractionTrendTip: "The correlation change between posts published by the homepage and the interactions received on those posts.",
    AuthViewPostInteractionTrend: "To view posting and post interaction trends, please complete social page authorization",
    InsHashtagTip: "The number of hashtags used in posts published on the specified date.",
    AuthViewHashtag: "To view the number of hashtags used, please complete social page authorization",
    InsPostExposureCount: "Post Exposure Count",
    InsImpressionsTip: "The number of times Instagram photos, videos, stories or albums were seen in the selected date range",
    AuthViewImpressions: "To view post exposure count, please complete social page authorization",
    InsReachTip: "The number of users who saw Instagram photos, videos, stories or albums in the selected date range.",
    AuthViewReach: "To view post reach count, please complete social page authorization",
    InsSavedTip: "The number of users who saved Instagram photos, videos, stories or albums in the selected date range.",
    AuthViewSaved: "To view post save count, please complete social page authorization",
    InsCarouselAlbum: "Carousel Album",
    InsCarouselTip: "Data related to {carousel} albums.",
    InsShareCount: "Shares",
    InsCollectionCount: "Saves",
    AuthViewCarousel: "To view carousel album data, please complete social page authorization",
    InsVideoViewTip: "The number of times videos on the Instagram homepage were viewed in the selected date range (excluding videos in {carousel}s)",
    AuthViewVideoViews: "To view video view count, please complete social page authorization",
    XPostCountDailyTooltip: "In the selected date range, the number of {postsData} published by the homepage per day.",
    XPostTypeTooltip: "Post type refers to the type of tweets published by users, including posts, retweets and replies. A post is a tweet published on the social homepage; a retweet is a tweet forwarded by the social account; a reply is a response by the social account to other users.",
    XVideoPlayTooltip: "The number of times a video was played for at least 3 seconds or nearly fully played (if the total duration of the video is less than 3 seconds)",
    XPostCreated: "Posts",
    XRetweeted: "Retweets",
    // X homepage detail tabs keep the posts section label consistent with page and follower data.
    XPostsData: "Posts Data",
    InsNeedAuthForReelsCount: "To view story count, please complete social page authorization first!",
    InsReelsExposureTip: "Total views of media files in the selected date range, shown as 0 if fewer than 5.",
    InsNeedAuthForReelsExposure: "To view story impressions, please complete social page authorization first!",
    ReelsCoveragePeople: "Story Reach",
    InsReelsCoverageTip: "Total unique users who viewed stories in the selected date range, shown as 0 if fewer than 5.",
    InsNeedAuthForReelsCoverage: "To view story reach, please complete social page authorization first!",
    ReelsSingleCoveragePeople: "Per Story Reach",
    InsReelsSingleCoverageTip: "Average number of unique users viewing each story in the selected date range.",
    InsNeedAuthForReelsSingleCoverage: "To view per-story reach, please complete social page authorization first!",
    ReelsCompletionRate: "Story Completion Rate",
    InsReelsCompletionRateTip: "Percentage of story views that were not interrupted (exit, tap forward, tap back). Story completion rate = (Impressions - Exits - Tap Forwards - Tap Backs) / Impressions * 100%; if negative, shown as 0%.",
    InsNeedAuthForReelsCompletionRate: "To view story completion rate, please complete social page authorization first!",
    ReelsRepliesCount: "Replies",
    InsReelsReplyTip: "Total replies (comments) received by stories in the selected date range, shown as 0 if fewer than 5. This value excludes replies from users in certain regions, including Europe (from December 1, 2020) and Japan (from April 14, 2021). If a story was created by a user in any of these regions, the reply count is 0.",
    InsNeedAuthForReelsReply: "To view reply count, please complete social page authorization first!",
    ReelsExitsCount: "Exits",
    InsReelsExitTip: "Number of times users exited stories in the selected date range, shown as 0 if fewer than 5.",
    InsNeedAuthForReelsExit: "To view exit count, please complete social page authorization first!",
    ForwardBackwardCount: "Tap Forward/Back Count",
    PostInteractionTrend: "Post Interaction Trends",
    ReelsViewTrend: "Story View Trends",
    ReelsReachTrend: "Story Reach Trends",
    ReelsCompletionTrend: "Story Completion Trends",
    ReelsReplyTrend: "Story Reply Trends",
    ReelsExitTrend: "Story Exit Trends",
    FansOnlineTrend: "Fans Online Trends",
    AvgInteraction: "Avg Interaction",
    MaxInteraction: "Max Interaction",
    MinInteraction: "Min Interaction",
    ImpressionsDetail: "Impressions Detail",
    ReachDetail: "Reach Detail",
    ReelsExposureDetail: "Story Impressions Detail",
    ReachPeopleDetail: "Reach Detail",
    SingleCoverageDetail: "Per Story Reach Detail",
    CompletionRateDetail: "Completion Rate Detail",
    ReplyCountDetail: "Replies Detail",
    ExitCountDetail: "Exits Detail",
    PostImpressionsDetail: "Post Impressions Detail",
    PostReachDetail: "Post Reach Detail",
    VideoViewsDetail: "Video Views Detail",
    CommentsDetail: "Comments Detail",
    TopicsDetail: "Topics Detail",
    SavedDetail: "Saved Detail",
    AlbumDetail: "Album Detail",
    ViewsDetail: "Views Detail",
    ViewDetail: "View Detail",
    NewFansDetail: "New Fans Detail",
    NetFansDetail: "Net Fans Detail",
    TotalFansDetail: "Total Fans Detail",
    FollowersDetail: "Followers Detail",
    CountryDetail: "Country Detail",
    CityDetail: "City Detail",
    LanguageDetail: "Language Detail",
    OnlineUsersDetail: "Online Users Detail",
    SignalPostDataDetail: "Post Data Detail",
    SignalPostCommentsDetail: "Post Comments Detail",
    CarouselAlbumDetail: "Carousel Album Detail",
    NeedAuthForInteractions: "To view interaction data, please complete social page authorization!",
    NeedAuthForFollowers: "To view follower data, please complete social page authorization!",
    NeedAuthForOnlineUsers: "To view online user data, please complete social page authorization!",
    NeedAuthForReels: "To view story data, please complete social page authorization!",
    NeedAuthForPosts: "To view post data, please complete social page authorization!",
    NeedAuthForSaved: "To view saved data, please complete social page authorization!",
    NeedAuthForAlbum: "To view album data, please complete social page authorization!",
    NeedAuthForExposure: "To view impression data, please complete social page authorization!",
    NeedAuthForCoverage: "To view reach data, please complete social page authorization!",
    NeedAuthForVideoData: "To view video data, please complete social page authorization!",
    NeedAuthForComments: "To view comment data, please complete social page authorization!",
    NeedAuthForTopics: "To view topic data, please complete social page authorization!",
    MainPageInteraction: "Page Interactions",
    MainPageFollowers: "Page Followers",
    MainPageExposure: "Page Impressions",
    MainPageCoverage: "Page Reach",
    FollowingCount: "Channel Following",
    MediaCount: "Media Count",
    PostData: "Post Data",
    ReelsData: "Story Data",
    CommentData: "Comment Data",
    SignalPostData: "Post Data",
    SignalPostComments: "Post Comments",
    Overview: "Overview",
    FollowerProfile: "Follower Profile",
    FansOnline: "Fans Online",
    VideoViewCount: "Video Views",
    FollowerInteractionRate: "Follower Interaction Rate",
    QuoteRetweetCount: "Quote Retweets",
    Text: "Text",
    Combined: "Combined",
    Link: "Link",
    Gif: "GIF",
    Other: "Other",
    Original: "Original",
    Quote: "Quote",
    DataOverview: "Data Overview",
    PostInteractionRatio: "Post Interaction Ratio",
    PostInteractionRatioTooltip: "Ratio of different interaction types to total interactions.",
    TotalInteractions: "Total Interactions",
    Like: "Like",
    Reply: "Reply",
    Retweet: "Retweet",
    Reels: "Reels",
    SingletonInteractionTitle: "Per Post Interactions",
    SingletonInteractionTooltip: "Average interactions per post = total interactions / total posts in the selected date range.",
    InteractionPer1KTooltip: "Interactions per 1K followers = (total interactions received by posts on a given day) / (follower count on that day) × 1000. If no posts were made on that date, the value is 0.",
    FollowingListTitle: "Following Users",
    FollowingListTooltip: "Current number of users this X page is following.",
    ListedListTitle: "Listed",
    ListedListTooltip: "Total number of lists this X page belongs to. A social account belongs to a list when it is included as a member.",
    ListedTotal: "Total Listed",
    ListedNew: "New Listed",
    FollowingUserInfo: "Following User Info",
    FollowingTime: "Following Time",
    UnfollowTime: "Unfollow Time",
    BelongedList: "List",
    JoinTime: "Join Time",
    RemoveTime: "Remove Time",
    SingletonInteractionNum: "Per Post Interactions",
    NeedAuthTooltip: "Available after authorization",
    SinglePostInteractionTitle: "Per Post Interactions",
    SinglePostInteractionAuth: "To view per post interactions, please complete social page authorization!",
    FollowingUsersTitle: "Following Users",
    FollowingUsersTooltip: "Number of users this Instagram page is following.",
    FollowingUsersAuthMsg: "To view following users, please complete page authorization",
    ExposureAuthTitle: "Page Impressions (Auth)",
    ExposureAuthMsg: "To view page impressions, please complete page authorization",
    CoverageAuthTitle: "Page Reach (Auth)",
    CoverageAuthMsg: "To view page reach, please complete page authorization",
    InteractionPer1KPublic: "Interactions per 1K (Public)",
    InteractionPer1KAuth: "Interactions per 1K (Auth)",
    SinglePostInteractionPublic: "Per Post Interactions (Public)",
    SinglePostInteractionAuth: "Per Post Interactions (Auth)",
    TotalFollowingUsers: "Total Following",
    NewFollowingUsers: "New Following",
    NetFollowingUsers: "Net Following Growth",
    ExposureAuthCol: "Page Impressions (Auth)",
    CancelFollowing: "Unfollowed",
    TotalCoverage: "Total Reach",
    SinglePostInteractionTooltip: "Per post interactions (public) = total public interactions (likes + comments) on posts on a given day / number of posts on that day. If no posts were published on that day, the value is 0.",
    Exposure: "Impressions",
    Coverage: "Reach",
    FollowersCol: "Followers",
    FansCol: "Followers",
 
    CarouselType: "Carousel",
    StoryType: "Story",
    UpvoteType: "Upvote",
    DownvoteType: "Downvote",
    ShareType: "Share",
    CommentType: "Comment",
    LikeType: "Like",
    TipLabel: "Tip",
    ConfirmLabel: "Confirm",
    TranslateBtn: "Translate",
    DownloadLink: "Download Link",
    GoToVideoDetails: "Go to Video Details",
    LikesCount: "Likes",
    RepostsCount: "Reposts",
    ReactionsCount: "Reactions",
    DislikesCount: "Dislikes",
    InteractionsCount: "Interactions",
    PostsCountLabel: "Posts Count",
    TotalPostsCount: "Total Posts",
    VideosCount: "Videos Count",
    ViewsCount: "Views",
    PostContentLabel: "Post Content",
    PostTypeLabel: "Post Type",
    PostTimeLabel: "Post Time",
    PostInteractionRateLabel: "Post Interaction Rate",
    InteractionRateAuthLabel: "Interaction Rate (Auth)",
    ViewInteractionRateLabel: "View Interaction Rate",
    TotalInteractionsCount: "Total Interactions",
    VideoInteractionsCount: "Video Interactions",
    VideoPlayLabel: "Video Play",
    TotalWatchTime: "Total Watch Time",
    TotalViewersCount: "Total Viewers",
    TotalViewsCount: "Total Views",
    ViewsAndInteractionRate: "Views & View Interaction Rate",
    ViewsAndCompletionRate: "Views & Video Completion Rate",
    LostFollowersCount: "Lost Followers",
    NewVideosCount: "New Videos",
    TotalVideosCount: "Total Videos",
    TotalVideoDurationLabel: "Total Video Duration",
    TotalSavedCount: "Total Saved",
    HashtagsUsedCount: "Hashtags Used",
    CommentCountLabel: "Comment Count",
    StatusNormal: "Normal",
    StatusPaid: "Paid",
    StatusReplied: "Replied",
    StatusNotReplied: "Not Replied",
    SentimentNeutral: "Neutral",
    PositiveCommentsCount: "Positive Comments Count",
    NegativeCommentsCount: "Negative Comments Count",
    NeutralCommentsCount: "Neutral Comments Count",
    AllComments: "All Comments",
    ReplyStatusLabel: "Reply Status",
    PostExposureAuth: "Post Exposure (Auth)",
    PostReachAuth: "Post Reach (Auth)",
    PostSavedAuth: "Post Saved (Auth)",
    NeutralCommentsAuth: "Neutral Comments (Auth)",
    TotalCommentsAuth: "Total Comments (Auth)",
    SavedAuth: "Saved (Auth)",
    AuthVisibleTip: "Data is visible after authorization",
    CreationPostCountCol: "Posts Created",
    RepliesCountCol: "Replies",
    ReactionsCountCol: "Reactions",
    ReactionsCountColAuth: "Reactions (Auth)",
    ClickCountColAuth: "Clicks (Auth)",
    FollowerInteractionRateCol: "Follower Interaction Rate",
    FollowerInteractionRateColAuth: "Follower Interaction Rate (Auth)",
    InteractionPer1KCol: "Interaction per 1K Fans",
    InteractionPer1KColAuth: "Interaction per 1K Fans (Auth)",
    PostImpressionsCol: "Impressions",
    PostImpressionsPaidCol: "Paid Impressions",
    PostImpressionsOrganicCol: "Organic Impressions",
    ExposureInteractionRateCol: "Impression Interaction Rate",
    ExposureInteractionRateColAuth: "Impression Interaction Rate (Auth)",
    PhotoClickColAuth: "Clicks – Photo View (Auth)",
    VideoClickColAuth: "Clicks – Video Play (Auth)",
    LinkClickColAuth: "Clicks – Link Click (Auth)",
    OtherClickColAuth: "Clicks – Other (Auth)",
    VideoViewsCol: "Video Views",
    VideoViewsColAuth: "Video Views (Auth)",
    VideoPaidViewsColAuth: "Paid Video Views (Auth)",
    VideoOrganicViewsColAuth: "Organic Video Views (Auth)",
    VideoUniqueViewersColAuth: "Video Viewers (Auth)",
    VideoPaidUniqueViewersColAuth: "Paid Video Viewers (Auth)",
    VideoOrganicUniqueViewersColAuth: "Organic Video Viewers (Auth)",
    VideoTotalWatchTimeColAuth: "Total Video Watch Time (Auth)",
    VideoAvgWatchTimeColAuth: "Avg Video Watch Time (Auth)",
    VideoCompletionRateColAuth: "Video Completion Rate (Auth)",
    Video30sViewsColAuth: "30-Second Views (Auth)",
    PositiveCommentsCol: "Positive Comments",
    NegativeCommentsCol: "Negative Comments",
    NeutralCommentsCol: "Neutral Comments",
    PositiveCommentsColAuth: "Positive Comments (Auth)",
    NegativeCommentsColAuth: "Negative Comments (Auth)",
    NeutralCommentsColAuth: "Neutral Comments (Auth)",
    SharesCountColAuth: "Shares (Auth)",
    CarouselAlbumViewsColAuth: "Carousel Album Views (Auth)",
    CarouselAlbumReachColAuth: "Carousel Album Reach (Auth)",
    CarouselAlbumSavedColAuth: "Carousel Album Saved (Auth)",
    ViewInteractionRateCol: "View Interaction Rate",
    CompletionRateCol: "Completion Rate",
    ReachInteractionRateCol: "Reach Interaction Rate",
    TotalWatchTimeCol: "Total Watch Time",
    AvgWatchTimeCol: "Avg Watch Time",
    // Facebook data details column descriptions
    PostCountColDesc: "The number of posts published by the page per day within the selected date range.",
    PostInteractionCountColDesc: "Post Interactions = cumulative post interactions (reactions + shares + comments) received by posts published on the specified date.",
    ReactionsCountColDesc: "All emotional reactions such as Like, Love, Wow, Haha, Sad and Angry are counted by type and aggregated.",
    CommentsCountColDesc: "The total number of comments received on posts.",
    SharesCountColDesc: "The number of times posts were shared.",
    ClickCountColAuthDesc: "The number of times users clicked anywhere on the post.",
    FollowerInteractionRateColDesc: "Follower Interaction Rate = public interactions of the post (reactions + comments + shares) / public followers on the post date × 100%.",
    FollowerInteractionRateColAuthDesc: "Follower Interaction Rate (Auth) = authorized interactions of the post (reactions + comments + shares) / authorized followers on the post date × 100%.",
    InteractionPer1KColDesc: "Interaction per 1K = public interactions of the post (reactions + comments + shares) / public followers on the post date × 1000.",
    InteractionPer1KColAuthDesc: "Interaction per 1K (Auth) = authorized interactions of the post (reactions + comments + shares) / authorized followers on the post date × 1000.",
    PostImpressionsColDesc: "Within the selected time range, the number of times your published content was played or displayed, including videos, posts, stories and ads.",
    PostImpressionsPaidColDesc: "Paid Impressions refers to the number of times a post was displayed to users through paid display (e.g., ads).",
    PostImpressionsOrganicColDesc: "Organic Impressions refers to the number of times a post was displayed to users through non-paid display.",
    ExposureInteractionRateColAuthDesc: "Impression Interaction Rate (Auth) = authorized interactions of the post (reactions + comments + shares + clicks) / impressions × 100%.",
    PhotoClickColAuthDesc: "The number of times users clicked to view photos.",
    VideoClickColAuthDesc: "Video plays: the number of times videos in posts were clicked to play.",
    LinkClickColAuthDesc: "Link clicks: clicks on links in posts (links that jump to destinations on or off Facebook).",
    OtherClickColAuthDesc: "The number of clicks on other parts of the post.",
    VideoPaidViewsColAuthDesc: "Paid video views: the number of times a promoted video was played for at least 3 seconds, or almost fully if the video is shorter than 3 seconds.",
    VideoOrganicViewsColAuthDesc: "Organic video views: the number of times users with organic reach played a video for at least 3 seconds, or almost fully if the video is shorter than 3 seconds.",
    VideoUniqueViewersColAuthDesc: "Video viewers: the number of users who watched a video for at least 3 seconds or almost fully (if the video is shorter than 3 seconds).",
    VideoPaidUniqueViewersColAuthDesc: "The number of users who watched a promoted video for at least 3 seconds or almost fully (if the video is shorter than 3 seconds).",
    VideoOrganicUniqueViewersColAuthDesc: "Organic video viewers: the number of users with organic reach who watched a video for at least 3 seconds or almost fully (if the video is shorter than 3 seconds).",
    VideoTotalWatchTimeColAuthDesc: "Total duration of video plays.",
    VideoAvgWatchTimeColAuthDesc: "The average duration users watched videos.",
    Video30sViewsColAuthDesc: "The number of times a video was played for at least 30 seconds, or almost fully if the video is shorter than 30 seconds.",
    TotalCommentsColAuthDesc: "The number of newly published comments, excluding comments deleted by users.",
    PositiveCommentsColAuthDesc: "The number of comments expressing positive emotions such as satisfaction, praise, affection or support.",
    NegativeCommentsColAuthDesc: "The number of comments expressing negative emotions such as dissatisfaction, criticism, disgust or opposition.",
    NeutralCommentsColAuthDesc: "The number of comments that are neither clearly positive nor clearly negative.",
    // TikTok data details column descriptions
    NewVideosCountDesc: "The number of videos published within the selected date range.",
    InteractionsCountDesc: "The number of interactions on videos published within the selected date range.",
    LikesCountDesc: "The number of likes on videos published within the selected date range.",
    CommentsCountDesc: "The number of comments on videos published within the selected date range.",
    SharesCountDesc: "The number of shares on videos published within the selected date range.",
    FollowerInteractionRateDesc: "Follower Interaction Rate = video public interactions (likes + comments + shares) / followers on the post date × 100%.",
    VideoViewsColDesc: "The number of times videos published within the selected date range were viewed.",
    ViewInteractionRateColDesc: "View Interaction Rate = video public interactions (likes + comments + shares) / video views × 100%.",
    ExposureCountColDesc: "TikTok videos do not support impression metrics. For cross-platform comparison, the video views of videos published within the selected date range are used as impressions.",
    ExposureInteractionRateColDesc: "Impression Interaction Rate = video public interactions (likes + comments + shares) / impressions × 100%. Video views are used as impressions.",
    EmojiCommentCount: "Emoji Comments",
    RepostsCountCol: "Reposts",
    BrandLabel: "Brand",
    IndustryLabel: "Industry",
    RegionGroup: "Region Group",
    AboutPage: "About Page",
    CreatedTime: "Created Time",
    ContactInfo: "Contact Information",
    WebsiteLabel: "Website",
    PhoneLabel: "Phone",
    EmailLabel: "Email",
    AddressLabel: "Address",
    GoTo: "Go to",
    Platform: "Platform",
    GoToPlatform: "Open {platform}",
    NeedAuthForPostCount: "To view post count, please complete social page authorization!",
    VideoWatchDurationTooltip: "Total duration and average duration of video plays.",
    PostInteractionTooltip:
      "Public data: Public post {interaction} = total {interaction} accumulated by all posts published by the page on the specified date (reactions + shares + comments), broken down by interaction type. If the page did not publish any post on a certain date, the post {interaction} for that day is 0.\nAuthorized data: Authorized post {interaction} = total {interaction} accumulated by posts published by the page on the specified date up to the cutoff date (reactions + shares + comments + post clicks), broken down by interaction type. If the page did not publish any post on a certain date, the post {interaction} for that day is 0.",
    PostExposure: "Post Exposure",
    PostInteractionFormula:
      "Post interactions = total post interactions (reactions + shares + comments) accumulated by posts published on the specified date.",
    HeartsTotalTooltip: "Total reactions received by the posts.",
    CommentsTotalTooltip: "Number of comments on your posts.",
    SharesTotalTooltip: "Number of shares of your posts.",
    FollowerInteractionRateTooltip: "Percentage of post interactions divided by page followers.",
    TotalInteractionsTooltip: "Total interactions gained by posts published by the page within the selected date range.",
    TotalPostsTooltip: "Total number of posts published within the selected date range.",
    TotalWatchTimeTooltip: "Total watch time of videos within the selected date, including replays.",
    AvgWatchTimeTooltip: "Average playback duration of videos within the selected date, including replay time on a single impression.",
    TotalCommentsTooltip: "Total number of comments on posts within the selected date range.",
    PositiveCommentsColDesc: "Number of comments expressing positive emotions such as satisfaction, appreciation, affection, or support.",
    NegativeCommentsColDesc: "Number of comments expressing negative emotions such as dissatisfaction, criticism, aversion, or opposition.",
    NeutralCommentsColDesc: "Number of comments that express neither obvious positive nor obvious negative emotions.",
    ClickTotalLabel: "Total Clicks",
    ClickTotalTooltip: "Number of times post content was clicked within the selected date range.",
    ImageViewTooltip: "Number of times users clicked to view images.",
    VideoPlayTooltip: "Number of times users clicked to play videos.",
    LinkClickTooltip: "Number of times users clicked links in posts.",
    OtherClickTooltip: "Clicks of other types on posts.",
    ImageViewLabel: "Image Views",
    CommentsInfo: "Comments Info",
    OnlyAuthorizedComments: "Only comments from authorized pages can be viewed",
    AuthorizePage: "Authorize Page",
    ViewMoreReplies: "View More Replies",
    ViewMoreRepliesCount: "View all {count} replies",
    BasicInfo: "Basic Info",
    CommentCount: "Comments",
    FanInteractionRate: "Fan Interaction Rate",
    HeartsCountAuth: "Reactions (Auth)",
    LikeCount: "Likes",
    Proportion: "Proportion",
    Time: "Time",
    LinkClickLabel: "Link Clicks",
    OtherClickLabel: "Other Clicks",
    OrganicImpressionsCount: "Organic Impressions",
    PaidImpressionsCount: "Paid Impressions",
    OrganicReachCount: "Organic Reach",
    PaidReachCount: "Paid Reach",
    OrganicViewsCount: "Organic Views",
    PaidViewsCount: "Paid Views",
    FollowerImpressionsCount: "Follower Impressions",
    NonFollowerImpressionsCount: "Non-Follower Impressions",
    PaidPromotion: "Paid Promotion",
    NormalPromotion: "Normal Promotion",
    LanguageChinese: "Chinese",
    LanguageSimplifiedChinese: "Simplified Chinese",
    LanguageTraditionalChinese: "Traditional Chinese",
    CommentListFailed: "Failed to get comment list",
    GetDataFailed: "Failed to get data",
    DeleteFailed: "Delete Failed",
    ReplyFailed: "Reply Failed",
    ReplySuccess: "Reply Successful",
    TranslationFailed: "Translation Failed",
    CancelTranslation: "Cancel Translation",
    NoDataAvailable: "No data available yet",
    EnterReplyContent: "Please enter reply content",
    EnterCommentContent: "Please enter comment content",
    EnterPostContent: "Please enter post content",
    SelectOriginalStatus: "Please select original status",
    SelectPostStatus: "Please select post status",
    SelectPostType: "Please select post type",
    SelectPromotionType: "Please select promotion type",
    SelectPaidStatus: "Please select paid status",
    MissingParams: "Missing page or post parameters",
    DeleteCommentConfirm: "This comment cannot be recovered after deletion. Confirm delete?",
    AllCommentsWithCount: "All Comments ({count})",
    PacificTimeZone: "Pacific Time (UTC -07:00)",
    AllCommentsFilter: "All Comments",
    // Facebook single-post comment controls change together with the active locale.
    FacebookPostDetailTabs: "Post Detail Tabs",
    FacebookPostDataTab: "Post Data",
    FacebookCommentsInfoTab: "Comments Info",
    FilterComments: "Filter Comments",
    BeijingTimeZone: "Beijing Time (UTC +08:00)",
    LanguageEnglish: "English",
    FbPositiveComment: "Positive Comments",
    FbNegativeComment: "Negative Comments",
    FbNeutralComment: "Neutral Comments",
    ReplyStatusFilter: "Reply Status",
    RepliedStatus: "Replied",
    NotRepliedStatus: "Not Replied",
    ExportComments: "Export Comments",
    CancelReply: "Cancel Reply",
    Processing: "Processing",
    UnhideComment: "Unhide",
    CommentHiddenStatus: "This comment is hidden and not visible to users",
    Deleting: "Deleting",
    Emoji: "Emoji",
    ExceedCharsLimit: "Exceeds {count} characters",
    NoCommentsData: "No comment data",
    DataUpdatingTip: "Data is updating, please wait...",
    DsInteractionCountLabel: "Interactions",
    DsReactionTotalLabel: "Reactions",
    DsCommentsLabel: "Comments",
    DsSharesLabel: "Shares",
    DsPer1KInteractionsLabel: "Interactions per 1K followers",
    DsFollowerInteractionRateLabel: "Follower interaction rate",
    DsClickCountLabel: "Clicks",
    DsImpressionsLabel: "Impressions",
    DsReachCountLabel: "Reach",
    DsImpInteractionRateLabel: "Impression interaction rate",
    DsReachInteractionRateLabel: "Reach interaction rate",
    DsLikesLabel: "Likes",
    DsRepliesLabel: "Replies",
    DsRetweetsLabel: "Retweets",
    DsViewsLabel: "Views",
    DsThumbsUpLabel: "Likes",
    DsShareCountLabel: "Shares",
    DsSavedLabel: "Saves",
    DsVideoViewCountLabel: "Video views",
    DsLikeCountLabel: "Likes",
    DsViewInteractionRateLabel: "View interaction rate",
    DsAvgWatchTimeLabel: "Average watch time",
    DsCompletionRateLabel: "Video completion rate",
    DsYtLikeCountLabel: "Likes",
    DsReactionsLabel: "Reactions",
    DsVideoViewInteractionRateLabel: "Video view interaction rate",
    DsInteractionTotalTip: "Total interactions on the post",
    DsInteractionTotalAuthTip: "Total interactions on the post (authorized)",
    DsInteractionFbTip: "Interactions = Reactions + Comments + Shares",
    DsReactionTotalTip: "Unique users who expressed a reaction on the post (“Like”, “Love”, “Haha”, “Wow”, “Sad” or “Angry”). If a user expresses multiple reactions on the same post, it is counted only once.",
    DsFollowerRateFbTip: "Follower interaction rate = Public interactions on the post (Reactions + Comments + Shares) / Public followers on the post date × 100%",
    DsInteractionAuthFbTip: "Interactions (authorized) = Reactions + Comments + Shares + Clicks",
    DsClickCountTip: "Number of times users clicked anywhere on the post",
    DsImpressionsTip: "Number of times the post was shown to users",
    DsReachCountTip: "Unique users who saw the post",
    DsReachCountDotTip: "Unique users who saw the post.",
    DsPer1KAuthFbTip: "Interactions per 1K followers (authorized) = Authorized interactions on the post (Reactions + Comments + Shares + Clicks) / Authorized followers on the post date × 1000",
    DsFollowerRateAuthFbTip: "Follower interaction rate (authorized) = Authorized interactions on the post (Reactions + Comments + Shares + Clicks) / Authorized followers on the post date × 100%",
    DsImpRateAuthFbTip: "Impression interaction rate (authorized) = Authorized interactions on the post (Reactions + Comments + Shares + Clicks) / Impressions × 100%",
    DsReachRateAuthFbTip: "Reach interaction rate (authorized) = Authorized interactions on the post (Reactions + Comments + Shares + Clicks) / Reach × 100%",
    DsLikesTip: "Number of likes on the post",
    DsRepliesTip: "Number of replies on the post",
    DsRetweetsTip: "Number of times the post was retweeted",
    DsPer1KXTip: "Interactions per 1K followers = Public interactions on the post / Followers on the post date × 1000",
    DsFollowerRateXTip: "Follower interaction rate = Public interactions on the post / Followers on the post date × 100%",
    DsImpRateXTip: "Impression interaction rate = Public interactions on the post / Views × 100%",
    DsThumbsUpTip: "Number of likes on the post",
    DsPer1KIGTip: "Interactions per 1K followers = Public interactions on the post (Likes + Comments) / Followers on the post date × 1000",
    DsFollowerRateIGTip: "Follower interaction rate = Public interactions on the post (Likes + Comments) / Followers on the post date × 100%",
    DsInteractionIGAuthTip: "Interactions (authorized) = Likes + Comments + Shares + Saves; shares only available for Reels",
    DsSavedTip: "Number of times the post was saved by users",
    DsPer1KIGAuthTip: "Interactions per 1K followers = Authorized interactions on the post (Likes + Comments + Shares + Saves) / Followers on the post date × 1000; shares only available for Reels.",
    DsFollowerRateIGAuthTip: "Follower interaction rate = Authorized interactions on the post (Likes + Comments + Shares + Saves) / Followers on the post date × 100%; shares only available for Reels.",
    DsImpRateIGAuthTip: "Impression interaction rate = Authorized interactions on the post (Likes + Comments + Shares + Saves) / Impressions × 100%. For Reels, plays count as impressions. Shares only available for Reels.",
    DsReachRateIGAuthTip: "Reach interaction rate (authorized) = Authorized interactions on the post (Likes + Comments + Shares + Saves) / Reach × 100%; shares only available for Reels.",
    DsInteractionTikTokTip: "Interactions = Likes + Comments + Shares",
    DsLikeCountTip: "Number of likes on the post",
    DsPer1KTikTokTip: "Interactions per 1K followers = Video interactions (Likes + Comments + Shares) / Followers on the video publish date × 1000",
    DsFollowerRateTikTokTip: "Follower interaction rate = Public video interactions (Likes + Comments + Shares) / Followers on the post date × 100%",
    DsImpRateTikTokTip: "Impression interaction rate = Public video interactions (Likes + Comments + Shares) / Impressions × 100%; video views are used as impressions",
    DsViewRateTikTokTip: "Video view interaction rate = Public video interactions (Likes + Comments + Shares) / Video views × 100%",
    DsReachRateTikTokTip: "Reach interaction rate = Public video interactions (Likes + Comments + Shares) / Reach × 100%",
    DsAvgWatchTimeTip: "Average time users watched the video",
    DsCompletionRateTip: "Percentage of video views that were watched in full",
    DsInteractionYtTip: "Interactions = Likes + Comments",
    DsYtLikeCountTip: "Total number of likes on the video",
    DsVideoCommentsTip: "Number of comments on the video",
    DsPer1KYtTip: "Interactions per 1K followers = Public video interactions (Likes + Comments) / Channel subscribers on the video publish date × 1000",
    DsFollowerRateYtTip: "Follower interaction rate = Public video interactions (Likes + Comments) / Channel subscribers on the video publish date × 100%",
    DsViewRateYtTip: "Video view interaction rate = Public video interactions (Likes + Comments) / Video views × 100%",
    DsInteractionThreadsTip: "Interactions = Reactions + Comments + Shares",
    DsReactionsTip: "Number of reactions used in comments",
    DsPer1KThreadsTip: "Interactions per 1K followers = (Reactions + Comments + Shares) / Followers on the post date × 1000",
    DsFollowerRateThreadsTip: "Follower interaction rate = Public interactions on the post (Reactions + Comments + Shares) / Followers on the post date × 100%",
    VideoAddCount: "New videos",
    VideoTotalDuration: "Total video duration",
    YtVideoDataTooltip: "Number of videos published by the channel.",
    YtVideoDataTooltipDot: "Number of videos published by the channel in the selected date range.",
    VideoAdd: "New videos",
    ViewsAddCount: "New views",
    ViewsTotalCount: "Total views",
    YtViewsTooltip: "Number of video views obtained by the channel.",
    YtViewsTooltipDot: "Number of views on videos newly published by the channel in the selected date range.",
    // YouTube video interaction metrics include shares alongside likes, dislikes, and comments; the detail-table tooltip spells out all four.
    UpVote: "Likes",
    DownVote: "Dislikes",
    YtInteractionTooltip1: "Interactions obtained by videos published by the channel in the selected date range, i.e., likes + dislikes + shares + comments.",
    YtInteractionTooltip2: "Interactions obtained by videos published by the channel in the selected date range, i.e.: likes + dislikes + shares + comments.",
    YtCommentTrendTooltip: "Trend of positive and negative sentiment of user comments on posts in the selected date range",
    VideoWatchData: "Video Views",
    VideoInteractionData: "Video Interactions",
    CommentTrend: "Comment Trend",
    VideoDurationCol: "Video Duration",
    YtViewRateTooltip: "Correlation between videos published by the channel and the interactions they received.",
    TableSummaryTotal: "Total",
    CommentTimeLaBeijing: "Comment time: Pacific (UTC -07:00) {laTime} · Beijing {beijingTime}",
    CommentTimeBeijing: "Comment time: Beijing {beijingTime}",
    CommentTimeLa: "Comment time: Pacific (UTC -07:00) {laTime}",
    CommentTimeEmpty: "Comment time: -",
    ReplyToUser: "Reply @{name}",
    User: "User",
    Translate: "Translate",
    ReplyExceedCharsLimit: "Reply content exceeds {count} characters",
    DeleteSuccess: "Deleted successfully",
    Tip: "Notice",
    Confirm: "Confirm",
    PostCommentCountDesc: "Number of comments on the post",
    PostViewCountDesc: "Number of times the post was viewed",
    PostCommentedCountDesc: "Number of times the post was commented on",
    InteractionFormula1: "Interactions = Likes + Comments + Shares",
    InteractionFormula2: "Interactions = Reactions + Comments + Shares",
    PostInteractionTooltip: "Total post interactions (reactions + shares + comments + clicks).",
    ContentDisplayedTooltip: "Number of times your content was played or displayed, including videos, posts, stories, and ads.",
    ContentReachTooltip: "Number of Meta accounts that have viewed your content at least once.",
    VideoPlay3SecTooltip: "Number of times a video was played for at least 3 seconds or almost fully played (if less than 3 seconds).",
    FbTextCountTooltip: "Number of posts that are text only.",
    FbImgCountTooltip: "Number of posts containing images.",
    FbVideoCountTooltip: "Number of posts containing videos.",
    FbGroupCountTooltip: "Number of posts containing a combination of media types.",
    FbLinkCountTooltip: "Number of posts containing links.",
    FbReelsCountTooltip: "Number of Reels short video posts.",
    FbGifCountTooltip: "Number of posts containing GIFs.",
    FbOtherCountTooltip: "Number of posts of other types.",
    FbFollowerNonFollower: "Followers/Non-followers",
    FbPageViewsTooltip: "Number of times your published content was played or displayed within the time range, including videos, posts, stories, and ads.",
    FbPaidViewsTooltip: "Paid views refer to the number of times posts were shown to users through paid placements (e.g., ads).",
    FbOrganicViewsTooltip: "Organic reach refers to the number of times posts were shown to users through non-paid placements.",
    FbFollowerViewsTooltip: "Number of times your content was viewed by followers.",
    FbNonFollowerViewsTooltip: "Number of times your content was viewed by non-followers.",
    FbTotalPlayCount: "Total Plays",
    FbPaidViews3SecTooltip: "Paid video views are the number of times promoted videos were played for at least 3 seconds or almost fully played (if the video is shorter than 3 seconds).",
    FbOrganicViews3SecTooltip: "Organic video views are the number of times users reached organically played videos for at least 3 seconds or almost fully played (if the video is shorter than 3 seconds).",
    FbAutoPlayViewsTooltip: "Number of times videos started playing automatically.",
    FbClickPlayViewsTooltip: "Number of times users actively clicked to play videos.",
    FbViews30SecTooltip: "Number of times a video was played for 30 seconds.",
    FbPaidViews30SecTooltip: "Number of times promoted videos were played for at least 30 seconds or almost fully played (if the video is shorter than 30 seconds). Each video impression is counted separately, and no replay time is counted.",
    FbOrganicViews30SecTooltip: "Number of times videos were played for at least 30 seconds or almost fully played (if the video is shorter than 30 seconds), broken down by organic reach. No replay time is counted for each video play.",
    FbAutoPlayViews30SecTooltip: "Number of times videos were auto-played for at least 30 seconds or almost fully played (if the video is shorter than 30 seconds).",
    FbClickPlayViews30SecTooltip: "Number of times users played videos for at least 30 seconds or almost fully played (if the video is shorter than 30 seconds) after clicking to play.",
    FbCompletionRateTooltip: "Percentage of videos that were played to completion.",
    FollowTrendTooltip: "Trend of people following the page.",
    SubscriberCountTooltip: "Number of people subscribed to the channel.",
    ChannelVideoCountTooltip: "Number of videos published by the channel.",
    ChannelVideoViewsTooltip: "Number of video views received by the channel.",
    ChannelInteractionTooltip: "Total interactions on videos published by the channel in the selected period, i.e. upvotes + downvotes + comments.",
    PageInteractionsTooltip: "Number of interactions on posts published by the page in the selected period, i.e. likes + comments + shares.",
    StoryTapTooltip: "Total times users tapped to view the next/previous photo or video in a story. If less than 5, it shows 0.",
    StoryCountTooltip: "Number of stories published per day by the page within the selected date range.",
    CommentSentimentTrendTooltip: "Sentiment trend of user comments on posts within the selected date range.",
    CommentSentimentTrendTooltip2: "Sentiment trend of user comments on posts within the selected date range.",
    PostsPublishedTooltip: "Number of posts published by the page within the selected date range.",
    PostsViewedTooltip: "Number of times posts were viewed within the selected date range.",
    FansOnlineHourlyTooltip: "Total online followers of Instagram users on each day of the last week within the selected date range, broken down by hour.",
    FollowerCountryTooltip: "Countries/regions of followers on the last day of the selected date range.",
    VideoUniqueViewersTooltip: "Number of unique users who viewed videos published on the selected date.",
    NeutralCommentCountDesc: "Number of neutral comments on videos published on the selected date.",
    PositiveCommentCountDesc: "Number of positive comments on videos published on the selected date.",
    TotalWatchTimeDesc: "Total watch time of videos published on the selected date.",
    NegativeCommentCountDesc: "Number of negative comments on videos published on the selected date.",
    AvgWatchTimeDesc: "Average watch time of videos published on the selected date.",
    NeedAuthForFollowerCountry: "View follower country distribution, requires social page authorization first.",
    NeedAuthForFollowerOnline: "View follower online time, requires social page authorization first!",
    NeedAuthForFollowerAge: "View follower age distribution, requires social page authorization first!",
    NeedAuthForFollowerCount: "View follower count, requires social page authorization first!",
    NeedAuthForTapCount: "View tap forward/back count, requires social page authorization first!",
    InteractionPer1KAuthFormula: "Interaction per 1K (Auth) = Authorized post interactions (reactions + comments + shares + clicks) / Authorized followers on post date × 1000.",
    FollowerInteractionRateAuthFormula: "Follower Interaction Rate (Auth) = Authorized post interactions (reactions + comments + shares + clicks) / Authorized followers on post date × 100%.",
    ReachInteractionRateAuthFormula: "Reach Interaction Rate (Auth) = Video public interactions (likes + comments + shares) / Reach × 100%",
    InteractionPer1KFormula: "Interaction per 1K = Video interactions (likes + comments + shares) / Followers on video publish date × 1000",
    VideoCompletionAuthFormula: "Video Completion Rate (Auth) = 30s Views / Total Views × 100%",
    NewViewsCount: "New Views",
    NewViewsCountAlt: "New Views Count",
    // TODO
 
    PostAndInteractionTrend: "Post & Post Interaction Trend",
    PostReachAuth2: "Post Reach (Auth)",
    PostExposureAuth2: "Post Exposure (Auth)",
    VideoViewsAndCompletionRate: "Video Views & Completion Rate",
    VideoCompletionRateAuthLabel: "Video Completion Rate (Auth)",
    PaidImpressionTooltip: "Number of times your public page posts, stories, or related content appeared on user screens via paid display (e.g., ads).",
    OrganicImpressionTooltip2: "Number of times any of your public page content (excluding social context content about your page) appeared on user screens.",
    FollowerViewsLabel: "Follower Views",
    FollowerViewsTooltip: "Number of times your page content was displayed on screen to accounts that follow or like your page.",
    NonFollowerViewsLabel: "Non-Follower Views",
    NonFollowerViewsTooltip: "Number of times your page content was displayed on screen to accounts that do not follow or like your page.",
    Watch30Sec: "Watch 30s",
    PaidVideoImpressionTooltip: "Number of times any of your video content appeared on user screens via paid display.",
    VideoImpressionTooltip: "Number of times any of your video content appeared on user screens.",
    PostReachUsersTooltip: "Number of users who saw any of your page posts on their device screen within the selected date range.",
    VideoViewerDefinitionTooltip: "Number of users who watched a video for at least 3 seconds or nearly fully (if the video is less than 3 seconds).",
    ViewSourceLabel: "View Source",
    PlayTriggerTypeLabel: "Play Trigger Type",
    Watch30SecComplete: "30s/Complete Watch",
    ReplyToFollower: "Reply to Follower",
    OverallDataLabel: "Overall Data",
    Last24Hours: "Last 24 Hours",
    CountryDistributionTooltip: "Number of users who like the public page on the last day of the statistics period, by country/region. The system only shows the top 45 countries/regions with the most likes.",
    CityDistributionTooltip: "City distribution of users who like the page on the last day of the selected date range; only shows the top 45 cities. City names may be displayed in multiple languages.",
    AgeGenderDistributionLabel: "Age & Gender Distribution",
    OnlineFansPerHour: "Online Fans per Hour",
    UserRetentionLabel: "User Retention",
    NewFollowersLabel: "New Followers",
    NetFollowerChange: "Net Follower Change",
    DataTrendOverview: "Data Trend Overview",
    PostEngagedUsers: "Post Engaged Users",
    PostReachCount: "Post Reach",
    CommentSourceLabel: "Comment Source",
    CommentFilterLabel: "Comment Filter",
    CommentInteractionFormula: "Total comment interactions = Likes + Comments (including follower replies) + Shares",
    CommentEngagedFormula: "Total comment engaged users = Users who liked + Users who commented (including follower replies) + Users who shared",
    CommentPercentageLabel: "Comment Percentage",
    CommentSentimentDistribution: "Comment Sentiment Distribution",
    PostViewTooltip2: "Number of times posts were viewed within the selected date range.",
    PostInteractionTooltip2: "Total post interactions (reactions + shares + comments + clicks) within the selected date range.",
    ViewCompletionRateFormula: "View Completion Rate = 30s Complete Views / Viewers.",
    VideoRetentionTooltip: "User retention rate of videos published on the selected date.",
    PageIdLabel: "Page ID",
    PageNameLabel: "Page Name",
    PageFollowersCount: "Page Followers",
    PageLinkLabel: "Page Link",
    PageAvatarLabel: "Page Avatar",
    AuthorizationExpirationLabel: "Authorization Expiration",
    AuthorizationTypeLabel: "Authorization Type",
    PageAuthorizationLabel: "Page Authorization",
    DataFetchTimeLabel: "Data Fetch Time",
    CommentsAuth: "Comments (Auth)",
    CommentsPublic: "Comments (Public)",
    TranslationNotSupported: "Translation not supported for public data",
    ShowTranslation: "Show Translation",
    HideTranslation: "Hide Translation",
    TranslatingStatus: "Translating...",
    TranslatedStatus: "Translated",
    OriginalLanguageLabel: "Original Language",
    TranslationLanguageLabel: "Translation Language",
    TranslatedContentLabel: "Translated Content",
    HideLabel: "Hide",
    DeleteLabel: "Delete",
    MoreLabel: "More",
    ViewOriginalBtn: "View Original",
    LoadingText: "Loading...",
    NoMoreDataText: "No More Data",
    LoadFailedText: "Load Failed",
    ClickToRetryText: "Click to Retry",
    CancelledStatus: "Cancelled",
    FilterLabel: "Filter",
    ClearLabel: "Clear",
    CopyLinkBtn: "Copy Link",
    OpenLinkBtn: "Open Link",
    PublishPostBtn: "Publish Post",
    NoCommentsText: "No Comments",
    CommentDeletedText: "Comment Deleted",
    CommentHiddenText: "Comment Hidden",
    AuthorLabel: "Author",    DataDimensionColon: "Data Dimension:",
    CountryRegion: "Country/Region",
    FansCount: "Fans Count",
    CountryRegionAndCity: "(Country/Region) and City",
    ActiveFansCount: "Active Fans",
    AuthorizedDataVisible: "Data visible after authorization",
    Language: "Language",
    NetFansGrowthTooltip: "The number of follows minus unfollows during the selected period.",
    NewFollowsTooltip: "The number of new follows on the Page.",
    UnfollowsTooltip: "The number of Accounts Center accounts that unfollowed your Page during the selected period.",
    ActiveFansTooltip: "The number of fans who have interacted during the selected period.",
    TotalFansFacebookTooltip: "The number of fans your Facebook Page or profile has. Calculated as: total follows minus unfollows since the creation of your Facebook Page or profile.",
    LanguageDistributionTooltip: "The language distribution of users who liked the Page as of the last day of the selected date range, based on the default language setting when users access Facebook.",
    PageLikesTotalTooltip: 'The trend of total number of people who have liked the Page during the selected date range. For market Pages in the global pages structure, after authorization, you can view the market Page\'s own page likes in the "Authorized Data" chart. Without authorization, you can only view global page likes in the "Public Data" chart.',
    PageLikes: "Page Likes",
    AuthorizedData: "Authorized Data",
    ProfileViews: "Profile Views",
    ProfileViewsTooltip: "The trend of TikTok profile views during the selected date range. This information is not applicable to accounts with fewer than 100 fans.",
    VideoInteractionsPer1000Tooltip: "The number of video interactions per 1,000 subscribers during the selected date range, calculated as: total video interactions in the selected date range / number of subscribers in the selected date range * 1,000.",
    InteractionProportion: "Interaction Proportion",
    PostDetail: "Post Detail",
    TwitterFollowersTrendTooltip: 'The trend of follower count changes during the selected date range. For market accounts in the global structure, after authorization, you can view the market account\'s own follower count in the "Authorized Data" chart. Without authorization, you can only view global follower count in the "Public Data" chart.',
    FansChangeTooltip: "The change in Fans during the selected date range.",
    FacebookLoginNetworkError: "Unable to log in to Facebook in the current network environment. Please check your network!",
    InstagramLoginNetworkError: "Unable to log in to Instagram in the current network environment. Please check your network!",
    TikTokLoginNetworkError: "Unable to log in to TikTok in the current network environment. Please check your network!",
    XLoginNetworkError: "Unable to log in to X in the current network environment. Please check your network!",
    YouTubeLoginNetworkError: "Unable to log in to YouTube in the current network environment. Please check your network!",
    TelegramLoginNetworkError: "Unable to log in to Telegram in the current network environment. Please check your network!",
    MostInteractionsDayTooltip: "The day with the most user interactions.",
    LeastInteractionsDayTooltip: "The day with the least user interactions.",
    PostInteractionsTooltip: "The number of times users interact with posts through likes, comments, and shares.",
    ThousandFanInteractionsTooltip: "Thousand-fan interactions refers to the average number of post interactions generated per 1,000 fans on the specified date. Specified date thousand-fan interactions = (total post interactions (reactions + shares + comments) of posts published by the Page on the specified date ÷ number of fans on the specified date) × 1,000. If the Page does not publish any posts on a given date, the thousand-fan interaction count for that date is 0.",
    PageViewsTooltip: "The number of times logged-in and logged-out users view the Page.",
    MostViewsDayTooltip: "The day with the most views.",
    LeastViewsDayTooltip: "The day with the least views.",
    PostReactionsTooltip: "The total number of reactions received by Page posts per day, broken down by type.",
    MostReactionsDayTooltip: "The day with the most total reactions on Page posts.",
    LeastReactionsDayTooltip: "The day with the least total reactions on Page posts.",
    PageLikesCountTooltip: "The number of people who have liked the Page as of the last day of the selected date range.",
    PageLikesNetChangeTooltip: "The net change in total Page likes (total likes on the last day of the selected date range minus total likes on the previous day).",
    PositiveCommentCol: "Positive Comment",
    NegativeCommentCol: "Negative Comment",
    NeutralCommentCol: "Neutral Comment",
    TwitterFollowersTrendFullTooltip: "The trend of follower count changes during the selected date range. For market Pages in the global pages structure, after authorization, you can view the market Page's own follower count in the \"Authorized Data\" chart. Without authorization, you can only view global follower count in the \"Public Data\" chart.",
    ProfileViewsAuthorized: "Profile Views (Authorized)",
    ContentCoverageTooltip: "The number of Meta accounts that viewed your content at least once. Content includes Reels, posts, stories, live videos, and ads.",
    ContentCoverageMostDayTooltip: "The day with the highest number of Meta accounts that viewed your content.",
    ContentCoverageLeastDayTooltip: "The day with the lowest number of Meta accounts that viewed your content.",
    Video3SecViewsTooltip: "The number of times a Page video was played for at least 3 seconds, or for almost its full duration if the video is shorter than 3 seconds.",
    AutoPlay3SecViewsTooltip: "The number of times a Page video was auto-played for at least 3 seconds, or for almost its full duration if the video is shorter than 3 seconds.",
    ClickPlay3SecViewsTooltip: "The number of times a Page video was played for at least 3 seconds after clicking play, or for almost its full duration if the video is shorter than 3 seconds.",
    Video30SecViewsTooltip: "The number of times a Page video was played for at least 30 seconds, or for almost its full duration if the video is shorter than 30 seconds.",
    PromotedVideo30SecViewsTooltip: "The number of times a promoted Page video was played for at least 30 seconds, or for almost its full duration if the video is shorter than 30 seconds.",
    AutoPlay30SecViewsTooltip: "The number of times an auto-played Page video was played for at least 30 seconds, or for almost its full duration if the video is shorter than 30 seconds.",
    ClickPlay30SecViewsTooltip: "The number of times a Page video was played for at least 30 seconds after clicking play, or for almost its full duration if the video is shorter than 30 seconds.",
    ReactionLike: "Like",
    ReactionWow: "Wow",
    ReactionAngry: "Angry",
    MaxDailyViews: "Max Daily Views",
    MinDailyViews: "Min Daily Views",
    OnlineTime: "Online Time",
    GoToAuth: "Authorize",
    NeedAuthForGenderDistribution: "Viewing fan gender distribution requires social account authorization first!",
    NeedAuthForGenderDistributionShort: "Viewing fan gender distribution requires social account authorization",
    NeedAuthForOnlineTime: "Viewing fan online time requires social account authorization",
    VideoViewsCount: "Video Views",
    VideoInteractionsTooltip: "The trend of interaction count for all videos from the account during the selected date range. Interactions include likes, comments, and shares.",
    NeedAuthForVideoInteractions: "Viewing video interactions requires social account authorization first!",
    VideoViewsAuthorized: "Video Views (Authorized)",
    VideoInteractionsAuthorized: "Video Interactions (Authorized)",
    CommentsCountAuthorized: "Comments Count (Authorized)",
    SharesCountAuthorized: "Shares Count (Authorized)",
    ProfileFollowers: "Profile Followers",
    ProfileLists: "Profile Lists",
    InteractionCountTooltip: "Interaction Count = Likes + Comments + Shares",
    CommentCountTooltip: "The number of comments received by the post",
    PostInteractionProportion: "Post Interaction Proportion",
    YouTubePostInteractionDistribution: "Post Interaction Distribution",
    CumulativeFollowers: "Cumulative Followers",
    SinglePostInteractionCount: "Single Post Interaction Count",
    AvgVideoInteractionsTooltip: "The average video interactions per video, calculated as: total video interactions within the selected date range / number of videos within the selected date range.",
    ViewInteractionRate: "View Interaction Rate",
    VideoDuration: "Video Duration",
    ThousandFanInteractionsDetailTooltip: "Thousand-fan interactions is the average number of post interactions generated per 1,000 fans on a given date. Formula: (total post interactions on posts published by the Page on the given date ÷ number of fans on the given date) × 1,000. If the Page did not publish posts on a given date, the count for that date is 0.",
    Video3SecOrganicTooltip: "The number of times a Page video was played for at least 3 seconds, broken down by organic reach.",
    Video3SecPaidTooltip: "The number of times a Page video was played for at least 3 seconds, broken down by paid reach.",
    Video30SecOrganicTooltip: "The number of times a Page video was played for at least 30 seconds, broken down by organic reach.",
    ThousandFanInteractionsFormulaTooltip: "Thousand-fan interactions = public post interactions (reactions + comments + shares) / public fans on post date × 1,000",
    ThousandFanInteractionsAuthorized: "Thousand-Fan Interactions (Authorized)",
    AvgThousandFanInteractionsTooltip: "The average number of post interactions per 1,000 fans (authorized).",
    ContentViewsCountTooltip: "The number of Meta accounts that viewed your content at least once.",
    AllReactionsTooltip: "All reactions including Like, Love, Wow, Haha, Sad, and Angry, counted and totaled by type.",
    Video3SecViewsShortTooltip: "The number of times a Page video was played for at least 3 seconds.",
    Video30SecViewsShortTooltip: "The number of times a Page video was played for at least 30 seconds.",
    NeedAuthForPageLikes: "Viewing page likes requires social account authorization first!",
    Year: "Year",
    ParamError: "Parameter error",
    NeedAuthForProfileViews: "Viewing profile views requires social account authorization first!",
    VideoInteractionsTrendTooltip: "Trend of interaction count for all videos from the account during the selected date range. Interactions include likes, comments, and shares.",
    InteractionCountFormulaTooltip: "Interaction Count = Likes + Comments + Shares",
    PostCommentCountTooltip: "Number of comments received by the post",
    VideoInteractionsPer1000YT: "Number of video interactions per 1,000 subscribers during the selected date range, calculated as: total video interactions / total subscribers * 1,000.",
    StatusDeleted: "Deleted",
    FollowerCountFBTip: "As of the last day of the selected date range, the number of followers of a Facebook Page, obtained via the public data API. Follower count is a newly supported metric of the Facebook API. For ease of statistical analysis, where historical follower counts are missing, the approximate \"Page Likes\" is used as a substitute.",
    FollowerCountXTip: "As of the last day of the selected date range, the number of followers of an X account",
    FollowerCountIGTip: "As of the last day of the selected date range, the number of followers of an Instagram account",
    FollowerCountTikTokTip: "As of the last day of the selected date range, the number of followers of a TikTok account.",
    FollowerCountYTTip: "As of the last day of the selected date range, the number of subscribers of a YouTube channel. This value is rounded to the first three significant digits.",
    FollowerCountTGTip: "As of the last day of the selected date range, the net increase in subscribers of a Telegram channel",
    FollowerCountLinkedInTip: "As of the last day of the selected date range, the number of followers of a LinkedIn Company Page.",
    FollowerCountThreadsTip: "As of the last day of the selected date range, the number of followers of a Threads account.",
    FollowerNetGrowthFBTip: "The net increase in followers of a Facebook Page during the selected date range, obtained via the public data API. Follower count is a newly supported metric of the Facebook API. For ease of statistical analysis, where historical follower counts are missing, the approximate \"Page Likes\" is used as a substitute",
    FollowerNetGrowthXTip: "The net increase in followers of an X account during the selected date range.",
    FollowerNetGrowthIGTip: "The net increase in followers of an Instagram account during the selected date range.",
    FollowerNetGrowthTikTokTip: "The net increase in followers of a TikTok account during the selected date range.",
    FollowerNetGrowthYTTip: "The net increase in subscribers of a YouTube channel during the selected date range.",
    FollowerNetGrowthTGTip: "The net increase in subscribers of a Telegram channel during the selected date range.",
    FollowerNetGrowthLinkedInTip: "The net increase in followers of a LinkedIn Company Page during the selected date range.",
    FollowerNetGrowthThreadsTip: "As of the last day of the selected date range, the net increase in followers of a Threads account.",
    PostCountFBTip: "The number of posts published by the account during the selected date range (including Reels, excluding Stories).",
    PostCountXTip: "The number of posts published by the account during the selected date range (excluding reposts and replies).",
    PostCountTikTokTip: "The number of videos published by the account during the selected date range.",
    PostCountYTTip: "The number of videos published by the account during the selected date range (including Shorts).",
    PostCountTGTip: "The number of posts published on Telegram during the selected date range",
    PostCountLinkedInTip: "The number of posts published by the account during the selected date range.",
    InteractionFBTip: "Interaction Count = Reactions + Comments + Shares",
    InteractionXTip: "Interaction Count = Likes + Replies + Retweets",
    InteractionIGTip: "Interaction Count = Likes + Comments\nDue to API limitations, data for Instagram business accounts is organic, while data for personal accounts is the total of organic and paid.",
    InteractionTikTokTip: "Interaction Count = Likes + Comments + Shares",
    // YouTube list metrics include likes, dislikes, shares, and comments in the interaction calculation.
    InteractionYTTip: "Interaction Count = Likes + Dislikes + Shares + Comments",
    InteractionTGTip: "Interaction Count = Emojis + Comments + Forwards",
    InteractionLinkedInTip: "Interaction Count = Reactions + Comments + Reposts",
    InteractionThreadsTip: "Interaction Count = Likes + Replies + Reposts",
    ImpressionsFBTip: "The number of times content was displayed to users",
    ImpressionsXTip: "The number of times a post was viewed.",
    ImpressionsIGTip: "Impressions refer to the number of times a post or story was displayed to users; for Reels, play count is used as impressions.",
    ImpressionsIGShortTip: "Impressions refer to the number of times a post or story was displayed to users; for Reels, play count is used as impressions",
    ImpressionsTikTokTip: "TikTok videos do not support the impressions metric. For ease of cross-platform comparison, video view count is used as impressions.",
    ImpressionsTikTokShortTip: "TikTok videos do not support the impressions metric. For ease of cross-platform comparison, video view count is used as impressions",
    ImpressionsTGTip: "The number of times a post was viewed",
    ImpressionsLinkedInTip: "Impressions refer to the number of times a post was displayed to users.",
    ImpressionsThreadsTip: "Impressions refer to the number of times content or videos were displayed to users. Obtained via the authorized data API.",
    ReachTip: "Reach refers to the number of unique users who saw a post.",
    ReachShortTip: "Reach refers to the number of unique users who saw a post",
    VideoViewsFBTip: "The number of times a video was played for at least 3 seconds, or nearly to completion (if the video is shorter than 3 seconds).",
    VideoViewsXTip: "The total number of times videos were viewed across all posts.",
    VideoViewsIGTip: "The number of times videos were viewed. This metric will show 0 for carousel posts without videos; for Instagram Reels, the play count is counted as views. Play count refers to video sessions played for at least 1 millisecond, excluding replays.",
    VideoViewsShortTip: "The number of times a video was viewed",
    FollowerRateFBTip: "Follower Interaction Rate = Post public interactions (Reactions + Comments + Shares) / Public followers on the posting date × 100%.",
    FollowerRateXTip: "Follower Interaction Rate = Post public interactions (Likes + Replies + Retweets) / Followers on the posting date × 100%.",
    FollowerRateIGTip: "Follower Interaction Rate = Post public interactions (Likes + Comments) / Followers on the posting date × 100%\nDue to API limitations, data for Instagram business accounts is organic, while data for personal accounts is the total of organic and paid.",
    FollowerRateTikTokTip: "Follower Interaction Rate = Video public interactions (Likes + Comments + Shares) / Followers on the posting date × 100%.",
    FollowerRateYTTip: "Follower Interaction Rate = Video public interactions (Likes + Dislikes + Shares + Comments) / Followers on the posting date * 100%",
    FollowerRateTGTip: "Follower Interaction Rate = Video public interactions (Emojis + Comments + Forwards) / Followers on the posting date × 100%",
    FollowerRateLinkedInTip: "Follower Interaction Rate = Post public interactions (Reactions + Comments + Reposts) / Followers on the posting date × 100%.",
    FollowerRateThreadsTip: "Follower Interaction Rate = Post public interactions (Reactions + Replies + Reposts) / Followers on the posting date × 100%.",
    ExposureRateFBTip: "Exposure Interaction Rate = Post authorized interactions (Reactions + Comments + Shares + Clicks*) / Impressions* × 100%.",
    ExposureRateXTip: "Exposure Interaction Rate = Post public interactions (Likes + Replies + Retweets) / Impressions × 100%.",
    ExposureRateIGTip: "Exposure Interaction Rate = Post authorized interactions (Likes + Comments + Shares* + Saves*) / Impressions* × 100%. For Reels, play count is used as impressions.",
    ExposureRateTikTokTip: "Exposure Interaction Rate = Video public interactions (Likes + Comments + Shares) / Impressions × 100%. Video view count is used as impressions.",
    ExposureRateYTTip: "Exposure Interaction Rate = Video interactions (Likes + Dislikes + Shares + Comments) / Impressions * 100%",
    ExposureRateTGTip: "Exposure Interaction Rate = Video interactions (Emojis + Comments + Forwards) / Impressions × 100%",
    ExposureRateLinkedInTip: "Exposure Interaction Rate = Post authorized interactions (Reactions + Comments + Reposts + Clicks*) / Impressions* × 100%\nDue to LinkedIn API limitations, metrics marked with * include organic data only",
    ExposureRateThreadsTip: "Exposure Interaction Rate (authorized) = Post public interactions (Reactions + Replies + Reposts) / Post impressions* × 100%",
    ReachRateFBTip: "Reach Interaction Rate = Post authorized interactions (Reactions + Comments + Shares + Clicks*) / Reach* × 100%.",
    ReachRateTGTip: "Reach Interaction Rate = Video public interactions (Likes + Comments + Shares) / Reach* × 100%.",
    ReachRateIGTip: "Reach Interaction Rate = Post authorized interactions (Likes + Comments + Shares* + Saves*) / Reach* × 100%.",
    ReachRateLinkedInTip: "Reach Interaction Rate = Post authorized interactions (Reactions + Comments + Reposts + Clicks*) / Reach* × 100%\nDue to LinkedIn API limitations, metrics marked with * include organic data only.",
    ReactionsFBTip: "The number of unique users who reacted to a post (\"Like\", \"Love\", \"Haha\", \"Wow\", \"Sad\", or \"Angry\"). When a user reacts with multiple different reactions to the same post, it is counted only once.",
    LikesXTip: "The number of likes a post received.",
    LikesIGTip: "The number of likes a post received. Due to API limitations, data for Instagram business accounts is organic, while data for personal accounts is the total of organic and paid.",
    LikesTikTokTip: "The number of likes a video received.",
    LikesYTTip: "The number of likes a video received. The dislikes metric is no longer supported since December 13, 2021.",
    ReactionsTGTip: "The number of reactions a post received",
    CommentsFBTip: "The number of comments a post received.",
    RepliesXTip: "The number of direct replies a post received.",
    CommentsIGTip: "The number of comments a post received. Due to API limitations, data for Instagram business accounts is organic, while data for personal accounts is the total of organic and paid.",
    CommentsShortTip: "The number of comments a post received",
    SharesFBTip: "The number of times a post was shared.",
    RetweetsXTip: "The number of times a post was retweeted, including quote retweets.",
    SharesShortTip: "The number of times a post was shared",
    SavedIGTip: "The number of times a post was saved by users.",
    ClicksFBTip: "The number of times users clicked anywhere on a post.",
    ViewRateTikTokTip: "TikTok: Video View Interaction Rate = Video public interactions (Likes + Comments + Shares) / Video views × 100%",
    ViewRateYTTip: "YouTube: Video View Interaction Rate = Video public interactions (Likes + Comments) / Video views × 100%",
    PageImpressionsFBTip: "The number of times any Page content or Page-related content appeared on a user's device screen. This includes posts, stories, ads, and other content or information on the Page.",
    PageImpressionsIGTip: "The number of times any Instagram account content was displayed to users, excluding profile page views.",
    PageVideoViewsFBTip: "The total number of times any video on the Page was played for at least 3 seconds, or nearly to completion (if the video is shorter than 3 seconds), during the selected date range.",
    PageVideoViewsTikTokTip: "The total number of times any video on the Page was viewed during the selected date range.",
    PagePostImpressionsFBTip: "The number of times your Page posts appeared on a user's device screen. Includes posts such as status updates, photos, links, and videos.",
    NegativeActionsFBTip: "The number of times users performed negative actions (e.g., unliking the Page or hiding a post).",
    AvgPostInteractionsTip: "The average number of public interactions received per post published during the selected date range. Calculation: total post interactions / number of posts.",
    AvgPostInteractionsAuthTip: "The average number of authorized interactions received per post published during the selected date range. Calculation: total post interactions (authorized) / number of posts.",
    PerMilleFBTip: "Interactions per 1,000 fans = Post public interactions (Reactions + Comments + Shares) / Public followers on the posting date × 1000",
    PerMilleXTip: "Interactions per 1,000 fans = Post interactions (Likes + Replies + Retweets) / Followers on the posting date × 1000",
    PerMilleIGTip: "Interactions per 1,000 fans = Post public interactions (Likes + Comments) / Followers on the posting date × 1000. Due to API limitations, data for Instagram business accounts is organic, while data for personal accounts is the total of organic and paid.",
    PerMilleTikTokTip: "Interactions per 1,000 fans = Video interactions (Likes + Comments + Shares) / Followers on the video posting date × 1000",
    PerMilleYTTip: "Interactions per 1,000 fans = Video interactions (Likes + Dislikes + Comments) / Channel subscribers on the video posting date × 1000",
    PerMilleTGTip: "Interactions per 1,000 fans = Post interactions (Emojis + Comments + Forwards) / Followers on the posting date × 1000",
    PerMilleFBAuthTip: "Interactions per 1,000 fans (authorized) = Post authorized interactions (Reactions + Comments + Shares + Clicks*) / Authorized followers on the posting date × 1000.",
    PerMilleIGAuthTip: "Interactions per 1,000 fans (authorized) = Post authorized interactions (Likes + Comments + Shares* + Saves* + Story replies*) / Followers on the posting date × 1000",
    PageLikesFBTip: "As of the last day of the selected date range, the number of likes on a Facebook Page, obtained via the public data API.",
    PageLikesNetGrowthFBTip: "The net increase in likes on a Facebook Page during the selected date range, obtained via the public data API.",
    PageLikesFBAuthTip: "Facebook: As of the last day of the selected date range, the number of likes on a Facebook Page, obtained via the authorized data API.",
    PageLikesNetGrowthFBAuthTip: "Facebook: The net increase in likes on a Facebook Page during the selected date range, obtained via the authorized data API.",
    PostTypeFBTip: "Post types include: Text, Photo, Video, Link, Combo, Reels, GIF, and Other",
    PostTypeIGTip: "Post types include: Image, Video, Carousel, and Reels",
    PostStatusFBTip: "Post status: Published, Deleted",
    PostStatusIGTip: "The current status of the post",
    PostTimeBeijingTip: "Post publish time (Beijing Time)",
    PostTimePacificTip: "Post publish time (Pacific Time)",
    PostImpressionsFBTip: "The number of times your content was played or displayed. Content includes videos, posts, stories, and ads.",
    PostInteractionsFBTip: "The cumulative number of interactions a post received (Reactions + Shares + Comments).",
    PostReactionsFBTip: "All reactions including Like, Love, Wow, Haha, Sad, and Angry, counted and totaled by type.",
    PostSharesIGTip: "The number of times a post was shared. Shares* are only available for Reels",
    FollowerRateFBSingleTip: "Follower Interaction Rate = Post public interactions (Reactions + Comments + Shares) / Public followers on the posting date × 100%.",
    FollowerRateIGSingleTip: "Follower Interaction Rate = Post public interactions (Likes + Comments) / Followers on the posting date × 100%.",
    FollowerRateFBAuthSingleTip: "Follower Interaction Rate (authorized) = Post authorized interactions (Reactions + Comments + Shares) / Authorized followers on the posting date × 100%.",
    FollowerRateIGAuthTip: "Follower Interaction Rate = Post public interactions (Likes + Comments) / Followers on the posting date × 100%. Due to API limitations, data for Instagram business accounts is organic, while data for personal accounts is the total of organic and paid.",
    PerMilleFBSingleTip: "Interactions per 1,000 fans = Post public interactions (Reactions + Comments + Shares) / Public followers on the posting date × 1000.",
    PerMilleFBAuthSingleTip: "Interactions per 1,000 fans (authorized) = Post authorized interactions (Reactions + Comments + Shares) / Authorized followers on the posting date × 1000.",
    PaidViewsFBTip: "Paid views refer to the number of times a post was displayed to users through paid placements (e.g., ads).",
    OrganicReachFBTip: "Organic reach refers to the number of times a post was displayed to users through unpaid placements.",
    UniqueViewsFBTip: "The number of Meta accounts that viewed your content at least once.",
    ReachIGSingleTip: "Reach refers to the number of unique users who saw the post.",
    ImageClicksFBTip: "The number of times users clicked to view images.",
    VideoClicksFBTip: "The number of times users clicked to play videos.",
    LinkClicksFBTip: "The number of times users clicked links in a post.",
    OtherClicksFBTip: "The number of other types of post clicks.",
    TotalWatchTimeFBTip: "The total duration of video playback.",
    AvgWatchTimeFBTip: "The average duration users watched a video.",
    VideoCompletionRateTip: "Video Completion Rate (authorized) = Views at 30 seconds* / Views at 3 seconds* × 100%",
    Views30SecTip: "Views at 30 seconds refer to the number of times a video was played for at least 30 seconds, or nearly to completion (if the video is shorter than 30 seconds).",
    AllCommentsFBTip: "The total number of comments a post received.",
    PositiveCommentsTip: "The number of comments expressing positive sentiments such as satisfaction, praise, appreciation, or support.",
    NegativeCommentsTip: "The number of comments expressing negative sentiments such as dissatisfaction, criticism, dislike, or opposition.",
    NeutralCommentsTip: "The number of comments that express neither clearly positive nor clearly negative sentiments.",
    PostDateTip: "The date a post was published",
    PerMilleTTTip: "Interactions per 1,000 fans = Video interactions (Likes + Comments + Shares) / Followers on the video posting date × 1000",
    InteractionTTCheckTip: "Interaction Count = Likes + Comments + Shares",
    LikesTTShortTip: "The number of likes a video received",
    FollowerRateTTTip: "Follower Interaction Rate = Video public interactions (Likes + Comments + Shares) / Followers on the posting date × 100%",
    ExposureRateTTTip: "Exposure Interaction Rate = Video public interactions (Likes + Comments + Shares) / Impressions × 100%. Video view count is used as impressions",
    ReachRateTTTip: "Reach Interaction Rate (authorized) = Video public interactions (Likes + Comments + Shares) / Reach* × 100%",
    ViewRateTTTip: "Video View Interaction Rate = Video public interactions (Likes + Comments + Shares) / Video views × 100%",
    TotalWatchTimeShortTip: "The total duration of video playback",
    AvgWatchTimeShortTip: "The average duration users watched a video",
    VideoDurationTip: "The length of a video",
    PositiveCommentsTTTip: "The number of positive comments on a video",
    NegativeCommentsTTTip: "The number of negative comments on a video",
    NeutralCommentsTTTip: "The number of neutral comments on a video",
    InteractionXCheckTip: "Interaction Count = Likes + Replies + Retweets",
    LikesXShortTip: "The number of likes a post received",
    RepliesXShortTip: "The number of direct replies a post received",
    RetweetsXShortTip: "The number of retweets a post received, including quote tweets",
    ImpressionsXShortTip: "The number of times a post was viewed",
    PerMilleXShortTip: "Interactions per 1,000 fans = Post public interactions (Likes + Replies + Retweets) / Followers on the posting date × 1000",
    FollowerRateXShortTip: "Follower Interaction Rate = Post public interactions (Likes + Replies + Retweets) / Followers on the posting date × 100%",
    ExposureRateXShortTip: "Exposure Interaction Rate = Post public interactions (Likes + Replies + Retweets) / Impressions × 100%, where impressions refer to view count",
    QuoteCountXTip: "Quote tweets refer to the number of times users quoted a post",
    PerMilleIGAuthShortTip: "Interactions per 1,000 fans (authorized) = Post authorized interactions (Likes + Comments + Shares* + Saves*) / Followers on the posting date × 1000",
    InteractionIGCheckTip: "Interaction Count = Likes + Comments",
    LikesIGShortTip: "The number of likes a post received",
    CommentsIGShortTip: "The number of comments a post received",
    ReachRateIGShortTip: "Reach Interaction Rate (authorized) = Post authorized interactions (Likes + Comments + Shares* + Saves*) / Reach* × 100%. Shares* are only available for Reels",
    TikTokHomepageDetail: "TikTok Homepage Details",
    TikTokMainData: "Homepage Data",
    TikTokFansData: "Fans Data",
    TikTokSignalPostTab: "Signal Posts",
    TikTokPacificTime: "Pacific Time (UTC + 00:00)",
    TikTokNeedAuthDesc: "To view data, please authorize your social homepage first!",
    TikTokGoAuthorize: "Go to Authorize",
    // YouTube's new detail page shares the TikTok / INS shell but requires its own localized tabs and timezone label.
    YouTubeHomepageDetail: "YouTube Homepage Details",
    YouTubeMainData: "Homepage Data",
    YouTubeFansData: "Follower Data",
    YouTubeVideosData: "Video Data",
    // The YouTube follower and video pages share this summary-table title.
    YouTubeDataSummaryTable: "Data Summary Table",
    YouTubeSignalPostTab: "Single Post",
    YouTubePacificTime: "Pacific Time (UTC -07:00)",
    YouTubeNeedAuthForModule: "To view {title}, please authorize your social homepage first!",
    // The YouTube subscriber page follows the new Figma layout with four metrics and switchable trend data.
    YouTubeFansCount: "Subscribers",
    YouTubeFansTrend: "Subscriber Trend",
    YouTubeNewFansTip: "Number of subscribers newly gained by the channel during the selected date range.",
    YouTubeLostFansTip: "Number of subscribers who unsubscribed from the channel during the selected date range.",
    YouTubeNetFansTip: "New subscribers minus lost subscribers during the selected date range.",
    YouTubeTotalFansTip: "Total subscribers the channel has as of the current reporting date.",
    TikTokNeedAuthForInteractionPer1K: "To view interactions per 1K, please authorize your social homepage first!",
    TikTokNeedAuthForInteractionCount: "To view interaction count, please authorize your social homepage first!",
    TikTokNeedAuthForInteractionTrend: "To view interaction count and fan interaction rate trend, please authorize your social homepage first!",
    TikTokNeedAuthForCoverage: "To view reach count, please authorize your social homepage first!",
    TikTokNeedAuthForVideoWatchTime: "To view video watch time, please authorize your social homepage first!",
    TikTokNeedAuthForTrafficSource: "To view video traffic source, please authorize your social homepage first!",
    TikTokNeedAuthForViewerSource: "To view viewer source, please authorize your social homepage first!",
    TikTokInteractionFanRateTrend: "Interaction Count & Fan Interaction Rate Trend",
    TikTokInteractionFanRateTrendTip: "Trend of interaction count and fan interaction rate",
    TikTokVideoViewsInteractionTrend: "Video Views & Interaction Trend",
    TikTokVideoViewsInteractionTrendTip: "Information about video views within the selected date range.",
    TikTokViewsInteractionTrend: "Views & Interaction Trend",
    TikTokExposureCount: "Exposure Count",
    TikTokExposureCountTip: "TikTok does not support the exposure count metric. For cross-platform comparison, video views are used as exposure count.",
    TikTokReachTip: "Reach refers to the number of unique users who saw the post.",
    TikTokVideoWatchTime: "Video Watch Time",
    TikTokWatchTimeTip: "Total and average duration of video playback.",
    TikTokVideoTrafficSource: "Video Traffic Source",
    TikTokTrafficSourceTip: "The source of video views.",
    TikTokViewerSource: "Viewer Source",
    TikTokTrendChartLabel: "Trend Chart:",
    TikTokSourceTypeCol: "Source Type",
    TikTokPublishVideosTitle: "Videos Posted",
    TikTokVideoTrendTip: "The trend of {video}s published in the selected date range.",
    TikTokAuthViewVideoCount: "To view the number of videos posted, please authorize your social homepage first!",
    TikTokNeedAuthForVideoInteractionTrend: "To view video views and interaction trend, please authorize your social homepage first!",
    TikTokNeedAuthForExposure: "To view exposure count, please authorize your social homepage first!",
    TikTokViewsAndInteractionRate: "Views & Interaction Rate",
    TikTokViewsAndCompletionRate: "Views & Video Completion Rate",
    TikTokCreativePreferences: "Creative Preferences",
    TikTokTopHashtags: "Top Hashtags",
    TikTokHashtagCol: "Hashtag",
    TikTokUsageCountCol: "Usage Count",
    TikTokTopSounds: "Top Sounds",
    TikTokNameCol: "Name",
    TikTokVideoReleaseDuration: "Video Release Duration",
    TikTokTopMentionedUsers: "Most Mentioned Users",
    TikTokMentionedUserCol: "User Name",
    TikTokVideoReleaseTimeSlot: "Video Release Time Slot",
    TikTokTopUrls: "Most Mentioned URLs",
    TikTokUrlCol: "URL",
    TikTokSourceName: "Source",
    TikTokViewerCount: "Profile Views",
    VideoAvgDurationMin: "Avg Video Duration (min)",
    VideoTotalWatchDurationMin: "Total Video Watch Duration (min)",
    TikTokMostActiveTime: "Most Active Time",
    TikTokActiveTimeTrend: "Active Time Trend",
    TikTokActivePeak: "Your followers are most active at {time}",
    TikTokActivePeakEn: "Your followers are most active at {time}",
    TikTokActiveFollowers: "Active Followers",
    TikTokHourUnit: "Hour",
    TikTokDayUnit: "Day",
    TikTokMonthDay: "{month}/{day}",
    TikTokYearMonthDay: "{year}/{month}/{day}",
    MonthDayFormat: "{month}/{day}",
    Authorizing: "Authorizing with YouTube",
    AuthProcessing: "Please wait, we are processing your authorization request...",
    AuthCodeNotFound: "Authorization code not found. Please try authorizing again.",
    AuthSuccessTip: "You have successfully authorized us to access your YouTube account.",
    AuthNetworkError: "Network error. Please check your network connection and try again.",
    AuthSuccess: "Authorization Successful",
    AuthFailed: "Authorization Failed",
    CloseWindow: "Close Window",
    Retry: "Retry",
    TotalSocialAccounts: "Total: {count} social accounts",
    PlatformDataDetail: "Platform Data Details",
    NoSocialAccountData: "No social account data",
    TotalInteractionCount: "Total Interactions",
    TotalInteractionTip: "The number of interactions (likes + comments + shares) received by posts published on this page within the selected date range.",
    CommentTrendTip: "The sentiment trend of user comments on posts within the selected date range.",
    ViewsTip: "The number of times posts were viewed within the selected date range.",
    PositiveCommentCount: "Positive Comments",
    NegativeCommentCount: "Negative Comments",
    NeutralCommentCount: "Neutral Comments",
    TikTokYearMonthDayTime: "{year}/{month}/{day} {time}",
    TikTokFansTrend: "Fans Trend",
    TikTokTotalFans: "Total Fans",
    TikTokTotalFansMeta: "Cumulative Total Fans",
    TikTokTotalFansTip: "Total TikTok fans.",
    TikTokNetNewFans: "Net New Fans",
    TikTokNetNewFansTip: "Net fans gained within the selected time range.",
    TikTokComparedToLast: "vs. Last Period",
    TikTokDataSummaryTable: "Data Summary Table",
    TikTokTotalCount: "{count} items in total",
    TikTokSummary: "Summary",
    TikTokTimeCol: "Time",
    TikTokViewsCol: "Views",
    TikTokViewsColTip: "Daily views of your videos",
    TikTokVisitsCol: "Visits",
    TikTokVisitsColTip: "Daily visits to your profile.",
    TikTokInteractionCol: "Interactions",
    TikTokInteractionColTip: "Total likes, comments and shares on your published videos.",
    TikTokLikesCol: "Likes",
    TikTokLikesColTip: "Daily likes on your published videos",
    TikTokCommentsCol: "Comments",
    TikTokCommentsColTip: "Daily comments on your published videos.",
    TikTokSharesCol: "Shares",
    TikTokSharesColTip: "Daily shares of your published videos",
    TikTokViewersCol: "Viewers",
    TikTokViewersColTip: "Users who watched your published content at least once per day.",
    TikTokInteractionViewersCol: "Interaction Viewers",
    TikTokInteractionViewersColTip: "Users who interacted (liked, commented, shared) with at least one piece of your published content per day",
    TikTokViewCount: "Views",
    TikTokViewTrend: "Views Trend",
    TikTokTotalViews: "Total Views",
    TikTokTotalViewsTip: "The number of times viewers watched your videos within the selected date range.",
    TikTokMaxDailyViews: "Max Daily Views",
    TikTokMaxDailyViewsTip: "The day with the most views of your videos within the selected date range.",
    TikTokMinDailyViews: "Min Daily Views",
    TikTokMinDailyViewsTip: "The day with the fewest views of your videos within the selected date range.",
    TikTokDateColon: "Date: ",
    TikTokProfileVisits: "Profile Visits",
    TikTokVisitsTrend: "Visits Trend",
    TikTokTotalVisits: "Total Visits",
    TikTokTotalVisitsTip: "The number of times your profile was viewed within the selected date range.",
    TikTokMaxDailyVisits: "Max Daily Visits",
    TikTokMaxDailyVisitsTip: "The day with the most profile views within the selected date range.",
    TikTokMinDailyVisits: "Min Daily Visits",
    TikTokMinDailyVisitsTip: "The day with the fewest profile views within the selected date range.",
    TikTokInteractionCount: "Homepage Interactions",
    TikTokInteractionTrend: "Interaction Trend",
    TikTokTotalInteractions: "Total Interactions",
    TikTokTotalInteractionsTip: "The total number of likes, comments and shares on your published videos within the selected date range.",
    TikTokLikesCount: "Likes",
    TikTokLikesCountTip: "The number of likes on your published videos.",
    TikTokCommentsCount: "Comments",
    TikTokCommentsCountTip: "The number of comments on your published videos.",
    TikTokSharesCount: "Shares",
    TikTokSharesCountTip: "The number of shares of your published videos.",
    TikTokAudienceCount: "Audience",
    TikTokAudienceTrend: "Audience Trend",
    TikTokTotalAudience: "Total Audience",
    TikTokTotalAudienceTip: "Users who watched your published content at least once within the selected date range.",
    TikTokMaxDailyAudience: "Max Daily Audience",
    TikTokMaxDailyAudienceTip: "The day with the most users watching your published content within the selected date range.",
    TikTokMinDailyAudience: "Min Daily Audience",
    TikTokMinDailyAudienceTip: "The day with the fewest users watching your published content within the selected date range.",
    TikTokInteractionAudienceCount: "Interaction Audience",
    TikTokInteractionAudienceTrend: "Interaction Audience Trend",
    TikTokTotalInteractionAudience: "Total Interaction Audience",
    TikTokTotalInteractionAudienceTip: "Users who interacted (liked, commented, shared) with at least one piece of your published content within the selected date range.",
    TikTokMaxDailyInteractionAudience: "Max Daily Interaction Audience",
    TikTokMaxDailyInteractionAudienceTip: "The day with the most users interacting with your published content within the selected date range.",
    TikTokMinDailyInteractionAudience: "Min Daily Interaction Audience",
    TikTokMinDailyInteractionAudienceTip: "The day with the fewest users interacting with your published content within the selected date range.",
    TikTokAllPromotions: "All Promotions",
    TikTokPaidPromotion: "Paid Promotion",
    TikTokNormalPromotion: "Normal Promotion",
    TikTokAllStatus: "All Status",
    TikTokDisplaying: "Displaying",
    TikTokDeleted: "Deleted",
    TikTokPostNamePlaceholder: "Please enter the post name",
    TikTokExportReport: "Export",
    TikTokPostContent: "Post Content",
    TikTokStatus: "Status",
    TikTokCountryDistribution: "By Country",
    TikTokCountryDetail: "Country/Region Distribution Details",
    TikTokCountryRegion: "Country/Region",
    TikTokFollowers: "Followers",
    TikTokPercentage: "Percentage",
    TikTokFansColon: "Followers: ",
    TikTokPercentColon: "Percentage: ",
    TikTokCityDistribution: "By City",
    TikTokCityDetail: "City Distribution Details",
    TikTokGenderAgeDistribution: "Gender & Age Distribution",
    TikTokGenderChart: "Gender Distribution Chart",
    TikTokAgeChart: "Age Distribution Chart",
    TikTokFemale: "Female",
    TikTokMale: "Male",
    TikTokUnknown: "Unknown",
    TikTokTimeDimension: "Time Dimension",
    TikTokDay: "Day",
    TikTokWeek: "Week",
    TikTokMonth: "Month",
    TikTokGenderSeries: "Gender Distribution",
    TikTokAgeSeries: "Age Distribution",
    TikTokFan: "Fans",
    TikTokNonFan: "Non-Fans",
    TikTokNewViewer: "New Viewers",
    TikTokReturningViewer: "Returning Viewers",
    TikTokPositive: "Positive",
    TikTokNeutral: "Neutral",
    TikTokNegative: "Negative",
    TikTokPostDetail: "Post Details",
    TikTokDataOverview: "Data Overview",
    TikTokAudienceType: "Audience Type",
    TikTokFansNonFans: "Fans / Non-Fans",
    TikTokNewReturningViewers: "New Viewers / Returning Viewers",
    TikTokGenderComments: "Gender & Comments",
    TikTokAudienceGenderChart: "Audience Gender Distribution Chart",
    TikTokCommentAnalysisChart: "Comment Analysis Chart",
    TikTokTotalComments: "Total Comments",
    TikTokAudienceCountry: "Audience Country/Region",
    TikTokAudienceCountryChart: "Audience Country/Region Chart",
    TikTokTrafficSource: "Traffic Sources",
    TikTokTrafficSourceChart: "Traffic Source Chart",
    TikTokAudienceRetention: "Audience Retention",
    TikTokAudienceRetentionChart: "Audience Retention Trend",
    TikTokDropOffTip: "Most of your audience stopped watching at {time}",
    TikTokTotalWatchTime: "Total Watch Time",
    TikTokTotalWatchTimeTip: "The duration viewers watched your video posts.",
    TikTokAvgWatchTime: "Average Watch Time",
    TikTokAvgWatchTimeTip: "The average duration viewers watched your video posts.",
    TikTokSecondUnit: " s",
    TikTokFullWatchRate: "Completed Video Views",
    TikTokFullWatchRateTip: "The percentage of viewers who watched your video posts to completion.",
    TikTokNewFollowers: "New Followers",
    TikTokNewFollowersTip: "The number of viewers who newly followed you.",
    TikTokSignalPostViews: "The number of times viewers watched your video posts.",
    TikTokSignalPostAudience: "Audience",
    TikTokSignalPostAudienceTip: "The number of people who viewed your published content at least once.",
    TikTokSignalPostInteractions: "Interactions",
    TikTokSignalPostInteractionsTip: "Total interactions (likes, comments, shares) on the post",
    TikTokSignalPostLikes: "Likes",
    TikTokSignalPostLikesTip: "Total likes on the post.",
    TikTokSignalPostComments: "Comments",
    TikTokSignalPostCommentsTip: "Total comments on the post.",
    TikTokSignalPostShares: "Shares",
    TikTokSignalPostSharesTip: "Total shares of the post.",
    TikTokCollectCount: "Saves",
    TikTokCollectCountTip: "Total saves of the post.",
    TikTokPublishTimeUTC: "Publish Time (UTC00:00)",
    TikTokPublishTimeUTCTip: "The date and time the post was published",
    TikTokPublishTimeBJ: "Publish Time (Beijing Time)",
    TikTokPublishTimeBJTip: "The Beijing time when the post was published",
    TikTokRetentionColon: "Retention Rate: ",
    TikTokVisitHomepage: "Visit TikTok Homepage",
    TikTokCollapse: "Collapse",
    TikTokExpand: "Expand",
    TikTokPublishTime: "Publish Time",
    TikTokPostSerialNumber: "Post Serial Number",
    TikTokTags: "Tags",
    TikTokProfileIntro: "Bio",
    TikTokNotAuthorized: "Unauthorized",
    TikTokAuthorized: "Authorized",
    TikTokBusinessAccount: "Business Account",
    TikTokAdPost: "Ad Post",
    TikTokNormalPost: "Organic Post",
    InsHomepageDetail: "Instagram Homepage Details",
    InsMainData: "Homepage Data",
    InsFansData: "Follower Data",
    InsPostsData: "Post Data",
    InsStoriesData: "Story Data",
    InsSignalPostTab: "Single Post",
    PostDetail: "Post Details",
    InsPacificTime: "Pacific Time (UTC -07:00)",
    InsNeedAuthForModule: "To view {title}, please authorize your social homepage first!",
    XFansNeedAuthDescription: "To view follower count, please authorize your social homepage first!",
    TikTokNeedAuthForModule: "To view {title}, please authorize your social homepage first!",
    TikTokHigh: "High",
    TikTokLow: "Low",
    MonitoringData: "Data",
    DataOverview: "Data Overview",
    MonitoringTotalCount: "{count} items in total",
    VisitPlatformHomepage: "Visit {platform} Homepage",
    PublishTime: "Publish Time",
    PostSerialNumber: "Post ID",
    AccountLabels: "Labels",
    ContactInformation: "Contact Information",
    Location: "Location",
    ProfileIntro: "Bio",
    AccountBasicInfo: "Basic Information",
    AccountOverview: "Account Overview",
    BrandName: "Brand Name",
    MainCategory: "Main Category",
    SubCategories: "Subcategories",
    AccountCreatedAt: "Created At",
    // Facebook single-post sidebar titles and promotion tags stay synchronized with the active locale.
    PostUpdatedAt: "Updated At",
    FacebookPaidPost: "Paid Post",
    FacebookOrganicPost: "Organic Post",
    AccountType: "Account Type",
    PersonalAccount: "Personal Account",
    OfficialWebsite: "Official Website",
    ContactPhone: "Phone",
    Email: "Email",
    FullAddress: "Full Address",
    BelongingBrand: "Brand",
    BelongingIndustry: "Industry",
    AudienceRegion: "Region",
    AboutHomepage: "About",
    WebsiteLink: "Website",
    ContactAddress: "Address",
    City: "City",
    Country: "Country",
    InstagramAdPost: "Ad Post",
    InstagramNormalPost: "Organic Post",
    // INS 指标配置和单帖详情历史上以中文直写；公共入口通过该映射统一输出英文，避免图表与卡片重复维护翻译。
    MonitoringText: {
      "时间维度": "Time Dimension",
      "数据维度": "Data Dimension",
      "日": "Day",
      "周": "Week",
      "月": "Month",
      "公开数据": "Public Data",
      "授权数据": "Authorized Data",
      "数据": "Data",
      "来源": "Source",
      "粉丝": "Followers",
      "非粉丝": "Non-followers",
      "自然": "Organic",
      "付费": "Paid",
      "新增": "New",
      // YouTube 粉丝趋势的数据维度短标签，与新增、累计保持一致。
      "流失": "Lost",
      "净增": "Net Growth",
      "累计": "Cumulative",
      "图片": "Images",
      "视频": "Videos",
      "轮播": "Carousel",
      "快拍": "Stories",
      "发帖数": "Post Count",
      "发帖总数": "Total Posts",
      "发帖数占比图": "Post Count Chart",
      "发帖与互动趋势": "Posts & Interactions Trend",
      "发帖及帖子互动趋势": "Post Publishing & Post Interactions Trend",
      "发帖及帖子互动趋势图": "Post Publishing & Post Interactions Trend Chart",
      "发帖与活动趋势图": "Posts & Interactions Trend Chart",
      "帖子数据": "Post Data",
      "快拍数据": "Story Data",
      "主页数据": "Homepage Data",
      "粉丝数据": "Follower Data",
      "单一帖子": "Single Post",
      "浏览量": "Views",
      // Facebook 主页、帖子概览及数据明细统一由公共本地化入口转换以下标题、指标、筛选和图表分类。
      "Facebook 帖子数据": "Facebook Post Data",
      "Facebook 粉丝数据": "Facebook Follower Data",
      "帖子数据明细": "Post Data Details",
      "主页互动次数趋势图": "Page Engagements Trend",
      "付费观看": "Paid Video Views",
      "净增粉丝数": "Net New Followers",
      "单日最大心情数": "Maximum Daily Reactions",
      "单日最小心情数": "Minimum Daily Reactions",
      "单日最大浏览人数": "Maximum Daily Accounts Reached",
      "单日最小浏览人数": "Minimum Daily Accounts Reached",
      "单日最大访问量": "Maximum Daily Page Visits",
      "单日最小访问量": "Minimum Daily Page Visits",
      "受众": "Audience",
      "高": "High",
      "低": "Low",
      "哇": "Wow",
      "哈哈": "Haha",
      "图片点击": "Image Clicks",
      "大爱": "Love",
      "帖子互动占比图": "Post Interaction Distribution",
      "帖子心情": "Post Reactions",
      "平均观看时长": "Average Watch Time",
      "心情总数": "Total Reactions",
      "心碎": "Sad",
      "怒": "Angry",
      "总浏览人数": "Total Accounts Reached",
      "总访问量": "Total Page Visits",
      "播放方式": "Playback Method",
      "新增粉丝数": "New Followers",
      "汇总观看次数": "Total Video Views",
      "汉语": "Chinese",
      "活跃粉丝数": "Active Followers",
      "流失粉丝数": "Lost Followers",
      "在所选时段内有过互动行为的粉丝数量。": "Number of followers who interacted during the selected period.",
      "浏览人数趋势图": "Accounts Reached Trend",
      "点击总数": "Total Clicks",
      "点击次数": "Clicks",
      "点击次数占比图": "Click Distribution",
      "点击观看": "Click-to-Play Views",
      "点击观看次数": "Click-to-Play Views",
      "粉丝浏览": "Follower Views",
      "粉丝浏览量": "Follower Views",
      "粉丝互动率（授权） = 帖子授权互动次数（心情数 + 评论数 + 分享次数）/ 发帖日期授权的粉丝数 × 100%。": "Authorized follower interaction rate = authorized post interactions (reactions + comments + shares) / authorized followers on the post date × 100%.",
      "累计粉丝数": "Total Followers",
      "累计观看时长": "Total Watch Time",
      "自动观看": "Autoplay Views",
      "自动观看次数": "Autoplay Views",
      "自然观看": "Organic Video Views",
      "观看总量": "Total Video Views",
      "观看来源": "View Source",
      "观看达30秒次数趋势图": "30-Second Video Views Trend",
      "视频点击": "Video Clicks",
      "视频观看时长": "Video Watch Time",
      "视频观看时长趋势图": "Video Watch Time Trend",
      "视频观看次数趋势图": "Video Views Trend",
      "视频观看达30秒趋势图": "30-Second Video Views Trend",
      "访问主页量最多的一天。": "The day with the most page visits.",
      "访问主页量最少的一天。": "The day with the fewest page visits.",
      "访问量趋势图": "Page Visits Trend",
      "赞": "Like",
      "选定时段内的关注次数减去取关次数。": "Follows during the selected period minus unfollows.",
      "非粉丝浏览": "Non-follower Views",
      "非粉丝浏览量": "Non-follower Views",
      "观看数": "Views",
      "观看次数": "Views",
      "主页访问量": "Profile Views",
      "浏览总量": "Total Views",
      "总浏览量": "Total Views",
      // INS 帖子数据的列名与指标说明由公共 localizeMonitoringText 读取，集中维护后语言切换不会遗留中文表头或 tooltip。
      "自然获得-浏览量": "Organic Views",
      "来自广告-浏览量": "Ad Views",
      "粉丝-浏览量": "Follower Views",
      "非粉丝-浏览量": "Non-follower Views",
      "粉丝-覆盖人数": "Follower Reach",
      "非粉丝-覆盖人数": "Non-follower Reach",
      "帖文互动数": "Post Interactions",
      "帖子互动数": "Post Interactions",
      "轮播图-浏览量": "Carousel Views",
      "轮播图-覆盖人数": "Carousel Reach",
      "轮播图-收藏数": "Carousel Saves",
      "总互动次数": "Total Content Interactions",
      "总收藏数": "Total Saves",
      "覆盖总人数": "Total Story Reach",
      "单日最大回复": "Max Daily Replies",
      "单日最小回复": "Min Daily Replies",
      "单日最大完播率": "Max Daily Completion Rate",
      "单日最小完播率": "Min Daily Completion Rate",
      "单日最大收藏数": "Max Daily Saves",
      "单日最小收藏数": "Min Daily Saves",
      "单日最大覆盖": "Max Daily Reach",
      "单日最小覆盖": "Min Daily Reach",
      "单日最大观看": "Max Daily Video Views",
      "单日最小观看": "Min Daily Video Views",
      "单日最大话题数": "Max Daily Hashtags",
      "单日最小话题数": "Min Daily Hashtags",
      "单日最大退出": "Max Daily Exits",
      "单日最小退出": "Min Daily Exits",
      // 指标卡的 tooltip 使用完整业务解释作为映射键，保证 INS 页面切换语言后标题和悬浮说明同步更新。
      "不明显表示积极情感，也不明显表示消极情感的言论次数。": "Comments that do not clearly express positive or negative sentiment.",
      "所选日期区间内，用户对帖子评论的总数。": "The total number of comments users made on posts during the selected date range.",
      "与您内容（包括广告）互动的账户数量。内容涵盖帖子、快拍、Reels、视频和直播。": "Accounts that interacted with your content, including ads, posts, stories, Reels, videos, and live content.",
      "你的内容（包括广告）获得赞或心情、收藏、评论、分享和回复的次数。内容可以包括帖子、快拍和 Reels 等格式。": "Likes, reactions, saves, comments, shares, and replies received by your content, including ads, posts, stories, and Reels.",
      "你的帖子获得的收藏次数减去取消收藏的次数。": "Post saves minus unsaves.",
      "你的帖子被分享的次数。": "The number of times your posts were shared.",
      "使用话题最多的一天。": "The day with the most hashtags used.",
      "使用话题最少的一天。": "The day with the fewest hashtags used.",
      "单日覆盖人数最多的一天。": "The day with the highest reach.",
      "单日覆盖人数最少的一天。": "The day with the lowest reach.",
      "单日退出最多的一天。": "The day with the most story exits.",
      "单日退出最少的一天。": "The day with the fewest story exits.",
      "回复次数最多的一天。": "The day with the most replies.",
      "回复次数最少的一天。": "The day with the fewest replies.",
      "在快拍中点击查看下一个或上一个照片、视频的总次数；少于 5 次时显示为 0。": "Total taps to move forward or back through story photos and videos; values below 5 are shown as 0.",
      "在快拍中点击查看下一个或上一个照片的总次数；少于 5 次时显示为 0。": "Total taps to move forward or back through story photos; values below 5 are shown as 0.",
      "在快拍中点击查看下一个或上一个视频的总次数；少于 5 次时显示为 0。": "Total taps to move forward or back through story videos; values below 5 are shown as 0.",
      "完播率最低的一天。": "The day with the lowest completion rate.",
      "完播率最高的一天。": "The day with the highest completion rate.",
      "所选日期区间内，Instagram 主页上的视频被观看的次数，不含轮播图中的视频。": "Video views on the Instagram page during the selected period, excluding videos in carousels.",
      "所选日期区间内，主页发布的图片类快拍条数。": "The number of image stories published during the selected period.",
      "所选日期区间内，主页发布的快拍条数。": "The number of stories published during the selected period.",
      "所选日期区间内，主页发布的视频类快拍条数。": "The number of video stories published during the selected period.",
      "所选日期区间内，主页每天发布的 Reels 内容数。": "The number of Reels published by the page each day during the selected period.",
      "所选日期区间内，主页每天发布的图片内容数。": "The number of image posts published by the page each day during the selected period.",
      "所选日期区间内，主页每天发布的视频内容数。": "The number of video posts published by the page each day during the selected period.",
      "所选日期区间内，主页每天发布的轮播图片内容数。": "The number of carousel posts published by the page each day during the selected period.",
      "所选日期区间内，媒体文件的总浏览次数；少于 5 次时显示为 0。": "Total media views during the selected period; values below 5 are shown as 0.",
      "所选日期区间内，平均查看每个快拍的独立用户数。": "Average unique people who viewed each story during the selected period.",
      "所选日期区间内，快拍收到的回复（评论）总数；少于 5 次时显示为 0。欧洲（2020-12-01 起）和日本（2021-04-14 起）创建的快拍回复次数为 0。": "Total story replies during the selected period; values below 5 are shown as 0. Replies are 0 for stories created in Europe from 2020-12-01 and Japan from 2021-04-14.",
      "所选日期区间内，查看快拍的独立用户总数；少于 5 人时显示为 0。": "Total unique people who viewed stories during the selected period; values below 5 are shown as 0.",
      "所选日期区间内，用户退出快拍的次数；少于 5 次时显示为 0。": "The number of story exits during the selected period; values below 5 are shown as 0.",
      "所选日期区间内，看到 Instagram 照片、视频、动态或相册的用户数。": "People who saw Instagram photos, videos, stories, or carousels during the selected period.",
      "指定日期内帖子累计获得的互动次数；公开数据统计点赞和评论，授权数据还包含分享和收藏。": "Interactions received by posts published on that date; public data includes likes and comments, while authorized data also includes shares and saves.",
      "指定日期平均每 1000 个粉丝产生的帖子互动次数；当天未发帖时，千粉互动数为 0。": "Average post interactions per 1,000 followers on the selected date; the value is 0 when no post was published.",
      "收藏次数最多的一天。": "The day with the most saves.",
      "收藏次数最少的一天。": "The day with the fewest saves.",
      "收藏轮播图相册的人数。": "People who saved a carousel album.",
      "浏览量最大的一天。": "The day with the most views.",
      "浏览量最小的一天。": "The day with the fewest views.",
      "用户互动最多的一天。": "The day with the most user interactions.",
      "用户互动最少的一天。": "The day with the fewest user interactions.",
      "看到轮播图相册的用户人数。": "People who saw a carousel album.",
      "看过你的内容的粉丝人数。这项指标是估计值。请注意，将粉丝和非粉丝覆盖人数相加不一定总是等于你的总覆盖人数。这是因为，如果粉丝之后取关你，那么总覆盖人数仅统计一次。": "Estimated followers who saw your content. Follower and non-follower reach may not equal total reach because people who later unfollow are counted only once.",
      "看过你的内容的非粉丝人数。这项指标是估计值。请注意，将粉丝和非粉丝覆盖人数相加不一定总是等于你的总覆盖人数。这是因为，如果粉丝之后取关你，那么总覆盖人数仅统计一次。": "Estimated non-followers who saw your content. Follower and non-follower reach may not equal total reach because people who later unfollow are counted only once.",
      "自然获得的内容互动次数。": "Content interactions gained organically.",
      "表达不满、批评、厌恶或反对等消极情感的言论次数。": "Comments expressing dissatisfaction, criticism, dislike, or opposition.",
      "表达满意、赞赏、喜爱或支持等积极情感的言论次数。": "Comments expressing satisfaction, appreciation, affection, or support.",
      "覆盖人数最多的一天。": "The day with the most people reached.",
      "覆盖人数最少的一天。": "The day with the fewest people reached.",
      "观看次数最多的一天。": "The day with the most video views.",
      "观看次数最少的一天。": "The day with the fewest video views.",
      "轮播图相册的浏览总数。": "Total views of carousel albums.",
      "这一指标计算你的 Instagram 内容通过自然方式或付费传播获得的覆盖人数，内容包括速推的帖子和快拍。如果通过自然方式和付费传播共同促成了一次覆盖，那么这仅算作一次覆盖。这项指标是估计值。": "Estimated people reached by your Instagram content through organic or paid distribution. A person reached by both is counted once.",
      "选定时间内关注你的账户净增长数，即新增关注数减去取消关注数。": "Net account follows during the selected period: new follows minus unfollows.",
      "通过广告获得的内容互动次数。": "Content interactions gained through ads.",
      "内容被播放或展示的次数，涵盖 Reels、帖子、快拍。": "The number of times your content was played or displayed, including Reels, posts, and stories.",
      "自然获得的浏览量总数。": "Total views gained organically.",
      "通过广告获得的浏览量总数。": "Total views gained through ads.",
      "粉丝浏览你内容的次数。": "The number of times followers viewed your content.",
      "非粉丝浏览你内容的次数。": "The number of times non-followers viewed your content.",
      "Instagram 内容通过自然方式或付费传播获得的覆盖人数；该指标是估计值。": "Estimated people reached by your Instagram content through organic or paid distribution.",
      "看过你的内容的粉丝人数；该指标是估计值。": "Estimated number of followers who saw your content.",
      "看过你的内容的非粉丝人数；该指标是估计值。": "Estimated number of non-followers who saw your content.",
      "与您内容（包括广告）互动的账户数量，内容涵盖帖子、快拍、Reels、视频和直播。": "Accounts that interacted with your content, including ads, posts, stories, Reels, videos, and live content.",
      "你的内容（包括广告）获得赞或心情、收藏、评论、分享和回复的次数。": "Likes, reactions, saves, comments, shares, and replies received by your content, including ads.",
      "帖子、Reels 和视频的点赞数量。": "Likes on posts, Reels, and videos.",
      "帖子、Reels、视频和直播的评论数量。": "Comments on posts, Reels, videos, and live content.",
      "帖子、快拍、Reels 和视频的被转发次数。": "Shares of posts, stories, Reels, and videos.",
      "帖子、Reels 和视频的被收藏次数。": "Saves of posts, Reels, and videos.",
      "Instagram 账户创建至今获得的关注次数减去取关次数。": "Total follows since the Instagram account was created, minus unfollows.",
      "选定时间内，账户关注你的次数。": "The number of accounts that followed you during the selected period.",
      "选定时间内，账户取消关注你的次数。": "The number of accounts that unfollowed you during the selected period.",
      "选定时间内关注账户的净增长数，即新增关注数减去取消关注数。": "Net follower growth during the selected period: new follows minus unfollows.",
      "所选日期区间内，主页每天发布的帖子条数。": "The number of posts published by the page each day during the selected period.",
      "指定日期所发帖子累计获得的互动次数；授权数据包含点赞、评论、分享和收藏。": "Interactions received by posts published on that date; authorized data includes likes, comments, shares, and saves.",
      "你的帖子获得的评论次数减去已删除评论次数。": "Post comments minus deleted comments.",
      "你的帖子获得的点赞和心情数量减去移除心情的次数。": "Post likes and reactions minus removed reactions.",
      "你的帖子被分享的次数，仅授权数据支持。": "The number of times your posts were shared; available in authorized data only.",
      "你的帖子获得的收藏次数减去取消收藏的次数，仅授权数据支持。": "Post saves minus unsaves; available in authorized data only.",
      "指定日期发布的帖文中使用话题标签（hashtag）的数量。": "The number of hashtags used in posts published on the selected date.",
      "指定日期发布的帖子中使用话题标签（hashtag）的数量。": "The number of hashtags used in posts published on the selected date.",
      "你的内容播放或展示的次数，仅授权数据支持。": "The number of times your content was played or displayed; available in authorized data only.",
      "看到 Instagram 照片、视频、动态或相册的用户数，仅授权数据支持。": "People who saw Instagram photos, videos, stories, or carousels; available in authorized data only.",
      "轮播图相册的浏览总数，仅授权数据支持。": "Total carousel views; available in authorized data only.",
      "看到轮播图相册的用户人数，仅授权数据支持。": "People who saw a carousel; available in authorized data only.",
      "收藏轮播图相册的人数，仅授权数据支持。": "People who saved a carousel; available in authorized data only.",
      "Instagram 主页上的视频被观看的次数，不含轮播图中的视频。": "Video views on the Instagram page, excluding videos in carousels.",
      "表达满意、赞赏、喜爱或支持等积极情感的言论次数，仅授权数据支持。": "Comments expressing satisfaction, appreciation, affection, or support; available in authorized data only.",
      "不明显表示积极或消极情感的言论次数，仅授权数据支持。": "Comments with no clear positive or negative sentiment; available in authorized data only.",
      "表达不满、批评、厌恶或反对等消极情感的言论次数，仅授权数据支持。": "Comments expressing dissatisfaction, criticism, dislike, or opposition; available in authorized data only.",
      "帖文互动总数与覆盖人数的比率。": "The ratio of total post interactions to reach.",
      "帖子互动总数与覆盖人数的比率。": "The ratio of total post interactions to reach.",
      "授权数据下的帖文互动总数与覆盖人数的比率。": "The ratio of authorized post interactions to reach.",
      "授权数据下的帖子互动总数与覆盖人数的比率。": "The ratio of authorized post interactions to reach.",
      "浏览量趋势图": "Views Trend",
      "单日最大浏览量": "Max Daily Views",
      "单日最小浏览量": "Min Daily Views",
      "覆盖人数": "Reach",
      "总覆盖人数": "Total Reach",
      "覆盖人数趋势图": "Reach Trend",
      "单日最大覆盖人数": "Max Daily Reach",
      "单日最小覆盖人数": "Min Daily Reach",
      "互动用户数": "Engaged Accounts",
      "互动用户趋势图": "Engaged Accounts Trend",
      "内容互动次数": "Content Interactions",
      "内容互动趋势图": "Content Interactions Trend",
      "帖子互动数": "Post Interactions",
      "互动类型": "Interaction Types",
      "内容类型占比图": "Content Type Distribution",
      "互动次数": "Interactions",
      "互动总数": "Total Interactions",
      "互动数": "Interactions",
      "互动率": "Interaction Rate",
      "互动率（授权）": "Interaction Rate (Authorized)",
      "点赞": "Likes",
      "点赞数": "Likes",
      "评论": "Comments",
      "评论数": "Comments",
      "评论趋势": "Comment Trend",
      "评论占比图": "Comment Distribution",
      "评论总数": "Total Comments",
      "正面": "Positive",
      "中立": "Neutral",
      "负面": "Negative",
      "正面评论": "Positive Comments",
      "中立评论": "Neutral Comments",
      "负面评论": "Negative Comments",
      "正面评论数": "Positive Comments",
      "中立评论数": "Neutral Comments",
      "负面评论数": "Negative Comments",
      "分享": "Shares",
      "分享数": "Shares",
      "转发": "Reposts",
      "收藏": "Saves",
      "收藏数": "Saves",
      "收藏数趋势图": "Saves Trend",
      "千粉互动": "Interactions per 1K Followers",
      // Facebook 帖子数据的概览卡片和明细按中文配置，英文环境在这里补齐相应标题、表头和提示。
      "数据概览": "Data Overview",
      "帖子类型": "Post Type",
      "帖子状态": "Post Status",
      "发帖时间 (UTC+08:00)": "Posted At (UTC+08:00)",
      "发帖时间 (UTC-07:00)": "Posted At (UTC-07:00)",
      "点击-图片浏览（授权）": "Clicks - Image Views (Authorized)",
      "点击-视频播放（授权）": "Clicks - Video Plays (Authorized)",
      "点击-链接点击（授权）": "Clicks - Link Clicks (Authorized)",
      "点击-其他点击（授权）": "Clicks - Other Clicks (Authorized)",
      "浏览人数（授权）": "Accounts Reached (Authorized)",
      "观看达3秒次数": "3-Second Video Views",
      "观看达30秒次数（授权）": "30-Second Video Views (Authorized)",
      "帖子互动-授权": "Post Interactions - Authorized",
      "心情数-授权": "Reactions - Authorized",
      "点击数": "Clicks",
      "粉丝互动率-授权": "Follower Interaction Rate - Authorized",
      "千粉丝互动数": "Interactions per 1K Followers",
      "千粉丝互动数-授权": "Interactions per 1K Followers - Authorized",
      "图片浏览": "Image Views",
      "视频播放": "Video Plays",
      "链接点击": "Link Clicks",
      "其他点击": "Other Clicks",
      "付费观看次数": "Paid Video Views",
      "自然观看次数": "Organic Video Views",
      "视频观看人数": "Video Viewers",
      "付费观看人数": "Paid Video Viewers",
      "自然观看人数": "Organic Video Viewers",
      "视频观看总时长": "Total Video Watch Time",
      "视频完播率": "Video Completion Rate",
      "视频观看达30秒次数": "30-Second Video Views",
      "帖子互动数（授权）": "Post Interactions (Authorized)",
      "心情数": "Reactions",
      "心情数（授权）": "Reactions (Authorized)",
      "点击数（授权）": "Clicks (Authorized)",
      "千粉互动数": "Interactions per 1K Followers",
      "千粉互动数（授权）": "Interactions per 1K Followers (Authorized)",
      "付费浏览量": "Paid Views",
      "自然浏览量": "Organic Views",
      "点击-图片浏览": "Clicks - Image Views",
      "点击-视频播放": "Clicks - Video Plays",
      "点击-链接点击": "Clicks - Link Clicks",
      "点击-其他点击": "Clicks - Other Clicks",
      "付费观看次数（授权）": "Paid Video Views (Authorized)",
      "自然观看次数（授权）": "Organic Video Views (Authorized)",
      "视频观看人数（授权）": "Video Viewers (Authorized)",
      "付费观看人数（授权）": "Paid Video Viewers (Authorized)",
      "自然观看人数（授权）": "Organic Video Viewers (Authorized)",
      "视频观看总时长（授权）": "Total Video Watch Time (Authorized)",
      "视频平均观看时长（授权）": "Average Video Watch Time (Authorized)",
      "视频完播率（授权）": "Video Completion Rate (Authorized)",
      "视频观看次数": "Video Views",
      "正面评论数（授权）": "Positive Comments (Authorized)",
      "负面评论数（授权）": "Negative Comments (Authorized)",
      "中立评论数（授权）": "Neutral Comments (Authorized)",
      "访问量": "Page Visits",
      "主页互动次数": "Page Engagements",
      "帖子心情（公开）": "Post Reactions (Public)",
      "帖子心情（授权）": "Post Reactions (Authorized)",
      "视频播放次数": "Video Views",
      "观看达30秒次数": "30-Second Video Views",
      "千粉互动趋势图": "Interactions per 1K Followers Trend",
      // YouTube 主页沿用 Figma 的“单帖互动”词组，避免英文表头退回旧组件的错别字文案。
      "单帖互动": "Per Post Interactions",
      "单帖互动趋势图": "Per Post Interactions Trend",
      "单帖互动数": "Per Post Interactions",
      "平均互动数": "Average Interactions",
      "单日最大互动数": "Max Daily Interactions",
      "单日最小互动数": "Min Daily Interactions",
      // X 新版主页数据沿用监控页的中文配置，英文界面在此集中映射四个主页趋势模块文案。
      "单帖互动": "Per Post Interactions",
      "单帖互动趋势图": "Per Post Interactions Trend",
      "主页关注用户": "Profile Followers",
      "主页关注用户趋势图": "Profile Followers Trend",
      "主页归属列表": "Profile Lists",
      "主页归属列表趋势图": "Profile Lists Trend",
      "关注总数": "Total Following",
      "新增关注数": "New Following",
      "归属总数": "Total Listings",
      "新增归属数": "New Listings",
      // X 主页新增两张明细表，列名继续走 MonitoringText 以便组件可复用中文配置。
      "关注用户信息": "Following User",
      "关注时间": "Followed At",
      "取关时间": "Unfollowed At",
      "所属列表": "Listed In",
      "加入时间": "Joined At",
      "移除时间": "Removed At",
      "粉丝数": "Followers",
      "粉丝总数": "Total Followers",
      "粉丝数趋势图": "Followers Trend",
      "新增关注": "New Followers",
      "取消关注": "Unfollows",
      "净增关注": "Net Follows",
      "性别年龄分布": "Gender & Age Distribution",
      "性别分布": "Gender Distribution",
      "年龄分布": "Age Distribution",
      "男性": "Male",
      "女性": "Female",
      "其他": "Other",
      "按国家分布": "By Country",
      "按城市分布": "By City",
      "在线时间": "Online Time",
      "在线人数": "Online Followers",
      "最活跃时段": "Most Active Time",
      "话题数量": "Hashtag Count",
      "话题数": "Hashtags",
      "话题数趋势图": "Hashtag Trend",
      "使用话题总数": "Total Hashtags Used",
      "轮播图相册": "Carousel Album",
      "轮播图相册趋势图": "Carousel Album Trend",
      // YouTube 视频页：对应 Figma 卡片、图表及明细表的新增文案。
      "视频数据": "Video Data",
      "视频数据趋势图": "Video Data Trend",
      "新增视频数": "New Videos",
      "视频总数": "Total Videos",
      "视频总时长": "Total Video Duration",
      "新增视频": "New Videos",
      "视频观看趋势图": "Video Views Trend",
      "新增观看次数": "New Views",
      "观看总次数": "Total Views",
      "观看互动率": "View Interaction Rate",
      "新增观看": "New Views",
      "视频互动数": "Video Interactions",
      "视频互动占比图": "Video Interaction Breakdown",
      "顶数": "Likes",
      "踩数": "Dislikes",
      "顶": "Likes",
      "踩": "Dislikes",
      "视频数": "Videos",
      "视频观看": "Video Views",
      "观看总数": "Total Video Views",
      "观看视频趋势图": "Video Views Trend",
      "快拍数": "Story Count",
      "快拍数占比图": "Story Count Chart",
      "快拍完播率": "Story Completion Rate",
      "完播率": "Completion Rate",
      "完播率趋势图": "Completion Rate Trend",
      "回复次数": "Replies",
      "回复总数": "Total Replies",
      "回复次数趋势图": "Replies Trend",
      "退出次数": "Exits",
      "退出总数": "Total Exits",
      "退出次数趋势图": "Exits Trend",
      "轻触前进/返回次数": "Forward / Back Taps",
      "轻触前进/返回占比图": "Forward / Back Taps Chart",
      "全部次数": "Total Taps",
      "图片次数": "Image Taps",
      "视频次数": "Video Taps",
      "单条覆盖人数": "Reach per Story",
      "单条覆盖人数趋势图": "Reach per Story Trend",
      "互动分析分布图": "Interaction Distribution",
      "评论占比": "Comment Distribution",
      "评论分析分布图": "Comment Analysis Distribution",
      "性别分布图": "Gender Distribution Chart",
      "年龄分布图": "Age Distribution Chart",
      "国家/地区分布明细": "Country / Region Details",
      "城市分布占比图": "City Distribution Chart",
      "城市分布明细": "City Distribution Details",
      "数据汇总表": "Data Summary",
      "时间": "Time",
      "汇总": "Summary",
      "本页汇总": "Page Summary",
      "国家/地区": "Country / Region",
      "城市": "City",
      "占比": "Percentage",
      // Facebook 单一帖子列表的筛选、固定列与状态标签使用同一套映射，切换语言时即时更新。
      "来自广告": "From Ads",
      "自然获得": "Organic",
      "全部付费状态": "All Promotion Types",
      "付费推广": "Paid Promotion",
      "普通推广": "Organic Promotion",
      "全部帖子状态": "All Post Statuses",
      "展示中": "Active",
      "全部帖文状态": "All Post Statuses",
      "全部帖子状态": "All Post Statuses",
      "全部帖文类型": "All Post Types",
      "全部帖子类型": "All Post Types",
      "全部帖子类型": "All Post Types",
      "链接": "Link",
      "正常": "Active",
      "已删除": "Deleted",
      "帖子内容": "Post Content",
      "帖文状态": "Post Status",
      "帖子状态": "Post Status",
      "帖文类型": "Post Type",
      "帖子类型": "Post Type",
      // YouTube 独立列表的列配置弹窗使用原始中文配置，补齐对应英文显示。
      "帖子时间（北京时间）": "Post Time (Beijing)",
      "帖子时间（太平洋时间）": "Post Time (Pacific)",
      "千粉互动数": "Interactions per 1,000 Followers",
      // 单帖详情的图表标题和互动类型统一使用“帖子”术语。
      "视频观看次数": "Video Views",
      "视频观看互动率": "Video View Interaction Rate",
      "帖文互动占比": "Post Interaction Breakdown",
      "帖子互动分布图": "Post Interaction Distribution",
      "互动总数": "Total Interactions",
      "点赞数": "Likes",
      "评论数": "Comments",
      "分享数": "Shares",
      "喜欢数": "Likes",
      "回复数": "Replies",
      "转发数": "Shares",
      "不喜欢数": "Dislikes",
      "点赞": "Likes",
      "评论": "Comments",
      "分享": "Shares",
      "喜欢": "Likes",
      "回复": "Replies",
      "转发": "Shares",
      "不喜欢": "Dislikes",
      "点赞、不喜欢、评论和分享的总次数。": "Total likes, dislikes, comments and shares.",
      "点赞次数及其占互动总数的比例。": "Likes and their percentage of total interactions.",
      "评论次数及其占互动总数的比例。": "Comments and their percentage of total interactions.",
      "分享次数及其占互动总数的比例。": "Shares and their percentage of total interactions.",
      "该视频获得的观看次数。": "Number of views received by this video.",
      "喜欢、不喜欢、回复和转发的总次数。": "Total likes, dislikes, replies and shares.",
      "喜欢次数及其占互动总数的比例。": "Likes and their percentage of total interactions.",
      "回复次数及其占互动总数的比例。": "Replies and their percentage of total interactions.",
      "转发次数及其占互动总数的比例。": "Shares and their percentage of total interactions.",
      "不喜欢次数及其占互动总数的比例。": "Dislikes and their percentage of total interactions.",
      "视频时长": "Video Duration",
      "发帖时间（UTC+08:00）": "Posted At (UTC+08:00)",
      "发帖时间（UTC-07:00）": "Posted At (UTC-07:00)",
      "请输入帖子名称": "Please enter post content",
      "请输入帖文名称": "Please enter post content",
      "请输入帖子名称": "Please enter post content",
      "授权后可查看该数据": "Authorize to view this data",
      "暂无数据": "No data available",
      "较上期": "vs. previous period",
      // INS 单帖表格列在配置文件中以中文直写，统一收口在这里使表头和“调整列表”同步翻译。
      "浏览人数": "Accounts Reached",
      "千粉互动（授权）": "Interactions per 1K Followers (Authorized)",
      "互动次数（授权）": "Interactions (Authorized)",
      "获赞数和心情数": "Likes and Reactions",
      "评论数（授权）": "Comments (Authorized)",
      "分享次数（授权）": "Shares (Authorized)",
      "收藏次数（授权）": "Saves (Authorized)",
      "链接点击量": "Link Clicks",
      "关注数": "Follows",
      "关注次数": "Follows",
      "观看时长": "Watch Time",
      "视频平均观看时长": "Average Watch Time",
      "观看达 3 秒次数": "3-Second Video Views",
      "粉丝互动率": "Follower Interaction Rate",
      "粉丝互动率（授权）": "Follower Interaction Rate (Authorized)",
      "覆盖互动率（授权）": "Reach Interaction Rate (Authorized)",
      "覆盖互动率": "Reach Interaction Rate",
      "快拍通过自然或付费传播获得的覆盖人数；同一用户的自然和付费覆盖仅统计一次，属于估计值。": "Estimated unique people reached by a story through organic or paid distribution. A person's organic and paid reach is counted once.",
      "看过你的内容至少一次的 Meta 账户数量，属于估计值且仍在完善中。": "Estimated number of Meta accounts that viewed your content at least once.",
      "帖子公开互动次数（点赞数 + 评论数）除以发帖日期粉丝数，再乘以 1000。": "Public post interactions (likes plus comments) divided by followers on the post date, multiplied by 1,000.",
      "帖子授权互动次数（点赞数 + 评论数 + 分享次数 + 收藏次数）除以发帖日期粉丝数，再乘以 1000。": "Authorized post interactions divided by followers on the post date, multiplied by 1,000.",
      "帖子获得的赞、心情、收藏、评论和分享次数减去删除或移除的互动次数。": "Post likes, reactions, saves, comments, and shares, minus deleted or removed interactions.",
      "帖子授权互动次数；快拍包含赞或心情、回复和分享次数。": "Authorized post interactions; stories include reactions, replies, and shares.",
      "帖子获得的点赞和心情数量减去移除心情的次数。": "Post likes and reactions, minus removed reactions.",
      "帖子获得的评论次数减去已删除评论次数。": "Post comments, minus deleted comments.",
      "帖子或快拍被分享的次数。": "The number of times a post or story was shared.",
      "帖子获得的收藏次数减去取消收藏的次数。": "Post saves, minus removed saves.",
      "快拍中上滑链接的点击量。": "Link swipe-up clicks in a story.",
      "快拍获得的文字回复和快捷心情回复次数。": "Text and quick-reaction replies received by a story.",
      "用户从内容点击关注按钮的次数，包含速推内容的点击。": "Follows from this content, including clicks from promoted content.",
      "Reels 播放的总时长，包含重播时间。": "Total Reels watch time, including replays.",
      "视频的平均播放时长，包含单次展示时的重播时间。": "Average video watch time, including replays during a single impression.",
      "视频或 Reels 播放满 3 秒或几乎完整播放的次数。": "The number of video or Reels plays that reached three seconds or nearly completed.",
      "帖子公开互动次数（点赞数 + 评论数）除以发帖日期粉丝数，再乘以 100%。": "Public post interactions divided by followers on the post date, multiplied by 100%.",
      "帖子授权互动次数除以发帖日期粉丝数，再乘以 100%。专业账户为自然数据，个人账户为自然和付费总数据。": "Authorized post interactions divided by followers on the post date, multiplied by 100%. Professional accounts use organic data; personal accounts use organic and paid data.",
      "帖子授权互动次数除以覆盖人数，再乘以 100%；分享次数仅 Reels 有数据。": "Authorized post interactions divided by reach, multiplied by 100%. Shares are available only for Reels.",
      "你的内容播放或展示的次数。": "The number of times your content was played or displayed.",
      "看到帖子内容的独立用户数，属于估计值。": "Estimated number of unique people who saw this post.",
      "帖子获得的赞、收藏、评论和分享次数。": "Likes, saves, comments, and shares received by this post.",
      "用户从内容点击关注按钮的次数。": "The number of times users followed from this content.",
      "授权互动次数除以发帖日期粉丝数，再乘以 100%。": "Authorized interactions divided by followers on the post date, multiplied by 100%.",
      "授权互动次数除以覆盖人数，再乘以 100%。": "Authorized interactions divided by reach, multiplied by 100%.",
      "授权互动次数除以发帖日期粉丝数，再乘以 1000。": "Authorized interactions divided by followers on the post date, multiplied by 1,000.",
      "帖子获得的互动总次数。": "Total interactions received by this post.",
      "帖子获得的点赞和心情数量。": "Likes and reactions received by this post.",
      "帖子获得的评论次数。": "Comments received by this post.",
      "帖子被分享的次数。": "The number of times this post was shared.",
      "帖子获得的收藏次数。": "The number of times this post was saved.",
      "表达积极情感的评论次数。": "Comments expressing positive sentiment.",
      "表达消极情感的评论次数。": "Comments expressing negative sentiment.",
      "不明显表达积极或消极情感的评论次数。": "Comments with no clear positive or negative sentiment.",
      // Facebook 监控页的指标提示以中文字段说明为 key，英文环境由公共 localizeMonitoringText 自动转换。
      "公共主页的新增关注数。": "New follows for the Page.",
      "在所选时段内取关你公共主页的账户中心账户数量。": "The number of Accounts Center accounts that unfollowed your Page during the selected period.",
      "你的 Facebook 公共主页或个人主页获得的粉丝人数。计算方式：Facebook 公共主页或个人主页创建至今所获得的关注次数减去取关次数。": "Followers gained by your Facebook Page or profile since creation, calculated as follows minus unfollows.",
      "千粉互动即指定日期平均每1000个粉丝产生的帖子互动数。指定日期千粉互动数 =（主页在指定日期所发帖子累计获得帖子互动数（心情+分享+评论）÷ 指定日期的粉丝数）x 1000。如某个日期主页未发帖，则当日的千粉互动数为0。": "Average post interactions per 1,000 followers on the specified date. It equals total reactions, shares, and comments on posts published that day divided by that day's followers, then multiplied by 1,000. The value is 0 if no post was published that day.",
      "用户互动量最多的一天。": "The day with the most user interactions.",
      "用户互动量最少的一天。": "The day with the fewest user interactions.",
      "用户通过点赞、评论和分享等方式与帖子互动的次数。": "The number of times users interacted with posts through likes, comments, shares, and similar actions.",
      "公共主页帖每天获得的心情总数，按类型细分。": "Total daily reactions received by Page posts, broken down by reaction type.",
      "公共主页帖获得心情总数最多的一天。": "The day Page posts received the most reactions.",
      "公共主页帖获得心情总数最少的一天。": "The day Page posts received the fewest reactions.",
      "所选日期范围内，帖子内容被点击的次数。": "The number of times post content was clicked during the selected date range.",
      "用户点击查看图片的次数。": "The number of times users clicked to view an image.",
      "用户点击播放视频的次数。": "The number of times users clicked to play a video.",
      "用户点击帖子中链接的次数。": "The number of times users clicked a link in a post.",
      "其他类型的帖子点击次数。": "The number of other types of post clicks.",
      "所选日期区间内发布的帖子总条数。": "Total posts published during the selected date range.",
      "所选日期区间内发布的${label}类型帖子数量。": "The number of {label} posts published during the selected date range.",
      "所选日期区间内，主页发布帖子获取的互动总数。": "Total interactions received by posts published by the Page during the selected date range.",
      "帖子互动数 = 主页在指定日期所发帖子累计获得帖子互动数（心情+分享+评论）。": "Post interactions equal the total reactions, shares, and comments received by posts published by the Page on the specified date.",
      "帖子发布的内容类型。": "The type of content published in the post.",
      "帖子当前是否仍在 Facebook 主页中展示。": "Whether the post is currently displayed on the Facebook Page.",
      "帖子在北京时间（UTC+08:00）的发布时间。": "The post publication time in Beijing time (UTC+08:00).",
      "帖子在太平洋时间（UTC-07:00）的发布时间。": "The post publication time in Pacific time (UTC-07:00).",
      "付费浏览量是指通过付费展示 (例如广告)，帖子展示给用户的次数。": "Paid views are the number of times posts were shown to users through paid placements, such as ads.",
      "帖子累计获得帖子互动数（心情+分享+评论）。": "Total post interactions received by the post, including reactions, shares, and comments.",
      "用户点击帖子任意位置的次数。": "The number of times users clicked anywhere on a post.",
      "你的帖子被评论的次数。": "The number of times your posts were commented on.",
      "帖子获得的心情总数。": "Total reactions received by posts.",
      "在时间范围内，你发布的内容被播放或展示的次数。内容包括视频、帖子、动态和广告。": "The number of times your published content was played or displayed during the selected period, including videos, posts, stories, and ads.",
      "付费浏览量是指通过付费展示（例如广告），帖子展示给用户的次数。": "Paid views are the number of times posts were shown to users through paid placements, such as ads.",
      "付费曝光是指通过付费展示 (例如广告)，帖子展示给用户的次数。": "Paid impressions are the number of times posts were shown to users through paid placements, such as ads.",
      "自然覆盖是指通过非付费展示，帖子展示给用户的次数。": "Organic views are the number of times posts were shown to users through unpaid placements.",
      "你的内容被粉丝浏览的次数。": "The number of times your content was viewed by followers.",
      "你的内容被非粉丝浏览的次数。": "The number of times your content was viewed by non-followers.",
      "帖子互动数除以主页粉丝数的百分比。": "The percentage of post interactions divided by the Page's follower count.",
      "粉丝互动率 = 帖子公开互动次数（心情数 + 评论数 + 分享次数）/ 发帖日期公开的粉丝数 × 100%。": "Follower interaction rate = public post interactions (reactions + comments + shares) / public followers on the post date × 100%.",
      "千粉互动 = 帖子公开互动次数（喜欢数 + 回复数 + 转发数）/ 发帖日期的粉丝数 × 1000。": "Interactions per 1K followers = public post interactions (likes + replies + shares) / followers on the post date × 1,000.",
      "千粉互动 = 帖子公开互动次数（心情数 + 评论数 + 分享次数）/ 发帖日期公开的粉丝数 × 1000。": "Interactions per 1K followers = public post interactions (reactions + comments + shares) / public followers on the post date × 1,000.",
      "千粉互动（授权） = 帖子授权互动次数（心情数 + 评论数 + 分享次数）/ 发帖日期授权的粉丝数 × 1000。": "Authorized interactions per 1K followers = authorized post interactions (reactions + comments + shares) / authorized followers on the post date × 1,000.",
      "粉丝互动率(授权) = 帖子授权互动次数（心情数 + 评论数+ 分享次数 ）/ 发帖日期授权的粉丝数× 100%。": "Authorized follower interaction rate = authorized post interactions (reactions + comments + shares) / authorized followers on the post date × 100%.",
      "千粉互动 = 帖子公开互动次数 (心情数+ 评论数 + 分享次数）/ 发帖日期公开的粉丝数 × 1000。": "Interactions per 1K followers = public post interactions (reactions + comments + shares) / public followers on the post date × 1,000.",
      "千粉互动 (授权) = 帖子授权互动次数（心情数 + 评论数 + 分享次数 ）/ 发帖日期授权的粉丝数× 1000。": "Authorized interactions per 1K followers = authorized post interactions (reactions + comments + shares) / authorized followers on the post date × 1,000.",
      "播放视频至少满3秒或几乎完整播放（如果视频的总时长不足3秒）的次数。": "The number of times a video was played for at least 3 seconds or nearly to completion when it is shorter than 3 seconds.",
      "视频付费观看次数是指播放推广视频至少满 3 秒或几乎完整播放（如果视频总时长不足 3 秒）的次数。": "Paid video views are plays of promoted videos for at least 3 seconds or nearly to completion when shorter than 3 seconds.",
      "视频自然观看次数是指在自然覆盖的用户播放视频至少满 3 秒或几乎完整播放（如果视频总时长不足 3 秒）的次数。": "Organic video views are plays by organically reached users for at least 3 seconds or nearly to completion when shorter than 3 seconds.",
      "视频自动开始播放的次数。": "The number of times videos started playing automatically.",
      "用户主动点击播放视频的次数。": "The number of times users actively clicked to play a video.",
      "视频播放时长达到30秒的次数。": "The number of video plays that reached 30 seconds.",
      "自动播放视频至少满 30 秒或几乎完整播放（如果视频总时长不足 30 秒）的次数。": "The number of auto-played videos viewed for at least 30 seconds or nearly to completion when shorter than 30 seconds.",
      "用户点击播放后，播放视频至少满 30 秒或几乎完整播放（如果视频总时长不足 30 秒）的次数。": "The number of videos viewed for at least 30 seconds after a user clicked play, or nearly to completion when shorter than 30 seconds.",
      "所选日期内，视频观看的总时长，重播也计算在内。": "Total video watch time during the selected period, including replays.",
      "所选日期内，视频的平均播放时长，包括单次展示时的重播时间。": "Average video watch time during the selected period, including replays within a single impression.",
      "视频被完整播放到结束的比例。": "The proportion of videos played through to completion.",
      "你的内容被播放或展示的次数。内容包括视频、帖子、快拍和广告。": "The number of times your content was played or displayed, including videos, posts, stories, and ads.",
      "你的任意公共主页内容（不包括围绕你公共主页生成的带有社交信息的内容）出现在用户设备屏幕中的次数。": "The number of times any of your Page content, excluding social context generated around your Page, appeared on a user's screen.",
      "通过付费展示（例如广告），你的任何公共主页帖子或快拍、或公共主页相关内容出现在用户设备屏幕中的次数。": "The number of times any Page post, story, or Page-related content appeared on a user's screen through paid placements such as ads.",
      "看过你的内容至少一次的 Meta 账户数量。内容包括 Reels、帖子、快拍、直播视频和广告。": "The number of Meta accounts that viewed your content at least once, including Reels, posts, stories, live videos, and ads.",
      "看过你的内容的 Meta 账户数量最多的一天。": "The day with the most Meta accounts viewing your content.",
      "看过你的内容的 Meta 账户数量最少的一天。": "The day with the fewest Meta accounts viewing your content.",
      "登录和未登录用户查看主页的次数。": "The number of times logged-in and logged-out users viewed the Page.",
      // 与访问量卡片的中文提示完全一致，避免英文环境遗漏单日极值翻译。
      "访问主页次数最多的一天。": "The day with the most Page visits.",
      "访问主页次数最少的一天。": "The day with the fewest Page visits.",
      "把点赞、爱心、哇喔、哈哈、心碎、愤怒全部情绪反应，按类型分别统计并合计汇总。": "All Like, Love, Wow, Haha, Sad, and Angry reactions, counted by type and totaled.",
      "帖子获得的全部评论数。": "The total number of comments received by the post.",
      "视频观看人数是指观看视频至少满 3 秒或几乎完整观看（如果视频总时长不足 3 秒）的用户人数。": "The number of people who watched a video for at least 3 seconds or nearly to completion when it is shorter than 3 seconds.",
      "视频通过推广方式下，观看视频至少满 3 秒或几乎完整观看（如果视频总时长不足 3 秒）的用户人数。": "The number of people who watched a promoted video for at least 3 seconds or nearly to completion when it is shorter than 3 seconds.",
      "视频自然观看人数是指自然覆盖的用户观看视频至少满 3 秒或几乎完整观看（如果视频总时长不足 3 秒）的用户人数。": "The number of organically reached people who watched a video for at least 3 seconds or nearly to completion when it is shorter than 3 seconds.",
      "视频播放的总时长。": "Total video watch time.",
      "用户观看视频的平均时长。": "Average time users watched a video.",
      "视频完播率（授权） = 视频观看达30秒的次数 / 视频观看次数 × 100%。": "Authorized video completion rate = 30-second video views / video views × 100%.",
      "视频完播率(授权) = 视频观看达30秒的次数 / 视频观看次数 × 100%。": "Authorized video completion rate = 30-second video views / video views × 100%.",
      "视频观看达30秒的次数是指播放视频至少满30秒或几乎完整播放（如果视频的总时长不足30秒）的次数。": "The number of times a video was watched for at least 30 seconds or nearly to completion when it is shorter than 30 seconds.",
      "看过你的内容至少一次的 Meta 账户数量。": "The number of Meta accounts that saw your content at least once.",
      "视频完播率(授权) = 视频观看达30秒的次数 / 视频观看达3秒次数 × 100%。": "Authorized video completion rate = 30-second video views / 3-second video views × 100%.",
      "播放主页视频至少满 3 秒或几乎完整播放（如果视频总时长不足 3 秒）的次数。": "The number of times a Page video was played for at least 3 seconds or nearly to completion when it is shorter than 3 seconds.",
      "播放主页视频至少满 3 秒或几乎完整播放（如果视频总时长不足 3 秒）的次数，按自然覆盖人数细分。": "The number of times a Page video was played for at least 3 seconds or nearly to completion when it is shorter than 3 seconds, broken down by organic reach.",
      "播放主页视频至少满 3 秒或几乎完整播放（如果视频总时长不足 3 秒）的次数，按付费覆盖人数细分。": "The number of times a Page video was played for at least 3 seconds or nearly to completion when it is shorter than 3 seconds, broken down by paid reach.",
      "自动播放主页视频至少满 3 秒或几乎完整播放（如果视频总时长不足 3 秒）的次数。": "The number of times a Page video auto-played for at least 3 seconds or nearly to completion when it is shorter than 3 seconds.",
      "用户点击播放后，播放主页视频至少满 3 秒或几乎完整播放（如果视频总时长不足 3 秒）的次数。": "The number of times a Page video was played for at least 3 seconds after a user clicked play, or nearly to completion when it is shorter than 3 seconds.",
      "播放主页视频至少满 30 秒或几乎完整播放（如果视频总时长不足 30 秒）的次数。": "The number of times a Page video was played for at least 30 seconds or nearly to completion when it is shorter than 30 seconds.",
      "播放主页视频至少满 30 秒或几乎完整播放（如果视频总时长不足 30 秒）的次数，按自然覆盖人数细分。": "The number of times a Page video was played for at least 30 seconds or nearly to completion when it is shorter than 30 seconds, broken down by organic reach.",
      "播放主页推广视频至少满 30 秒或几乎完整播放（如果视频总时长不足 30 秒）的次数。": "The number of times a promoted Page video was played for at least 30 seconds or nearly to completion when it is shorter than 30 seconds.",
      "播放主页自动播放视频至少满 30 秒或几乎完整播放（如果视频总时长不足 30 秒）的次数。": "The number of times an auto-played Page video was played for at least 30 seconds or nearly to completion when it is shorter than 30 seconds.",
      "用户点击播放后，播放主页视频至少满 30 秒或几乎完整播放（如果视频总时长不足 30 秒）的次数。": "The number of times a Page video was played for at least 30 seconds after a user clicked play, or nearly to completion when it is shorter than 30 seconds.",
      "播放视频至少满 30 秒或几乎完整播放（如果视频总时长不足 30 秒）的次数，按自然覆盖人数细分。对于每次视频播放，我们不会计算任何视频重播时间。": "The number of times a video was played for at least 30 seconds or nearly to completion when it is shorter than 30 seconds, broken down by organic reach. Replays are excluded from each video play.",
      "播放推广视频至少满 30 秒或几乎完整播放（如果视频总时长不足 30 秒）的次数。每一次视频展示均单独统计时长达标的观看量，且不计算任何视频重播时间。": "The number of times a promoted video was played for at least 30 seconds or nearly to completion when it is shorter than 30 seconds. Each impression is counted separately and replays are excluded.",
      // Facebook 发帖数按内容类型展示，保持标签与字段提示在英文界面同步切换。
      "文本": "Text",
      "组合": "Mixed Media",
      "动图": "GIF",
      "类型为纯文本的帖子数量。": "The number of text-only posts.",
      "包含图片的帖子数量。": "The number of posts containing images.",
      "包含视频的帖子数量。": "The number of posts containing videos.",
      "包含多种媒体组合的帖子数量。": "The number of posts containing a mix of media types.",
      "包含链接的帖子数量。": "The number of posts containing links.",
      "Reels 短视频帖子数量。": "The number of Reels short-video posts.",
      "包含动图的帖子数量。": "The number of posts containing GIFs.",
      "其他类型的帖子数量。": "The number of posts of other types.",
    },
    More: "More",

  },

  massEmail: {
    NewBlastTask: "New Mass Email",
    TaskStatus: "Task Status",
    StatusPending: "Pending",
    StatusSending: "Sending",
    StatusCompleted: "Completed",
    StatusCancelled: "Cancelled",
    StatusAbnormal: "Abnormal",
    StatusUnsent: "Unsent",
    StatusDelivered: "Delivered",
    StatusFailed: "Delivery Failed",
    CreateStartTime: "Create Start Time",
    CreateEndTime: "Create End Time",
    SearchTaskPlaceholder: "Search by task name",
    TaskCancelled: "Task cancelled successfully",
    TaskName: "Task Name",
    Delivered: "Delivered",
    Read: "Read",
    CreatedAtUtc8: "Created At (UTC+08:00)",
    SendTimeUtc8: "Send Time (UTC+08:00)",
    SendTimeActualTimezone: "Send Time (Actual Timezone)",
    PacificTimeUtcMinus3: "Pacific Time (UTC-03:00)",
    Operation: "Operation",
    ViewDetails: "View Details",
    CancelTaskConfirm: "The task cannot be restored after cancellation. Are you sure you want to cancel?",
    Confirm: "OK",
    ThinkAgain: "Not Now",
    CancelTask: "Cancel",
    TaskDetail: "Task Details",
    ExportReport: "Export Report",
    TaskMeta: "ID {id} · Mass Email · Created At {createdAt}",
    Statistics: "Statistics",
    TaskSettings: "Task Settings",
    SendList: "Send List",
    ManualEmails: "Manually Added Emails",
    EmailAddress: "Email Address",
    TotalRecords: "Total {count} records",
    AllSendStatus: "All Send Statuses",
    SendStartTime: "Send Start Time",
    SendEndTime: "Send End Time",
    OpenedStartTime: "Opened Start Time",
    OpenedEndTime: "Opened End Time",
    Email: "Email",
    SendStatus: "Send Status",
    DeliveredAtUtc8: "Send Time (UTC+8:00)",
    OpenedAtUtc8: "Read Time (UTC+8:00)",
    ValidUsers: "Valid Users",
    MetricDelivered: "Delivered",
    MetricOpened: "Read",
    DeliveredRate: "Delivery Rate",
    OpenedRate: "Open Rate",
    ActualMetrics: "Actual Metrics",
    ConversionFunnel: "Conversion Funnel",
    PreviousRingRate: "Conversion Rate vs Previous Stage",
    BasicInfo: "Basic Info",
    EmailContent: "Email Content",
    EmailBody: "Email Body",
    TargetUsers: "Target Users",
    PushRules: "Push Rules",
    EmailPreview: "Email Preview",
    SendImmediately: "Send Immediately",
    ScheduledSend: "Scheduled Send",
    Attachment: "Attachment",
    FrequencyPerMail: "{count} min/email",
    TaskNameColon: "Task Name:",
    SenderEmailColon: "Sender Email:",
    EmailSubjectColon: "Email Subject:",
    UploadAttachmentColon: "Upload Attachments:",
    EstimatedScaleColon: "Estimated Scale:",
    LocalUploadColon: "Local Upload:",
    ManualAddEmailColon: "Manually Added Emails:",
    ImportEmailColon: "Imported Emails:",
    SendFrequencyColon: "Send Frequency:",
    SendMethodColon: "Send Method:",
    SelectedTimezoneColon: "Selected Timezone:",
    ScheduledTimeColon: "Scheduled Time:",
    NewTaskTitle: "New Mass Email Task",
    TaskNamePlaceholder: "Enter a task name, e.g. Promotion Notification",
    MaxTaskNameChars: "Up to 30 characters; task names must be unique",
    SenderEmail: "Sender Email",
    AddEmail: "Add Email",
    SelectSenderEmailAccount: "Select a sender email account",
    EmailSubject: "Email Subject",
    EmailBodyPlaceholder: "Enter the email body",
    UploadAttachment: "Upload Attachments",
    DragFileToUpload: "Drag files here or click to upload",
    UploadAttachmentHint: "Supports PDF, images, documents, etc. Max 10MB per file",
    UploadEmailTable: "Upload Email Table",
    DownloadTemplate: "Download Import Template",
    UploadCsvHint: "Please upload a CSV file within 60MB",
    ManualAddEmail: "Manually Add Emails",
    ContactsInputHint: "Supports batch input. Separate multiple emails with half-width commas (,), semicolons (;), or newlines",
    ContactsPlaceholder: "Enter or paste email addresses, e.g.:\nUsers1@examile.com\nUsers2@example.com",
    SendFrequency: "Send Frequency",
    MinPerMail: "min/email",
    SendTime: "Send Time",
    SendDate: "Send Date",
    PleaseSelect: "Please Select",
    ScheduledSendHint: "Messages will start sending at this time in the selected timezone",
    EmailBodyPreview: "Email body......",
    ConfirmBlastTask: "Confirm Mass Email Task",
    CreateTask: "Create Task",
    Source: "Source",
    Summary: "Total",
    Valid: "Valid",
    Invalid: "Invalid",
    Duplicate: "Duplicate",
    SendSettings: "Send Settings",
    TimeIntervalColon: "Time Interval:",
    TimezoneColon: "Timezone:",
    SendTimeColon: "Send Time:",
    ConfirmBlast: "Confirm Mass Email",
    Cancel: "Cancel",
    UploadFileOrFillEmailsRequired: "Please upload the target user file or enter email addresses manually",
    InvalidEmailFormat: "Invalid email format: {email}",
    InvalidSeparatorFormat: "Full-width separators detected. Please use half-width commas (,), semicolons (;), or newlines to separate emails",
    DuplicateEmail: "Duplicate email address: {email}",
    EnterTaskName: "Enter the task name",
    SelectSenderEmail: "Select the sender email",
    EnterEmailSubject: "Enter the email subject",
    UploadOrFillTargetUsers: "Please upload a file or enter target users",
    SendTimeMustBeFuture: "The send time must be later than the current time (considering the selected timezone)",
    FileTooLarge: "File size exceeds the limit ({size}MB); the maximum supported size is {limit}MB",
    AttachmentUploadFailed: "Attachment upload failed",
    CsvOnlyError: "Only CSV files are allowed!",
    ReselectFilesWarning: "Please re-select the attachments and target user file",
    UploadSource: "File Upload",
    ManualSource: "Manually Added",
    AddEmailAddress: "Add Sender Email",
    NewProviderTitle: "Add {name}",
    SelectProviderHint: "Select the email provider to bind; the authorization method will be provided accordingly.",
    FillEmailInfoHint: "Fill in the email information and authorization code to complete the binding",
    EmailAccount: "Email Account",
    NoAccountNeededHint: "No account needed. Click the account authorization button to authorize",
    EnterValidEmailAddress: "Enter a valid email address",
    OauthLogin: "Authorized Login",
    AccountAuthorize: "Authorize Account",
    AuthorizeFailed: "Authorization Failed",
    EmailAuthCode: "Email Authorization Code",
    EnterAuthCode: "Enter the email authorization code or password",
    HowToGetAuthCode: "How to get the authorization code?",
    UsageDescription: "Usage Description",
    UsageDescriptionPlaceholder: "Enter a description (optional)",
    ServiceTypeColon: "Service Type:",
    ProtocolServerLabel: "{protocol} Server:",
    SmtpServerLabel: "SMTP Server:",
    ExamplePlaceholder: "e.g. {example}",
    ConfirmNew: "Confirm",
    EnterEmailAddress: "Enter the email address",
    SelectServiceType: "Select the receiving service type",
    EnterReceivingHost: "Enter the receiving server address",
    EnterPortNumber: "Enter the port number",
    EnterOutboxHost: "Enter the sending server address",
    EnterPortType: "Enter the port type",
    AuthorizeFirstWarning: "Please click account authorization first",
    Tip: "Tip",
    CreateBotFailed: "Failed to create bot",
    EmailBindSuccess: "Email bound successfully",
    EmailBindFailed: "Failed to bind email",
    OauthSuccessAlert: "Account authorized successfully. Click OK to link the email.",
    // Authorization-mode dialog copy; the provider name is injected through the provider param.
    NewAuthorizationTitle: "Add Email Authorization",
    SelectProviderAuthorizationHint: "Select an email provider and complete the authorization it requires",
    ProviderConfigUnavailable: "This email provider configuration is unavailable. Please try again later",
    AuthorizationSuccessTitle: "Email Authorization Successful",
    AuthorizationFailedTitle: "Email Authorization Failed",
    AuthorizationPartialFailedTitle: "Some Emails Failed to Authorize",
    AuthorizationSuccessHint: "{success} emails authorized successfully",
    AuthorizationFailedHint: "{failed} emails failed to authorize. Please check the failed accounts and try again",
    AuthorizationPartialFailedHint: "{success} emails authorized successfully and {failed} failed. Please check the failed accounts and try again",
    SelectBindingAccountsTitle: "Select accounts to bind",
    SelectBindingAccountsHint: "You can bind up to {count} more email accounts. Select the accounts to bind this time",
    AuthorizationStatusSuccess: "Authorized",
    AuthorizationStatusOtherTeam: "Authorized to Another Team",
    AuthorizationStatusFailed: "Authorization Failed",
    SkipLabelAssociation: "Skip for Now",
    AssociateLabelAction: "Associate Labels",
    LabelAssociationSuccess: "Labels associated successfully",
    LabelAssociationFailed: "Failed to associate labels",
    LabelAssociationNoAccount: "No emails available for label association",
    AuthorizationTitle: "Bind {provider} Email",
    ConfirmAuthorizationBinding: "Confirm Binding",
    OauthConfirmHint: "{provider} authorization is complete. Please confirm the email information",
    OauthGuideHint: "Go to {provider} to authorize your account. The email address is retrieved automatically after authorization",
    OauthGuideStepLogin: "Sign in to {provider} to authorize the account",
    OauthGuideStepScope: "Review and confirm the required email access permissions",
    OauthGuideStepFinish: "Return to JoinCompass after authorization and finish adding the binding",
    OauthUrlFailed: "Failed to get the authorization URL. Please try again",
    ConfirmAuthorization: "Confirm Authorization",
    GetAuthCode: "Get Authorization Code",
    SwitchProvider: "Switch Provider",
    AddMailAuthorizationHint: "Fill in the email account, authorization code and service type",
    MultiMailAuthorizationHint: "Fill in the email account and authorization code; multiple emails are supported",
    EmailIndex: "Email {index}",
    DeleteEmail: "Delete email {index}",
    EnterYourEmail: "Enter your email address",
    UsageDescriptionOptional: "Enter a usage description (optional)",
  },

  marketing: {
    MarketingTools: "Martech",
    WhatsAppBlast: "WhatsApp Blast",
    AbnormalReason: "Exception Reason",
    ViewWhatsAppAccount: "View WhatsApp Account",
    WhatsAppContacts: "WhatsApp Contacts",
    TagManagement: "Tag Management",
    // Coupon Library text is shared by its list, import, and detail pages.
    CouponLibrary: "Coupon Library",
    MaterialCreation: "Material Creation",
    ImportCoupon: "Import Coupons",
    // Coupon Library text covers import, details, date filters, report export, drag-and-drop upload, API validation, and invalid-code details.
    CouponImportHint: "Enter a coupon name and upload a coupon-code file.",
    CouponNamePlaceholder: "Enter coupon name",
    CouponNameRequired: "Please enter a coupon name",
    CouponFileRequired: "Please upload a coupon-code file",
    UploadCouponCode: "Upload coupon codes",
    DownloadCouponTemplate: "Download template",
    SelectCouponFile: "Select an Excel file",
    DragOrSelectCouponFile: "Drag a file here or click to upload",
    CouponFileFormatHint: "Supports .csv / .xlsx / .xls files up to 10MB",
    CouponFileTypeInvalid: "Upload a CSV, XLS, or XLSX coupon-code file",
    CouponFileTooLarge: "The coupon-code file cannot exceed 10MB",
    DeleteCouponTaskTitle: "Delete Coupon Task",
    DeleteCouponTaskConfirm: "Delete the coupon task “{name}”? This action cannot be undone.",
    DeleteCouponTaskSuccess: "Coupon task deleted successfully",
    CouponFileValidationFailed: "Coupon code validation failed",
    CouponFileValidationHint: "Detected {count} invalid coupon code(s). Update the file and upload it again.",
    ViewExampleData: "View invalid data",
    CouponImportErrorTitle: "Invalid Coupon Codes",
    CouponErrorRow: "No.",
    CouponErrorCode: "Coupon Code",
    CouponErrorReason: "Reason",
    CouponErrorClose: "Close",
    ConfirmImport: "Confirm Import",
    CouponCreated: "Coupon created successfully",
    CouponTemplateDownloadFailed: "Failed to download the coupon template. Please try again later.",
    CouponReportExportFailed: "Failed to export the coupon report. Please try again later.",
    SearchCouponPlaceholder: "Enter coupon name",
    CouponName: "Coupon Name",
    CouponTotal: "Total Coupons",
    SentQuantity: "Sent",
    UnsentQuantity: "Unsent",
    // Messages shown when validating dynamic coupon availability before task creation.
    CouponAvailabilityTitle: "Insufficient Coupon Availability",
    CouponAvailabilityInsufficient: 'Coupon "{name}" has insufficient availability. At least {count} coupons are required.',
    CouponAvailabilityCheckFailed: "Unable to verify coupon availability. Please try again later.",
    CreatedAt: "Created At",
    Authorizer: "Authorizer",
    Action: "Actions",
    ViewDetails: "View Details",
    CouponFeaturePending: "This feature is not available yet",
    CouponDetail: "Coupon Details",
    CouponSendData: "Sending Data",
    CouponList: "Coupon List",
    CouponCode: "Coupon Code",
    CouponFaceValue: "Face Value",
    CouponImportTime: "Imported At (UTC+08:00)",
    CouponSendTime: "Sent At (UTC+08:00)",
    CouponImportStartTime: "Import Start Time",
    CouponImportEndTime: "Import End Time",
    CouponSendStartTime: "Send Start Time",
    CouponSendEndTime: "Send End Time",
    CouponRecipientName: "Recipient Name",
    CouponRecipientPhone: "Recipient Phone",
    CouponRecipientCountry: "Recipient Country",
    CouponStatusAll: "All Statuses",
    CouponNotSent: "Not Sent",
    CouponSent: "Sent",
    CouponSending: "Sending",
    CouponCreatedBy: "Created By",
    CouponTaskInfo: "{user} · Created at {time}",
    CouponUnknownTask: "Coupon Task",
    CouponTaskMissing: "Coupon task was not found. Return to Coupon Library and select a task again.",
    CreateBlast: "Create Blast",
    TaskStatus: "Task Status",
    Pending: "Pending",
    Sending: "Sending",
    Completed: "Completed",
    CreateStartTime: "Create Start Time",
    CreateEndTime: "Create End Time",
    // Keep the WhatsApp blast search hint aligned with the Chinese WABA search scope.
    SearchTaskPlaceholder: "Search task name / creator / WABA ID / WABA name",
    SearchWabaIdPlaceholder: "Enter WABA ID or name",
    TaskCancelled: "Task cancelled successfully",
    NoBlastTasks: "No blast tasks yet",
    TaskName: "Task Name",
    Delivered: "Delivered",
    DeliveredTooltip: "Delivery confirmation received by JoinCompass for WhatsApp messages",
    // Blast-list labels for no_service_user_num and fail_rate.
    DeliveryFailed: "Delivery Failed",
    DeliveryFailedTooltip: "Number of users whose messages were not delivered",
    FailureRate: "Failure Rate",
    FailureReasons: "Failure Reasons",
    FailureReason: "Reason {number}",
    FailureCount: "{count} record(s)",
    ViewAllFailureRecords: "View All Failure Records",
    ValidUser: "Valid Users",
    ValidUserTooltip: "Total number of blast users",
    Read: "Read",
    ReadTooltip: "The messages you sent have been read by users. Read receipts only apply to users who enabled the read receipt feature. For users who did not enable it, you will only receive the delivered status.",
    Clicked: "Clicked",
    ClickedTooltip: "Number of times buttons in the message were clicked, only available for templates with tracking enabled",
    ActualCost: "Actual Cost",
    // The blast task list shows the amount reserved before task execution.
    FreezeAmount: "Frozen Amount",
    BelongsWaba: "Belongs to WABA",
    WabaIdPrefix: "WABA ID:",
    SenderPhone: "Sender Phone",
    CreatedAtUtc8: "Created At (UTC+08:00)",
    SendTimeUtc8: "Send Time (UTC+08:00)",
    SendTimeActualTimezone: "Send Time (Actual Timezone)",
    Creator: "Creator",
    ViewDetails: "View Details",
    ReadRate: "Read Rate",
    ClickRate: "Click Rate",
    ConversionRate: "Conversion Rate",
    Operation: "Operation",
    OperationConfirm: "Operation Confirmation",
    Cancel: "Cancel",
    DeleteTaskConfirm: "After the task is deleted, the task-related data will also be deleted!",
    CancelTaskConfirm: "After cancellation, the system will no longer push notifications to unsent phone numbers!",
    CancelTask: "Cancel",
    Cancelled: "Cancelled",
    ExportReport: "Export Report",
    SyncData: "Sync Data",
    AllCountries: "All Countries",
    SelectTagsPlaceholder: "Select linked tags",
    // Template variable modes mirror the Chinese labels until dynamic data sources are introduced.
    StaticParameter: "Static parameter",
    DynamicParameter: "Dynamic parameter",
    SelectParameter: "Select parameter",
    // Dynamic drawer labels share the later data-source contract with the Chinese translations.
    DynamicParameterTitle: "Select parameter",
    DynamicParameterTip: "Choose a dynamic data parameter for “{name}”",
    ContactInformation: "Contact information",
    ContactInformationTip: "Choose contact name, phone, address, and more",
    ProductInformation: "Product information",
    ProductInformationTip: "Choose product name, price, stock, and more",
    CouponInformation: "Coupon information",
    CouponInformationTip: "Choose coupon code, discount, expiry, and more",
    AvailableParameters: "Available parameters",
    ContactNickname: "Nickname",
    ContactNicknameTip: "WhatsApp contact nickname",
    ContactPhone: "Contact phone",
    ContactPhoneTip: "WhatsApp contact phone number",
    ContactEmail: "Email address",
    ContactEmailTip: "WhatsApp contact email address",
    ProductName: "Product name",
    ProductNameTip: "Product name",
    ProductPrice: "Product price",
    ProductPriceTip: "Current product price",
    CouponName: "Coupon name",
    CouponNameTip: "Coupon name",
    CouponDiscount: "Coupon discount",
    CouponDiscountTip: "Coupon amount or discount rate",
    // Product and coupon association labels preserve the UI contract for later backend mapping.
    ProductAssociationTip: "Select a store, then choose the product to associate",
    CouponAssociationTip: "Select a coupon template, then choose the content to associate",
    SelectStore: "Select store",
    SelectProduct: "Select product",
    SelectCouponTemplate: "Select coupon template",
    AvailableCouponParameters: "Available coupon parameters",
    ProductImage: "Product image",
    ProductImageTip: "Product primary image",
    ProductLowestPrice: "Lowest price",
    ProductLowestPriceTip: "Lowest product variant price",
    ProductHighestPrice: "Highest price",
    ProductHighestPriceTip: "Highest product variant price",
    ProductVariantTotal: "Variant count",
    ProductVariantTotalTip: "Total product variants",
    ProductAvailableVariantTotal: "In-stock variant count",
    ProductAvailableVariantTotalTip: "Available product variants",
    ProductCurrency: "Currency",
    ProductCurrencyTip: "Product pricing currency",
    ProductBrand: "Brand",
    ProductBrandTip: "Product brand",
    ProductUpdatedAt: "Updated at",
    ProductUpdatedAtTip: "Product last updated time",
    CouponCode: "Coupon code",
    CouponCodeTip: "Coupon code available to the user",
    CouponAmount: "Amount",
    CouponAmountTip: "Coupon discount amount",
    OrderFirstName: "First name",
    OrderFirstNameTip: "Customer's first name",
    OrderLastName: "Last name",
    OrderLastNameTip: "Customer's last name",
    OrderEmail: "Email",
    OrderEmailTip: "Customer email address",
    OrderProductCount: "Product count",
    OrderProductCountTip: "Total product count in the order",
    OrderTotalAmount: "Order amount",
    OrderTotalAmountTip: "Total order amount",
    OrderOrderId: "Order ID",
    OrderOrderIdTip: "System order number",
    OrderCreatedAt: "Order time",
    OrderCreatedAtTip: "Order creation time",
    OrderSubtotal: "Subtotal",
    OrderSubtotalTip: "Product subtotal",
    OrderTax: "Tax",
    OrderTaxTip: "Order tax amount",
    OrderLogisticsChannel: "Logistics channel",
    OrderLogisticsChannelTip: "Logistics channel name",
    OrderWaybillNumber: "Waybill number",
    OrderWaybillNumberTip: "Logistics waybill number",
    OrderInternalNumber: "Internal number",
    OrderInternalNumberTip: "Internal logistics number",
    SearchContactPlaceholder: "Enter username, phone number or WABA ID",
    Nickname: "Nickname",
    Country: "Country",
    PhoneNumber: "Phone Number",
    BSUID: "BSUID",
    ParentBSUID: "Parent BSUID",
    Email: "Email",
    BelongsToWaba: "Belongs to WABA",
    // WhatsApp contacts support source filtering, localized ad attribution, and opening the ad link from More.
    ContactSource: "Source",
    SelectContactSource: "Select source",
    ContactAdId: "Ad ID",
    OpenAdLink: "Open Ad Link",
    ContactSourceImport: "Imported",
    ContactSourceOrganic: "Organic Follow",
    ContactSourceAdvertisement: "Ad Lead",
    LinkedTags: "Linked Tags",
    ContactCount: "Contact Count",
    Add: "Add",
    LastContactNumber: "Last Contact Number",
    FirstChatTime: "First Interaction Time",
    LastContactTime: "Last Contact Time",
    CreatedAt: "Created At",
    ViewHistory: "View History",
    NotBoundToBot: "This contact is not bound to a customer service bot",
    HistoryChat: "History Chat",
    LinkTags: "Link Tags",
    Deleting: "Deleting",
    Delete: "Delete",
    More: "More",
    LinkTagsDesc: "After linking tags, you can directly select by tags during data filtering.",
    NoLinkedTags: "No linked tags yet",
    TagSelection: "Tag Selection",
    AddTag: "Add Tag",
    SearchTagsPlaceholder: "Search for tags to link",
    Linking: "Linking",
    ConfirmLink: "Confirm Link",
    DeleteContactTitle: "Delete Contact",
    DeleteContactConfirm: "After deletion, this contact will be removed from the contact list. Confirm deletion?",
    SyncDataDesc: "Due to WhatsApp platform rules, data can only be synced within 24 hours after authorization. To re-sync data later, you need to authorize again.",
    WabaAccount: "WABA Account",
    SearchWabaPlaceholder: "Search WABA account",
    Account: "Account",
    LastSyncTime: "Last Sync Time",
    Updating: "Updating",
    NoWabaAccount: "No WABA accounts yet",
    Syncing: "Syncing",
    StartSync: "Start Sync",
    MissingContactId: "Missing contact ID, cannot delete temporarily",
    DeleteContactFailed: "Failed to delete contact",
    DeleteSuccess: "Deleted successfully",
    MissingContactIdForTag: "Missing contact ID, cannot link tags temporarily",
    LinkTagFailed: "Failed to link tags",
    LinkSuccess: "Linked successfully",
    AddCategory: "Add Category",
    SearchTagPlaceholder: "Enter tag name",
    Category: "Category",
    Tag: "Tag",
    ClickTagToEdit: "(Click tag to edit)",
    DeleteTagConfirm: "After deletion, the tag cannot be recovered. The tag will be removed from all places in the system, including but not limited to users and coupons.",
    DeleteCategoryConfirm: "After deletion, the category cannot be recovered. Tags under this category will also be deleted.",
    OperationSuccess: "Operation successful",
    NoTags: "No tags",
    EditCategory: "Edit Category",
    DeleteCategory: "Delete Category",
    Edit: "Edit",
    NamePlaceholder: "Enter {title} name",
    BlastTools: "Blast Tools",
    SummaryData: "Summary Data",
    DataDetails: "Data Details",
    EffectiveUsers: "Effective Users",
    UserCountries: "User Countries",
    SpendAmount: "Spend ($)",
    Sent: "Sent",
    DeliveredCount: "Delivered",
    Opened: "Opened",
    NotOpened: "Not Opened",
    NotSent: "Not Sent",
    SentNotOpened: "Sent Not Opened",
    DeliveryOpenRate: "Delivery & Open Rate",
    SelectSendStatus: "Select Send Status",
    SelectDeliveryStatus: "Select Delivery Status",
    SelectOpenStatus: "Select Open Status",
    NotDelivered: "Not Delivered",
    SelectStartDate: "Start Date",
    SelectEndDate: "End Date",
    UserName: "User Name",
    CountryRegion: "Country/Region",
    SendStatus: "Send Status",
    DeliveryStatus: "Delivery Status",
    OpenStatus: "Open Status",
    DeliveryFailed: "Delivery Failed",
    SendTime: "Send Time",
    NewBlast: "New Blast",
    BasicInfo: "Basic Information",
    SelectTemplate: "Select Template",
    TargetUsers: "Target Users",
    SendChannel: "Send Channel",
    PushRules: "Push Rules",
    StepBasicInfo: "1. Basic Information",
    StepSelectTemplate: "2. Select Template",
    StepTargetUsers: "3. Target Users",
    StepSendChannel: "4. Send Channel",
    StepPushRules: "5. Push Rules",
    TaskNameLabel: "Task Name",
    TaskNamePlaceholder: "Please enter task name",
    TaskNameHelp: "Up to 30 characters, task name cannot be repeated",
    WabaPlatform: "WABA Platform",
    WabaAccountPlaceholder: "Please select WABA account",
    PushNumber: "Push Number",
    SelectPhone: "Select Phone",
    VerifiedCompany: "Verified Company",
    MessageTemplate: "Message Template",
    MessageTemplatePlaceholder: "Please select message template",
    SelectLocation: "Select Location",
    LocationPlaceholder: "Search location, e.g. Shenzhen MixC",
    // A map result is required so the template receives both a name and coordinates.
    LocationRequired: "Please select a location from the map",
    DragUploadText: "Drag file here or click to upload",
    Uploading: "Uploading...",
    UploadHeaderRequired: "Please upload the template header media first",
    MediaUploadFailed: "Failed to upload the media file, please try again",
    TagSelectLabel: "Tag Selection",
    SelectTargetTags: "Please select target user tags",
    LocalUpload: "Local Upload",
    DownloadNumberTemplate: "Download Number Template",
    NumberCountSuffix: "numbers",
    UploadHint: "Please upload an xls file within 60M",
    SelectedTargetUsers: "Selected Target Users",
    CustomNumbers: "Custom Numbers",
    People: "people",
    Valid: "Valid",
    Invalid: "Invalid",
    Duplicate: "Duplicate",
    Unsubscribed: "Unsubscribed",
    FinalSend: "Final Send",
    ChannelType: "Channel Type",
    NormalChannel: "Normal Channel",
    NormalChannelDesc: "Standard delivery, applicable to all message types, supports two-way communication",
    MarketingChannel: "Marketing Dedicated Channel",
    PendingActivation: "Pending Activation",
    Activated: "Activated",
    MarketingChannelDesc: "AI-optimized delivery, delivery rate improved by about 9%, only for marketing template messages",
    ActivateNow: "Activate Now",
    ViewAdvantages: "View Advantages",
    MessageExpiry: "Message Expiry",
    SelectExpiry: "Please select expiry time",
    TTL12Hours: "12 Hours",
    TTL1Day: "1 Day",
    TTL3Days: "3 Days",
    TTL7Days: "7 Days",
    TTL14Days: "14 Days",
    TTL30Days: "30 Days",
    Custom: "Custom",
    Day: "Day",
    Hour: "Hour",
    ExpiryHelp: "Messages not delivered within the validity period will be automatically discarded.",
    SendTimeLabel: "Send Time",
    SendNow: "Send Now",
    ScheduleSend: "Schedule Send",
    SendDate: "Send Date",
    SelectPlaceholder: "Please select",
    SendTimeHelp: "Messages will start pushing at this time in the specified timezone",
    SaveChanges: "Save Changes",
    CreateTask: "Create Task",
    SelectStatusPlaceholder: "Select status",
    TaskNotStarted: "Not started",
    TaskInProgress: "In progress",
    DataMetrics: "Data Metrics",
    InteractionUsers: "Interacted Users",
    InteractedUsers: "Interacted Users",
    ActualMetrics: "Actual Metrics",
    UsageTrend: "Usage Trend",
    TriggerCount: "Trigger Count",
    TagCount: "Tagging Count",
    TriggerCountTip: "Total times the task was triggered during the selected period",
    InteractedUsersTip: "Users who interacted with the task during the selected period",
    TagCountTip: "Total times the task performed tagging during the selected period",
    BeijingTimeUtc8: "Beijing Time (UTC+08:00)",
    AutomateTaskMeta: "ID {id} · Automation Task · {monitorType} · Created {createdAt}",
    InteractionList: "Interaction List",
    ContactInfo: "Contact Info",
    Country: "Country",
    RelatedTags: "Related Tags",
    LastTriggerTimeUtc8: "Last Trigger Time (UTC+08:00)",
    Operation: "Operation",
    TotalContacts: "{count} Contacts",
    InteractionUserDetail: "Interaction User Details",
    TriggerRecords: "Trigger Records",
    TriggerRecordTotal: "Total {count} times",
    ActionSendMessage: "Send Message",
    ActionAddTag: "Add Tag",
    ActionAddTagDesc: "Added the specified tags during this execution",
    ViewMessageDetail: "View Message Details",
    CollapseMessageDetail: "Collapse Message Details",
    MessageSendTime: "Send Time: {time}",
    MessageDeliveredTime: "Delivered Time: {time}",
    MessageContent: "Message Content:",
    NormalTask: "Normal task",
    SelectPhoneTitle: "Select Phone",
    NoAvailablePhone: "No available phone number",
    NoVerifiedPhone: "No verified phone numbers yet",
    VerifyFirstTip: "Please verify your phone number before creating a blast",
    ConfirmAdd: "Confirm Add",
    Close: "Close",
    AddTargetUsers: "Add Target Users",
    UploadByTag: "Upload by Tag",
    CountryRegionColon: "Country/Region:",
    AllCountriesRegions: "All Countries/Regions",
    TagColon: "Tag:",
    UploadFile: "Upload File",
    TotalPhoneNumbers: "Total {count} phone numbers",
    DownloadPhoneTemplate: "Download Phone Number Template",
    Confirm: "Confirm",
    SelectedPhones: "Selected Phones",
    Name: "Name",
    LastInteractionTime: "Last Interaction Time",
    Tags: "Tags",
    ConfirmBlastTask: "Confirm Blast Task",
    InsufficientBalance: "Insufficient Balance",
    CurrentBalance: "Current Balance",
    EstimatedCost: "Estimated Cost",
    Difference: "Difference",
    TemplateName: "Template Name",
    WabaId: "WABA ID",
    PushCode: "Push Code",
    Summary: "Summary",
    EstimatedSpend: "Estimated Spend",
    EstimatedConversations: "Estimated Conversations",
    EstimatedCostAmount: "Estimated Cost ($)",
    CurrentBalanceAmount: "Current Balance ($)",
    GoRecharge: "Recharge",
    ConfirmBlast: "Confirm Blast",
    CertificationDesc: "Certification Description",
    SevenAdvantages: "Activate to enjoy 7 major advantages",
    SevenAdvantagesDesc: "Compared with ordinary cloud APIs, fully enhanced in delivery, materials, data, operations and compliance",
    ActivateMarketingChannel: "Activate Marketing Dedicated Channel",
    Adv1Title: "I. Improved Delivery Efficiency",
    Adv1Body1Title: "1. Tiered Delivery Mechanism",
    Adv1Body1Text: "The system identifies highly engaged, highly relevant marketing messages and prioritizes them; compared with ordinary cloud APIs, delivery of quality messages can increase by up to 9% without a blanket cap on marketing message volume.",
    Adv1Body2Title: "2. Customizable Extended Message Validity",
    Adv1Body2Text: "Marketing templates support 12-hour to 30-day delivery windows; the general cloud API only supports TTL for verification code and notification messages, not marketing messages.",
    Adv2Title: "II. Stronger Template Materials and Link Formats",
    Adv2Body1Title: "1. GIF Support in Template Headers",
    Adv2Body1Text: "Stronger visual appeal; not supported by the general API.",
    Adv2Body2Title: "2. Built-in Android App Deep Links",
    Adv2Body2Text: "One-click jump to the merchant App; not available in the ordinary cloud API.",
    Adv2Body3Title: "3. Full Support for All Marketing Components",
    Adv2Body3Text: "Basic marketing template components such as product carousels, multi-product catalogs, discount codes, limited-time campaigns, location cards, interactive buttons, and list menus.",
    Adv3Title: "III. Automatic Material Optimization",
    Adv3Body1Title: "1. Platform Automatically Optimizes Template Images and Visuals",
    Adv3Body1Text: "Improves open and click engagement; the standard cloud API has no automatic material optimization capability.",
    Adv4Title: "IV. Marketing Data and Conversion Analysis",
    Adv4Body1Title: "1. Industry Benchmark Data",
    Adv4Body1Text: "View average read and click rates of similar templates from local merchants in the same industry to judge template performance.",
    Adv4Body2Title: "2. Intelligent Optimization Suggestions",
    Adv4Body2Text: "Provides optimization recommendations for template copy, materials, and button settings based on platform big data.",
    Adv4Body3Title: "3. Complete Conversion Funnel Metrics",
    Adv4Body3Text: "Track deep conversions brought by messages: add to cart, start checkout, complete orders and more.",
    Adv4Body4Title: "4. Complete Cost Statistics",
    Adv4Body4Text: "Per-template cost, per-delivery cost, and per-click cost for easy ROI calculation.",
    Adv5Title: "V. Easier Onboarding and Operations",
    Adv5Body1Title: "1. More Onboarding Channels",
    Adv5Body1Text: "Multiple activation paths including embedded registration, intent API, and intent UI; the cloud API only supports embedded registration.",
    Adv5Body2Title: "2. Fine-grained Onboarding Status Queries",
    Adv5Body2Text: "Dedicated status fields and detailed error prompts to quickly locate activation failures.",
    Adv5Body3Title: "3. Dedicated Error Code System",
    Adv5Body3Text: "Distinguishes various marketing exceptions for higher troubleshooting efficiency.",
    Adv5Body4Title: "4. Automatic Throughput Scaling",
    Adv5Body4Text: "Automatically increases send quotas during traffic peaks and pushes Webhook notifications.",
    Adv6Title: "VI. Compliance and Security Guarantees",
    Adv6Body1Title: "1. Full Compliance Certifications",
    Adv6Body1Text: "GDPR, LGPD, ISO27001, and SOC audit reports to meet marketing compliance across regions.",
    Adv6Body2Title: "2. Local Number Data Storage Deployment",
    Adv6Body2Text: "Support on-premises data storage deployment for numbers.",
    Adv6Body3Title: "3. Real-time Platform Service Status Monitoring",
    Adv6Body3Text: "Real-time failure synchronization.",
    Adv7Title: "VII. Full Coverage of Marketing-Specific Template Types",
    Adv7Body1Title: "1. Native Marketing Templates, Ready to Use",
    Adv7Body1Text: "Discount code templates, limited-time promotion templates; product image carousel templates, multi-product catalog templates; store location lead templates, event invitation templates; call permission requests, CTA order and payment templates.",
    GotIt: "Got it",
    PleaseEnterTaskName: "Please enter task name",
    PleaseSelectWaba: "Please select WABA account",
    PleaseSelectPhone: "Please select phone",
    PleaseSelectTemplate: "Please select message template",
    PleaseSelectTargetUser: "Please select target users",
    PleaseSelectPushTime: "Please select push time",
    ImageContent: "Image Content",
    VideoContent: "Video Content",
    DocumentContent: "Document Content",
    MediaContent: "Media Content",
    UploadImage: "Upload Image",
    UploadVideo: "Upload Video",
    UploadDocument: "Upload Document",
    // Shared validation feedback for template-header file selection and drag-and-drop uploads.
    MediaFileTypeInvalid: "Please upload a file in one of these formats: {types}",
    MarketingType: "Marketing",
    Utility: "Utility",
    Authentication: "Authentication",
    InvalidTTL: "Please enter a valid positive integer",
    TTLExceed30Days: "Expiry time cannot exceed 30 days (720 hours)",
    TTLExceed30DaysShort: "Expiry time cannot exceed 30 days",
    SelectPushPhone: "Please select push phone",
    SelectWabaFirst: "Please select WABA platform first",
    OnlyXlsAllowed: "Only xls/xlsx files are allowed",
    FileTooLarge: "File too large, max 60M",
    PleaseUploadFile: "Please upload a file first",
    TaskUpdateSuccess: "Task updated successfully, you can view the progress in the blast task list!",
    TaskCreateSuccess: "Task created successfully, you can view the progress in the blast task list!",
    AutomateTaskCreateSuccess: "Automation task created successfully",
    AutomateTaskUpdateSuccess: "Automation task updated",
    OperationTip: "Operation Tip",
    SendTimeMustBeLater: "Send time must be later than the current time (considering the selected timezone)",
    RefreshSuccess: "Refreshed successfully",
    PleaseEnter: "Please enter {name}",
    EditBlastTask: "Edit Blast Task",
    NewBlastTask: "New Blast Task",
    TTLCustom: "Custom",
    PleaseSelectWabaAccount: "Please select a WABA account",
    UtilityType: "Utility",
    AuthenticationType: "Authentication",
    TemplateTypeImage: "Image message",
    TemplateTypeVideo: "Video message",
    TemplateTypeText: "Text message",
    TemplateTypeDocument: "Document message",
    TemplateTypeLocation: "Location message",
    TTLExceed30DaysHours: "Expiry time cannot exceed 30 days (720 hours)",
    MissingContactIdForDelete: "Missing contact ID, temporarily unable to delete",
    SelectedTargetUsers: "Selected Target Users",
    ViewUsers: "View Users",
    AddTagsToTargetUsersTip: "Add tags to the valid target users of this task (optional)",
    TagsAppliedAfterCreation: "Not set yet. Tags will be applied after the task is created.",
    NoTargetUsers: "No users added yet",
    NoTargetUsersTip: "Filter by conditions or upload a local list; the system will automatically merge, validate and deduplicate.",
    AddNow: "Add Now",
    AddTargetUsers: "Add Target Users",
    SelectByCondition: "Select by Conditions",
    TargetUserTags: "Target User Tags",
    InteractionStatus: "Interaction Status",
    SelectInteractionPlaceholder: "Please select interaction status",
    HasInteraction: "Has Interaction",
    NoInteraction: "No Interaction",
    Recent: "Last",
    DaysUnit: "days",
    TargetUserScope: "Target User Scope",
    IncludeLabel: "Include",
    ExcludeLabel: "Exclude",
    IncludedStatus: "included",
    ExcludedStatus: "excluded",
    FilterInteractionDesc: "Select users who have {interaction} <span class=\"label-highlight\">within the last {days} days</span>.",
    FilterCountryDesc: "Users <span class=\"label-highlight\">from {countries}</span> will be {status}.",
    FilterLabelDesc: "Users with tags <span class=\"label-highlight\">{labels}</span> will be {status}.",
    UploadList: "Upload List",
    ConfirmAdd: "Confirm",
    AddTagsForContacts: "Add tags for these contacts",
    // Match the single-contact title used by the WhatsApp service tag dialog.
    AddTagForContact: "Add tags for contact",
    // The shared tag picker switches its title and confirmation label by mode.
    SearchByTag: "Search by tag",
    ConfirmSelection: "Confirm",
    SearchTagPlaceholder: "Search tag name",
    NoCategories: "No categories",
    NoTags: "No tags",
    SelectedTagsCount: "Selected: {count}",
    AddNewCategory: "New Category",
    AddNewTag: "New Tag",
    EnterCategoryName: "Please enter category name",
    EnterTagName: "Please enter tag name",
    ConfirmCreate: "Confirm",
    SelectWabaFirst: "Please select a WABA platform first",
    NoTargetUsersFound: "No target users found",
    SelectCategoryFirst: "Please select a category first",
    UploadFailed: "Upload failed",
    TaskModifiedSuccess: "Task modified successfully. You can check the task progress in the blast task list!",
    OperationTip: "Operation Tip",
    // 自动化任务模块：创建 / 列表 / 统计 / 互动详情
    AutomateNewTask: "New Automation Task",
    AutomateTaskDetailCrumb: "Automation Task: {name}",
    AutomateStepScene: "Scene Settings",
    AutomateStepAction: "Execution Action",
    AutomateStepRule: "Execution Rules",
    AutomateSectionBasic: "1. Basic Information",
    AutomateSectionScene: "2. Task Scene",
    AutomateSectionAction: "3. Execution Action",
    AutomateSectionRule: "4. Execution Rules",
    AutomateTaskNamePlaceholder: "Enter a task name with at least 2 characters",
    AutomateTaskNameMin: "Please enter a task name with at least 2 characters",
    AutomateTaskTime: "Task Time",
    AutomateLongTerm: "Always valid",
    AutomateCustomTime: "Custom time",
    AutomateStartDate: "Task start time",
    AutomateEndDate: "Task end time",
    AutomateDateTo: "to",
    AutomateSceneScope: "Scene Scope",
    AutomateSceneDialog: "Conversation Scene",
    AutomateSceneOrder: "Order Information",
    AutomateSceneUser: "User Group",
    AutomateSceneHint: "When and how to trigger subsequent actions",
    AutomateScenePlaceholder: "Describe your scenario; AI will understand when or how to trigger subsequent actions.\ne.g. # Scene - When a customer follows for the first time or adds WeCom, send a welcome message.",
    AutomateSaveAsTemplate: "Save as Template",
    AutomateUseSceneTemplate: "Use Scene Template",
    AutomateSceneTemplate: "Scene Template",
    AutomateManageTemplate: "Manage Templates",
    AutomateSearchTemplate: "Search template name",
    AutomateSystemPreset: "System Presets",
    AutomateMyTemplate: "My Templates",
    AutomateSceneTemplateEmpty: "No scene templates",
    AutomateUserCountryRegion: "User Country/Region",
    AutomateUserInteraction: "User Interaction",
    AutomateDaysAgo: "Within the last",
    AutomateWithinDays: "days",
    AutomateSelectScene: "Please select a scene",
    AutomateSelectStoreLabel: "Select Store",
    AutomateOrderUnpaid: "Order unpaid",
    AutomateOrderPaid: "Order paid",
    AutomateOrderShipped: "Order shipped",
    AutomateOrderDelivered: "Order delivered",
    AutomateOrderCancelled: "Order cancelled",
    AutomateAddTagDesc: "AI automatically adds the specified tags to contacts that meet the conditions",
    AutomateNoTagSelected: "No tags added yet,",
    AutomateSelectTagTip: "please select the tags to add automatically to contacts",
    AutomateSendMessageDesc: "AI automatically sends a WhatsApp template message to contacts that meet the conditions",
    AutomateNoTemplateSelected: "No message template selected yet,",
    AutomateSelectTemplateTip: "select a template to configure dynamic parameters in the message",
    AutomateExecutionTime: "Execution Time",
    AutomateConversationEnd: "After the conversation ends",
    AutomateHourUnit: "hour(s)",
    AutomateMinuteUnit: "minute(s)",
    AutomateExecuteAfter: "later",
    AutomateTriggerFrequency: "Trigger Frequency",
    AutomateTriggerOnce: "Trigger once",
    AutomateTriggerEveryTime: "Trigger every time",
    AutomateExecuteImmediately: "Execute immediately",
    AutomateExcludeUsers: "Exclude Users",
    AutomateNotExclude: "Do not exclude",
    AutomateExcludeProcessed: "Exclude processed contacts",
    AutomateTaskPreview: "Task Preview",
    AutomateTemplateManagement: "Template Management",
    AutomateTemplateColumn: "Template",
    AutomateTypeColumn: "Type",
    AutomateCustomScene: "Custom",
    AutomateApplyTemplate: "Apply",
    AutomateEditTemplate: "Edit Template",
    AutomateTemplateDialogTip: "Fill in the template name and scene content to complete the scene template settings",
    AutomateTemplateNamePlaceholder: "Please enter your template name",
    AutomateSceneContent: "Scene Content",
    AutomateSave: "Save",
    AutomateDeleteSceneConfirm: "Delete the team scene “{name}”? This action cannot be undone.",
    AutomateDeleteSceneTitle: "Delete Team Scene",
    AutomateSelectAction: "Please select an execution action",
    AutomateInteractionRequired: "Please select user interaction",
    AutomateInteractionDaysRequired: "Please enter the interaction days",
    AutomateTaskEnded: "Ended",
    AutomateTaskAbnormal: "Abnormal",
    AutomateInteractionNotOrdered: "No order",
    AutomateInteractionOrdered: "Ordered",
    AutomateInteractionFirstFollow: "First follow",
    AutomateDeleteConfirm: "After deletion, the task cannot be recovered. Delete this task?",
    AutomateDeleteTitle: "Delete Task",
    AutomateDeleted: "Task deleted",
    AutomateFilterWaba: "WABA Account",
    AutomateCreateStart: "Created start date",
    AutomateCreateEnd: "Created end date",
    AutomateSearchNameCreator: "Search task name or creator",
    AutomateEnableSwitch: "Enabled",
    AutomateTriggerScene: "Trigger Scene",
    AutomateMonitorConversation: "Conversation",
    AutomateMonitorOrder: "Order",
    AutomateMonitorUser: "User",
    AutomateNoAvailablePhone: "No phone number is available for blasting. Please bind an available phone number in your WhatsApp account first",
    MessageNotDelivered: "Not delivered",
    MessageDelivered: "Delivered",
    MessageDeliveryFailed: "Delivery failed",
    EveryDay: "Every Day",
    CustomerName: "Customer",
    IsMaxPriceAlertText: "This template does not support bid cap adjustment. You need to set the bid cap in the template first before editing this parameter.",
    IsMaxPriceAlertTitle: "Cannot set the highest bid.",
    IsWabaMaxPriceWhitelist: "To set up the Highest Bid feature, please first add your WABA account to the whitelist. You can contact your dedicated sales representative to apply for activation.",
    // WhatsApp blast - Set Highest Bid drawer
    BestBidTitle: "Set Highest Bid",
    BestBidSearchPlaceholder: "Enter a country/region",
    BestBidTargetCoveragePrefix: "Target users cover",
    BestBidSelectedPrefix: "Selected",
    BestBidCountryRegionUnit: "countries/regions",
    BestBidBatchAdjust: "Batch Adjust",
    BestBidClearSelection: "Clear Selection",
    BestBidCountryRegion: "Country/Region",
    BestBidTargetUserCount: "{count} target users",
    BestBidAdjustment: "Adjustment",
    BestBidPercentagePlaceholder: "Enter",
    BestBidHighestBid: "Highest Bid",
    BestBidOriginalPrice: "Original Price",
    BestBidIncrease: "Increase",
    BestBidNoChange: "No Change",
    BestBidDecrease: "Decrease",
    BestBidAdjustedSummary: "{total} countries/regions, {adjusted} adjusted",
    BestBidSaveSettings: "Save Settings",
    BestBidBatchAdjustTitle: "Batch Adjust Bids",
    BestBidAdjustScope: "Scope: {count} countries/regions selected",
    BestBidConfirmAdjust: "Confirm Adjustment",
    BestBidSelectCountryFirst: "Select the countries/regions to adjust",
    BestBidOutOfRange: "The {adjust} percentage ({percentage}%) for “{country}” is out of range (1%–{max}%).",
    BestBidPercentageRange: "When set to {adjust}, the percentage must be between 1% and {max}%.",
    // WhatsApp blast - New Task page: highest bid card, risk-check prompts, and unsupported-region dialog
    BestBidCustomCostTitle: "Custom cost per marketing message",
    BestBidCustomCostDesc: "The highest bid is a Meta whitelist feature that gives you flexible control over blast costs and delivery priority.",
    BestBidSetBid: "Set Bid",
    BestBidConfigured: "Configured",
    BestBidEditBid: "Edit Bid",
    RiskCheckReviewingTitle: "Under review",
    RiskCheckReviewingDesc: "The system is checking whether the task content complies with platform policies.",
    RiskCheckPleaseWait: "Please wait…",
    RiskCheckFailureTitle: "Risk Control Alert",
    RiskCheckAdjust: "Adjust",
    RiskCheckFailureDefaultMessage: "Your WhatsApp blast task has triggered the platform's risk control rules. Please adjust the message template content and submit the task again.",
    MaxPriceUnsupportedTitle: "The highest bid is not supported in some contacts' regions",
    MaxPriceUnsupportedSubTitle: "The current target users include {count} countries/regions where the highest bid is not supported.",
    MaxPriceUnsupportedRegionsLabel: "Countries/regions involved:",
    MaxPriceUnsupportedRegionsCount: "{count} in total",
    MaxPriceUnsupportedDesc: "Contacts in these regions will fail to receive the message. You can go back to modify the target users or confirm to continue creating the task.",
    MaxPriceUnsupportedTooltip: "Countries/regions that do not support the highest bid (18 in total): European Economic Area, United States, United Kingdom, China, Japan, South Korea, Thailand, Iran, Syria, Abkhazia, Nigeria, South Africa, United States, Cuba, North Korea, Venezuela, Crimea, Donetsk, Luhansk, Russia, Belarus, Sint Maarten, Guadeloupe, Greenland, Saint Pierre and Miquelon, French Guiana, Falkland Islands, Ascension Island, New Caledonia, French Polynesia",
    MaxPriceUnsupportedListLabel: "View all unsupported regions"
  },
  instruct: {
    "My-Templates": "My Templates",
    "Create-Template": "Create Template",
    "Edit-Template": "Edit Template",
    Template: "Template",
    "Step1-Basic-Command": "Step 1: Basic Command Settings",
    "Using-Scene": "Use Scenario",
    "Using-Scene-Placeholder": "For document writing or industry advisor",
    "Doc-Writing": "Document Writing",
    "Industry-Advisor": "Industry Advisor",
    "Role-Setting": "Role Setting (Assume you are)",
    "Role-Placeholder": "Internet marketing expert",
    "Output-Language-Style": "Output Language Style",
    "Mood-Placeholder": "Select the language style for output content",
    "Task-Goal": "Task Goal",
    "Task-Placeholder": "Write a market demand report based on my requirements",
    "Step2-Form-Fields": "Step 2: Form Field Settings",
    "Custom-Fields": "Custom fields users need to fill in",
    "Field-Name": "Field Name",
    "Field-Placeholder-Example": "Enter a guide text, e.g. Please enter the brand name",
    "Add-Field": "Add Field",
    "Template-Preview": "Template Preview",
    "Save-Template": "Save Template",
    "AI-Model": "AI Model",
    "Output-Language": "Output Language",
    "Language-Placeholder": "Select the output language",
    "Full-Command-Preview": "Full Command Preview",
    "Command-Preview-Tip": "The command is only shown when creating, not during actual use",
    "Start-Generating": "Start Generating",
    "Generated-Result": "Generated Result Preview",
    "Generated-Result-Short": "Generated Result",
    Back: "Back",
    "Stop-Generating": "Stop Generating",
    "Template-Name": "Template Name",
    "Enter-Template-Name": "Please enter the template name",
    "Template-Desc": "Template Description",
    "Enter-Template-Desc": "Please enter the template description",
    "Use-Permission": "Usage Permission",
    "Only-Self": "Only me",
    "Team-Usable": "Team",
    "Rule-Select-Feature": "Please select a feature module",
    "Rule-Enter-Role": "Please enter the role setting",
    "Rule-Select-Mood": "Please select a tone",
    "Rule-Enter-Task": "Please enter the task goal",
    "Rule-Select-Permission": "Please select the permission for this template",
    "Rule-Add-Field": "Please add custom fields",
    "Brand-Name": "Brand Name",
    "Enter-Brand-Name": "Please enter the brand name",
    "Instruct-You-Are": "You are a ",
    "Instruct-Role-Empty": "(Role not set)",
    "Instruct-Task-Empty": "(Task goal not set)",
    "Instruct-Empty": "(Not filled)",
    "Instruct-Please-Use": "Please use ",
    "Instruct-Mood-Output": " tone to output the content; the output language is: ",
    "Instruct-Mood-Output-Use": " tone to output the content, the output language is: ",
    "Instruct-Not-Selected": "(Not selected)",
    "Confirm-Stop-AI": "Do you want to stop the AI response?",
    "Confirm-Delete-Template": "This operation will permanently delete this template. Continue?",
    "Created-By-Me": "Created by me",
    "Created-By-Others": "Created by others",
    "New-Template": "New Template",
    Generating: "Generating...",
    "Copy-Result": "Copy Result",
    All: "All",
  },
  bot: {
    "Add-Mail-Title": "Bind New Email",
    "Email-Account": "Email Account: ",
    "Enter-Correct-Email": "Enter a valid email address",
    "Email-Auth-Code": "Email Authorization Code: ",
    "Enter-Email-Auth-Code": "Enter the email authorization code",
    "Usage-Desc": "Usage Description: ",
    "Enter-Desc": "Enter a description",
    "Service-Type": "Service Type: ",
    "Enter-Email": "Enter the email address",
    Server: "Server: ",
    "Host-Example": "e.g. {host}",
    "Port-Example": "e.g. {port}",
    "Enter-Email-Rule": "Please fill in the email address",
    "Enter-Auth-Code-Rule": "Enter the email authorization code",
    "Enter-Cs-Desc": "Please fill in the customer service description",
    "Select-Service-Type": "Select the receiving service type",
    "Enter-Receiving-Host": "Enter the receiving server address",
    "Enter-Port": "Enter the port number",
    "Enter-Outbox-Host": "Enter the sending server address",
    "Enter-Port-Type": "Enter the port type",
    "Create-Success-Confirm": "The email assistant was created successfully and uses the global default settings. To modify it, click the Edit button!",
    "Create-Success-Title": "Created Successfully",
    "Go-Edit": "Go to Edit",
    "Associate-Email-Success": "Email associated successfully",
    Submit: "Submit",
    "Not-Exist-Correlation": "No shops linked",
    "Mall-Name": "Mall Name",
    "Mall-Platform": "Mall Platform",
    "Self-Build-Site": "Self-built Site",
    "Products-Orders-Count": "Products & Order Count",
    "Order-Colon": "Orders: ",
    "Product-Colon": "Products: ",
    "Update-Time": "Updated At",
    Operation: "Operations",
    "Update-Data": "Update Data",
    "Authorized-Platforms": "Authorized E-commerce Platforms",
    "Select-Platform-Type": "Select platform type",
    "Refresh-List": "Refresh List",
    "Authorize-New-Account": "Authorize New Account",
    "Shopify-Shopline-Tip": "You can only select one Shopify and one Shopline store, but multiple standalone sites",
    "Independent-Site": "Standalone Site",
    Updating: "Updating...",
    "Total-Orders-Info": "{count} order records in total",
    "Product-Info-Suffix": ", {count} product records",
    "Already-Added": "Added to this e-commerce",
    "Media-Account": "Media Account: ",
    "Website-Colon": "Website: ",
    "Last-Update-Time": "Last updated: ",
    "Info-Update-Success": "Info updated successfully",
    "Shopify-Shopline-Only-One": "You can only select one Shopify and one Shopline store. Please re-select!",
    "Cancel-Correlation-Confirm": "Once the mall link is canceled, the bot cannot reference data from the mall",
    "Cancel-Correlation-Title": "Cancel Mall Link",
    "Header-Content": "Header Content: ",
    "Header-Content-Short": "Header Content",
    "Header-Content-Tip": "This is the opening section of the email, used to greet the recipient. You can choose an appropriate greeting based on the formality of the email",
    "Enter-Header-Content": "Dear customer, hello!",
    "AI-Command-Header": "Generate an email opening template for me",
    "Footer-Content": "Footer Content: ",
    "Footer-Content-Short": "Footer Content",
    "Footer-Content-Tip": "Closing thanks: thank the recipient for reading the email and any action they may take, which conveys politeness and respect. Signature: include your name, title, and contact information so the recipient can better identify and contact you.",
    "AI-Command-Footer": "Generate an email signature for me",
    "Enter-Mail-Header-Rule": "Enter the email header content",
    "Enter-Mail-Footer-Rule": "Enter the email footer content",
    "Footer-Placeholder": "If you have any questions or need further assistance, please feel free to contact us. We will serve you wholeheartedly.\n\n\nThank you again for your purchase. We wish you a pleasant shopping experience!\n\nSincerely,\n[Name]\n[Title]\n[Company Name]\n[Phone]\n[Email]\n[Company Address]",
    "Email-Preview-Title": "Email Preview",
    "Query-From-Payment": "At query time, {min} to {max} days since payment",
    "Join-Separator": ", ",
    "Auth-Code-Help-Prefix": "(For auth code instructions, refer to ",
    "Auth-Code-Help-Mail": "163 Mail",
    "Auth-Code-Help-Suffix": " etc.)",
    "Mail-Pending-Reply": "Pending Reply",
    "Mail-Replied": "Replied",
    "Last-Reply-Time": "Last Reply Time",
    "Enter-Sender-Title-Search": "Enter sender or title and press Enter to search",
    "Sender-Colon": "Sender: ",
    "Handler-Colon": "Handler: ",
    "Select-Email-Detail": "Select an email to view details",
    "Mark-As-Read": "Mark as Replied",
    "Sort-Method": "Sort Method",
    "Sort-Desc": "Descending",
    "Sort-Asc": "Ascending",
    "Batch-Select": "Batch Select",
    "Select-All": "Select All",
    "Selected-Count": "{n} selected",
    "Dates-All": "All",
    "Dates-Today": "Today",
    "Dates-Yesterday": "Yesterday",
    "Dates-Last-3-Days": "Last 3 Days",
    "Dates-Last-30-Days": "Last 30 Days",
    "Loading": "Loading...",
    "No-Data": "No Data",
    "Send": "Send",
    "AI-Suggest": "AI Suggestions",
    "Reply-Colon": "Reply: ",
    "Enter-Reply-Content": "Enter the reply content",
    "AI-Assistant": "AI Assistant",
    "Assistant": "Assistant",
    "Email-Format-Invalid": "Incorrect email format",
    "Enter-Reply-Content-Tip": "Please enter the reply content!",
    "Send-Success": "Sent successfully",
    "Mail-Reply": "Email Reply",
    "Confirm-Stop-AI-Reply": "Do you want to stop the AI response?",
    "Reply-Email": "Reply Email",
    "Customer-Email": "Customer Email",
    "Recipient-Colon": "Recipient: ",
    "Recipient": "Recipient",
    "Enter-Email-Subject": "Enter the email subject",
    "Enter-Mail-Content": "Edit the email content here",
    "Send-Immediately": "Send Now",
    "Quick-Reply": "Quick Reply",
    "Add-Quick-Reply": "Add Quick Reply",
    "Edit-Quick-Reply": "Edit Quick Reply",
    "Quick-Reply-Subtitle": "Fill in the template name and reply content to complete the quick reply template setup",
    "Email-Template": "Email Template",
    "Search-Template-Name": "Search template name",
    "Add-Template": "Add Template",
    "Apply-Template": "Apply Template",
    "Edit-Template": "Edit Template",
    "Save-Template": "Save Template",
    "Topic-Name": "Template Name",
    "Topic-Name-Required": "Please enter the template name",
    "Enter-Topic-Name": "Please enter your template name",
    "Reply-Content": "Reply Content",
    "Confirm-Delete-Template": "Are you sure you want to delete this template?",
    "More": "More",
    "Translate": "Translate",
    "Translate-Result": "Translation result: ",
    "Translate-Success": "Translated successfully",
    "Translate-Email": "Translate Email",
    "Show-Original": "Show Original",
    "Original-Email-Below": "The following is the original email",
    "On-Wrote": "On {time}, \"{user}\" wrote:",
    "Relate-Time": "Related time: ",
    "Operator-Colon": "Operator: ",
    "Unbind-Relation": "Unlink",
    "Confirm-Delete-Bound-Mail": "Confirm to delete the currently bound email?",
    "Robot": "Robot",
    "Related-Mail": "Related Email",
    "Published-Platform": "Published Platforms",
    "Customer-Service-Admin": "Customer Service Admin",
    "Create-Time": "Creation Time",
    "Scene-Data": "Scene Data",
    "Scene-Count": "Scene Count",
    "Scene-Count-Tip": "The specific number of scenes triggered by users",
    "Scene-Interaction-Count": "Scene Interaction Count",
    "Scene-Interaction-Tip": "The cumulative number of times user interaction behavior triggered scenes",
    "Interaction-Data": "Interaction Data",
    "Export-Data": "Export Data",
    "Date": "Date",
    "User-Interaction-Count": "User Interaction Count",
    "User-Interaction-Person": "User Interaction Persons",
    "Manual-Reply-Count": "Manual Reply Count",
    "AI-Auto-Reply-Count": "AI Auto Reply Count",
    "Manual-Reply-Ratio": "Manual Reply Ratio",
    "Manual-Reply-Ratio-Text": "Customer Service Manual Reply Ratio",
    "AI-Auto-Reply-Ratio": "AI Auto Reply Ratio",
    "Scene": "Scene",
    "Interaction-Count": "Interaction Count",
    "Crumb-Intelligent-Robot": "Intelligent Robot",
    "Crumb-Data-Analysis": "Data Analysis",
    "Crumb-Robot-Detail": "Robot Details",
    "User-Interaction-Count-Desc": "The number of interactions between users and the robot",
    "User-Interaction-Person-Desc": "The number of users who interacted with the robot",
    "Manual-Reply-Count-Desc": "Customer interaction issues replied by customer service staff",
    "AI-Auto-Reply-Count-Desc": "Customer interaction issues replied by AI",
    "Manual-Reply-Ratio-Desc": "The percentage of manual replies in total replies",
    "AI-Auto-Reply-Ratio-Desc": "The percentage of AI replies in total replies",
    "Email-Colon": "Email: ",
    "Phone-Colon": "Phone: ",
    "Todo-Count": "To-do: {count}",
    "Pending-Message-Count": "Pending messages: {count}",
    "Only-Show-Todo": "Only show to-do",
    "Message-Importance": "Message importance",
    "Todo": "To-do",
    "AI-Suggestion": "AI suggestions",
    "Mark-Todo": "Mark as to-do",
    "Cancel-Todo": "Cancel to-do",
    "WhatsApp-Audio": "WhatsApp audio {index}",
    "Audio-Not-Supported": "Your browser does not support audio playback.",
    "Location": "Location",
    "No-Chat-Seven-Days": "This user has not interacted with your page for over seven days, so you cannot chat with them.",
    "No-Chat-One-Day": "This user has not interacted with your page for over a day, so you cannot chat with them.",
    "No-Chat": "Unable to chat with this user",
    "No-Chat-Days": "This user has not interacted with your page for over {days} day(s), so you cannot chat with them.",
    "Input-Enter-Send": "Type content, press Enter to send",
    "Unsupported-Message-Type": "Unsupported message type: {type}",
    "Document": "Document",
    "Contact": "Contact",
    "Pending-Reply": "Pending reply",
    "Search-Name-Enter": "Type a name and press Enter to search",
    "Only-Unread": "Unread only",
    "All-Scenes": "All scenes",
    "Media-Attachment": "[Media attachment]",
    "Loading": "Loading...",
    "No-Results": "No results",
    "Today": "Today",
    "Yesterday": "Yesterday",
    "Last-3-Days": "Last 3 days",
    "Last-30-Days": "Last 30 days",
    "Effect-Preview": "Effect preview",
    "Auto-Reply-Enabled": "Auto reply enabled",
    "Start": "Start",
    "Start-Tip": "After tapping start, {name} will see your public information",
    "Locating-History": "Locating historical conversation...",
    "Click-Left-To-Reply": "Click the list on the left to reply to messages",
    "Update-Start-Date": "Update start date",
    "Select-Source-Channel": "Please select source channel",
    "Enter-Product-Name": "Please enter product name",
    "Total-Product-Info": "Total {count} product(s)",
    "No-Related-Shopify-Shopline": "The current bot is not linked to any Shopify or Shopline store!",
    "Customer-Service-Bot": "Customer Service Bot",
    "Configure-Bot": "Configure Bot",
  },
  // AI bot API list, shared create/edit form, scene settings, local mock interactions, and disable-confirmation dialog copy.
  aiRobot: {
    pageTitle: "AI Bot",
    createRobot: "Create Bot",
    searchPlaceholder: "Enter a bot name or creator",
    statusPlaceholder: "Select status",
    allStatuses: "All",
    enabled: "Enabled",
    disabled: "Disabled",
    disableConfirmTitle: "Disable this bot?",
    disableConfirmDescription: "After disabling, {name} will stop replying automatically. Configured scenes will remain and can be re-enabled at any time.",
    close: "Close",
    robot: "Bot",
    enableSwitch: "Enable",
    servicePlatform: "Service Platform",
    robotType: "Bot Type",
    linkedAccounts: "Linked Accounts",
    creator: "Creator",
    createdAt: "Created At",
    actions: "Actions",
    noDescription: "No description",
    onlineService: "Online Service",
    // The list action opens the full bot settings flow; scene settings remain an inner page.
    configureRobot: "Set Up Bot",
    more: "More",
    edit: "Edit",
    copyRobot: "Duplicate Bot",
    deleteRobot: "Delete",
    me: "Me",
    // Pagination uses the filtered total returned by the list endpoint in both languages.
    totalCount: "{count} items in total",
    goTo: "Go to",
    page: "Page",
    empty: "No bots yet",
    // Distinguish a failed list request from a successful empty server page.
    listLoadFailed: "Could not load the bot list",
    retry: "Retry",
    createTitle: "Create Bot",
    editTitle: "Edit Bot",
    // Open the edit drawer first, then show progress while its detail request completes.
    detailLoading: "Loading bot details...",
    // Keep shared create/edit avatar guidance, placeholders, and enablement copy aligned with both designs.
    avatarLabel: "Bot Avatar",
    avatarChange: "Click to change bot avatar",
    avatarHint: "JPG / PNG, 1:1 square recommended, up to 2 MB",
    avatarInvalidType: "Only JPG or PNG images are supported",
    avatarTooLarge: "Image size must not exceed 2 MB",
    name: "Bot Name",
    namePlaceholder: "Enter a bot name to identify it quickly in the list",
    description: "Bot Description",
    descriptionPlaceholder: "Briefly describe the bot's services and capabilities for your team",
    enableStatus: "Enable Status",
    enableHint: "When enabled, this bot takes effect immediately for new contacts on this platform",
    cancel: "Cancel",
    save: "Save",
    create: "Create",
    // Distinguish request progress and explain missing team context or save failures without losing the draft.
    creating: "Creating...",
    saving: "Saving...",
    createFailed: "Could not create the bot. Please try again.",
    editFailed: "Could not save the bot. Please try again.",
    teamMissing: "Could not identify the current team. Refresh the page and try again.",
    avatarUploadFailed: "Could not upload the avatar. Please try again.",
    nameRequired: "Enter a bot name",
    created: "Bot created",
    saved: "Changes saved",
    // Check both the returned bot ID and target status before changing the switch.
    updatingStatus: "Updating...",
    statusUpdated: "Bot status updated",
    statusUpdateFailed: "Could not update bot status. Please try again.",
    copied: "Bot duplicated",
    // The server creates the copy; show progress and keep legacy local demo copies out of the API.
    copying: "Duplicating...",
    copyFailed: "Could not duplicate the bot. Please try again.",
    copyUnavailable: "Local demo bots cannot be duplicated",
    deleted: "Bot deleted",
    // Confirm soft deletion only after the server returns the same bot ID; block duplicate submissions.
    deleting: "Deleting...",
    deleteFailed: "Could not delete the bot. Please try again.",
    deleteConfirm: "Delete this bot?",
    linkedSummary: "{count} linked accounts",
    // The linked-account drawer fetches WhatsApp page details and distinguishes loading, empty, and failed results.
    accountsDrawer: {
      title: "Linked Accounts",
      accountCount: "{count} accounts",
      linkedSummary: "{count} linked WABA accounts",
      accountInfo: "Account Information",
      companyVerification: "Company Verification",
      accountStatus: "Account Status",
      linkedPhone: "Linked Phones",
      messageUsage: "Messages Used / Limit",
      goTo: "Go to",
      page: "Page",
      empty: "No linked accounts",
      loading: "Loading...",
      loadFailed: "Could not load accounts",
      retry: "Retry",
      close: "Close",
      // Company verification codes and account review values use the same localized status badges.
      statuses: {
        verified: "Verified",
        unverified: "Unverified",
        companyRejected: "Rejected",
        certificationFailed: "Verification failed",
        reviewing: "Under review",
        approved: "Approved",
        disabled: "Disabled",
        pending: "Pending",
        rejected: "Rejected",
        expired: "Expired",
        failed: "Failed",
        ineligible: "Ineligible",
        notVerified: "Not verified",
        pendingNeedMoreInfo: "More information needed",
        pendingSubmission: "Pending submission",
        revoked: "Revoked",
        accountVerified: "Verified",
        disconnected: "Disconnected",
        unbound: "Unbound",
      },
    },
    sceneSummary: "{count} configured scenes",
    // Keep scene settings and the test preview in sync with the bot list when the language changes.
    settings: {
      breadcrumb: "Bot Settings",
      back: "Back to bot list",
      orchestration: "Orchestration",
      capabilities: "Capabilities",
      knowledgeBase: "Knowledge Base",
      ecommercePlatform: "E-commerce Platform",
      title: "Scene Settings",
      introduction: "Set how the bot replies to customers and which conversations it handles",
      replyStyleTitle: "1. Reply Style",
      replyStyleDescription: "Choose the tone and language the bot uses to reply",
      toneLabel: "Reply Tone",
      // Keep the five server tones alongside legacy friendly and concise draft labels.
      toneFormal: "Formal",
      toneProfessional: "Professional",
      toneRelaxed: "Relaxed",
      toneRigorous: "Rigorous",
      toneHumorous: "Humorous",
      toneFriendly: "Friendly",
      toneConcise: "Concise",
      fallbackLanguageLabel: "Fallback Language",
      fallbackLanguageTip: "Use this language when the customer's language cannot be detected",
      receptionTitle: "2. Reception Scope",
      receptionDescription: "Choose when AI handles a conversation and how it responds when information is missing",
      autoReplyScene: "Auto-reply Scene Settings",
      autoReplyPlaceholder: "Describe when and how the bot should reply automatically",
      promptRequired: "Enter the auto-reply scene settings",
      officialVersion: "Use Official Version",
      answerModeTitle: "How to Answer in Matching Scenes",
      answerModeDescription: "Choose whether AI may use information beyond the knowledge base and e-commerce data",
      answerStrictTitle: "Use source material only",
      answerStrictDescription: "Do not guess, expand on, or answer questions not covered by the source material",
      answerBalancedTitle: "Prefer source material; improvise when needed",
      answerBalancedDescription: "AI may answer questions not covered by the source material",
      answerFreeTitle: "Let AI answer freely",
      answerFreeDescription: "Source material is optional reference for the answer",
      // Scene settings only advances to confirmation; the next page performs the final publish.
      skip: "Set Up Later",
      next: "Next",
      published: "Published successfully",
      previewTab: "Test Preview",
      robotInfoTab: "Bot Information",
      previewPlaceholder: "Enter a message to test the bot's reply",
      // The composer shares WhatsApp labels; these messages only describe preview replies and uploads.
      previewReplyFailed: "The bot could not reply. Please try again.",
      previewSendFailed: "Reply failed",
      previewRetry: "Retry",
      previewUnavailable: "Demo bots cannot be tested. Select a created bot.",
      previewToneInvalid: "Choose a valid reply tone",
      previewAnswerModeInvalid: "Choose a valid answer mode",
      previewUploadFailed: "File upload failed",
      previewAttachmentInvalid: "The file type, size, or count is not supported",
      previewAiReply: "AI auto-reply",
      robotName: "Bot Name",
      robotDescription: "Bot Description",
      robotStatus: "Enabled",
      // The bot information tab shows the current mock record and its published version.
      // The revised info tab groups bot details and shows the version and publish time on separate rows.
      infoType: "Bot Type",
      infoPlatform: "Service Platform",
      infoVersion: "Current Version",
      infoDescription: "Bot Description",
      infoPublishTitle: "Publish Information",
      infoPublishedAt: "Published At",
      infoEnabled: "Enabled",
      infoDisabled: "Disabled",
      infoEmptyDescription: "No description",
    },
    // Validate release notes and show submit progress; pending results, history loading, and retry share these labels.
    publishPage: {
      title: "Publish & Versions",
      subtitle: "Review release history and publish the current settings as a new version",
      currentVersion: "Current active version: {version}",
      noVersion: "No active version",
      releaseMeta: "{date} published by {name}",
      releasedAt: "Published at",
      releasedBy: "Published by",
      sectionSettings: "1. Release Settings",
      impactLabel: "Effect on ongoing conversations",
      impactNew: "New conversations only (recommended)",
      impactAll: "Apply to all conversations immediately",
      noteLabel: "Release Notes",
      notePlaceholder: "Briefly describe this change for future reference",
      noteRequired: "Enter release notes",
      toneUnsupported: "Choose a supported reply tone before publishing",
      answerModeInvalid: "Choose a valid answer mode",
      sectionHistory: "2. Version History",
      versionLabel: "Version {version}",
      currentTag: "Current",
      previous: "Previous",
      publish: "Publish",
      publishLoading: "Publishing...",
      publishFailed: "Could not publish. Please try again.",
      publishPending: "The server reported success, but the version is not confirmed yet. Check the history shortly.",
      unknownPublisher: "Unknown",
      emptyHistory: "No releases yet",
      historyLoadFailed: "Failed to load version history",
      historyRetry: "Retry",
      historyLoadMore: "Load more",
      historyLoading: "Loading...",
    },
    // Share copy across the knowledge list, source menu, and online/upload/link review drawers; source labels map to local mock records.
    knowledge: {
      searchPlaceholder: "Enter a resource name",
      statusPlaceholder: "Select training status",
      add: "Add Resource",
      addUpload: "Upload Resource",
      addLink: "Extract from Link",
      tableName: "Bot",
      status: "Training Status",
      usageCount: "Times Used",
      creator: "Creator",
      createdAt: "Created At",
      actions: "Actions",
      sourcePrefix: "Source: ",
      sourceUpload: "Upload Document",
      sourceLink: "Web Link",
      sourceOnline: "Write Online",
      statusTraining: "Training",
      statusCompleted: "Training Complete",
      // The knowledge list uses server status and retry text alongside the existing demo editor copy.
      statusFailed: "Training Failed",
      loadFailed: "Failed to load knowledge resources",
      retry: "Retry",
      createFailed: "Could not add the resource. Please try again.",
      updateFailed: "Could not update the resource. Please try again.",
      edit: "Edit Resource",
      // Load the full text before opening any resource for editing.
      detailFetching: "Loading...",
      detailLoadFailed: "Could not load the resource details. Please try again.",
      delete: "Delete",
      empty: "No resources yet",
      addTitle: "Add Resource",
      editTitle: "Edit Resource",
      nameLabel: "Resource Name",
      namePlaceholder: "Enter a resource name",
      sourceLabel: "Resource Source",
      detailLabel: "Content",
      detailPlaceholder: "Enter resource content",
      chooseFile: "Choose File",
      cancel: "Cancel",
      save: "Save",
      // The delete dialog names the resource and explains its effect on reply training before local removal.
      deleteDialogTitle: "Delete Resource",
      deleteDialogDescription:
        "After deletion, {name} will no longer be used for reply training. Answers to similar questions may become less accurate. Delete it?",
      deleteDialogCancel: "Cancel",
      deleteDialogConfirm: "Confirm",
      created: "Resource added",
      saved: "Changes saved",
      deleted: "Resource deleted",
      deleteFailed: "Could not delete the resource. Please try again.",
      nameRequired: "Enter a resource name",
      // The online writer mirrors the design's title and rich text fields and stays within local mock data.
      onlineTitle: "Write Online",
      onlineNameLabel: "Resource Title",
      onlineNamePlaceholder: "Enter a resource title",
      onlineNameRequired: "Enter a resource title",
      onlineContentLabel: "Resource Content",
      onlineContentPlaceholder: "Enter resource content, such as product details, FAQs, and standard replies...",
      onlineUndo: "Undo",
      onlineRedo: "Redo",
      onlineConfirm: "Confirm",
      onlineContentRequired: "Enter resource content",
      // The upload drawer labels file transfer and import as separate loading stages.
      uploadTitle: "Upload Resource",
      uploadLocalLabel: "Local Upload",
      uploadDropPrompt: "Drag files here or click to upload",
      // File limits follow the single-file upload API; parsing is a separate step.
      uploadHintLine1: "Supports .txt, .pdf, .ppt, .pptx, .doc and .docx; TXT up to 800 KB, others up to 200 MB.",
      uploadHintLine2: "Select up to 100 files",
      uploadSelectedFiles: "Selected Files",
      uploadConfirm: "Confirm",
      uploadFile: "Upload Files",
      uploadUploading: "Uploading...",
      uploadStore: "Parse and Import",
      uploadStoring: "Importing...",
      uploadReady: "Uploaded, awaiting import",
      uploadFailed: "File upload failed. Please try again.",
      uploadStoreFailed: "Could not import the files. Please try again.",
      uploadStored: "{count} resources imported",
      uploadStorePartial: "{count} files could not be imported. Upload them again.",
      uploadReselect: "This file has expired. Remove it and select it again.",
      uploadPickFile: "Choose files",
      uploadRemoveFile: "Remove file: {name}",
      uploadNoFiles: "Select a file first",
      uploadInvalidType: "Only TXT, PDF, PPT, PPTX, DOC and DOCX files are supported",
      uploadTxtTooLarge: "TXT files must be 800 KB or smaller",
      uploadOtherTooLarge: "Files must be 200 MB or smaller",
      uploadTooManyFiles: "You can select up to {count} files",
      uploadDuplicateFile: "File already added: {name}",
      // The link capture drawer retains the design's notice and distinct inputs for each crawl mode; results stay in local mock data.
      linkTitle: "Capture Link Content",
      linkNoticeTitle: "Avoid infringing others' websites. Make sure links are public and their content can be copied.",
      linkNoticeLine1: "Capture one URL or all related URLs on a webpage.",
      linkNoticeLine2:
        "When capturing a site, JavaScript is filtered and text plus links beginning with the URL are collected. More URLs take longer; up to 600 URLs can be submitted at once.",
      linkNoticeLine3: "Previously captured content is filtered automatically to avoid duplicates.",
      linkModeLabel: "Capture Mode",
      linkModeSingle: "Single Link Page",
      linkModeRelated: "Related Link Pages",
      linkUrlLabel: "Website Link",
      linkUrlPlaceholder: "Enter a webpage URL, such as https://www.example.com",
      linkRelatedPlaceholder: "Enter a link beginning with http:// or https://",
      linkRelatedHint:
        "For example, to capture everything under https://www.example.com/active/, enter https://www.example.com/active/.",
      linkAddUrl: "Add Link",
      linkRemoveUrl: "Remove link",
      linkStartParse: "Start Parsing URL",
      linkUrlRequired: "Enter at least one website link",
      linkInvalidUrl: "Enter a valid HTTP or HTTPS website link",
      linkDuplicateUrl: "Do not enter duplicate website links",
      linkTooManyUrls: "You can add up to {count} website links at once",
      // A simulated progress dialog covers task startup and list loading; failures keep the URL input intact.
      linkParsingTitle: "Parsing links",
      linkParsingMessage: "Capturing page content. Please wait...",
      linkNoContentTitle: "Notice",
      linkNoContentMessage: "No content was found at the links you entered. Check or replace the links.",
      linkDialogConfirm: "OK",
      linkTaskStarted: "Capture task started",
      linkStartFailed: "Could not start capture. Please try again.",
      // The review page submits only retained URLs and keeps its actions locked while confirmation runs.
      capturedTitle: "Captured Links",
      capturedContent: "Captured Content",
      capturedCountPrefix: "Total ",
      capturedCountSuffix: " links",
      capturedBack: "Previous",
      capturedImport: "Capture and Import",
      capturedSubmitting: "Capturing...",
      capturedSubmitted: "Capture task submitted",
      capturedConfirmFailed: "Could not capture the resources. Please try again.",
      capturedOpen: "Open link: {url}",
      capturedRemove: "Remove link: {url}",
      capturedEmpty: "No links to import",
      capturedLoading: "Loading links...",
      capturedLoadFailed: "Could not load links. Please retry.",
      capturedNoResults: "No links yet",
      // Returning to the URL form discards the current results, so the dialog asks first.
      backConfirmTitle: "Please Confirm",
      backConfirmDescription: "The pages captured here will be discarded when you go back.",
      backConfirmCancel: "Cancel",
      backConfirmAccept: "Confirm",
    },
    // Real bots bind and unlink stores through APIs; demo bots continue using local examples.
    commerce: {
      title: "E-commerce Platform",
      description: "Linked stores provide product and order information for this bot's replies",
      searchPlaceholder: "Enter a store name or domain",
      linkButton: "Link E-commerce Platform",
      domain: "Domain",
      connectedAt: "Connected at",
      independent: "Standalone Site",
      unknownPlatform: "Platform {type}",
      empty: "No linked e-commerce platforms",
      searchEmpty: "No matching e-commerce platforms",
      loading: "Loading e-commerce platforms...",
      loadFailed: "Failed to load e-commerce platforms",
      retry: "Retry",
      bindLoading: "Linking...",
      bindFailed: "Could not confirm the link result. Refresh and retry.",
      bindSuccess: "Linked {count} e-commerce platforms",
      bindSkipped: "The selected platforms are already linked",
      // Batch linking may partly succeed; show skipped counts and the specific missing platforms.
      bindWithSkipped: "Linked {bound}; skipped {skipped} already linked platforms",
      bindPartial: "Linked {bound}, skipped {skipped}, not found {notFound}: {missing}",
      bindNoChanges: "No new e-commerce platforms were linked",
      remove: "Unlink",
      linkDialogDescription: "Select e-commerce sites for this bot to access product and order information. Multiple selections are supported.",
      linkSelectPlaceholder: "Enter a platform name",
      linkSearch: "Search platforms",
      linkAvailableCount: "Available to link: {count}",
      linkSelectedCount: "Selected: {count}",
      alreadyLinked: "Linked",
      linkedAt: "Connected on {time}",
      linkNone: "No stores available to link",
      linkSearchEmpty: "No matching e-commerce platforms",
      linkCancel: "Cancel",
      linkConfirm: "Confirm",
      chooseStore: "Select a store first",
      linked: "Store linked",
      unlinkTitle: "Unlink Store",
      unlinkConfirm: "After unlinking, {name} will no longer provide product or order information for this bot's replies. Unlink this store?",
      unlinkAccept: "Confirm",
      // Unlinking uses the platform ID; keep the dialog open when the result cannot be confirmed.
      unlinkMissingPlatformId: "Platform ID is missing. This store cannot be unlinked.",
      unlinkFailed: "Could not unlink this store. Try again.",
      unlinked: "Store unlinked",
    },
  },
  // JoinCompass landing-page copy for the Chinese and English language switcher.
  joinCompass: {
    header: {
      menu: "Open menu",
      stock: "Publicly Listed · Stock Code 002279",
      demo: "Book a Demo",
      trial: "Free Trial",
    },
    actions: {
      trial: "Start Free Trial",
      demo: "Book a Demo",
    },
    hero: {
      tag: "· Meta Authorized Agency ·",
      titleFirst: "JoinCompass",
      titleSecond: "AI-powered Global Customer Engagement Platform",
      description: "Acquire through ads + manage public channels + nurture private leads = closed-loop growth",
      productAlt: "JoinCompass omnichannel customer touchpoint tracking overview",
      carouselLabel: "JoinCompass product carousel",
      carouselItemLabel: "Switch to hero slide {number}",
    },
    // The WhatsApp campaign slide follows the same i18n lifecycle as the existing JoinCompass hero slide.
    whatsappHero: {
      tag: "· Meta Authorized Agency ·",
      titleFirst: "Activate the WhatsApp lifecycle",
      titleSecond: "and grow owned audiences continuously",
      description: "Reach · retain · activate · convert · repurchase",
      primaryAction: "Use WhatsApp",
      secondaryAction: "Learn More",
      productAlt: "WhatsApp lifecycle growth overview",
    },
    channels: {
      title: "Unified Channels",
      description: "Connect social, messaging, email, and commerce channels to manage every customer touchpoint in one place.",
    },
    capabilities: {
      title: "Core Capabilities",
      tabList: "Core capability categories",
      // 首页核心能力标签使用精简英文，匹配 PC、平板与手机端的有限显示空间。
      publicLabel: "Public Reach",
      publicDescription: "Publish across channels, manage social comments, and automatically hide harmful feedback.",
      privateLabel: "Owned Nurture",
      privateDescription: "Unify customer touchpoints and make every conversation more effective.",
      managementLabel: "Enterprise Ops",
      managementDescription: "Manage business data and team collaboration with a clearer view of growth.",
    },
    growth: {
      titleFirst: "Every interaction",
      titleSecond: "is a growth opportunity",
    },
    demoDialog: {
      close: "Close demo booking dialog",
      title: "Book a Product Demo",
      description: "Scan to add a dedicated advisor and book a one-on-one JoinCompass demo.",
      qrcodeAlt: "QR code for booking a product demo",
      hint: "Scan to add your dedicated advisor",
    },
    // JoinCompass registration fields stay localized when the homepage switches to English.
    register: {
      referralLabel: "Referral code (optional)",
      referralPlaceholder: "Enter referral code",
    },
    footer: {
      platform: "AI-powered Global Customer Engagement Platform",
      officialAccount: "Official WeChat Account",
      productContact: "Product Contact",
      compliance: "Compliance",
      privacy: "Privacy Policy",
      agreement: "User Agreement",
      about: "About Us",
      listedCompany: "Listed Company Profile",
      overseasResources: "Global Advertising Resources",
      aiMaterials: "JoinSpark AI Creative Studio",
      copyright: "Copyright ©2012–2026 Jiuqi Digital Communication Co., Ltd.",
      icp: "ICP Filing No. 18018614-6",
      license: "Value-added Telecommunications License: Jing B2-20203609",
      police: "Public Security Filing No. 11030102011668",
    },
  },
};
